import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
  createContext,
  useContext,
} from "react";
import {
  Clock,
  Search,
  BrainCircuit,
  Send,
  MapPin,
  Linkedin,
  Instagram,
  CircleDollarSign,
  DollarSign,
  CornerUpLeft,
  Coins,
  Github,
  TrendingUp,
  DownloadCloud,
  Upload,
  ChevronDown,
  Workflow,
  ChevronLeft,
  Receipt,
  Banknote,
  Package,
  PiggyBank,
  Inbox,
  LayoutDashboard,
  Play,
  BentoBox,
  PackageCheck,
  ArrowRightLeft,
  Handshake,
  Briefcase,
  Plus,
  Boxes,
  Factory,
  Bot,
  DatabaseZap,
  Loader2,
  FileSignature,
  CheckCircle,
  CalendarCheck,
  MessageSquare,
  RefreshCcw,
  XCircle,
  MoreHorizontal,
  FileSearch,
  ShieldAlert,
  Layers,
  ArrowDownRight,
  FolderKanban,
  Target,
  Calendar,
  Save,
  Trash2,
  Award,
  Sun,
  Moon,
  History as HistoryIcon,
  FolderOpen,
  EyeOff,
  Monitor,
  UserPlus,
  Truck,
  Pencil,
  Calculator,
  Info,
  Shield,
  Lock,
  Mail,
  CheckCheck,
  FolderPlus,
  Bell,
  FileCheck,
  Crown,
  LogOut,
  LogIn,
  FileSpreadsheet,
  Users,
  Eye,
  ArrowLeft,
  FileUp,
  Cpu,
  TrendingDown,
  Share2,
  User,
  PackageSearch,
  ArrowRight,
  Building2,
  Loader,
  ClipboardSignature,
  ArrowUp,
  UploadCloud,
  Zap,
  Globe,
  HelpCircle,
  AlertTriangle,
  Database,
  FileDown,
  BarChart3,
  Timer,
  AlertCircle,
  Trophy,
  FileText,
  Edit3,
  Check,
  Wallet,
  CreditCard,
  Sparkles,
  Medal,
  ArrowUpRight,
  CheckCircle2,
  LayoutGrid,
  List,
  ChevronUp,
  ChevronRight,
  PackageOpen,
  X,
  PieChart as PieIcon,
  ClipboardList,
  ClipboardCheck,
  Download,
  Phone,
  RefreshCw,
  Settings,
  MessageCircle,
  ShieldCheck,
  Rocket,
  Maximize2,
} from "lucide-react";
import {
  LabelList,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Legend,
  Label,
  Area,
  AreaChart,
  PieChart,
  ScatterChart,
  Scatter,
  ZAxis,
  Pie,
} from "recharts";
import { PiClockClockwise, PiChartLineUp, PiCurrencyCircleDollar, PiStack, PiWarningCircle, PiFilePdfDuotone } from "react-icons/pi";
import { TbClockHour4 } from "react-icons/tb";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import { AnimatePresence, motion } from "framer-motion";
import axios from 'axios';
import './styles.css';
import ReactGA from 'react-ga4';

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
/////////////////       NAV BAR.        //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

const NAVIGATION_TABS = [
  { id: "main", label: "Project Items", icon: <PackageOpen size={20} /> },
  { id: "mgmt", label: "Supplier Network", icon: <Users size={20} /> },
  { id: "quotes", label: "Supplier Quotes", icon: <FileSignature size={20} /> },
  { id: "comp", label: "Results", icon: <TrendingUp size={20} /> },
  { id: "reps", label: "Analytics", icon: <PieIcon size={20} /> },
];

const NavButton = React.memo(({ t, isActive, onClick }) => (
  <button
    onClick={() => onClick(t.id)}
    className={`flex-1 flex items-center justify-center gap-3 py-5 px-6 rounded-[22px] transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] group relative isolate h-full ${isActive
      ? "text-white scale-[1.02]"
      : "text-slate-400 dark:text-slate-500 hover:text-indigo-600 dark:hover:text-indigo-400 hover:scale-[1.01]"
      }`}
  >
    {/* DYNAMIC BACKGROUND (Active & Hover) */}
    <div
      className={`absolute inset-0 z-0 overflow-hidden rounded-[22px] transition-all duration-500 ease-out ${isActive
        ? "opacity-100"
        : "opacity-0 group-hover:opacity-100"
        }`}
    >
      {/* The Base Color: Solid for Active, Soft for Hover */}
      <div className={`absolute inset-0 transition-colors duration-500 ${isActive ? "bg-indigo-600" : "bg-indigo-50/50 dark:bg-indigo-900/20"
        }`} />

      {/* The 3D Depth Layer (Same for both) */}
      <div className={`absolute inset-0 shadow-[inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_6px_rgba(0,0,0,0.2)] ${isActive ? "opacity-100" : "opacity-40"
        }`} />

      {/* The Premium Sheen (Same for both) */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent opacity-40" />

      {/* Active-only Glow Shadow */}
      {isActive && (
        <div className="absolute inset-0 shadow-[0_10px_30px_-5px_rgba(79,70,229,0.5)]" />
      )}
    </div>

    {/* CONTENT CONTAINER */}
    <div className="relative z-10 flex flex-row items-center justify-center gap-3 pointer-events-none">
      {t.icon && (
        <div className={`flex items-center justify-center transition-all duration-500 ${isActive
          ? "text-white drop-shadow-md scale-110"
          : "text-slate-300 dark:text-slate-600 group-hover:text-indigo-500 group-hover:scale-110"
          }`}>
          {React.cloneElement(t.icon, {
            size: 20,
            strokeWidth: isActive ? 2.5 : 2
          })}
        </div>
      )}

      <span className={`text-[10px] uppercase tracking-[0.25em] transition-all duration-300 ${isActive
        ? "font-black text-white"
        : "font-bold group-hover:text-indigo-600 dark:group-hover:text-indigo-400"
        }`}>
        {t.label}
      </span>
    </div>
  </button>
));

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
/////////////////       PROJECTS        //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

const ProjectItemsRow = React.memo(
  ({ item, allItems = [], onSave, onRemove, onUpdateGlobal, setItemToDelete }) => {
    const [localItem, setLocalItem] = React.useState(item);
    const [isSaving, setIsSaving] = React.useState(false);

    // 1. Logic to check for duplicates
    // We check if any OTHER item in the list has the same REF
    const isDuplicate = React.useMemo(() => {
      if (!localItem.ref) return false;
      return allItems.some(
        (otherItem) =>
          otherItem.id !== localItem.id &&
          otherItem.ref?.toUpperCase().trim() === localItem.ref?.toUpperCase().trim()
      );
    }, [localItem.ref, allItems, localItem.id]);

    React.useEffect(() => {
      setLocalItem(item);
    }, [item.id, item.ref, item.desc, item.qty, item.unit]);

    const handleLocalChange = (field, value) => {
      setLocalItem((prev) => ({ ...prev, [field]: value }));
    };

    const handleBlur = () => {
      if (
        item.ref !== localItem.ref ||
        item.desc !== localItem.desc ||
        item.qty !== localItem.qty ||
        item.unit !== localItem.unit
      ) {
        onUpdateGlobal(localItem.id, localItem);
      }
    };

    const inputBase = `
      w-full px-3 py-2 bg-slate-50/30 dark:bg-slate-800/20 
      border border-slate-200/50 dark:border-slate-700/50 
      rounded-xl outline-none transition-all duration-200
      hover:border-indigo-300 dark:hover:border-indigo-800
      focus:bg-white dark:focus:bg-slate-800 
      focus:border-indigo-500 dark:focus:border-indigo-400 
      focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-400/5
    `;

    return (
      <tr className="group border-b border-slate-50 dark:border-slate-800/50 hover:bg-slate-50/80 dark:hover:bg-indigo-500/[0.02] transition-colors">
        {/* REF */}
        <td className="w-[15%] px-3 py-3">
          <div className="relative">
            <input
              type="text"
              value={localItem.ref || ""}
              onChange={(e) => handleLocalChange("ref", e.target.value)}
              onBlur={handleBlur}
              // 2. Conditional Styling: Red border if duplicate
              className={`${inputBase} font-bold uppercase text-xs tracking-wider ${isDuplicate
                ? "border-rose-500 text-rose-600 focus:border-rose-600 focus:ring-rose-500/10"
                : "text-slate-700 dark:text-slate-200"
                }`}
              placeholder="REF"
            />
            {/* 3. Small warning tooltip/icon */}
            {isDuplicate && (
              <span className="absolute -top-2 -right-1 flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-rose-500 text-[10px] text-white items-center justify-center font-black">!</span>
              </span>
            )}
          </div>
        </td>

        {/* DESCRIPTION */}
        <td className="w-[55%] px-3 py-3">
          <input
            type="text"
            value={localItem.desc || ""}
            onChange={(e) => handleLocalChange("desc", e.target.value)}
            onBlur={handleBlur}
            className={`${inputBase} font-medium text-slate-600 dark:text-slate-400 text-sm`}
            placeholder="Enter item description..."
          />
        </td>

        {/* QTY */}
        <td className="w-[10%] px-3 py-3 text-center">
          <input
            type="number"
            value={localItem.qty || ""}
            onChange={(e) => handleLocalChange("qty", Number(e.target.value))}
            onBlur={handleBlur}
            className={`${inputBase} font-black text-indigo-600 dark:text-indigo-400 text-center text-sm`}
          />
        </td>

        {/* UNIT */}
        <td className="w-[10%] px-3 py-3 text-center">
          <div className="relative">
            <select
              value={localItem.unit || ""}
              onChange={(e) => {
                const newUnit = e.target.value;
                handleLocalChange("unit", newUnit);
                // Trigger global update immediately for selects as there is no 'blur'
                onUpdateGlobal(localItem.id, { ...localItem, unit: newUnit });
              }}
              className={`${inputBase} appearance-none font-bold text-slate-400 dark:text-slate-500 text-center text-[10px] uppercase cursor-pointer pr-6`}
            >
              <option value="" disabled>
                Unit
              </option>
              <optgroup label="Count">
                <option value="PCS">PCS</option>
                <option value="UNIT">UNIT</option>
                <option value="SET">SET</option>
              </optgroup>
              <optgroup label="Mass">
                <option value="KG">KG</option>
                <option value="GRM">GRM</option>
                <option value="TON">TON</option>
              </optgroup>
              <optgroup label="Length">
                <option value="M">M</option>
                <option value="LM">LM</option>
                <option value="MM">MM</option>
              </optgroup>
              <optgroup label="Area">
                <option value="M2">M²</option>
                <option value="FT2">FT²</option>
              </optgroup>
              <optgroup label="Volume">
                <option value="L">L</option>
                <option value="ML">ML</option>
                <option value="M3">M³</option>
              </optgroup>
              <optgroup label="Time">
                <option value="HR">HR</option>
                <option value="DAY">DAY</option>
              </optgroup>
            </select>
            <ChevronDown
              size={10}
              className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400"
            />
          </div>
        </td>

        {/* ACTIONS */}
        <td className="w-[10%] px-4 py-3 text-center">
          <div className="flex justify-center items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-200">
            <button
              onClick={async () => {
                if (isDuplicate) {
                  alert("Duplicate REF numbers are not allowed.");
                  return;
                }
                setIsSaving(true);
                await onSave(localItem.id, localItem);
                setIsSaving(false);
              }}
              disabled={isSaving}
              className={`p-2 rounded-xl shadow-sm border transition-all ${isSaving
                ? "bg-slate-100 text-slate-300 border-slate-200"
                : isDuplicate
                  ? "bg-rose-50 text-rose-300 border-rose-100 cursor-not-allowed"
                  : "bg-white dark:bg-slate-800 text-emerald-500 border-emerald-100 dark:border-emerald-500/20 hover:bg-emerald-500 hover:text-white"
                }`}
            >
              {isSaving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />}
            </button>
            <button
              onClick={() => setItemToDelete(localItem)}
              className="p-2 bg-white dark:bg-slate-800 text-rose-400 border border-rose-100 dark:border-rose-500/20 rounded-xl hover:bg-rose-500 hover:text-white"
            >
              <Trash2 size={16} />
            </button>
          </div>
        </td>
      </tr>
    );
  }
);

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
/////////////////       SUPPLIERS       //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

const SupplierRow = React.memo(
  ({
    s,
    onUpdate,
    onSave,
    setSupplierToDelete,
    setActiveSup,
    setIsViewOnly,
    setIsSupModalOpen,
  }) => {
    const [local, setLocal] = React.useState(s);
    const fileInputRef = React.useRef(null);

    const handleViewClick = (supplier) => {
      setActiveSup(supplier);
      setIsViewOnly(true); // Lock the fields
      setIsSupModalOpen(true); // 🚩 THIS OPENS THE MODAL
    };

    //Saving animation useState for clicking the "Save" icon in the supplier row
    const [isSaving, setIsSaving] = React.useState(false);
    const [isSavingView, setIsSavingView] = React.useState(false);
    //Deleting animation useState for clicking the "Save" icon in the supplier row
    const [isDeleting, setIsDeleting] = React.useState(false);

    React.useEffect(() => {
      setLocal(s);
    }, [s]);

    const getBeeStyles = (level) => {
      // Shared base styles for the dropdown/badge
      const base = "border transition-all duration-300 ";

      // Level 1 - 2 == Green
      if (["Level 1", "Level 2"].includes(level)) {
        return `${base} bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-200 dark:border-emerald-500/20 shadow-emerald-500/5`;
      }

      // Level 3 - 5 == Orange
      if (["Level 3", "Level 4", "Level 5"].includes(level)) {
        return `${base} bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-200 dark:border-orange-500/20 shadow-orange-500/5`;
      }

      // Level 6 - 8 and Non-Compliant == Red
      return `${base} bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-200 dark:border-rose-500/20 shadow-rose-500/5`;
    };

    const handleChange = (field, val) => {
      const updated = { ...local, [field]: val };
      setLocal(updated);
      onUpdate(s.id, updated);
    };



    const inputBase = `
    w-full px-3 py-2 bg-slate-50/30 dark:bg-slate-800/20 
    border border-slate-200/50 dark:border-slate-700/50 
    rounded-xl outline-none transition-all duration-200
    hover:border-indigo-300 dark:hover:border-indigo-800
    focus:bg-white dark:focus:bg-slate-800 
    focus:border-indigo-500 dark:focus:border-indigo-400 
    focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-400/5
  `;

    return (
      <tr className="group border-b border-slate-50 dark:border-slate-800/50 hover:bg-slate-50/80 dark:hover:bg-indigo-500/[0.02] transition-colors">
        <td className="px-3 py-3">
          <input
            type="text"
            value={local.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
            className={`${inputBase} font-bold text-slate-700 dark:text-slate-200 text-sm`}
            placeholder="Supplier Name"
          />
        </td>

        <td className="px-3 py-3">
          <input
            type="email"
            value={local.email || ""}
            onChange={(e) =>
              handleChange("email", e.target.value.toLowerCase().trim())
            }
            className={`${inputBase} font-medium text-slate-600 dark:text-slate-400 text-sm`}
            placeholder="email@example.com"
          />
        </td>

        <td className="px-3 py-3">
          <input
            type="text"
            value={local.phone || ""}
            onChange={(e) => handleChange("phone", e.target.value)}
            className={`${inputBase} font-bold text-slate-500 text-sm`}
            placeholder="+27..."
          />
        </td>

        <td className="px-3 py-3">
          <div className="relative">
            <select
              value={local.beeLevel || "Non-Compliant"}
              onChange={(e) => handleChange("beeLevel", e.target.value)}
              className={`${inputBase} ${getBeeStyles(local.beeLevel)} 
        appearance-none font-black text-center text-[10px] uppercase 
        tracking-widest cursor-pointer pr-4 transition-all duration-300 shadow-sm`}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8].map((lvl) => (
                <option
                  key={lvl}
                  value={`Level ${lvl}`}
                  className="bg-white dark:bg-slate-900 text-slate-900 dark:text-white"
                >
                  Level {lvl}
                </option>
              ))}
              <option
                value="Non-Compliant"
                className="bg-white dark:bg-slate-900 text-slate-900 dark:text-white"
              >
                Non-Compliant
              </option>
            </select>

            {/* Tiny custom arrow to indicate it's a dropdown */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none opacity-50">
              <ChevronDown size={10} />
            </div>
          </div>
        </td>

        <td className="px-4 py-3 text-right">
          {/* Supplier Action Items */}
          <div className="flex justify-end items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-200 transform translate-x-2 group-hover:translate-x-0">
            <button
              onClick={async () => {
                setIsSaving(true);
                try {
                  await onSave(s.id);
                  // Optional: Add a "Success" flash here if you want
                } catch (err) {
                  console.error("Save failed", err);
                } finally {
                  setIsSaving(false);
                }
              }}
              disabled={isSaving}
              className={`p-2 border rounded-xl transition-all flex items-center justify-center ${isSaving
                ? "bg-slate-50 dark:bg-slate-800 text-slate-400 border-slate-200 cursor-wait"
                : "bg-white dark:bg-slate-800 text-emerald-500 border-emerald-100 dark:border-emerald-500/20 hover:bg-emerald-500 hover:text-white"
                }`}
            >
              {isSaving ? (
                <Loader2 size={16} className="animate-spin" />
              ) : (
                <Save size={16} />
              )}
            </button>
            <button
              onClick={() => handleViewClick(s)}
              disabled={isSavingView}
              className={`p-2 border rounded-xl transition-all flex items-center justify-center ${isSavingView
                ? "bg-slate-50 dark:bg-slate-800 text-slate-400 border-slate-200 cursor-wait"
                : "bg-white dark:bg-slate-800 text-orange-500 border-orange-100 dark:border-orange-500/20 hover:bg-orange-500 hover:text-white"
                }`}
            >
              {isSavingView ? (
                <Loader2 size={16} className="animate-spin" />
              ) : (
                <Eye size={16} />
              )}
            </button>
            <button
              onClick={() => setSupplierToDelete(s)} // Open the modal with this supplier's data
              className="p-2 bg-white dark:bg-slate-800 text-rose-400 border border-rose-100 dark:border-rose-500/20 rounded-xl hover:bg-rose-500 hover:text-white transition-all"
            >
              <Trash2 size={16} />
            </button>
          </div>
        </td>
      </tr>
    );
  }
);

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
/////////////////        QUOTES         //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

const SupplierQuoteCard = React.memo(
  ({
    s,
    supList,
    sups,
    setDuplicateErrorSup,
    updQuoteSup,
    openQuoteModal,
    shareToWhatsApp,
    setQuoteSupToDelete,
    currentProjectName,
    quote,
    itemSearchQuery,
    updQuote,
    deleteItemQuote,
    uploadQuoteItems,
    user,
    handleAIDocumentProcess
  }) => {
    const [isImporting, setIsImporting] = React.useState(false); //Manual Import Loader
    const [isImporting2, setIsImporting2] = React.useState(false); //AI Loader
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [isAssigning, setIsAssigning] = React.useState(false);
    const [isShaking, setIsShaking] = React.useState(false);
    const manualFileInputRef = React.useRef(null);
    const aiFileInputRef = React.useRef(null);

    // This prevents the card from "vanishing" or "locking" during parent updates.
    const selectRef = React.useRef(null);

    const handleSelectChange = async (e) => {
      const newSid = e.target.value;
      const currentSid = s.sid || "";

      // 1. Path A: User clears the selection
      if (!newSid || newSid === "") {
        setIsAssigning(true);
        try {
          await updQuoteSup(s.id, "");
        } finally {
          setIsAssigning(false);
        }
        return;
      }

      // 2. Path B: THE DUPLICATE CHECK
      const isDuplicate = sups?.some((otherSup) => {
        return (
          String(otherSup.sid) === String(newSid) &&
          String(otherSup.id) !== String(s.id)
        );
      });

      if (isDuplicate) {
        setIsShaking(true);
        // Force the dropdown back to whatever the parent 's.sid' currently is
        if (selectRef.current) selectRef.current.value = currentSid;

        const existingSupInfo = supList.find(
          (sl) => String(sl.id) === String(newSid)
        );
        setDuplicateErrorSup(existingSupInfo || { name: "This Supplier" });
        setTimeout(() => setIsShaking(false), 500);
        return;
      }

      // 3. Path C: SUCCESS PATH
      setIsAssigning(true);
      try {
        await updQuoteSup(s.id, newSid);
      } catch (error) {
        console.error("Assignment Failed:", error);
        // If DB fails, reset UI to existing sid
        if (selectRef.current) selectRef.current.value = currentSid;
      } finally {
        setIsAssigning(false);
      }
    };

    return (
      <div
        className={`bg-white/70 dark:bg-slate-900/40 backdrop-blur-xl rounded-[32px] border border-slate-200/50 dark:border-white/5 shadow-sm overflow-hidden flex flex-col transition-all duration-300 ${isShaking ? "animate-shake" : ""
          }`}
      >
        {/* TOP BAR */}
        <div className="p-6 bg-slate-50/50 dark:bg-slate-950 flex flex-col sm:flex-row items-center gap-4 relative">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.05),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

          <div className="bg-white dark:bg-slate-700 p-3 rounded-2xl shadow-sm text-indigo-600 dark:text-indigo-400 z-10">
            <Building2 size={24} />
          </div>

          <div className="flex-1 flex items-center gap-2 relative z-10">
            <div className="relative w-full group">
              <select
                ref={selectRef}
                disabled={isAssigning}
                value={s.sid || ""}
                onChange={handleSelectChange}
                className={`
        w-full px-4 py-2.5 
        bg-slate-50 dark:bg-slate-800/50 
        hover:bg-slate-100 dark:hover:bg-slate-800
        border border-slate-200 dark:border-slate-700 
        rounded-2xl 
        font-black text-lg 
        outline-none transition-all duration-200
        appearance-none cursor-pointer
        dark:text-white
        focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500
        ${isAssigning ? "opacity-50" : "opacity-100"}
      `}
              >
                <option value="" className="dark:bg-slate-900">Select Supplier...</option>
                {supList.map((sl) => (
                  <option key={sl.id} value={sl.id} className="dark:bg-slate-900">
                    {sl.name}
                  </option>
                ))}
              </select>

              {/* 🚩 Custom Dropdown Arrow (Since appearance-none hides the native one) */}
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400 group-hover:text-indigo-500 transition-colors">
                <ChevronDown size={18} />
              </div>
            </div>

            {isAssigning && (
              <div className="animate-in fade-in zoom-in-75">
                <Loader2 size={18} className="text-indigo-500 animate-spin" />
              </div>
            )}
          </div>

          <details
            className="relative group select-none"
          >
            {/* THE TRIGGER */}
            <summary className="list-none cursor-pointer p-2.5 bg-white/50 dark:bg-slate-800/40 text-slate-400 hover:text-indigo-600 rounded-2xl border border-slate-200/50 dark:border-slate-700/50 transition-all outline-none">
              <MoreHorizontal
                size={20}
                className="group-open:rotate-90 group-open:text-indigo-600 transition-all duration-300 ease-out"
              />
            </summary>

            {/* THE DROPDOWN CONTENT - Animated Pan Out */}
            <div className="absolute right-0 top-full mt-2 flex items-center gap-1.5 p-1.5 bg-white dark:bg-slate-900 rounded-[1.25rem] border border-slate-200/60 dark:border-white/10 shadow-2xl shadow-indigo-200/20 dark:shadow-none z-50 
              origin-top-right 
              animate-in fade-in zoom-in-95 slide-in-from-top-4 slide-in-from-right-2 
              duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
            >

              {/* 1. Manual Import Excel */}
              <div className="flex items-center">
                <button
                  type="button"
                  title="Import Excel/CSV"
                  // 🚩 The Fix: Manual trigger + stopPropagation prevents the menu from closing/glitching
                  onClick={(e) => {
                    e.stopPropagation();
                    manualFileInputRef.current?.click();
                  }}
                  disabled={!s.sid || isImporting}
                  className={`p-2 rounded-xl transition-all select-none ${!s.sid || isImporting
                    ? "opacity-30 cursor-not-allowed text-slate-300"
                    : "text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 cursor-pointer"
                    }`}
                >
                  {isImporting ? <Loader2 size={18} className="animate-spin" /> : <Upload size={18} />}
                </button>

                {/* 🚩 The Hidden Input: Moved outside the button but keeps the Ref */}
                <input
                  ref={manualFileInputRef}
                  type="file"
                  className="hidden"
                  accept=".xlsx, .xls, .csv"
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;

                    setIsImporting(true);
                    try {
                      // Pass the FILE directly, not the event (Cleaner for Step 2)
                      await uploadQuoteItems(file, s.id);
                    } finally {
                      setIsImporting(false);
                      e.target.value = ""; // Reset so you can upload the same file twice
                    }
                  }}
                />
              </div>

              {/* 2. AI PDF Parse */}
              {(() => {
                const userPlan = user?.plan || "free";
                const hasAIAccess = userPlan === "pro" || userPlan === "businessPlus";
                const canProcess = !!(hasAIAccess && s?.sid && !isImporting2);

                return (
                  <div className="relative flex items-center justify-center">
                    <button
                      type="button"
                      // 🚩 Tooltip logic: hides when processing or restricted
                      title={!hasAIAccess ? "Upgrade to Pro for AI Parsing" : isImporting2 ? "" : "AI PDF Parser"}
                      disabled={!canProcess}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents menu close
                        aiFileInputRef.current?.click();
                      }}
                      className={`p-2 rounded-xl transition-all flex items-center justify-center group/item select-none ${canProcess
                        ? "text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 cursor-pointer"
                        : "text-slate-300 dark:text-slate-600 cursor-not-allowed"
                        }`}
                    >
                      {/* Icon Logic */}
                      {isImporting2 ? (
                        <Loader2 size={18} className="animate-spin text-indigo-500" />
                      ) : !hasAIAccess ? (
                        <Lock size={16} className="opacity-40" />
                      ) : (
                        <BrainCircuit size={18} className="group-hover/item:scale-110 transition-transform" />
                      )}
                    </button>

                    {/* 🚩 Hidden File Input controlled by Ref */}
                    <input
                      ref={aiFileInputRef}
                      type="file"
                      accept=".pdf"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        if (!hasAIAccess || !file) return;

                        // Use the internal card state or parent function
                        if (typeof setIsImporting2 === 'function') setIsImporting2(true);

                        try {
                          await handleAIDocumentProcess(file, s.id);
                        } finally {
                          if (typeof setIsImporting2 === 'function') setIsImporting2(false);
                          e.target.value = "";
                        }
                      }}
                    />
                  </div>
                );
              })()}

              <div className="w-[1px] h-4 bg-slate-200 dark:bg-slate-800 mx-1" />

              {/* 3. Calculator */}
              <button title="Quote Costs" disabled={!s.sid} onClick={() => openQuoteModal(s)} className={`p-2 rounded-xl transition-all ${!s.sid ? "opacity-30 cursor-not-allowed" : "text-slate-400 hover:text-orange-600 hover:bg-orange-50 dark:hover:bg-orange-500/10"}`}>
                <Calculator size={18} />
              </button>

              <div className="w-[1px] h-4 bg-slate-200 dark:bg-slate-800 mx-1" />

              {/* 4. WhatsApp */}
              <button title="Share to WhatsApp" disabled={!s.sid} onClick={() => shareToWhatsApp(s, currentProjectName)} className={`p-2 rounded-xl transition-all ${!s.sid ? "opacity-30 cursor-not-allowed" : "text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-500/10"}`}>
                <MessageCircle size={18} />
              </button>

              {/* 5. Mail */}
              <button
                title="Send Email"
                disabled={!s.sid}
                onClick={() => {
                  // 1. Core Fix: Look up the full profile from the registry using the supplier ID
                  const fullProfile = supList.find(
                    (profile) => profile.id === (s.sid || s.id)
                  );

                  // 2. Safely extract the email address from the resolved profile record
                  const targetEmail = fullProfile?.email || s.email || s.supplierEmail || "";

                  if (targetEmail) {
                    // Opens the native default OS mail system with the address pre-filled
                    window.location.href = `mailto:${targetEmail}?subject=Request%20for%20Quote%20-%20QuoPro`;
                  } else {
                    alert(`No email address found for ${fullProfile?.name || "this supplier"}.`);
                  }
                }}
                className={`p-2 rounded-xl transition-all ${!s.sid
                  ? "opacity-30 cursor-not-allowed"
                  : "text-slate-400 hover:text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-500/10"
                  }`}
              >
                <Mail size={18} />
              </button>

              <div className="w-[1px] h-4 bg-slate-200 dark:bg-slate-800 mx-1" />

              {/* 6. Delete */}
              <button title="Delete Quote Slot" onClick={() => setQuoteSupToDelete(s)} className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-xl transition-all">
                <Trash2 size={18} />
              </button>
            </div>
          </details>
        </div>

        {/* TABLE SECTION */}
        <div
          className="p-6 overflow-y-auto max-h-[500px] relative min-h-[300px] flex flex-col scrollbar-thin 
          [&::-webkit-scrollbar]:w-1.5
          [&::-webkit-scrollbar-track]:bg-transparent
          [&::-webkit-scrollbar-thumb]:bg-slate-200
          [&::-webkit-scrollbar-thumb]:rounded-full
          dark:[&::-webkit-scrollbar-thumb]:bg-slate-700
          dark:[&::-webkit-scrollbar-thumb]:hover:bg-slate-600"
        >
          {/* 🚩 FIX: Check s.sid directly to show/hide the table */}
          {!s.sid ? (
            <div className="flex-1 flex flex-col items-center justify-center py-12 px-6 text-center animate-in fade-in zoom-in-95 duration-500">
              <div className="w-16 h-16 bg-orange-50 dark:bg-orange-500/10 rounded-2xl flex items-center justify-center mb-4 border-orange-100 dark:border-orange-500/20">
                <UserPlus size={28} className="text-orange-500" />
              </div>
              <h4 className="text-base font-black text-slate-800 dark:text-slate-200 mb-1">
                No Supplier Assigned
              </h4>
              <p className="text-xs text-slate-400 font-bold tracking-tight max-w-[200px]">
                Please assign a vendor
              </p>
            </div>
          ) : (
            <table className="w-full table-fixed animate-in fade-in slide-in-from-bottom-2 duration-500">
              <thead>
                <tr className="text-left text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
                  <th className="pb-4 w-1/3">Item Ref</th>
                  <th className="pb-4 w-1/4">Price (R)</th>
                  <th className="pb-4 w-1/4 text-right">Lead Time</th>
                  <th className="pb-4 w-12"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50 dark:divide-slate-800/30">
                {Array.isArray(quote) && quote.length > 0 ? (
                  quote
                    .filter((item) => {
                      const query = (itemSearchQuery || "").toLowerCase();
                      return (
                        (item.ref || "").toLowerCase().includes(query) ||
                        (item.desc || "").toLowerCase().includes(query)
                      );
                    })
                    .map((item) => (
                      <QuoteItemRow
                        key={item.id}
                        item={item}
                        supplierId={s.id}
                        itemQuote={s.quotes?.[item.ref] || {}}
                        updQuote={updQuote}
                        deleteItemQuote={deleteItemQuote}
                      />
                    ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="py-10 text-center text-slate-400 font-bold"
                    >
                      No Items Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
);

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
/////////////////        QUOTES         //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

const QuoteItemRow = React.memo(
  ({ item, supplierId, itemQuote, updQuote, deleteItemQuote }) => {
    const [localPrice, setLocalPrice] = React.useState(itemQuote.price || "");
    const [localDays, setLocalDays] = React.useState(itemQuote.days || "");
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [isDeleting, setIsDeleting] = React.useState(false);

    // Sync with global state if it changes externally (e.g., AI scan)
    React.useEffect(() => {
      setLocalPrice(itemQuote.price || "");
      setLocalDays(itemQuote.days || "");
    }, [itemQuote.price, itemQuote.days]);

    const handleBlur = async (field, value) => {
      setIsUpdating(true);
      await updQuote(supplierId, item.ref, field, value);
      setIsUpdating(false);
    };

    return (
      <tr className="group hover:bg-indigo-50/30 dark:hover:bg-indigo-500/[0.02] transition-all">
        <td className="py-4 pr-2">
          <div className="font-bold text-slate-800 dark:text-slate-200 truncate">
            {item.ref || "N/A"}
          </div>
          <div className="text-[9px] text-slate-400 dark:text-slate-600 font-bold uppercase tracking-wider truncate">
            {item.desc}
          </div>
        </td>
        <td className="py-4 relative">
          <input
            type="number"
            value={localPrice}
            onChange={(e) => setLocalPrice(e.target.value)}
            onBlur={(e) => handleBlur("price", e.target.value)}
            className="w-full max-w-[120px] px-4 py-2.5 bg-slate-100/50 dark:bg-slate-800/40 border-transparent rounded-xl font-black text-indigo-600 dark:text-indigo-400 outline-none transition-all text-sm focus:bg-white"
            placeholder="0.00"
          />
          {isUpdating && (
            <Loader2
              size={10}
              className="absolute right-6 top-7 animate-spin text-indigo-400"
            />
          )}
        </td>
        <td className="py-4 text-right">
          <input
            type="number"
            value={localDays}
            onChange={(e) => setLocalDays(e.target.value)}
            onBlur={(e) => handleBlur("days", e.target.value)}
            className="w-full max-w-[80px] px-4 py-2.5 bg-orange-50/50 dark:bg-orange-500/10 border-transparent rounded-xl font-black text-orange-600 dark:text-orange-400 text-right outline-none transition-all text-sm ml-auto focus:bg-white"
            placeholder="0"
          />
        </td>
        <td className="py-4 text-center">
          <button
            onClick={async () => {
              setIsDeleting(true); // 1. Start the Orange spinner
              try {
                await deleteItemQuote(supplierId, item.ref); // 2. Run the actual delete
              } catch (err) {
                console.error(err);
              } finally {
                setIsDeleting(false); // 3. Stop spinner (if row still exists)
              }
            }}
            disabled={isDeleting} // Prevent double-clicks
            className={`p-2 transition-all duration-300 ${isDeleting
              ? "opacity-100 text-orange-500"
              : "opacity-0 group-hover:opacity-100 text-slate-300 dark:text-slate-700 hover:text-red-500"
              }`}
          >
            {isDeleting ? (
              <Loader2 size={14} className="animate-spin" />
            ) : (
              <Trash2 size={14} />
            )}
          </button>
        </td>
      </tr>
    );
  }
);

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
/////////////////  SPLIT MATRIX MODAL   //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

const SplitMatrixRow = React.memo(({ item, winner, idx }) => {
  // 🚩 CORE LOGIC
  const winnerItemPrice = parseFloat(winner?.quotes?.[item.ref]?.price || 0);
  const bestPrice = parseFloat(item.price || 0);

  // Identify if this row is sourced from the primary winner
  const isPreferred = item.isFromOverallWinner;

  const itemSaving =
    winnerItemPrice > bestPrice ? winnerItemPrice - bestPrice : 0;
  const hasSavings = itemSaving > 0;
  const beatGap = (parseFloat(item.runnerUpPrice) || 0) - bestPrice;

  return (
    <tr className="group">
      <td colSpan="7" className="px-12 pb-2.5">
        <div
          className={`flex items-center w-full transition-all duration-300 py-4 border-2 rounded-2xl relative overflow-hidden ${isPreferred
            ? "bg-indigo-50/30 dark:bg-indigo-500/5 border-indigo-200 dark:border-indigo-500/20 shadow-sm"
            : hasSavings
              ? "bg-white dark:bg-slate-900 border-emerald-100 dark:border-emerald-900/30 hover:border-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-500/10 shadow-sm hover:shadow-emerald-500/20"
              : "bg-white dark:bg-slate-900 border-slate-50 dark:border-slate-800 hover:border-indigo-400 hover:bg-slate-50"
            }`}
        >
          {/* 🚩 VISUAL BAR: Indigo for Winner, Emerald for Savings */}
          {(isPreferred || hasSavings) && (
            <div
              className={`absolute left-0 top-0 bottom-0 w-1.5 ${isPreferred ? "bg-indigo-500" : "bg-emerald-500"
                }`}
            />
          )}

          <div className="w-[10%] pl-8 font-black text-xs text-indigo-600">
            {item.ref}
          </div>

          <div className="w-[28%] pr-8">
            <p className="font-bold text-slate-700 dark:text-slate-200 text-xs truncate">
              {item.desc}
            </p>
            {/* Show "Consolidated" label if it's the winner, otherwise show the "Beats runner-up" logic */}
            {isPreferred ? (
              <p className="text-[9px] text-indigo-600 dark:text-indigo-400 font-black uppercase tracking-widest mt-0.5 flex items-center gap-1">
                <span className="w-1 h-1 rounded-full bg-indigo-500" /> Primary
                Winner (Consolidated)
              </p>
            ) : (
              hasSavings &&
              beatGap > 0 && (
                <p className="text-[9px] text-emerald-600 dark:text-emerald-400 font-medium mt-0.5 animate-in fade-in slide-in-from-left-2">
                  <span className="font-black uppercase tracking-tight">
                    Best price
                  </span>{" "}
                  beats winning vendor by{" "}
                  <span className="underline decoration-emerald-500/30 font-bold">
                    R
                    {beatGap.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                  </span>
                </p>
              )
            )}
          </div>

          <div className="w-[18%]">
            <span
              className={`inline-block px-3 py-1 rounded-lg text-[10px] font-black uppercase border transition-colors ${isPreferred
                ? "bg-indigo-100 dark:bg-indigo-500/20 text-indigo-600 dark:text-indigo-400 border-indigo-200 dark:border-indigo-500/30"
                : "bg-slate-100/50 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border-slate-200 dark:border-slate-700"
                }`}
            >
              {item.supplierName || "No Bid"}
            </span>
          </div>

          <div className="w-[6%] text-center text-slate-400 font-black text-xs">
            {item.qty}
          </div>

          <div className="w-[12%] text-right font-bold text-slate-500 text-xs pr-6">
            R
            {bestPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </div>

          <div className="w-[12%] text-right pr-6">
            {hasSavings ? (
              <span className="text-[10px] font-black text-white bg-emerald-600 px-3 py-1 rounded-full shadow-lg shadow-emerald-600/20">
                +R
                {itemSaving.toLocaleString(undefined, {
                  maximumFractionDigits: 0,
                })}
              </span>
            ) : isPreferred ? (
              <span className="text-[10px] font-black text-indigo-500/60 uppercase tracking-tighter">
                — Best —
              </span>
            ) : (
              <span className="text-slate-300 text-xs pr-6">—</span>
            )}
          </div>

          <div className="w-[14%] text-right pr-6 font-black text-slate-900 dark:text-white text-sm">
            R
            {(bestPrice * (parseFloat(item.qty) || 0)).toLocaleString(
              undefined,
              { minimumFractionDigits: 2 }
            )}
          </div>
        </div>
      </td>
    </tr>
  );
});

//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
///////////////// SUPPLIER STATS MODAL  //////////////////
/////////////////                       //////////////////
/////////////////                       //////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////

/* eslint-disable */
if (typeof window !== "undefined") {
  const resizeObserverError =
    "ResizeObserver loop completed with undelivered notifications.";

  // This intercepts the error and tells the browser "Nothing to see here"
  const originalError = console.error;

  window.addEventListener("error", (e) => {
    if (
      e.message === resizeObserverError ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

// --- Constants ---
const COLORS = [
  "#4f46e5",
  "#f59e0b",
  "#10b981",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#06b6d4",
];

const STATUS_OPTIONS = [
  "Draft",
  "In Progress",
  "Awaiting Quotes",
  "Analysing",
  "Completed",
];
const BACKEND_URL = "https://quopro-backend.onrender.com";

// 1. Badge Styles (Soft background with matching text/border)
const getStatusStyles = (status) => {
  switch (status) {
    case "Draft":
      return "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800/50 dark:text-slate-400 dark:border-slate-700";
    case "In Progress":
      return "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800";
    case "Awaiting Quotes":
      return "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/20 dark:text-purple-400 dark:border-purple-800";
    case "Analysing":
      return "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-800";
    case "Completed":
      return "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800";
    case "Pending Approval":
      return "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-900/20 dark:text-rose-400 dark:border-rose-800";
    default:
      return "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800/50 dark:text-slate-400";
  }
};

// 2. Progress Bar Styles (Solid vibrant colors with your glow logic)
const getStatusProgressColor = (status) => {
  if (!status) return "bg-indigo-600";

  switch (status) {
    case "Draft":
      return "bg-slate-500";
    case "In Progress":
      return "bg-blue-500";
    case "Awaiting Quotes":
      return "bg-purple-500"; // Matches Amber Glow
    case "Analysing":
      return "bg-amber-500";
    case "Completed":
      return "bg-emerald-500"; // Matches Emerald Glow
    default:
      return "bg-indigo-600";
  }
};

// Add this inside your component
const validatePassword = (pass) => {
  // Requirements: 8+ chars, at least one number, one uppercase
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return regex.test(pass);
};

const SupplierScorecard = ({
  supplier,
  rank,
  sups,
  user,
  workspace,
  quote,
  qp_stats,
  qp_FinalWinner,
  qp_secondary,
  supList,
}) => {
  const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);

  const activePlanPBP = (workspace?.plan || user?.plan || "starter").toLowerCase().trim();
  const isBusiness = activePlanPBP === "businessplus";
  const isStarter = activePlanPBP === "starter";

  // 1. STABLE MATH LOGIC (Calculated once per render, not inside the JSX)
  const winCost = qp_FinalWinner?.cost || 0;
  const runCost = qp_secondary?.cost || winCost;
  const priceDiffRaw = runCost - winCost;
  const priceDiffPercent =
    winCost > 0 ? Math.round(((runCost - winCost) / winCost) * 100) : 0;

  const winnerOriginalData = sups?.find(
    (s) => String(s.sid || s.id) === String(qp_FinalWinner?.id)
  );
  const runnerUpOriginalData = sups?.find(
    (s) => String(s.sid || s.id) === String(qp_secondary?.id)
  );

  const winDays = parseFloat(winnerOriginalData?.leadTime) || 0;
  const runDays = parseFloat(runnerUpOriginalData?.leadTime) || 0;
  const leadScoreComp =
    winDays > 0 ? Math.round((runDays / winDays) * 100) : 100;

  const winItemsCount = Object.keys(winnerOriginalData?.quotes || {}).length;
  const totalProjectItems = quote?.length || 1;

  const winProfile = (supList || []).find(
    (s) => String(s.id) === String(qp_FinalWinner?.id)
  );
  const winLevel = winProfile?.beeLevel
    ? parseInt(winProfile.beeLevel.replace(/\D/g, ""))
    : 9;

  const winCovScore = qp_FinalWinner ? Math.round(qp_FinalWinner.coverage) : 0;
  const beeVisualScore = Math.max(0, 110 - winLevel * 10);

  const realStats = [
    {
      id: "price",
      label: "Winner Savings",
      score: `R ${priceDiffRaw.toLocaleString()}`,
      visual: 100,
      color: "from-emerald-400 to-teal-500",
      bg: "bg-emerald-500/5",
      icon: <TrendingUp size={16} />,
      tooltip: `Saving R ${priceDiffRaw.toLocaleString()} (${priceDiffPercent}% cheaper).`,
    },
    {
      id: "lead",
      label: "Delivery Performance",
      // 🟢 EASY TO UNDERSTAND: Show the actual days
      score: `${qp_FinalWinner?.leadTime} Days`,

      // 📊 VISUAL CONTEXT: The bar shows they are 98% efficient compared to others
      visual: leadScoreComp,

      color: "from-orange-400 to-orange-600",
      bg: "bg-orange-50/50 dark:bg-orange-500/5",
      icon: <Timer size={14} />,

      // 💡 THE EXPLAINER: Use the tooltip to provide the "Advantage" context
      tooltip:
        leadScoreComp >= 100
          ? "This is the fastest delivery time available for this project."
          : `This option is ${leadScoreComp}% as fast as the market leader.`,
    },
    {
      id: "cov",
      label: "Coverage",
      score: `${winCovScore}%`,
      visual: winCovScore,
      color: "from-sky-400 to-indigo-600",
      bg: "bg-sky-500/5",
      icon: <PackageCheck size={16} />,
      tooltip: `Winner covers ${winCovScore}% of project items.`,
    },
    {
      id: "bee",
      label: "B-BBEE Status",
      score: `${beeVisualScore}%`,
      visual: beeVisualScore,
      color: "from-indigo-600 to-purple-500",
      bg: "bg-indigo-500/5",
      icon: <ShieldCheck size={16} />,
      tooltip: `B-BBEE Level ${winLevel} Advantage.`,
    },
  ];

  const getRankColor = (lvl) => {
    if (lvl <= 2) return "text-emerald-500";
    if (lvl <= 5) return "text-orange-500";
    return "text-rose-500";
  };

  const beeLevelRaw = supplier?.beeLevel;
  const displayBeeLevel =
    typeof beeLevelRaw === "string"
      ? parseInt(beeLevelRaw.replace(/\D/g, ""))
      : parseInt(beeLevelRaw) || 9;

  return (
    <div className="flex flex-col gap-4 w-full h-full">
      {/* --- RUNNER UP SUPPLIER CARD --- */}
      <div className="bg-white dark:bg-slate-900 rounded-[2rem] p-6 border border-slate-100 dark:border-slate-800 shadow-xl relative overflow-hidden group">
        <div className="relative z-10 flex justify-between items-center gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span
                className={`text-[10px] font-black uppercase tracking-widest ${getRankColor(
                  displayBeeLevel
                )}`}
              >
                Rank #{rank}
              </span>
              <span className="text-[10px] font-bold text-slate-400 uppercase">
                Alternative
              </span>
            </div>
            <h3 className="text-xl font-black text-slate-900 dark:text-white truncate">
              {supplier?.name || "Runner Up"}
            </h3>
          </div>
          <div className="h-12 w-12 bg-slate-50/50 dark:bg-white/5 rounded-2xl flex items-center justify-center border border-slate-100 dark:border-white/10">
            <Users className="text-slate-400" size={20} />
          </div>
        </div>
      </div>

      {/* --- EXECUTIVE SUMMARY --- */}
      <div className="bg-white dark:bg-slate-900 rounded-[2.5rem] p-8 border border-slate-100 dark:border-slate-800 shadow-xl relative overflow-hidden transition-all duration-500 flex-grow flex flex-col">

        {/* 🔒 PREMIUM UPGRADE OVERLAY LAYER (Only renders for Starter users) */}
        {isStarter && (
          <div
            onClick={() => setShowPricingModal(true)}
            className="absolute inset-0 z-20 bg-slate-500/5 dark:bg-slate-950/20 cursor-pointer flex flex-col items-center justify-center p-6 text-center group/overlay backdrop-blur-[2px] transition-all duration-300 hover:bg-slate-500/10 dark:hover:bg-slate-950/30"
          >
            <div className="p-4 bg-white dark:bg-slate-900 border border-slate-100 dark:border-white/5 rounded-3xl shadow-xl transition-all duration-300 group-hover/overlay:scale-110 group-hover/overlay:shadow-amber-500/10 text-2xl mb-3">
              🔒
            </div>
            <p className="text-[11px] font-black uppercase tracking-widest text-slate-800 dark:text-slate-200">
              Unlock Executive Summary
            </p>
            <p className="text-[9px] font-bold text-slate-400 mt-1 max-w-[200px]">
              Upgrade your workspace to view analytics insights and compare metrics.
            </p>
          </div>
        )}

        {/* MAIN CONTAINER LAYER (Blurs dynamically if Starter) */}
        <div className={`relative z-10 flex flex-col h-full transition-all duration-500 ${isStarter ? "blur-sm select-none pointer-events-none" : ""
          }`}>

          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="h-5 w-1.5 bg-gradient-to-b from-indigo-500 to-purple-600 rounded-full" />
              <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                Winner vs. Runner Up - Executive Summary
              </h4>
            </div>
          </div>

          {/* STATS MATRIX SECTION */}
          <div className="grid grid-cols-2 gap-4 flex-grow cursor-default">
            {realStats.map((stat) => (
              <div
                key={stat.id}
                className="relative group/quad"
                onMouseEnter={() => !isStarter && setActiveTooltip(stat.id)}
                onMouseLeave={() => !isStarter && setActiveTooltip(null)}
              >
                <div
                  className={`p-5 rounded-[2rem] border transition-all duration-300 h-full flex flex-col justify-between ${activeTooltip === stat.id
                    ? "bg-white dark:bg-slate-800 border-indigo-200 shadow-xl -translate-y-1"
                    : `${stat.bg} border-slate-100 dark:border-white/5`
                    }`}
                >
                  <div className="space-y-3">
                    <div
                      className={`p-2 w-fit rounded-xl bg-white dark:bg-slate-900 border border-slate-50 dark:border-white/5 ${activeTooltip === stat.id ? "text-indigo-500" : "text-slate-400"
                        }`}
                    >
                      {stat.icon}
                    </div>
                    <div>
                      <span className="text-[8px] font-black uppercase tracking-widest text-slate-400 block mb-1">
                        {stat.label}
                      </span>
                      <span
                        className={`text-[13px] font-black truncate block ${stat.id === "price" ? "text-emerald-600" : "text-slate-900 dark:text-white"
                          }`}
                      >
                        {stat.score}
                      </span>
                    </div>
                  </div>
                  <div className="h-1.5 w-full bg-slate-100 dark:bg-slate-950 rounded-full overflow-hidden mt-4">
                    <div
                      className={`h-full bg-gradient-to-r ${stat.color} transition-all duration-1000 ease-out`}
                      style={{ width: `${stat.visual}%` }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* BUTTON ACTION CONTAINER LAYER */}
          <div className="mt-8 space-y-4">
            <button
              onClick={() => {
                if (isBusiness) {
                  setIsCompareModalOpen(true);
                } else {
                  setShowPricingModal(true);
                }
              }}
              className={`group/btn relative w-full py-4 rounded-2xl font-black text-[11px] uppercase tracking-widest flex items-center justify-center gap-3 transition-all active:scale-95 shadow-md ${isBusiness
                ? "bg-slate-900 dark:bg-indigo-600 text-white hover:bg-indigo-700 dark:hover:bg-indigo-500 hover:shadow-indigo-500/20"
                : "bg-slate-900 dark:bg-indigo-600 text-white hover:text-slate-900 hover:bg-slate-200/60 dark:hover:bg-amber-500/10 border-2 border-transparent hover:border-slate-500/30"
                }`}
            >
              <div className="relative w-4 h-4 flex items-center justify-center">
                <ArrowRightLeft
                  size={16}
                  className={`absolute transition-all duration-500 ${isBusiness
                    ? "group-hover/btn:rotate-180"
                    : "group-hover/btn:opacity-0 group-hover/btn:scale-50"
                    }`}
                />

                {!isBusiness && (
                  <span className="absolute text-xl opacity-0 scale-50 transition-all duration-300 group-hover/btn:opacity-100 group-hover/btn:scale-110 normal-case">
                    🔒
                  </span>
                )}
              </div>

              <span className="font-bold transition-all duration-300">
                {isBusiness ? "Compare Options" : "Unlock Compare Options"}
              </span>
            </button>
          </div>

        </div>
      </div>
      <ComparativeModal
        isOpen={isCompareModalOpen}
        onClose={() => setIsCompareModalOpen(false)}
        sups={sups}
        quote={quote}
        // ADD THIS LINE:
        forcedWinner={qp_FinalWinner}
      />
    </div>
  );
};

const storage = {
  get: async (companyId) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/workspace/${companyId}`);
      if (!response.ok) return null;
      return await response.json();
    } catch (err) {
      console.error("Storage Get Error:", err);
      return null;
    }
  },

  set: async (
    companyId,
    projects,
    users,
    activities,
    suppliers,
    plan,
    email,
    theme
  ) => {
    try {
      // --- 1. THE WORKSPACE SYNC (The "Container") ---
      // This keeps the overall company data, activities, and user list intact.
      const workspaceResponse = await fetch(`${BACKEND_URL}/api/save-data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyId: companyId.toUpperCase(),
          projects,
          users,
          activities,
          supList: suppliers, // Mapping suppliers to your 'supList' key
          plan,
          lastUser: email,
          themePreference: theme,
        }),
      });

      if (!workspaceResponse.ok) throw new Error("Workspace sync failed");

      // --- 2. THE STANDALONE PROJECT SYNC (The "Blueprints") ---
      // 🚩 THIS IS THE NEW PART: We loop through every project and
      // ensure it exists in the standalone Project collection.
      if (Array.isArray(projects) && projects.length > 0) {
        // We use Promise.all to sync all projects in parallel for speed
        await Promise.all(
          projects.map(async (project) => {
            try {
              await fetch(`${BACKEND_URL}/api/projects/sync`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ projectData: project }),
              });
            } catch (err) {
              console.error(
                `Failed to sync standalone project: ${project.name}`,
                err
              );
            }
          })
        );
      }

      console.log(
        "✅ Full System Sync Complete: Workspace & Standalone Projects"
      );
      return true;
    } catch (error) {
      console.error("❌ Critical Sync Error:", error);
      return false;
    }
  },
};

// Initial state for the "Add" action
const emptySupplier = {
  name: "",
  email: "",
  phone: "",
  category: "General",
  beeLevel: "Non-Compliant",
  sarsTcsPin: "",
  cipcRegNumber: "",
  vatNumber: "",
  bankVerified: false,
  paymentTerms: "COD",
  popiaConsent: { agreed: false, date: null },
  notes: "",
  lastVerified: new Date().toISOString(), // Tracks the exact moment of the last check
  verificationStatus: "verified", // 'verified' | 'stale' | 'expired'
};

const QuoProLoader = ({ progress }) => {
  // Ensure we safely clamp the visual width between 0 and 100
  const normalizedProgress = Math.min(Math.max(Number(progress) || 0, 0), 100);

  return (
    <div className="fixed inset-0 z-[999] bg-white dark:bg-slate-950 flex flex-col items-center justify-center overflow-hidden transition-colors duration-500">

      {/* --- PREMIUM AMBIENT BACKDROP --- */}
      {/* Top High-Contrast Radial Spill */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(79,70,229,0.06),transparent_60%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(79,70,229,0.12),transparent_50%)] pointer-events-none" />
      {/* Sub-pixel Architectural Header Accent Grid Layer */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200/80 dark:via-slate-800 to-transparent" />
      {/* Center Soft-Glow Backplate Diffuser */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(79,70,229,0.02),transparent_40%)] pointer-events-none" />

      {/* --- MAIN CENTER CANVAS LAYOUT --- */}
      <div className="relative flex flex-col items-center">

        {/* 1. BRAND LOGO HOUSING WITH KINETIC DEPTH EMBEDDED */}
        <div className="relative mb-8 flex items-center justify-center">
          {/* Ambient Blurred Aura tracking the exact scale of the logo layer */}
          <div
            className="absolute w-24 h-24 bg-indigo-500/10 dark:bg-indigo-500/20 rounded-full blur-xl transition-transform duration-700 ease-in-out"
            style={{ transform: `scale(${1 + normalizedProgress * 0.002})` }}
          />

          {/* Main Logo Container Asset Wrapper */}
          <div
            className="w-20 h-20 relative z-10 transition-transform duration-300 ease-out"
            style={{ transform: `scale(${1 + (normalizedProgress * 0.2) / 100})` }}
          >
            <img
              src="/logo.png"
              className="w-full h-full object-contain"
              alt="QuoPro Platform Logo"
            />
          </div>
        </div>

        {/* 2. INFRASTRUCTURE TRACKING METRICS AREA */}
        <div className="text-center z-10 flex flex-col items-center w-64">

          {/* Micro-Precision Progress Bar Structure */}
          <div className="w-full h-[5px] bg-slate-100 dark:bg-slate-900 rounded-full overflow-hidden relative border border-slate-200/10 dark:border-white/5">
            <div
              className="absolute left-0 top-0 h-full bg-gradient-to-r from-indigo-500 via-indigo-600 to-indigo-500 transition-all duration-300 ease-out"
              style={{ width: `${normalizedProgress}%` }}
            />
            {/* Shimmer Track Glint Mask over the bar */}
            <div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 dark:via-white/20 to-transparent animate-[shimmer_2s_infinite]"
              style={{
                animation: 'shimmer 3s infinite',
                backgroundImage: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)'
              }}
            />
          </div>

          {/* Subtext Alignment Block */}
          <div className="flex items-center justify-between w-full mt-4 px-1">
            {/* Context Anchor Label */}
            <span className="text-[9px] font-black uppercase tracking-[0.3em] text-slate-400 dark:text-slate-500">
              Loading Workspace...
            </span>

            {/* Tabular Layout Monospaced Metric Counter */}
            <span className="text-[10px] font-mono font-bold text-indigo-600 dark:text-indigo-400 tabular-nums">
              {Math.round(normalizedProgress)}%
            </span>
          </div>
        </div>
      </div>

      {/* Global CSS Animation Declarations for Shimmer Tracking */}
      <style dangerouslySetInnerHTML={{
        __html: `
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      ` }} />
    </div>
  );
};

if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (
      e.message ===
      "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      const resizeObserverErrGuid = "f3504851-039c-4ec8-8b9d-473181816e9b";
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }
  });
}
/* eslint-disable */
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (
      e.message ===
      "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
      e.preventDefault(); // This kills the red error overlay
    }
  });
}

export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    priceMonthly: "Free",
    priceYearly: "Free",
    variantIdMonthly: null,
    variantIdYearly: null,
    projects: 2,
    sups: 5,
    color: "slate",
    features: [
      "2 Projects (Once Off)",
      "5 Suppliers (Once Off)",
      "Basic Analytics",
    ],
  },
  {
    id: "pro",
    name: "Professional",
    priceMonthly: "1 899", //MONTHLY -- R1899
    priceYearly: "19 370", //ANNUALLY -- R1899 * 12 == R22 788 (-15% yearly discount) == R22 788 - R3418 === R19 370 P/Y
    // REPLACE THESE WITH YOUR LS VARIANT IDs
    variantIdMonthly: "d44434e9-e250-4985-b603-393bb6bb97a0", //TEST ID
    variantIdYearly: "da329224-382c-41c9-9212-22b387440071", //TEST ID
    projects: 30,
    sups: 55,
    color: "indigo",
    features: [
      "30 Projects (Once Off)",
      "55 Suppliers (Once Off)",
      "Registry Export",
      "Cost Split Optimizer",
      "Sophisticated Audit Log",
      "Workflow Management",
    ],
  },
  {
    id: "businessPlus",
    name: "Business Plus+",
    priceMonthly: "4 399", //MONTHLY -- R4399
    priceYearly: "44 870", //ANNUALLY -- R4399 * 12 == R52788 (-15% yearly discount) == R52788 - R7918 === R44870 P/Y
    // REPLACE THESE WITH YOUR LS VARIANT IDs
    variantIdMonthly: "34df84b4-1b89-44fe-a452-e9cd741d3647", //TEST ID
    variantIdYearly: "b4502404-db50-4d32-846a-bc480d6550c7", //TEST ID
    projects: "Unlimited",
    sups: "Unlimited",
    color: "indigo",
    features: [
      "Includes all 'Pro' plan features",
      "Unlimited Projects",
      "Unlimited Suppliers",
      "Advanced Audit Reports",
      "AI Quote Management Tool",
      "Generate Invoices",
    ],
  },
];

/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////
////////////.                               .////////////
////////////.                               .////////////
////////////.        INCLUDE PAGES          .////////////
////////////.                               .////////////
////////////.                               .////////////
/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////

// 1. FINANCE PAGE
import FinancePage from "./components/pages/FinancePage";

// 2. ProjectModal Page
import ProjectModal from "./components/modals/ProjectModal";

// 3. SettingsModal
import SettingsModal from "./components/modals/SettingsModal";

// 4. SupplierStatsModal
import SupplierStatsModal from "./components/modals/SupplierStatsModal";

// 5. ComparativeModal
import ComparativeModal from "./components/modals/ComparativeModal";

// 6. ResetPassword page for resetting passwords for users
import ResetPassword from "./components/pages/ResetPassword";


/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////
////////////.                               .////////////
////////////.                               .////////////
////////////.        INCLUDE PAGES          .////////////
////////////.                               .////////////
////////////.                               .////////////
/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////

// 1. Add 'quoteList' as a second parameter
const calculateBaseTotal = (sup, quoteList) => {
  if (!sup || !quoteList) return 0;

  const total = quoteList.reduce((acc, item) => {
    // 1. Extract and cast to Number
    const price = Number(sup.quotes?.[item.ref]?.price || 0);
    const qty = Number(item.qty || 0);

    // 2. Calculate line total and round to 2 decimals to prevent float issues
    const lineTotal = Math.round((price * qty + Number.EPSILON) * 100) / 100;

    return acc + lineTotal;
  }, 0);

  // 3. Final rounding of the sum
  return Math.round((total + Number.EPSILON) * 100) / 100;
};

/////////////////////////////////////////////////////////

export const SecurityProvider = ({ children }) => {
  const [privacyMode, setPrivacyMode] = React.useState(false);

  return (
    <SecurityContext.Provider value={{ privacyMode, setPrivacyMode }}>
      {children}
    </SecurityContext.Provider>
  );
};

const SecurityContext = React.createContext(undefined);

export const useSecurity = () => {
  const context = React.useContext(SecurityContext);
  if (!context) return {}; // Prevents the "undefined" crash
  return context;
};

//REPORT FUNCTIONS
//REPORT 1 - PROJECT REGISTRY
const ProjectRegistryReport = ({ projects }) => {
  // Mock Logic for Synthesis
  const totalCapex = projects?.reduce((acc, p) => acc + (p.budget || 0), 0) || 0;
  const activeCount = projects?.length || 0;

  const getCompletionRate = () => {
    // 1. Guard against empty projects array
    if (!projects || projects.length === 0) return "0%";

    // 2. Filter for projects specifically marked as 'Completed'
    const completedCount = projects.filter(
      (p) => p.status?.toLowerCase() === "completed"
    ).length;

    // 3. Calculate the percentage
    const rate = (completedCount / projects.length) * 100;

    // 4. Return formatted string (0 decimal places for a clean UI look)
    return `${Math.round(rate)}%`;
  };

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-1000">

      {/* 1. TOP TIER METRICS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <MetricCardProjectRegistry
          label="Total Portfolio Value"
          value={new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR', maximumFractionDigits: 2 }).format(totalCapex)}
          icon={<PiCurrencyCircleDollar />}
          trend="+12.4%"
          isPositive={true}
        />
        <MetricCardProjectRegistry
          label="Active Procurement Units"
          value={activeCount}
          icon={<PiStack />}
        />
        <MetricCardProjectRegistry
          label="Project Completion Rate"
          value={getCompletionRate()}
          icon={<PiWarningCircle />}
          color="text-emerald" // QuoPro Level 1-2 Green
        />
      </div>
    </div>
  );
};

// Sub-component for the Top Cards
const MetricCardProjectRegistry = ({ label, value, icon, trend, isPositive, color = "text-slate-900 dark:text-white" }) => (
  <div className="group relative bg-white/70 dark:bg-slate-950/40 backdrop-blur-xl border border-slate-200/60 dark:border-white/10 p-8 rounded-[2.5rem] transition-all duration-500 hover:border-indigo-500/50 hover:shadow-[0_20px_40px_-15px_rgba(79,70,229,0.15)] dark:hover:shadow-[0_0_40px_-10px_rgba(79,70,229,0.3)] overflow-hidden">

    {/* 1. Ambient Background Glow (Hover) */}
    <div className="absolute -right-4 -top-4 w-24 h-24 bg-indigo-500/5 dark:bg-indigo-500/10 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700" />

    <div className="relative z-10">
      <div className="flex justify-between items-center mb-6">
        {/* 2. Icon Container - Adjusted for visibility in light mode */}
        <div className="p-4 bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-2xl text-indigo-600 dark:text-indigo-400 shadow-sm dark:shadow-inner group-hover:scale-110 group-hover:text-white group-hover:bg-indigo-600 transition-all duration-500">
          {React.cloneElement(icon, { size: 22, strokeWidth: 2.5 })}
        </div>

        {/* 3. Refined Trend Badge */}
        {trend && (
          <div className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-wider ${isPositive
            ? 'bg-[#22c55e]/10 text-[#16a34a] dark:text-[#22c55e] border border-[#22c55e]/20'
            : 'bg-rose-500/10 text-rose-600 dark:text-rose-500 border border-rose-500/20'
            }`}>
            <span className={isPositive ? "rotate-0" : "rotate-180"}>▲</span>
            {trend}
          </div>
        )}
      </div>

      {/* 4. Typography */}
      <div className="space-y-1">
        <p className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.15em]">
          {label}
        </p>
        <h3 className={`text-4xl font-bold tracking-tighter ${color} group-hover:tracking-tight transition-all duration-500`}>
          {value}
        </h3>
      </div>
    </div>

    {/* 5. Level 1-2 Green Bottom "Success" Line */}
    <div className="absolute bottom-0 left-0 h-[2px] bg-gradient-to-r from-transparent via-[#22c55e] to-transparent w-full opacity-10 dark:opacity-20 group-hover:opacity-100 transition-opacity duration-500" />
  </div>
);

//REPORT ENGINE
const QuoProIntelligencePanel = ({ isOpen, onClose, projects }) => {
  const [loadingReport, setLoadingReport] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeReport, setActiveReport] = useState(null);

  // Reset expansion when closed so it doesn't "jump" next time it opens
  useEffect(() => {
    if (!isOpen) {
      const timer = setTimeout(() => {
        setIsExpanded(false);
        setActiveReport(null);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const reports = [
    {
      id: "registry",
      title: "Global Project Registry",
      desc: "A comprehensive master ledger of every active procurement unit and cost center.",
      icon: <ClipboardList className="text-slate-500" size={20} />,
    },
    {
      id: "quotes",
      title: "Omni-Quote Matrix",
      desc: "Real-time analysis of all project quotes, pricing trends, and historical bid data.",
      icon: <BarChart3 className="text-indigo-600" size={20} />,
    },
    {
      id: "suppliers",
      title: "Supplier Master Intel",
      desc: "Deep-dive vendor repository including risk profiles and performance scores.",
      icon: <Users className="text-rose-500" size={20} />,
    },
    {
      id: "efficiency",
      title: "Efficiency Frontier",
      desc: "Strategic breakdown of procurement velocity, lead-times, and operational bottlenecks.",
      icon: <Zap className="text-amber-500" size={20} />,
    },
    {
      id: "compliance",
      title: "Transformation Audit",
      desc: "Automated B-BBEE compliance tracking and ESG spend distribution analysis.",
      icon: <ShieldCheck className="text-emerald-500" size={20} />,
    },
  ];

  const handleDownload = (id) => {
    setLoadingReport(id);
    // Simulate AI Synthesis
    setTimeout(() => {
      setLoadingReport(null);
      setActiveReport(id);
      setIsExpanded(true);
    }, 1800);
  };

  return (
    <>
      {/* Background Overlay */}
      <div
        className={`fixed inset-0 bg-slate-950/60 backdrop-blur-md z-[9999998] transition-opacity duration-500 
        ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={onClose}
      />

      {/* Main Panel */}
      <div
        className={`fixed z-[9999999] bg-white dark:bg-slate-950 shadow-[-40px_0_80px_rgba(0,0,0,0.3)] transition-all duration-500 ease-[cubic-bezier(0.2,1,0.3,1)]
          ${isOpen ? "visible" : "invisible"}
          ${isExpanded
            ? "top-[4vh] right-[3vw] w-[94vw] h-[92vh] rounded-[3rem] border border-slate-200 dark:border-white/10 shadow-[0_50px_100px_-20px_rgba(0,0,0,0.5)]"
            : `top-0 h-screen w-full max-w-[420px] rounded-none border-l border-slate-100 dark:border-white/10 ${isOpen ? "right-0" : "-right-full"}`
          }
        `}
      >
        {/* Morph Toggle Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
          className={`absolute -left-5 top-1/2 -translate-y-1/2 z-[100] p-2.5 bg-slate-900 dark:bg-indigo-600 text-white rounded-xl shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300 group
            ${!isOpen ? "opacity-0 pointer-events-none" : "opacity-100"}`}
        >
          <div className="absolute inset-0 rounded-xl bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
          <div className="relative z-10">
            {isExpanded ? (
              <ChevronRight size={16} strokeWidth={3} className="group-hover:translate-x-0.5 transition-transform" />
            ) : (
              <ChevronLeft size={16} strokeWidth={3} className="group-hover:-translate-x-0.5 transition-transform" />
            )}
          </div>
        </button>

        <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/10 blur-[120px] pointer-events-none animate-pulse" />

        <div className="relative h-full flex flex-col overflow-hidden">

          {/* HEADER */}
          <div className={`flex-none flex justify-between items-center z-20 transition-all duration-500 
            ${isExpanded ? "px-16 py-12" : "px-10 py-12 pb-8"}`}>
            <div className="space-y-1.5">
              <h2 className={`${isExpanded ? "text-5xl" : "text-3xl"} tracking-[-0.04em] text-slate-900 dark:text-white leading-none transition-all duration-500`}>
                {activeReport ? (
                  <button
                    onClick={() => setActiveReport(null)}
                    className="group flex items-center gap-4 hover:text-indigo-500 transition-colors"
                  >
                    <ArrowLeft size={32} className="group-hover:-translate-x-2 transition-transform" />
                    <span className="font-bold">Project <span className="font-bold bg-gradient-to-r from-indigo-500 to-cyan-400 bg-clip-text text-transparent">Registry</span></span>
                  </button>
                ) : (
                  <>Report <span className="font-bold bg-gradient-to-r from-indigo-500 to-cyan-400 bg-clip-text text-transparent">Engine</span></>
                )}
              </h2>
            </div>
            <button
              onClick={onClose}
              className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all"
            >
              <X size={24} />
            </button>
          </div>

          {/* CONTENT AREA */}
          <div className="relative flex-1 overflow-hidden">
            <div className={`h-full overflow-y-auto custom-scrollbar pb-32 transition-all duration-500
              ${isExpanded
                ? "px-16 pt-12"
                : "px-10 pt-10"
              }`}>

              {activeReport === 'registry' ? (
                <ProjectRegistryReport projects={projects} />
              ) : (
                <div className={`${isExpanded ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" : "space-y-10"}`}>
                  {reports.map((report) => (
                    <div
                      key={report.id}
                      className="group relative bg-slate-50/50 dark:bg-white/[0.02] border border-slate-100 dark:border-white/5 p-8 rounded-[2.5rem] transition-all duration-500 hover:bg-white dark:hover:bg-slate-900 hover:shadow-[0_40px_80px_-15px_rgba(0,0,0,0.15)] hover:-translate-y-3 hover:border-indigo-500/30 flex flex-col justify-between"
                    >
                      <div className="flex gap-6 items-start mb-8">
                        <div className="p-5 bg-white dark:bg-slate-950 rounded-[1.5rem] shadow-sm border border-slate-100 dark:border-white/5 group-hover:scale-110 group-hover:shadow-indigo-500/20 transition-all duration-500">
                          {React.cloneElement(report.icon, { size: 24, strokeWidth: 2.5 })}
                        </div>
                        <div className="flex-1 pt-1">
                          <h4 className="text-[14px] font-[1000] text-slate-900 dark:text-white uppercase tracking-tight mb-2">
                            {report.title}
                          </h4>
                          <p className="text-[12px] font-medium text-slate-400 leading-relaxed">
                            {report.desc}
                          </p>
                        </div>
                      </div>

                      <button
                        onClick={() => handleDownload(report.id)}
                        disabled={loadingReport !== null}
                        className={`w-full py-5 rounded-[1.25rem] text-[10px] font-black uppercase tracking-[0.2em] flex items-center justify-center gap-3 transition-all duration-300 ${loadingReport === report.id
                          ? "bg-slate-100 dark:bg-slate-800 text-slate-400 cursor-wait"
                          : "bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg shadow-indigo-600/20 active:scale-[0.97]"
                          }`}
                      >
                        {loadingReport === report.id ? (
                          <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        ) : (
                          <Download size={16} strokeWidth={3} />
                        )}
                        <span className="font-bold">
                          {loadingReport === report.id ? "Generating" : "Generate Report"}
                        </span>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

const QuoteManager = () => {
  //RESET PASSWORD PAGE
  // Change this in your App.js (at the top of QuoteManager)
  const isResetPath = window.location.pathname.startsWith('/reset-password');

  // 🚩 THE EARLY RETURN
  if (isResetPath) {
    return (
      <div style={{ minHeight: '100vh', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ResetPassword />
      </div>
    );
  }

  //MAINTENANCE MODE
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false); // Set to false when you want to go live
  const [visibleSectionsHero, setVisibleSectionsHero] = useState({
    hero: true,
  });

  //WEBSITE
  const [isLaunching, setIsLaunching] = useState(true);
  const [showWebsite, setShowWebsite] = useState(true);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isYearly, setIsYearly] = useState(false);
  const [visibleSections, setVisibleSections] = useState({});
  const websiteRef = useRef(null);
  const [showPricingTableModal, setShowPricingTableModal] = useState(false);
  const [featureSearchQuery, setFeatureSearchQuery] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const websiteScrollRef = useRef(null);
  const [expandedPlans, setExpandedPlans] = useState({});

  //Payment Modal
  const [showPaymentModal, setShowPaymentModal] = useState(true);
  const [workspace, setWorkspace] = useState(null);

  //Remove Teammate
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [pendingDeletion, setPendingDeletion] = useState(null);
  const [revokeReason, setRevokeReason] = useState("offboarding");
  const [revokeNote, setRevokeNote] = useState("");

  //MFA Login States
  const [showMfaInput, setShowMfaInput] = useState(false);
  const [mfaCode, setMfaCode] = useState("");
  const [showMfaChallenge, setShowMfaChallenge] = useState(false);
  const [tempUserId, setTempUserId] = useState(null);
  const [mfaToken, setMfaToken] = useState(""); // Also check this name!

  //Password Reset Triggers
  const [linkSent, setLinkSent] = useState(false);

  //SIDEBAR REPORTS
  const [isReportSidebarOpen, setIsReportSidebarOpen] = useState(false);

  //Supplier Delete Warning Modal
  const [supDeleteWarning, setSupDeleteWarning] = useState({
    show: false,
    name: "",
    projects: [],
  });

  // Controls the visibility of the new modal
  const [isSupModalOpen, setIsSupModalOpen] = useState(false);

  // Stores the specific supplier data currently being shown in the modal
  const [activeSup, setActiveSup] = useState(null);

  // Switches between 'Onboarding' mode and 'Read-Only' eye-icon mode
  const [isViewOnly, setIsViewOnly] = useState(false);

  //Connect Form email sent
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  ////////////////////////////////////////////////
  ////////////////////////////////////////////////
  ////////////////////////////////////////////////
  ////                                        ////
  ////                                        ////
  ////         SUPPLIER ADD FUNCTIONS         ////
  ////                                        ////
  ////                                        ////
  ////////////////////////////////////////////////
  ////////////////////////////////////////////////
  ////////////////////////////////////////////////

  const handleManualVerify = async (supId) => {
    const now = new Date().toISOString();

    // 1. Update the main list (The "Registry")
    const updatedList = supList.map((s) =>
      s.id === supId
        ? { ...s, lastVerified: now, verificationStatus: "verified" }
        : s
    );
    setSupList(updatedList);

    // 2. 🚩 CRITICAL: Update the modal's current view too!
    setActiveSup((prev) => ({
      ...prev,
      lastVerified: now,
      verificationStatus: "verified",
    }));

    // 3. Sync to Cloud
    if (user?.companyId) {
      try {
        const freshData = await storage.get(user.companyId);
        await storage.set(
          user.companyId,
          freshData.projects || projects,
          freshData.users || allUsers,
          [
            logActivity(
              "Compliance",
              `Manual SARS Verification: ${activeSup.name}`
            ),
            ...freshData.activities,
          ],
          updatedList,
          user.plan,
          user.email,
          darkMode ? "dark" : "light"
        );
        toast.success("SARS Compliance Verified");
      } catch (err) {
        console.error("Cloud sync failed:", err);
        toast.error("Verified locally, but cloud sync failed.");
      }
    }
  };

  const handleAddNewClick = () => {
    // 1. Try to find the user plan safely.
    // If 'user' is truly not in this component, we fallback to 'starter'
    let userPlan = "starter";

    try {
      // If 'user' exists globally or in scope, use it
      if (typeof user !== "undefined") {
        userPlan = user?.plan || "starter";
      }
    } catch (e) {
      console.warn(
        "User object not found in scope, defaulting to starter limits."
      );
    }

    ////////////////////////////////////////////////
    ////                   END                  ////
    ////////////////////////////////////////////////

    // 2. Check limits
    const currentCount = supList?.length || 0;
    const limit =
      typeof SUPPLIER_LIMITS !== "undefined" ? SUPPLIER_LIMITS[userPlan] : 5;

    if (userPlan !== "businessPlus" && currentCount >= limit) {
      toast.error(`Limit reached for ${userPlan} plan.`);
      return;
    }

    // Setup the empty state
    setActiveSup({
      id: Date.now().toString(),
      name: "",
      email: "",
      phone: "",
      category: "General",
      beeLevel: "Non-Compliant",
      sarsTcsPin: "",
      cipcRegNumber: "",
      vatNumber: "",
      bankVerified: false,
      popiaConsent: { agreed: false, date: null },
      verificationStatus: "verified",
      lastVerified: new Date().toISOString(),
    });

    setIsViewOnly(false); // Enable typing
    setIsSupModalOpen(true); // 🚩 THIS OPENS THE MODAL
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // If "other" is selected, extract the value from your custom state/ref if needed
    const finalBusinessLine = form.businessLine === "other"
      ? form.customBusinessLine // Make sure this property maps to your state tracking the custom input string!
      : form.businessLine;

    try {
      const response = await fetch(`${BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          businessLine: finalBusinessLine,
          message: form.message,
        }),
      });

      if (response.ok) {
        setSubmitStatus("success");
        // Reset form fields cleanly
        setForm({ name: "", email: "", businessLine: "", message: "", customBusinessLine: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("🚨 [QuoPro Contact Error]:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = document.querySelectorAll(".reveal-card");
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLaunching(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // 1. Define the refresh function
    const refreshStats = async () => {
      try {
        await fetchWorkflows(); // Assuming this updates your 'workflowStats' state
      } catch (error) {
        console.error("Failed to sync workflow:", error);
      }
    };

    // 2. Set the interval (30000ms = 30s)
    const interval = setInterval(refreshStats, 30000);

    // 3. Clean up on unmount to prevent memory leaks
    return () => clearInterval(interval);
  }, []); // Empty dependency array means this runs once on mount

  useEffect(() => {
    // Only run if the website is active and pre-loader is gone
    if (isLaunching || !showWebsite) return;

    const handleScroll = () => {
      const scrolled = window.scrollY;
      const maxHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress((scrolled / maxHeight) * 100);
    };

    const observerTimer = setTimeout(() => {
      const observerOptions = {
        threshold: 0.15, // Trigger when 15% of section is visible
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      }, observerOptions);

      const sections = ["hero", "features", "plans", "connect"];
      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });

      return () => observer.disconnect();
    }, 100);

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(observerTimer);
    };
  }, [isLaunching, showWebsite]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      },
      { threshold: 0.15 } // Trigger when 15% of the section is visible
    );

    const sections = document.querySelectorAll(".reveal-on-scroll");
    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  // Helper for classes
  const revealClass = (id, base) =>
    `${base} transition-all duration-[1200px] ease-out ${visibleSections[id]
      ? "opacity-100 translate-y-0"
      : "opacity-0 translate-y-12"
    }`;

  //SUPPLIER MODAL
  const [selectedSupForStats, setSelectedSupForStats] = useState(null);
  const handleSaveSupplier = async (supplierData) => {
    if (!supplierData.name?.trim()) {
      toast.error("Please enter a Company Name.");
      return;
    }

    if (user?.companyId) {
      setIsSaving(true);

      try {
        // 1. Workspace Sync (SaaS Tenant - Working)
        const freshData = await storage.get(user.companyId);
        if (!freshData) throw new Error("Cloud unreachable");

        const dbSuppliers =
          freshData.suppliers || freshData.supList || supList || [];
        const exists = dbSuppliers.find((s) => s.id === supplierData.id);

        const updatedSupList = exists
          ? dbSuppliers.map((s) =>
            s.id === supplierData.id ? supplierData : s
          )
          : [supplierData, ...dbSuppliers];

        // Atomic Workspace Update
        await storage.set(
          user.companyId,
          freshData.projects || projects,
          freshData.users || allUsers,
          [
            logActivity(
              exists ? "Supplier Updated" : "Supplier Onboarded",
              supplierData.name
            ),
            ...(freshData.activities || []),
          ],
          updatedSupList,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );

        // 2. STANDALONE DB SYNC (This is the fix)
        // Explicitly mapping to your MasterSupplierSchema keys
        const masterPayload = {
          id: String(supplierData.id), // Ensure it's a string for the Schema
          name: supplierData.name,
          email: supplierData.email,
          phone: supplierData.phone,
          category: supplierData.category || "General",
          beeLevel: supplierData.beeLevel || "Non-Compliant",
          sarsTcsPin: supplierData.sarsTcsPin || "",
          cipcRegNumber: supplierData.cipcRegNumber || "",
          vatNumber: supplierData.vatNumber || "",
          bankVerified: !!supplierData.bankingVerified,
          status: supplierData.isBlacklisted
            ? "blacklisted"
            : exists
              ? "active"
              : "pending",
          popiaConsent: {
            agreed: !!supplierData.popiaAgreed,
            agreedAt: supplierData.popiaAgreed ? new Date() : null,
            ipAddress: "Captured-UI",
          },
          companyId: user.companyId, // REQUIRED by your Schema
          addedBy: user.email,
          lastUpdated: new Date(),
        };

        // 🚩 CHECK THIS URL: If your backend route is /api/suppliers, ensure it's correct
        const response = await fetch(`${BACKEND_URL}/api/suppliers`, {
          method: "POST", // Using POST for both to let Mongoose 'upsert' or handle logic
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify(masterPayload),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Standalone Save Error:", errorData);
          throw new Error(
            errorData.message || "Failed to sync to Standalone Suppliers"
          );
        }

        // 3. UI Finalization
        setSupList(updatedSupList);

        // Force the UI to wait for the spinner, then close everything

        setIsSaving(false);
        setIsSupModalOpen(false);

        //SUPPLIER SAVE NOTIFICATION
        await triggerNotification(
          "supplier",
          `Supplier Updated`,
          `The supplier ${supplierData.name} has been updated.`
        );

      } catch (error) {
        console.error("Sync Failure:", error);
        toast.error(`Sync Error: ${error.message}`);
        setIsSaving(false); // Stop spinner so user can fix and retry
      }
      finally {
        setIsSaving(false);
        setIsSupModalOpen(false);
      }
    }
  };

  const [isSavingAll, setIsSavingAll] = useState(false);
  const [isClearingSuppliers, setIsClearingSuppliers] = React.useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);

  //Clearing Project Items and Suppliers
  const [confirmDeleteText, setConfirmDeleteText] = React.useState("");
  const [confirmProjectDeleteText, setConfirmProjectDeleteText] = React.useState("");
  const [isClearingProject, setIsClearingProject] = React.useState(false);
  const [showClearConfirmProject, setShowClearConfirmProject] = useState(false);
  const [showClearConfirmSupplier, setShowClearConfirmSupplier] = useState(false);

  //Deleteing single Project items
  const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null); // Stores the ID or Object
  const [isModalDeleting, setIsModalDeleting] = React.useState(false);

  //Adding New Suppliers
  const [isAddingSup, setIsAddingSup] = React.useState(false);

  //Deleting a single supplier
  const [supplierToDelete, setSupplierToDelete] = React.useState(null);
  const [isModalDeletingSup, setIsModalDeletingSup] = React.useState(false);

  //Managing Quote useStates
  const [quoteSupToDelete, setQuoteSupToDelete] = React.useState(null);
  const [isDeletingQuote, setIsDeletingQuote] = React.useState(false);
  const [duplicateErrorSup, setDuplicateErrorSup] = React.useState(null);
  const [showClearConfirmQuoteCard, setShowClearConfirmQuoteCard] = useState(false);
  const [sups, setSups] = useState([]);
  const [isClearingQuotes, setIsClearingQuotes] = useState(false);

  //RESULT CALCS
  const [activeBudget, setActiveBudget] = useState(0);

  //WORKFLOWS
  const [workflowToCancel, setWorkflowToCancel] = useState(null);
  const [isCancelling, setIsCancelling] = useState(false);

  //REST OF THE STATES
  const [appReady, setAppReady] = useState(false);
  const [hasPaid, sethasPaid] = useState(false);

  const [showTerms, setShowTerms] = useState(false);
  const [hasReadTerms, setHasReadTerms] = useState(false);

  const [view, setView] = useState("dashboard");
  const [projectSearch, setProjectSearch] = useState("");
  const [isDeadlineValid, setIsDeadlineValid] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ show: false, message: "" });
  const [darkMode, setDarkMode] = useState(() => {
    // 1. Check local storage first (fastest)
    const savedTheme = localStorage.getItem("quopro_theme");
    if (savedTheme) return savedTheme === "dark";

    // 2. Fallback to system preference (optional but nice)
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  const [decisionNotes, setDecisionNotes] = useState({}); // Stores comments per ID
  const [privacyMode, setPrivacyMode] = useState(false);

  //SPIN ANIMATIONS
  const [isReadingAll, setIsReadingAll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [pendingPlan, setPendingPlan] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [activities, setActivities] = useState([]);
  const [removalSuccess, setRemovalSuccess] = useState(null); // Stores the name of the removed person

  //SIGN UP MODALS
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selection, setSelection] = useState(null);
  const [billingCycle, setBillingCycle] = useState("monthly"); // "monthly" or "yearly"
  const [settingsTab, setSettingsTab] = useState("profile"); // "profile" or "subscription"
  const [pendingUser, setPendingUser] = useState(null);
  const [showSupWarning, setShowSupWarning] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [isCompareOpen, setIsCompareOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAuth, setIsAuth] = useState(false);
  const [regMode, setRegMode] = useState("create"); // 'create' or 'join'
  const [errorModal, setErrorModal] = useState({
    show: false,
    title: "",
    message: "",
  });
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [isAnalyticsOpen, setIsAnalyticsOpen] = useState(false);
  const [isInRevisionMode, setIsInRevisionMode] = useState(false);
  const [quoteSearchTerm, setQuoteSearchTerm] = useState("");
  const [isAddingProject, setIsAddingProject] = useState(false);
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("quo_pro_session");
    return saved
      ? JSON.parse(saved)
      : { companyId: "", email: "", plan: "free" };
  });
  const [mode, setMode] = useState("login");
  const [modeForgotPassword, setModeForgotPassword] = useState("FORGOT");
  const [resetToken, setResetToken] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    businessLine: "", // Added for the industry dropdown
    message: "",      // Added for the textarea
    password: "",     // Keep for auth
    companyId: "",    // Keep for auth
  });
  const [error, setError] = useState("");
  const [quoteView, setQuoteView] = useState("grid");
  const [showDuplicateWarning, setShowDuplicateWarning] = useState(false);
  const [duplicateName, setDuplicateName] = useState("");
  const [showSplitModal, setShowSplitModal] = useState(false);
  const [quote, setQuote] = useState([]);
  const [supList, setSupList] = useState([]);

  // Search for this line in your App.js
  const [allUsers, setAllUsers] = useState({}); // Ensure it is {} NOT []
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: "",
    message: "",
    onConfirm: null,
  });
  const [itemSearchQuery, setItemSearchQuery] = useState("");
  const [workflowSearch, setWorkflowSearch] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [loading, setLoading] = useState(false); //
  const [loadingForgotPassword, setLoadingForgotPassword] = useState(false);
  const [loadProgress, setLoadProgress] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [showAboutVideo, setShowAboutVideo] = useState(false);
  const [tab, setTab] = useState("main");
  const onTabClick = React.useCallback((id) => setTab(id), []);
  const [viewMode, setViewMode] = useState("list");
  const [showPassword, setShowPassword] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expandedSup, setExpandedSup] = useState(null);
  const [supSearchQuery, setSupSearchQuery] = useState("");
  const [searchBuffer, setSearchBuffer] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [projectSearchQuery, setProjectSearchQuery] = useState("");
  const [showProjectInfo, setShowProjectInfo] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState("");
  const [editBudget, setEditBudget] = useState(0);
  const [businessLine, setBusinessLine] = useState("");
  const nameRef = useRef(null);
  const budgetRef = useRef(null);
  const [editDeadline, setEditDeadline] = useState("");
  const saveTimerRef = useRef(null);
  const [activeTab, setActiveTab] = useState("pending");
  const [isReportDrawerOpen, setIsReportDrawerOpen] = useState(false);
  const [isFinalizing, setIsFinalizing] = useState(false);
  const [loadingStep, setLoadingStep] = useState(0);
  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(() => {
    return localStorage.getItem("lastProjectId") || null;
  });

  //PASSWORD RESET STATES
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [recoveryCompanyId, setRecoveryCompanyId] = useState(""); // 🚩 Added Company ID
  const [newPassword, setNewPassword] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isUpdatingPlan, setIsUpdatingPlan] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [processingId, setProcessingId] = useState(null);
  const [exitingId, setExitingId] = useState(null);
  const [renderingReady, setRenderingReady] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [projectBudget, setProjectBudget] = useState("");
  const [projectDeadline, setProjectDeadline] = useState("");
  const [projectName, setProjectName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingView, setIsSavingView] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  //AI IMPORT
  const handleAIDocumentProcess = async (file, slotId) => {
    if (!file || !slotId) return; // 🚩 Ensure slotId is passed
    setIsProcessing(true);

    try {
      const base64File = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });

      const response = await fetch(`${BACKEND_URL}/api/ai-extract`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fileBase64: base64File,
          // 🚩 Note: 'quote' here refers to the project items master list
          itemsToMatch: quote.map((q) => ({ ref: q.ref, desc: q.desc })),
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Backend failed to process PDF");
      }

      const data = await response.json();

      if (data && data.extractedItems) {
        // 1. Format the data for Excel structure
        const excelData = quote.map((q) => {
          const match = data.extractedItems.find(
            (ai) => String(ai.Reference) === String(q.ref)
          );
          return {
            Reference: q.ref,
            Description: q.desc,
            Quantity: q.qty,
            Unit: q.unit || "unit",
            Price: match ? Number(match.Price).toFixed(2) : "0.00",
            "Lead Time (Days)": match ? match["Lead Time (Days)"] : 0,
          };
        });

        // 2. Generate the Excel Buffer internally (No download)
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Supplier Quote");

        // 🚩 MAGIC STEP: Convert workbook to a Blob/File instead of saving it
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const virtualFile = new File([wbout], "ai_generated_quote.xlsx", {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        // 3. PIGGY-BACK: Send this virtual file to your manual upload function
        console.log("🚀 AI scan complete. Handing over to manual import logic...");
        await uploadQuoteItems(virtualFile, slotId);

      } else {
        throw new Error("AI returned an empty list.");
      }
    } catch (err) {
      console.error("Critical AI Error:", err);
      alert(`AI Scan failed: ${err.message}`);
    } finally {
      setIsProcessing(false);
    }
  };

  // Inside QuoteManager in App.js
  const handleStartMfaSetup = async () => {
    // 🚩 ADD THIS CONSOLE LOG TO SEE IF DATA ARRIVES
    console.log("Fetching MFA setup for user:", user.id);

    try {
      const response = await fetch(`${BACKEND_URL}/api/security/setup-mfa`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: user.id, email: user.email }),
      });

      const data = await response.json();
      console.log("MFA Data received:", data);

      if (!response.ok) throw new Error(data.message || "Backend error");

      return data; // 🚩 This MUST return the data to SettingsModal
    } catch (err) {
      console.error("Fetch failed:", err);
      throw err;
    }
  };

  // 🚩 2. Disable MFA
  const onDisable2FA = () => {
    const targetId = user?.id || user?._id;

    if (!targetId) {
      setErrorModal({
        show: true,
        title: "Session Error",
        message: "Could not verify your identity. Please log in again.",
        type: "error"
      });
      return;
    }

    setErrorModal({
      show: true,
      title: "Disable Security?",
      message: "This will remove two-factor authentication from your account.",
      type: "error",
      onConfirm: async () => {
        // 🚩 1. START SPINNER IMMEDIATELY
        setLoading(true);
        // 🚩 2. EXECUTE
        await executeDisableMfa(targetId);
      }
    });
  };

  // PDF Export Logic
  // 🚩 Extra parameters to match your button call
  const downloadProjectRegistryPDF = (
    projects = [],
    qp_FinalWinner = null,
    currentProject = null
  ) => {
    console.log("PDF Triggered with:", {
      projects,
      qp_FinalWinner,
      currentProject,
    });

    try {
      // 🚨 HARD CHECK
      if (!Array.isArray(projects) || projects.length === 0) {
        alert("No projects found to export.");
        return;
      }

      const doc = new jsPDF("l", "mm", "a4");
      const pageHeight = doc.internal.pageSize.height;
      const timestamp = new Date().toLocaleString("en-ZA");

      // =========================
      // HEADER
      // =========================
      doc.setFillColor(15, 23, 42);
      doc.rect(0, 0, 297, 45, "F");
      doc.setFillColor(79, 70, 229);
      doc.rect(0, 44, 297, 1.5, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(22);
      doc.text("MASTER PROJECT REGISTRY", 15, 20);
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(148, 163, 184);
      doc.text("ACTIVE PROCUREMENT PORTFOLIO", 15, 28);
      doc.setFillColor(30, 41, 59);
      doc.roundedRect(235, 12, 50, 20, 3, 3, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text("CONFIDENTIAL", 260, 20, { align: "center" });
      doc.setFontSize(7);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(148, 163, 184);
      doc.text(timestamp, 260, 26, { align: "center" });

      // =========================
      // DATA PREP
      // =========================
      const tableRows = projects.map((p) => {
        try {
          const target = p?.deadline ? new Date(p.deadline) : null;
          let dateStr = "No Date Set";
          let daysLeft = null;
          let urgency = "—";

          if (target && !isNaN(target.getTime())) {
            dateStr = target.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            });

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            daysLeft = Math.ceil(
              (target - today) / (1000 * 60 * 60 * 24)
            );

            urgency =
              daysLeft > 0
                ? `${daysLeft} DAYS LEFT`
                : daysLeft === 0
                  ? "DUE TODAY"
                  : "OVERDUE";
          }

          const lastDate = p?.lastUpdated
            ? new Date(p.lastUpdated)
            : null;

          return [
            `${(p?.name || "Unnamed").toUpperCase()}\nREF: ${String(p?.id || "").slice(0, 8)}`,
            p?.status?.toUpperCase() || "DRAFT",
            `${dateStr}\n${urgency}`,
            `${p?.sups?.length || 0}\nSUPPLIERS`,
            `${(p?.lastUpdatedBy || "System").toUpperCase()}\n${lastDate
              ? lastDate.toLocaleDateString("en-GB")
              : "N/A"
            }`,
          ];
        } catch (err) {
          console.error("Row error:", err);
          return ["ERROR", "-", "-", "-", "-"];
        }
      });

      // =========================
      // TABLE
      // =========================
      autoTable(doc, {
        startY: 55,
        head: [[
          "PROJECT DETAILS",
          "PROJECT STATUS",
          "PROJECT DEADLINE",
          "PROJECT SUPPLIERS",
          "PROJECT LAST MODIFIED BY",
        ]],
        body: tableRows,
        theme: "striped",
        styles: {
          fontSize: 8,
          cellPadding: 5,
        },
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: [100, 100, 100],
          fontStyle: "bold",
        },
        didParseCell: function (data) {
          if (data.section === 'body') {
            if (data.column.index === 0 || data.column.index === 1 || data.column.index === 4) {
              data.cell.styles.fontStyle = 'bold';
            }
          }
        }
      });

      // =========================
      // FOOTER
      // =========================
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(7);
        doc.setTextColor(120, 120, 120);
        doc.text(
          `Page ${i} of ${totalPages}`,
          148,
          pageHeight - 8,
          { align: "center" }
        );
        doc.text(
          "GENERATED VIA QUOPRO",
          15,
          pageHeight - 8
        );
      }

      // =========================
      // SAVE
      // =========================
      doc.save(
        `Project_Registry_${Date.now()}.pdf`
      );
      console.log("✅ PDF successfully generated");
    } catch (error) {
      console.error("❌ PDF Export Failed:", error);
      alert("Something went wrong generating the PDF.");
    }
  };

  const executeDisableMfa = async (userId) => {
    // 1. Double check we have an actual string ID
    const cleanId = typeof userId === 'object' ? userId?._id || userId?.id : userId;

    try {
      setLoading(true);

      const response = await fetch(`${BACKEND_URL}/api/security/disable-mfa`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Ensure the browser sends the credentials if needed
          "Authorization": `Bearer ${localStorage.getItem("quo_pro_token")}`
        },
        body: JSON.stringify({ userId: cleanId }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // ✅ DB UPDATED SUCCESSFULLY
        const updatedUser = { ...user, twoFactorEnabled: false };
        setUser(updatedUser);
        localStorage.setItem("quo_pro_session", JSON.stringify(updatedUser));

        // Close modal ONLY after success
        setErrorModal({ show: false, title: "", message: "", type: "error" });

        if (typeof logActivity === 'function') {
          await logActivity("Security Update", "MFA disabled successfully");
        }
      } else {
        // ❌ SERVER REJECTED IT
        throw new Error(result.message || "Database update failed");
      }
    } catch (err) {
      console.error("Critical Disable Error:", err);
      // Stay in the modal but show the error message
      setErrorModal(prev => ({
        ...prev,
        show: true,
        title: "Update Failed",
        message: err.message || "Check server logs.",
      }));
    } finally {
      setLoading(false); // 🚩 Stop the spinner
    }
  };

  // 🚩 3. Verify MFA (Success callback)
  const onMfaVerified = () => {
    // 1. Update State
    setUser(prev => ({
      ...prev,
      twoFactorEnabled: true
    }));

    // 2. Update LocalStorage
    const raw = localStorage.getItem("quo_pro_session");
    if (raw) {
      const savedSession = JSON.parse(raw);
      localStorage.setItem("quo_pro_session", JSON.stringify({
        ...savedSession,
        twoFactorEnabled: true
      }));
    }
  };

  // 1. Stable update function
  const handleUpdateGlobal = React.useCallback((id, updatedItem) => {
    setQuote((prev) => prev.map((i) => (i.id === id ? updatedItem : i)));
  }, []);

  const handleUpdateItem = React.useCallback((id, field, value) => {
    setQuote((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item))
    );
  }, []);

  // 2. Stable filtering
  const filteredItems = useMemo(() => {
    const query = (itemSearchQuery || "").toLowerCase();
    if (!query) return quote;
    return quote.filter(
      (item) =>
        (item.ref || "").toLowerCase().includes(query) ||
        (item.desc || "").toLowerCase().includes(query)
    );
  }, [quote, itemSearchQuery]);

  //SUPPLIER QUOTES RENDERING

  const memoSuppliers = useMemo(() => {
    const query = (supSearchQuery || "").toLowerCase();
    return supList.filter(
      (s) =>
        s.name?.toLowerCase().includes(query) ||
        s.email?.toLowerCase().includes(query)
    );
  }, [supList, supSearchQuery]);

  const filteredAndSortedProjects = useMemo(() => {
    if (!projects) return [];

    const searchTerm = (projectSearchQuery || "").toLowerCase();

    // ✅ Combined Filter: Search Logic + Exclusion of Cancelled Projects
    let result = projects.filter((p) => {
      // Check if project matches search term
      const matchesSearch =
        p.name?.toLowerCase().includes(searchTerm) ||
        p.client?.toLowerCase().includes(searchTerm) ||
        p.id?.toString().includes(searchTerm);

      // Check if project is NOT cancelled
      const isNotCancelled = p.status?.toUpperCase() !== "CANCELLED";

      return matchesSearch && isNotCancelled;
    });

    // Sort logic remains purely Alphabetical (A-Z)
    return result.sort((a, b) => {
      const nameA = a.name || "";
      const nameB = b.name || "";
      return nameA.localeCompare(nameB);
    });
  }, [projects, projectSearchQuery]);

  //WORKFLOWS
  // 1. Move the Modal State here
  const [workflows, setWorkflows] = useState([]); // Add this state
  const [showWorkflowModal, setShowWorkflowModal] = useState(false);

  const beeSpendData = useMemo(() => {
    if (!sups || sups.length === 0 || !quote) return [];

    const supplierMap = (supList || []).reduce((acc, s) => {
      acc[String(s.id)] = s;
      return acc;
    }, {});

    // Initialize levels with both a 0 value AND an empty Set for names
    const levels = {
      "Level 1": { value: 0, names: new Set() },
      "Level 2": { value: 0, names: new Set() },
      "Level 3": { value: 0, names: new Set() },
      "Level 4": { value: 0, names: new Set() },
      "Level 5": { value: 0, names: new Set() },
      "Level 6": { value: 0, names: new Set() },
      "Level 7": { value: 0, names: new Set() },
      "Level 8": { value: 0, names: new Set() },
      "Non-Compliant": { value: 0, names: new Set() },
    };

    sups.forEach((s) => {
      const detail = supplierMap[String(s.sid || s.id)];
      const vendorName = detail?.name || s.name || "Unknown Supplier";

      let levelValue = detail?.beeLevel
        ? String(detail.beeLevel)
        : "Non-Compliant";

      let levelKey = levelValue;
      if (!levelValue.includes("Level") && levelValue !== "Non-Compliant") {
        levelKey = `Level ${levelValue}`;
      }

      const totalSpend = (quote || []).reduce((acc, item) => {
        const price = parseFloat(s.quotes?.[item.ref]?.price || 0);
        const qty = parseFloat(item.qty || 0);
        return acc + price * qty;
      }, 0);

      const targetKey =
        levels[levelKey] !== undefined ? levelKey : "Non-Compliant";

      // Add the spend AND the name to the specific level
      levels[targetKey].value += totalSpend;
      if (totalSpend > 0) {
        levels[targetKey].names.add(vendorName);
      }
    });

    return Object.keys(levels).map((key) => ({
      name: key === "Non-Compliant" ? "N/C" : key.replace("Level ", "L"),
      value: levels[key].value,
      originalName: key,
      // Convert Set to Array so Recharts can pass it to the Tooltip
      suppliers: Array.from(levels[key].names),
    }));
  }, [sups, quote, supList]);

  const initiateCancel = (workflow) => {
    setWorkflowToCancel(workflow); // Triggers the modal below
  };

  const confirmCancelWorkflow = async () => {
    if (!workflowToCancel) return;
    setIsCancelling(true);

    const workflowId = workflowToCancel.id || workflowToCancel._id;
    const projectId = workflowToCancel.targetEntityId;

    try {
      // --- 🚀 STAGE 1: BACKEND UPDATES ---
      // We wrap these in Promise.all so they happen concurrently for speed
      const [workflowRes, projectRes] = await Promise.all([
        fetch(`${BACKEND_URL}/api/workflows/${workflowId}/status`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            status: "CANCELLED",
            approverEmail: user.email,
            comment: "Request cancelled by owner",
          }),
        }),
        fetch(`${BACKEND_URL}/api/projects/${projectId}?companyId=${user.companyId}`, {
          method: "DELETE"
        })
      ]);

      if (!workflowRes.ok || !projectRes.ok) {
        throw new Error("Server failed to process cancellation or deletion.");
      }

      // --- ✨ STAGE 2: UI SYNC (THE CRASH ZONE) ---

      // 1. Update Projects List
      if (typeof setProjects === 'function') {
        setProjects(prev => prev.filter(p => String(p.id) !== String(projectId)));
      }

      // 2. Update Workflow Stats (Safe Check)
      // Check if setWorkflowStats exists. If not, try setWorkflows.
      if (typeof setWorkflowStats === 'function') {
        setWorkflowStats((prev) => ({
          ...prev,
          mine: (prev.mine || []).map((req) => {
            const reqId = req.id || req._id;
            return reqId === workflowId
              ? { ...req, status: "CANCELLED", updatedAt: new Date().toISOString() }
              : req;
          }),
        }));
      } else if (typeof setWorkflows === 'function') {
        setWorkflows((prev) => prev.map((req) => {
          const reqId = req.id || req._id;
          return reqId === workflowId
            ? { ...req, status: "CANCELLED" }
            : req;
        }));
      }

      // 3. Handle Active Project Context
      if (currentProject && String(currentProject.id) === String(projectId)) {
        if (typeof switchProject === 'function') {
          // Pass null or the first available project from the locally filtered list
          switchProject(null);
        }
      }

      // --- 🏁 STAGE 3: CLEANUP ---
      setWorkflowToCancel(null);

    } catch (err) {
      console.error("Critical Sync Error:", err);
      // Only show the error modal if the error isn't about the UI state
      if (!err.message.includes("is not defined")) {
        setErrorModal({
          show: true,
          title: "Update Notice",
          message: "Action completed, but UI sync encountered an issue. Please refresh."
        });
      }
      // Force close modal anyway since the backend work IS done
      setWorkflowToCancel(null);
    } finally {
      setIsCancelling(false);
    }
  };

  // Optimized: One loop to categorize all workflows at once
  const workflowStats = useMemo(() => {
    const canApprove =
      user?.isOwner ||
      ["owner", "lead", "manager"].includes(user?.role?.toLowerCase());
    const initial = { pending: [], action: [], mine: [] };

    return (workflows || []).reduce((acc, w) => {
      const isPending = w.status?.toUpperCase() === "PENDING";

      if (isPending) acc.pending.push(w);

      // Action required if pending, I have permission, and I didn't start it
      if (isPending && canApprove && w.requestedBy !== user?.email) {
        acc.action.push(w);
      }

      // My own requests tracker
      if (w.requestedBy === user?.email) {
        acc.mine.push(w);
      }

      return acc;
    }, initial);
  }, [workflows, user]);

  const fetchWorkflows = async () => {
    try {
      const res = await fetch(
        `${BACKEND_URL}/api/workflows/workspace/${user.companyId}`
      );
      const data = await res.json();
      setWorkflows(data || []);
    } catch (err) {
      console.error("Workflow fetch failed", err);
    }
  };

  const [chatOpen, setChatOpen] = useState(false);
  const [chatInput, setChatInput] = useState("");
  const [messages, setMessages] = useState([
    {
      role: "ai",
      text: "Hey! I'm QuoBolt, your speedy assistant! I can help you analyze your projects or even wipe items if you ask nicely. What's on your mind?",
    },
  ]);

  //AUDIT LOG FEATURES AND FUNCTIONS
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "timestamp",
    direction: "desc",
  });
  const [matrixSort, setMatrixSort] = useState({
    key: "finalTotal", // Default to sorting by price
    direction: "asc", // Default to cheapest first
  });

  const [activeModalSup, setActiveModalSup] = useState(null);
  const [selectedSupplierForModal, setSelectedSupplierForModal] =
    useState(null);

  const verifyQuoteIntegrity = (sup, quoteList) => {
    // 1. Recalculate what the total SHOULD be right now
    const expectedTotal = calculateGrandTotal(sup, quoteList);

    // 2. Compare against the total stored in the supplier object
    const currentTotal = Number(sup.totalLandedCost) || 0;

    // 3. Check for discrepancy (using a 0.01 tolerance for safety)
    const isIntegrityIntact = Math.abs(expectedTotal - currentTotal) < 0.01;

    return {
      isIntegrityIntact,
      expectedTotal,
      currentTotal,
      diff: Math.abs(expectedTotal - currentTotal).toFixed(2),
    };
  };

  const updateSurcharge = (key, value) => {
    // Use parseFloat to ensure '10.50' stays 10.5 instead of 10
    const numericValue = value === "" ? 0 : parseFloat(value);

    setSelectedSupplierForModal((prev) => ({
      ...prev,
      [key]: numericValue,
    }));
  };

  const toggleVat = () => {
    setSelectedSupplierForModal((prev) => ({
      ...prev,
      isVatInclusive: !prev.isVatInclusive,
    }));
  };
  // This should be set when you select a project from your dashboard
  const [activeProject, setActiveProject] = useState(null);

  // 1. Helper to get the absolute base (Material only)
  const getBaseMaterialTotal = (supplierSlot, projectQuote) => {
    if (!supplierSlot || !projectQuote) return 0;

    const total = projectQuote.reduce((acc, item) => {
      // Use parseFloat to ensure cents in the price/qty are preserved
      const price = parseFloat(supplierSlot.quotes?.[item.ref]?.price) || 0;
      const qty = parseFloat(item.qty) || 0;
      return acc + price * qty;
    }, 0);

    return Number(total.toFixed(2));
  };

  // 2. The Master Grand Total Function
  const calculateGrandTotal = (
    supplierSlot,
    projectQuote,
    projectBudgetAmount = 0
  ) => {
    // 1. Get Base Material
    const baseMaterial =
      typeof getBaseMaterialTotal === "function"
        ? getBaseMaterialTotal(supplierSlot, projectQuote)
        : 0;

    // 2. Sum Fees safely
    const delivery = Number(supplierSlot?.deliveryFee) || 0;
    const insurance = Number(supplierSlot?.insuranceFee) || 0;
    const handling = Number(supplierSlot?.handlingFee) || 0;
    const misc = Number(supplierSlot?.miscFee) || 0;

    const subtotal = baseMaterial + delivery + insurance + handling + misc;

    // 3. VAT Calculation (15%)
    const vatAmount = supplierSlot?.isVatInclusive ? subtotal * 0.15 : 0;

    // 4. Final Grand Total
    const grandTotal = subtotal + vatAmount;

    // 5. Budget Variance - Use the passed-in amount
    const projectBudget = Number(projectBudgetAmount);
    const variance = projectBudget - grandTotal;
    const isOverBudget = variance < 0;

    return {
      subtotal: Number(subtotal.toFixed(2)),
      vatAmount: Number(vatAmount.toFixed(2)),
      grandTotal: Number(grandTotal.toFixed(2)),
      projectBudget,
      variance,
      isOverBudget,
    };
  };

  const handleSaveFinalCosts = async () => {
    if (!currentProject || !selectedSupplierForModal) return;

    const activeProj = projects.find(
      (p) => String(p.id) === String(currentProject)
    );

    // 🚩 FIX: Destructure the object from the logic function
    const { grandTotal, vatAmount, subtotal } = calculateGrandTotal(
      selectedSupplierForModal,
      quote,
      0
    );

    setIsSaving(true);

    const updatedSupplier = {
      ...selectedSupplierForModal,
      deliveryFee: Number(selectedSupplierForModal.deliveryFee) || 0,
      insuranceFee: Number(selectedSupplierForModal.insuranceFee) || 0,
      handlingFee: Number(selectedSupplierForModal.handlingFee) || 0,
      miscFee: Number(selectedSupplierForModal.miscFee) || 0,
      subtotalAmount: subtotal,
      vatAmount: vatAmount,
      totalLandedCost: grandTotal,
      lastUpdated: new Date().toISOString(),
    };

    // 1. Prepare the updated Project and Projects list
    const updatedSups = (activeProj.sups || []).map((s) =>
      String(s.id) === String(updatedSupplier.id) ? updatedSupplier : s
    );

    const updatedProject = {
      ...activeProj,
      sups: updatedSups,
      lastUpdated: new Date().toISOString(),
    };

    const finalProjectsList = projects.map((p) =>
      String(p.id) === String(updatedProject.id) ? updatedProject : p
    );

    try {
      // 2. Standalone DB Sync
      const response = await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: updatedProject }),
      });

      if (!response.ok)
        throw new Error("Server failed to update project costs");

      // 3. Workspace Sync (Storage)
      const freshData = await storage.get(user.companyId);
      await storage.set(
        user.companyId,
        finalProjectsList,
        freshData?.users || allUsers,
        freshData?.activities || activities,
        freshData?.suppliers || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 4. UI Success Sequence
      setProjects(finalProjectsList);
      setSups(updatedSups);

      setIsQuoteModalOpen(false);
      // ✅ Success: Toast removed
    } catch (error) {
      console.error("❌ Sync Error:", error);
      // ✅ Error: Toast removed
    } finally {
      setIsSaving(false);
    }
  };

  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  // Logic to filter and sort
  const filteredActivities = activities
    ?.filter(
      (log) =>
        log.user?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.action?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.details?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key])
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key])
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc")
      direction = "desc";
    setSortConfig({ key, direction });
  };

  const passwordRequirements = useMemo(() => {
    const p = form.password || "";
    return [
      { label: "8+ Characters", met: p.length >= 8 },
      { label: "One Number", met: /\d/.test(p) },
      { label: "One Uppercase", met: /[A-Z]/.test(p) },
      { label: "One Special (@$!%*?)", met: /[@$!%*?&]/.test(p) },
    ];
  }, [form.password]);

  //START NOTIFICATION DB CODE
  const [dismissedNotifs, setDismissedNotifs] = useState([]);
  const [showNotifs, setShowNotifs] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const triggerNotification = async (type, title, message) => {
    // 1. Validation: If we don't have a workspace ID, the DB call will fail
    if (!user?.companyId) {
      console.error(
        "❌ Notification failed: No companyId found in user state."
      );
      return;
    }

    try {
      const response = await fetch(`${BACKEND_URL}/api/notifications`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // Force to UpperCase and trim to match your storage.set logic
          workspaceId: user.companyId.toUpperCase().trim(),
          userId: user.uid || user.email,
          type: type,
          title: title,
          message: message,
          timestamp: new Date().toISOString(), // Good practice for DB indexing
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to write to DB");
      }

      console.log("✅ Notification pushed to DB successfully");

      // 2. CRITICAL: Refresh the local bell icon state so it shows up
      if (typeof fetchNotifications === "function") {
        await fetchNotifications();
      }
    } catch (err) {
      console.error("❌ Notification trigger failed:", err);
    }
  };

  const notificationService = {
    fetch: async (workspaceId) => {
      try {
        // Ensure we don't fetch if ID is missing
        if (!workspaceId) return [];

        const response = await fetch(
          `${BACKEND_URL}/api/notifications/${workspaceId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        return response.ok ? await response.json() : [];
      } catch (err) {
        console.error("Notification Fetch Failed:", err);
        return []; // Return empty array so the app doesn't crash
      }
    },
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setItemSearchQuery(searchBuffer);
    }, 300); // 300ms delay

    return () => clearTimeout(handler);
  }, [searchBuffer]);

  // Add this near your other useEffects
  useEffect(() => {
    if (showProjectModal) {
      setProjectName("");
      setProjectBudget("");
      setProjectDeadline("");
      setShowSuccess(false); // Reset success state too
    }
  }, [showProjectModal]);

  useEffect(() => {
    if (showWorkflowModal && user?.companyId) {
      fetchWorkflows();
    }
  }, [showWorkflowModal, user?.companyId]);

  useEffect(() => {
    if (!user?.companyId) return;

    const refreshNotifs = async () => {
      const data = await notificationService.fetch(user.companyId);
      setNotifications(data);
    };

    refreshNotifs();
    const interval = setInterval(refreshNotifs, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, [user?.companyId]);

  //END NOTIFICATION CODE

  const isPasswordValid = passwordRequirements.every((req) => req.met);

  const strengthLevel = useMemo(() => {
    const metCount = passwordRequirements.filter((r) => r.met).length;
    if (metCount === 0)
      return {
        label: "Very Weak",
        color: "bg-slate-200",
        width: "10%",
        textColor: "text-slate-400",
      };
    if (metCount <= 2)
      return {
        label: "Weak",
        color: "bg-red-400",
        width: "33%",
        textColor: "text-red-500",
      };
    if (metCount === 3)
      return {
        label: "Medium",
        color: "bg-amber-400",
        width: "66%",
        textColor: "text-amber-600",
      };
    return {
      label: "Strong",
      color: "bg-emerald-500",
      width: "100%",
      textColor: "text-emerald-600",
    };
  }, [passwordRequirements]);

  const handleAction = async (id, status, customComment) => {
    try {
      setProcessingId(id);

      const finalComment =
        customComment ||
        decisionNotes[id] ||
        (status === "APPROVED" ? "Approved" : "Rejected");

      // --- 🚀 STAGE 1: SYNC THE WORKFLOW STATUS ---
      const response = await fetch(
        `${BACKEND_URL}/api/workflows/${id}/status`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            status,
            approverEmail: user.email,
            comment: finalComment,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update workflow status");

      // --- 📦 STAGE 2: PROJECT CREATION LOGIC (Only on Approval) ---
      if (status === "APPROVED") {
        const approvedWorkflow = workflows.find(
          (w) =>
            String(w.id) === String(id) || String(w.workflowId) === String(id)
        );

        if (approvedWorkflow) {
          const finalProject = {
            id: Number(approvedWorkflow.targetEntityId),
            name: approvedWorkflow.projectName || approvedWorkflow.name,
            budget: Number(
              approvedWorkflow.snapshotValue || approvedWorkflow.totalValue || 0
            ),
            deadline:
              approvedWorkflow.deadline ||
              approvedWorkflow.projectDeadline ||
              null,
            status: "Draft",
            workflowApproved: true,
            createdBy:
              approvedWorkflow.requestedBy || approvedWorkflow.requester,
            companyId: user.companyId,
            lastUpdated: new Date().toISOString(),
            approvalNote: finalComment,
            quote: [],
            sups: [],
          };

          const projectSyncResponse = await fetch(
            `${BACKEND_URL}/api/projects/sync`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ projectData: finalProject }),
            }
          );

          if (!projectSyncResponse.ok) {
            const errorData = await projectSyncResponse.json();
            throw new Error(
              `Standalone Project Sync Failed: ${errorData.message}`
            );
          }

          const freshData = await storage.get(user.companyId);
          const targetId = Number(finalProject.id);
          const otherProjects = (freshData?.projects || projects || []).filter(
            (p) => Number(p.id) !== targetId
          );
          const updatedProjects = [finalProject, ...otherProjects];

          const userSync = freshData?.users && Object.keys(freshData.users).length > 0
            ? freshData.users
            : allUsers;

          const updatedActivities = [
            {
              id: Date.now(),
              user: user.name || user.email,
              action: "Project Approved",
              details: `${finalProject.name} has been approved. Project is now live in the workspace.`,
              timestamp: new Date().toISOString(),
              type: "SUCCESS",
            },
            ...(freshData.activities || []),
          ];

          await storage.set(
            user.companyId,
            updatedProjects,
            userSync,
            updatedActivities,
            (freshData?.supList || freshData?.suppliers || supList || []),
            user.plan || "starter",
            user.email,
            darkMode ? "dark" : "light"
          );

          setProjects(updatedProjects);
          setActivities(updatedActivities);
        }
      }
      // 🚩 --- 🛡️ STAGE 2.5: REJECTION LOGIC (New Fix) ---
      else if (status === "REJECTED") {
        const rejectedWorkflow = workflows.find(
          (w) => String(w.id) === String(id) || String(w.workflowId) === String(id)
        );

        if (rejectedWorkflow) {
          const targetId = Number(rejectedWorkflow.targetEntityId);
          const freshData = await storage.get(user.companyId);

          // 1. FILTER: Physically remove the rejected project from the list
          const updatedProjects = (freshData?.projects || projects || []).filter(
            (p) => Number(p.id) !== targetId
          );

          const userSync = freshData?.users && Object.keys(freshData.users).length > 0
            ? freshData.users
            : allUsers;

          const updatedActivities = [
            {
              id: Date.now(),
              user: user.name || user.email,
              action: "Project Rejected",
              details: `The project "${rejectedWorkflow.projectName || "Untitled"}" was rejected and removed from workspace.`,
              timestamp: new Date().toISOString(),
              type: "DANGER",
            },
            ...(freshData.activities || []),
          ];

          // 2. SYNC: Save the workspace without the rejected project
          await storage.set(
            user.companyId,
            updatedProjects,
            userSync,
            updatedActivities,
            (freshData?.supList || freshData?.suppliers || supList || []),
            user.plan || "starter",
            user.email,
            darkMode ? "dark" : "light"
          );

          // 3. UI SYNC: Update local state to reflect the removal
          setProjects(updatedProjects);
          setActivities(updatedActivities);
        }
      }

      // --- 🎨 STAGE 4: CLEANUP UI STATE ---
      setDecisionNotes((prev) => {
        const newNotes = { ...prev };
        delete newNotes[id];
        return newNotes;
      });

      fetchWorkflows();
    } catch (err) {
      console.error("❌ Action failed:", err);
      setErrorModal({
        show: true,
        title: "Action Failed",
        message: err.message,
      });
    } finally {
      setProcessingId(null);
    }
  };

  const handleRevise = async (rejectedReq) => {
    setIsRevisingId(rejectedReq.id); // Start loading animation

    try {
      // 1. Cleanup: Delete the old rejected workflow from the backend
      const response = await fetch(
        `${BACKEND_URL}/api/workflows/${rejectedReq.id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) throw new Error("Failed to clear old request");

      // 2. Pre-fill states and switch modals
      setProjectName(rejectedReq.name || rejectedReq.projectName);
      setProjectBudget(rejectedReq.totalValue?.toString() || "");
      setIsInRevisionMode(true);

      setShowWorkflowModal(false);

      setTimeout(() => {
        setShowProjectModal(true);
        fetchWorkflows(); // Refresh list in background
      }, 150);
    } catch (err) {
      console.error("Revision Error:", err);
      setErrorModal({
        show: true,
        title: "Revision Failed",
        message: err.message,
      });
    } finally {
      setIsRevisingId(null); // Stop loading animation
    }
  };

  // Slider State
  const slides = [
    {
      title: "Intelligent",
      highlight: "Procurement.",
      sub: "Simplified.",
      description:
        "Accelerate procurement cycles by centralising supplier quotes within a unified ecosystem. Identify optimal vendor combinations instantly based on fiscal efficiency and logistical speed.",
      stat: "1-Click",
      label: "Quote Import",
    },
    {
      title: "Centralised",
      highlight: "Workspace.",
      sub: "Optimised.",
      description:
        "Eliminate spreadsheet chaos. QuoPro centralises every project, supplier, and communication inside a high-performance dashboard built for modern procurement teams.",
      stat: "Unified",
      label: "Data Hub",
    },
    {
      title: "AI-Powered",
      highlight: "Automation.",
      sub: "Deterministic.",
      description:
        "Our proprietary logic engine instantly isolates 'Low-Cost' and 'Speed-Star' benchmarks, removing human bias and ensuring you always secure the most competitive landing metrics.",
      stat: "99%",
      label: "Faster Workforce",
    },
    {
      title: "Optimised",
      highlight: "Split Analytics.",
      sub: "Profitable.",
      description:
        "Drive profitability with instant Cost-Split Analysis. Pinpoint savings as quotes arrive, pick the best supplier, and generate payment advice without ever leaving your dashboard.",
      stat: "Real-Time",
      label: "Savings Tracking",
    },
    {
      title: "Stay Informed With",
      highlight: "Alerts and Workflows.",
      sub: "Transparent and Accountable.",
      description:
        "QuoPro optimises procurement by automating workflows and alerts. The system eliminates manual follow-ups by notifying stakeholders the moment an official approval is required.",
      stat: "Transparent",
      label: "Alerts and Workflows",
    },
  ];

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => {
      // Only auto-switch if the user hasn't manually set a preference yet
      if (!localStorage.getItem("quo_pro_theme_manual")) {
        setDarkMode(e.matches);
      }
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // ONLY ONE Init Effect
  useEffect(() => {
    const init = async () => {
      try {
        const saved = localStorage.getItem("quo_pro_session");
        if (saved) {
          const u = JSON.parse(saved);
          setUser(u);
          setIsAuth(true);

          // 🚩 Critical: Pulls your workspace data (Level 3-5 Orange loading)
          if (u.companyId) {
            await load(u.companyId);
          }
        }
      } catch (err) {
        console.error("Initialization failed:", err);
        // Optional: setError("Connection lost. Retrying...");
      } finally {
        // 🚩 Always set ready so the Login or Dashboard can actually render
        setAppReady(true);
      }
    };
    init();
  }, []);

  useEffect(() => {
    if (showSettingsModal && settingsTab === "audit") {
      fetchLogs();
    }
  }, [showSettingsModal, settingsTab]);

  useEffect(() => {
    // Disconnect any lingering observers when the component unmounts
    return () => {
      const observers = window.ResizeObserver ? [window.ResizeObserver] : [];
      observers.forEach((obs) => {
        if (obs.disconnect) obs.disconnect();
      });
    };
  }, [showSettingsModal]);

  //Splash Screen Timer - 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => setAppReady(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  // Slider Timer: Set to exactly 10 seconds with Pause Support
  useEffect(() => {
    let interval;

    if (!isAuth && !isPaused) {
      interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 10000);
    }

    // Cleanup: Stops the timer if user logs in, hovers, or leaves the page
    return () => clearInterval(interval);
  }, [isAuth, isPaused, slides.length]);

  // 2. THE MASTER CHECK: Find the owner for this specific company
  const companyOwner = Object.values(allUsers || {}).find(
    (u) => u.companyId === user?.companyId && u.isOwner
  );

  // 3. IF we find an owner, use THEIR plan.
  // Otherwise, fallback to the current user's plan.
  // Updated logic to bypass plan limits on localhost
  const isLocal =
    typeof window !== "undefined" && window.location.hostname === "localhost";

  const effectivePlan = isLocal
    ? "businessPlus" // Force highest plan on localhost
    : companyOwner
      ? companyOwner.plan
      : user?.plan;

  const isFreePlan = !isLocal && effectivePlan === "starter";

  //PASSWORD RESET FUNCTION
  const handleRecoverPassword = async (e) => {
    e.preventDefault();
    if (!validateEmail(recoveryEmail)) {
      return toast.error("Please enter a valid work email.");
    }

    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: recoveryEmail }),
      });

      if (response.ok) {
        setRecoverySent(true);
        toast.success("Recovery link dispatched to your inbox.");
      } else {
        toast.error("Account not found or server is sleeping.");
      }
    } catch (err) {
      console.error("Recovery error:", err);
      toast.error("System offline. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const logActivity = async (action, details, overrideUser = null) => {
    try {
      const activeUser = overrideUser || user;
      // Safety check: If no user and no companyId, we can't log to the cloud
      if (!activeUser || !activeUser.companyId) return activities;

      // 1. Get current workspace data to ensure we don't overwrite other changes
      // This ensures our activity list is merged with the most recent cloud state
      const result = await storage.get(activeUser.companyId);

      // Use logs from cloud if available, otherwise fallback to local state
      let currentLogs =
        result && result.activities ? result.activities : activities;

      const newLog = {
        id: Date.now(),
        user: activeUser.name || activeUser.email,
        action: action,
        details: details,
        timestamp: new Date().toISOString(),
        lastActive:
          new Date().toLocaleDateString("en-GB") +
          " " +
          new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
      };

      // Keep only the last 100 entries to keep the DB document lightweight
      const updatedLogs = [newLog, ...currentLogs].slice(0, 100);

      // 2. Sync to MongoDB using the robust 5-argument signature
      // We pass projects, users, and supList as they are to keep the document whole
      await storage.set(
        activeUser.companyId,
        projects,
        currentProject,
        allUsers,
        updatedLogs,
        supList
      );

      // 3. Update local UI state
      setActivities(updatedLogs);

      return updatedLogs; // Return the new list so calling functions can use the fresh data
    } catch (e) {
      console.error("Audit log failed:", e);
      return activities; // Return existing activities so we don't break the chain
    }
  };

  const [isLoadingLogs, setIsLoadingLogs] = useState(false); // Add this at the top with other states

  // 1. IMPROVED FETCH LOGS (Inside QuoteManager)
  const fetchLogs = async () => {
    if (!user?.companyId) return;
    setIsLoadingLogs(true);

    try {
      const cloudData = await storage.get(user.companyId);

      // Ensure we handle both legacy arrays and the new object structure
      const rawLogs = Array.isArray(cloudData?.activities)
        ? cloudData.activities
        : [];

      // Force a new reference for React's reconciliation engine
      const sortedLogs = [...rawLogs].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );

      setActivities(sortedLogs);
      console.log("✅ Audit Logs Refreshed:", sortedLogs.length);
    } catch (e) {
      console.error("Failed to fetch logs:", e);
    } finally {
      setTimeout(() => setIsLoadingLogs(false), 300);
    }
  };

  const clearAuditLog = async () => {
    setConfirmModal({
      show: true,
      title: "Clear Audit Log?",
      message:
        "This will permanently delete the entire activity history. This action cannot be undone.",
      onConfirm: async () => {
        setIsDeleting(true);
        try {
          if (!user?.companyId) return;

          // 1. FETCH THE TRUTH: Get the latest data from the cloud
          const freshData = await storage.get(user.companyId);

          // 2. DEFINE THE WIPE: We want the log to be empty, then add the "Wiped" entry
          const wipedActivities = [];

          // 3. PREPARE THE "WIPED BY" ENTRY (Compliance requirement)
          const cleanupEntry = {
            id: Date.now(),
            type: "system",
            title: "Audit Log Wiped",
            description: `All previous activity history was permanently deleted by ${user.name}`,
            timestamp: new Date().toISOString(),
          };

          const finalActivities = [cleanupEntry, ...wipedActivities];

          // 4. ATOMIC SYNC: Re-save everything from freshData, but swap in the new activities
          await storage.set(
            user.companyId,
            freshData?.projects || projects || [], // Use cloud data, fallback to local
            freshData?.users || allUsers || {}, // Ensure users object is preserved
            finalActivities, // THE ONLY THING BEING CHANGED
            freshData?.supList || supList || [], // Ensure suppliers are preserved
            user.plan || "starter",
            user.email || "",
            darkMode ? "dark" : "light"
          );

          // 5. UPDATE LOCAL UI
          setActivities(finalActivities);

          setConfirmModal((prev) => ({ ...prev, show: false }));
        } catch (e) {
          console.error("Wipe failed", e);
          alert("Error syncing data to cloud.");
        } finally {
          setIsDeleting(false);
        }
      },
    });
  };

  const validatePassword = (pass) => {
    // Criteria: 8+ chars, 1 uppercase, 1 number, 1 special symbol
    const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&*])[A-Za-z\d!@#$%&*]{8,}$/;
    return regex.test(pass);
  };



  const handleActivate = async (plan) => {
    setIsFinalizing(true);

    // Simulated steps for UX "feel"
    setTimeout(() => setLoadingStep(1), 800); // "Provisioning Database..."
    setTimeout(() => setLoadingStep(2), 1800); // "Securing Workspace..."
    setTimeout(() => setLoadingStep(3), 2800); // "Finalizing Credentials..."

    try {
      // Call your actual function
      await finalizeSignup(plan, false);
    } catch (error) {
      setIsFinalizing(false);
      toast.error("Activation failed. Please try again.");
    }
  };



  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  /////////////////                       //////////////////
  /////////////////                       //////////////////
  /////////////////     LEMON SQUEEZY     //////////////////
  /////////////////                       //////////////////
  /////////////////                       //////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////

  const signup = async () => {
    setLoading(true);
    setError("");

    if (!form.email || !form.password || !form.companyId || !form.name) {
      setError("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const formattedID = form.companyId.toUpperCase().trim();
      const isJoining = regMode === "join";

      if (isJoining) {
        const checkRes = await fetch(`${BACKEND_URL}/api/workspace/${formattedID}`);

        if (!checkRes.ok) {
          setError(`Workspace "${formattedID}" not found.`);
          setLoading(false);
          return;
        }

        const workspaceData = await checkRes.json();
        const usersArray = workspaceData.users ? Object.values(workspaceData.users) : [];
        const emailExists = usersArray.some(u => u?.email?.toLowerCase() === form.email.toLowerCase());

        if (emailExists) {
          setError(`"${form.email}" already exists in "${formattedID}".`);
          setLoading(false);
          return;
        }

        // 🟢 FIX 1: Safely grab the workspace owner's true plan tier
        const inheritedPlan = workspaceData.plan || "starter";

        // Pass the live database workspace data through to prevent frontend sync race conditions
        return await finalizeSignup({ id: inheritedPlan }, false, 'ZAR', workspaceData);

      } else {
        // OWNER PATH
        const checkRes = await fetch(`${BACKEND_URL}/api/workspace/${formattedID}`);
        if (checkRes.ok) {
          setError("Workspace ID already taken. Choose another or click 'Join'.");
          setLoading(false);
          return;
        }

        setLoading(false);
        setShowPricingModal(true); // This opens the modal where the user picks a plan
      }
    } catch (err) {
      console.error("Signup Check Error:", err);
      setError("Connection error. Please try again.");
      setLoading(false);
    }
  };

  const finalizeSignup = async (
    selectedPlan,
    isYearlyMode = false,
    selectedCurrency = 'ZAR',
    fetchedWorkspaceData = null // 🟢 FIX 2: Accept optional live database snapshot
  ) => {

    setLoading(true);
    setError("");

    try {
      const formattedID = form.companyId.toUpperCase().trim();
      const isJoining = regMode === "join";
      const isOwner = !isJoining;

      // ================================
      // DETERMINE PLAN
      // ================================
      const planId =
        (
          typeof selectedPlan === "string"
            ? selectedPlan
            : selectedPlan?.id
        ) || "starter";

      const isPaidPlan = planId === "pro" || planId === "businessPlus";
      const needsToPay = isOwner && isPaidPlan;

      // ================================================================
      // 🟢 FIX 3: ASSIGN THE REAL INHERITED PLAN TO THE SERVER PAYLOAD
      // ================================================================
      const signupData = {
        name: form.name,
        email: form.email.toLowerCase().trim(),
        password: form.password,
        companyId: formattedID,
        plan: planId, // 🚀 FORCE THE MEMBER TO ADOPT THE OWNER'S PLAN STRATEGICALLY!
        isJoining,
        isOwner,
        role: isOwner ? "owner" : "member",
        theme: darkMode ? "dark" : "light",
      };

      // ================================
      // CREATE USER
      // ================================
      const response = await fetch(
        `${BACKEND_URL}/api/auth/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(signupData),
        }
      );

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Signup failed.");
      }

      const userId = result.id || result._id || signupData.email;

      // ================================
      // PAID PLAN FLOW (OWNERS ONLY)
      // ================================
      if (needsToPay) {
        const checkoutMap = {
          pro: {
            monthly: "https://quopro.lemonsqueezy.com/buy/d44434e9-e250-4985-b603-393bb6bb97a0",
            annually: "https://quopro.lemonsqueezy.com/buy/da329224-382c-41c9-9212-22b387440071",
          },
          businessPlus: {
            monthly: "https://quopro.lemonsqueezy.com/buy/34df84b4-1b89-44fe-a452-e9cd741d3647",
            annually: "https://quopro.lemonsqueezy.com/buy/b4502404-db50-4d32-846a-bc480d6550c7",
          },
        };

        const cycle = isYearlyMode ? "annually" : "monthly";
        const checkoutUrl = checkoutMap[planId]?.[cycle];

        if (!checkoutUrl) {
          throw new Error(`Checkout URL missing for ${planId}`);
        }

        const params = new URLSearchParams({
          "checkout[email]": signupData.email,
          "checkout[name]": signupData.name,
          "checkout[custom][user_id]": signupData.email,
          "checkout[custom][companyId]": formattedID,
          "checkout[custom][plan]": planId,
          "checkout[billing_address][country]": "ZA",
          "embed": "1",
          "checkout[success_url]": "https://quopromanager.co.za",
          "checkout[media]": "0",
          "checkout[logo]": "0",
        });

        const finalCheckoutUrl = `${checkoutUrl}?${params.toString()}`;
        console.log("🚀 Opening Lemon Checkout:", finalCheckoutUrl);

        if (window.LemonSqueezy && window.LemonSqueezy.Url && typeof window.LemonSqueezy.Url.Open === "function") {
          window.LemonSqueezy.Url.Open(finalCheckoutUrl);
        } else {
          window.location.href = finalCheckoutUrl;
        }

        setLoading(false);
        return;
      }

      // ================================================================
      // FREE / JOIN FLOW (🟢 FIX 4: PREVENT FRESH CACHE DEGRADATION)
      // ================================================================
      // Prioritize the live database object passed down over stale storage reads
      const currentWorkspace = fetchedWorkspaceData || await storage.get(formattedID);
      const planToAssign = currentWorkspace?.plan || planId;

      const safeEmailKey = signupData.email.replace(/\./g, "_");

      const userEntry = {
        name: signupData.name,
        email: signupData.email,
        role: isOwner ? "Owner" : "Member",
        isOwner,
        joinedAt: new Date().toISOString(),
        plan: planToAssign, // Synchronized with Owner's active tier
        companyId: formattedID,
        theme: signupData.theme,
      };

      const existingUsers = currentWorkspace?.users && !Array.isArray(currentWorkspace.users)
        ? currentWorkspace.users
        : {};

      const updatedUsers = {
        ...existingUsers,
        [safeEmailKey]: userEntry,
      };

      await storage.set(
        formattedID,
        currentWorkspace?.projects || [],
        updatedUsers,
        currentWorkspace?.activities || [],
        currentWorkspace?.supList || [],
        planToAssign,
        signupData.email,
        signupData.theme
      );

      // 🟢 FIX 5: Ensure local session object matches the active plan before caching
      const sessionData = {
        ...signupData,
        plan: planToAssign, // Overwrite "pending" states in user context
        id: userId,
      };

      localStorage.setItem("quo_pro_session", JSON.stringify(sessionData));
      setUser(sessionData);

      await load(formattedID);
      setIsAuth(true);
      setShowPricingModal(false);

    } catch (e) {
      console.error("Finalise Error:", e);
      setError(e.message || "Something went wrong during signup.");
    } finally {
      setLoading(false);
    }
  };

  //////////////////////////////////////////////////////////
  /////////////////                       //////////////////
  /////////////////   LEMON SQUEEZY END   //////////////////
  /////////////////                       //////////////////
  //////////////////////////////////////////////////////////


  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  /////////////////                        //////////////////
  /////////////////                        //////////////////
  /////////////////  MFA LOGIN AND SIGNUP  //////////////////
  /////////////////                        //////////////////
  /////////////////                        //////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////

  const completeLoginSequence = async (u) => {
    const sess = {
      ...u, // 🚩 This is the safest way! It grabs EVERY field from the DB result
      id: u._id,
      twoFactorEnabled: u.twoFactorEnabled
    };

    // 1. Update session locally
    localStorage.setItem("quo_pro_session", JSON.stringify(sess));
    setUser(sess);

    // 2. Fetch the workspace data
    await load(u.companyId);

    // 3. Log Activity
    try {
      await logActivity("User Login", `${u.name || u.email} logged in`, sess);
    } catch (logErr) {
      console.warn("Activity log failed:", logErr);
    }

    // 4. Reset UI States
    setAppReady(true);
    setIsAuth(true);
    setShowMfaChallenge(false);
    setForm({ email: "", password: "", name: "", companyId: "" });
  };

  const login = async () => {
    if (!form.email?.trim() || !form.password?.trim() || !form.companyId?.trim()) {
      setError("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email.toLowerCase().trim(),
          password: form.password,
          companyId: form.companyId.toUpperCase().trim(),
        }),
      });

      const result = await response.json();

      if (!response.ok) throw new Error(result.message || "Invalid credentials");

      // 🚩 MFA INTERCEPT
      if (result.mfaRequired) {
        setTempUserId(result.userId); // Make sure this state exists
        setShowMfaChallenge(true);    // This matches your JSX variable
        setLoading(false);
        return;
      }

      // No MFA? Run the sequence
      await completeLoginSequence(result.user);

    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyMfaLogin = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/verify-login-mfa`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: tempUserId,
          token: mfaToken // Matches your JSX variable 'mfaToken'
        }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Invalid verification code");
      }

      // 🚩 MFA Success! Run the sequence
      await completeLoginSequence(result.user);
      // ✅ Log Login Activity using the 'result' object
      try {
        // Use 'result.user' since that is what the server returned
        const userIdentifier = result.user.name || result.user.email;

        // Ensure you are passing the correct session/token if logActivity requires it
        await logActivity("User Login", `${userIdentifier} logged in`, result.token || result.session);
      } catch (logErr) {
        console.warn("Activity log failed:", logErr);
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };



  //WORKING LOGIN FUNCTION
  /*const login = async () => {
    if (
      !form.email?.trim() ||
      !form.password?.trim() ||
      !form.companyId?.trim()
    ) {
      setError("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email.toLowerCase().trim(),
          password: form.password,
          companyId: form.companyId.toUpperCase().trim(),
        }),
      });

      const result = await response.json();

      // 🚩 START OF MFA ADDITION
      if (result.mfaRequired) {
        setTempUserId(result.userId); // Ensure you have this state defined in your component
        setShowMfaChallenge(true); // Ensure you have this state defined in your component
        setLoading(false);
        return; // Stop the function here to wait for the 6-digit code
      }
      // 🚩 END OF MFA ADDITION

      if (!response.ok || !result.success)
        throw new Error(result.message || "Invalid credentials");

      const u = result.user;
      if (!u || !u.companyId)
        throw new Error("Login successful, but user data is missing.");

      const sess = {
        email: u.email,
        name: u.name,
        plan: u.plan,
        isOwner: u.isOwner,
        companyId: u.companyId,
      };

      // 1. Update session locally
      localStorage.setItem("quo_pro_session", JSON.stringify(sess));
      setUser(sess);

      // 2. Fetch the workspace data
      await load(u.companyId);

      // 🚩 CRITICAL FIX: Await the log BEFORE changing Auth states
      try {
        // Inside your login function...
        await logActivity(
          "User Login",
          `${u.name || u.email} logged in to QuoPro`,
          sess // 🚩 Pass the session here as the 'overrideUser'
        );
      } catch (logErr) {
        console.warn("Activity log failed:", logErr);
      }

      // 3. Trigger UI changes ONLY after log is sent
      setAppReady(true);
      setIsAuth(true);
      setForm({ email: "", password: "", name: "", companyId: "" });
    } catch (e) {
      console.error("Login Error:", e);
      setError(e.message.includes("fetch") ? "Server offline" : e.message);
    } finally {
      setLoading(false);
    }
  };*/


  const shareToWhatsApp = (supplier, projectName) => {
    // 1. Safety Check: Find the full profile from registry to get the phone number
    const fullProfile = supList.find(
      (s) => s.id === (supplier.sid || supplier.id)
    );
    const phoneNumber = fullProfile?.phone || supplier.phone;

    if (!phoneNumber) {
      return alert(
        `No phone number found for ${fullProfile?.name || "this supplier"}.`
      );
    }

    // 2. Format the items list from the current project quote
    // We use the global 'quote' state which holds the current project's items [cite: 233, 282]
    const itemsList =
      quote.length > 0
        ? quote
          .map(
            (item) => `• *Ref:* ${item.ref} - ${item.desc} (Qty: ${item.qty})`
          )
          .join("\n")
        : "No items listed yet.";

    // 3. Clean and format the phone number securely for international routing
    let cleanPhone = phoneNumber.toString().replace(/\D/g, "");

    // 🇿🇦 South African Number Handler: If it starts with local 0 (e.g., 0721234567)
    if (cleanPhone.startsWith("0") && cleanPhone.length === 10) {
      cleanPhone = `27${cleanPhone.slice(1)}`; // Drops the '0', prepends '27' -> 27721234567
    }
    // If the user already saved it as 27721234567 but added a leading + (which got stripped to 27...)
    else if (cleanPhone.startsWith("27") && cleanPhone.length === 11) {
      // It's already perfect, do nothing
    }
    // Fallback safeguard: If it's missing a country code entirely and too short
    else if (cleanPhone.length === 9 && !cleanPhone.startsWith("27")) {
      cleanPhone = `27${cleanPhone}`;
    }

    // 4. Create the professional message template with the items list
    const rawMessage =
      `*Request for Quote*\n\n` +
      `Hi ${fullProfile?.name || "Supplier"},\n\n` +
      `We would like to request a quote for the following items:\n\n` +
      `${itemsList}\n\n` +
      `Please let us know your best pricing and lead times. A formal email will be sent upon request to further the quotation.\n\n` +
      'Thank you!';

    // 5. Securely encode the message for the URL
    const encodedMessage = encodeURIComponent(rawMessage);

    // 6. Open the WhatsApp Link
    window.open(`https://wa.me/${cleanPhone}?text=${encodedMessage}`, "_blank");
  };

  // --- THE FINAL SETTINGS CLOSE FIX ---
  const closeSettings = () => {
    setActivities([]);
    setShowSettingsModal(false);
    setShowPricingModal(false);
    setNewPassword("");
  };

  // Apply the theme class to the HTML root immediately
  useEffect(() => {
    const root = window.document.documentElement;
    if (darkMode) {
      root.classList.add("dark");
      // This ensures the setting survives a page refresh
      localStorage.setItem("quopro_theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("quopro_theme", "light");
    }
  }, [darkMode]);

  const load = async (companyId) => {
    if (!companyId) return;
    try {
      const freshData = await storage.get(companyId);
      if (freshData) {
        // 🚩 STEP 1: ONLY UPDATE IF DATA IS DIFFERENT (Prevents Scroll Jump)
        // This stops the constant re-rendering that throws you to the top
        if (JSON.stringify(freshData.projects) !== JSON.stringify(projects)) {
          setProjects(freshData.projects || []);
        }
        if (
          JSON.stringify(freshData.activities) !== JSON.stringify(activities)
        ) {
          setActivities(freshData.activities || []);
        }
        if (JSON.stringify(freshData.supList) !== JSON.stringify(supList)) {
          setSupList(freshData.supList || []);
        }
        if (JSON.stringify(freshData.users) !== JSON.stringify(allUsers)) {
          setAllUsers(freshData.users || {});
        }

        // 2. Resolve the Active Project
        const targetId = currentProject || freshData.projects?.[0]?.id;
        if (!targetId) return;

        const projectList = freshData.projects || [];
        const active = projectList.find(
          (p) => String(p.id) === String(targetId)
        );

        if (active) {
          // Only update basic strings if they changed
          if (String(currentProject) !== String(active.id)) {
            setCurrentProject(active.id);
          }
          if (projectName !== active.name) {
            setProjectName(active.name || "");
          }

          // 🚩 RESET PREVENTION LOGIC (Updated to be more strict)
          // We only hydrate these if the local state is completely empty
          // This ensures your scroll position in the quote table stays put.
          setQuote((prev) => {
            if (prev && prev.length > 0) return prev; // Keep current
            return active.quote || [];
          });

          setSups((prev) => {
            if (prev && prev.length > 0) return prev; // Keep current
            return active.sups || [];
          });
        }
      }
    } catch (err) {
      console.error("❌ Critical Load Error:", err);
    }
  };

  /*useEffect(() => {
    const initApp = async () => {
      // Start progress
      setLoadProgress(10);

      const saved = localStorage.getItem("quo_pro_session");
      if (saved) {
        const u = JSON.parse(saved);
        setUser(u);
        setIsAuth(true);

        if (u.companyId) {
          setLoadProgress(30);

          // Fake a smooth climb while the network works
          const interval = setInterval(() => {
            setLoadProgress((prev) => (prev < 90 ? prev + 2 : prev));
          }, 150);

          await load(u.companyId);

          clearInterval(interval);
          setLoadProgress(95);

          setTimeout(() => {
            setLoadProgress(100);
            setTimeout(() => setRenderingReady(true), 200);
          }, 400);
        }
      } else {
        setLoadProgress(100);
        setAppReady(true);
        setRenderingReady(true);
      }
    };
    initApp();
  }, [])*/
  useEffect(() => {
    const initApp = async () => {
      // 1. Initial Check: If no user is logged in, just stop here
      const saved = localStorage.getItem("quo_pro_session");
      if (!saved) {
        setLoadProgress(100);
        setAppReady(true);
        setRenderingReady(true);
        return;
      }

      setLoadProgress(10);
      const u = JSON.parse(saved);

      // Safety: Set local states if they aren't set yet
      if (!user) setUser(u);
      if (!isAuth) setIsAuth(true);

      if (u.companyId) {
        setLoadProgress(30);

        const interval = setInterval(() => {
          setLoadProgress((prev) => (prev < 90 ? prev + 2 : prev));
        }, 150);

        // --- 🚩 SYNC SUBSCRIPTION ON LOGIN/REFRESH ---
        try {
          const cleanId = u.companyId.trim().toUpperCase();
          const response = await fetch(`${BACKEND_URL}/api/workspace/${cleanId}/subscription`);

          if (response.ok) {
            const data = await response.json();

            // Update the workspace state so the UI locks/unlocks immediately
            setWorkspace(prev => ({
              ...prev,
              subscriptionActive: data.subscriptionActive
            }));

            console.log(`%c 💳 WORKSPACE SUBSCRIPTION: ${data.subscriptionActive ? 'ACTIVE' : 'INACTIVE'}`, "color: #38bdf8; font-weight: bold;");
          }
        } catch (err) {
          console.error("❌ Subscription Sync Error:", err);
        }

        await load(u.companyId);

        clearInterval(interval);
        setLoadProgress(95);

        setTimeout(() => {
          setLoadProgress(100);
          setTimeout(() => setRenderingReady(true), 200);
        }, 400);
      }
    };

    initApp();

    // 🚩 THE MAGIC: Adding these dependencies makes the code run 
    // the moment 'isAuth' changes to true (i.e., when you click login)
  }, [isAuth, user?.companyId]);


  const handleQuoteChange = (ref, field, value) => {
    setSelectedSupplierForModal((prev) => ({
      ...prev,
      quotes: {
        ...prev.quotes,
        [ref]: {
          ...prev.quotes?.[ref],
          [field]: value,
        },
      },
    }));
  };

  const logout = async () => {
    try {
      // 1. START THE ANIMATION FIRST
      // This triggers the {isLoggingOut && (...)} block in your UI
      setIsLoggingOut(false);
      window.isLoggingOut = true; // Global flag to block DB writes

      // 2. WAIT FOR THE DRAMATIC EFFECT
      // Your UI has "animate-in duration-700", so we wait 2 seconds
      // to let the user see the "cleansing" logs and progress bar.
      await new Promise((resolve) => setTimeout(resolve, 2500));

      // 3. NOW WIPE DATA (After the user has seen the animation)
      localStorage.removeItem("userEmail");
      localStorage.removeItem("companyId");
      localStorage.removeItem("quo_pro_session");

      // Clear state
      setProjects([]);
      setAllUsers({});
      setActivities([]);
      setSupList([]);

      // 4. THE FINAL BLOW
      // This will trigger your "if (!user)" redirect logic
      setUser(null);

      // 5. REDIRECT
      window.location.href = "/";
      setShowWebsite(false);
    } catch (err) {
      console.error("Logout error:", err);
      window.location.reload();
    }
  };

  // This ensures that ANY time 'projects' or 'currentProject' changes,
  // the UI immediately sees the latest status, even on first load.
  const currentProjectData = useMemo(() => {
    return projects.find((p) => String(p.id) === String(currentProject));
  }, [projects, currentProject]);

  const handleImportSuppliers = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const plans = typeof PLANS !== "undefined"
      ? PLANS
      : [{ id: "free", name: "Free", sups: 5 }];

    const userPlan =
      plans.find((p) => p.id === user?.plan) || {
        id: "free",
        name: "Free",
        sups: 5,
      };

    const currentSupCount = (supList || []).length;

    const isUnlimited =
      userPlan?.sups === "Unlimited" ||
      userPlan?.sups === "unlimited";

    const maxSuppliers = isUnlimited
      ? Infinity
      : Number(userPlan?.sups);

    const remainingSlots = isUnlimited
      ? Infinity
      : Math.max(0, maxSuppliers - currentSupCount);

    if (!isUnlimited && remainingSlots <= 0) {
      setErrorModal({
        show: true,
        title: "Limit Reached",
        message: `You cannot import more suppliers on the ${userPlan.name} plan.`,
        type: "error",
      });
      return;
    }

    // =====================================================
    // HEADER NORMALIZER
    // =====================================================
    const normalizeHeader = (header) =>
      header
        ?.toString()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "")
        .trim();

    // =====================================================
    // UNIVERSAL ROW MAPPER
    // =====================================================
    const mapSupplierRow = (row) => {
      const normalized = {};
      Object.keys(row).forEach((key) => {
        normalized[normalizeHeader(key)] = row[key];
      });

      return {
        name:
          normalized.name ||
          normalized.suppliername ||
          normalized.supplier ||
          normalized.companyname ||
          normalized.company ||
          "",

        email:
          normalized.email ||
          normalized.emailaddress ||
          normalized.mail ||
          "",

        phone:
          normalized.phone ||
          normalized.telephone ||
          normalized.telephonenumber ||
          normalized.cellphone ||
          normalized.mobilenumber ||
          "",

        beeLevel:
          normalized.beelevel ||
          normalized.bee ||
          "Non-Compliant",

        addrNo:
          normalized.addrno ||
          normalized.streetnumber ||
          "",

        addrStreet:
          normalized.addrstreet ||
          normalized.street ||
          "",

        addrBuilding:
          normalized.addrbuilding ||
          normalized.building ||
          "",

        addrSuburb:
          normalized.addrsuburb ||
          normalized.suburb ||
          "",

        addrCity:
          normalized.addrcity ||
          normalized.city ||
          "",

        addrProv:
          normalized.addrprov ||
          normalized.province ||
          "",

        addrCountry:
          normalized.addrcountry ||
          normalized.country ||
          "South Africa",

        addrPostal:
          normalized.addrpostal ||
          normalized.postalcode ||
          "",

        sarsPin:
          normalized.sarspin ||
          normalized.sarstcspin ||
          "",

        cipcNum:
          normalized.cipcnum ||
          normalized.cipc ||
          normalized.registrationnumber ||
          "",

        vatNum:
          normalized.vatnum ||
          normalized.vat ||
          "",
      };
    };

    // =====================================================
    // IMPORT PROCESSOR
    // =====================================================
    const processImportedData = async (rawRows) => {
      try {
        let duplicateCount = 0;

        const existingEmails = new Set(
          (supList || [])
            .map((s) => s.email?.toLowerCase().trim())
            .filter(Boolean)
        );

        const existingNames = new Set(
          (supList || [])
            .map((s) => s.name?.toLowerCase().trim())
            .filter(Boolean)
        );

        const uniqueNewSups = [];

        const clean = (value) =>
          value
            ?.toString()
            .replace(/\uFEFF/g, "")
            .replace(/\s+/g, " ")
            .trim() || "";

        for (let i = 0; i < rawRows.length; i++) {
          const rawRow = rawRows[i];
          if (!rawRow) continue;

          const row = mapSupplierRow(rawRow);

          const name = clean(row.name);
          const email = clean(row.email).toLowerCase();
          const phone = clean(row.phone);
          const beeLevel = clean(row.beeLevel || "Non-Compliant");

          const addrNo = clean(row.addrNo);
          const addrStreet = clean(row.addrStreet);
          const addrBuilding = clean(row.addrBuilding);
          const addrSuburb = clean(row.addrSuburb);
          const addrCity = clean(row.addrCity);
          const addrProv = clean(row.addrProv);
          const addrCountry = clean(row.addrCountry || "South Africa");
          const addrPostal = clean(row.addrPostal);

          const sarsPin = clean(row.sarsPin).toUpperCase();
          const cipcNum = clean(row.cipcNum);
          const vatNum = clean(row.vatNum);

          // ============================================
          // VALIDATION
          // ============================================
          if (!name || name.length < 2) {
            const row = mapSupplierRow(rawRow);
            console.log("Mapped Row:", row);
            console.warn(`⚠️ Invalid supplier name at row ${i + 1}`, rawRow);
            continue;
          }

          const lowerName = name.toLowerCase();

          const isDuplicate =
            (email && existingEmails.has(email)) ||
            existingNames.has(lowerName);

          const isSelfDuplicate = uniqueNewSups.some(
            (s) =>
              (email && s.email === email) ||
              s.name.toLowerCase() === lowerName
          );

          if (isDuplicate || isSelfDuplicate) {
            duplicateCount++;
            continue;
          }

          uniqueNewSups.push({
            // Robust runtime fallback calculation ensures UUID never fails in unsecure dev contexts
            id: (typeof crypto !== "undefined" && crypto.randomUUID)
              ? crypto.randomUUID()
              : `sup_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            name,
            email,
            phone,
            status: "pending",
            category: "General",
            beeLevel,
            sarsTcsPin: sarsPin,
            cipcRegNumber: cipcNum,
            vatNumber: vatNum,
            address: {
              no: addrNo,
              street: addrStreet,
              building: addrBuilding,
              suburb: addrSuburb,
              city: addrCity,
              province: addrProv,
              country: addrCountry,
              postalCode: addrPostal,
            },
            popiaConsent: {
              agreed: true,
              agreedAt: new Date(),
              ipAddress: "Bulk-Import",
            },
            companyId: user?.companyId,
            addedBy: user?.email,
            bankVerified: false,
          });
        }
        console.log("uniqueNewSups:", uniqueNewSups);

        console.log("remainingSlots:", remainingSlots);

        console.log("supList:", supList);
        const finalSupsToImport = uniqueNewSups.slice(0, remainingSlots);
        console.log("finalSupsToImport:", finalSupsToImport);
        // ============================================
        // NOTHING VALID
        // ============================================
        if (finalSupsToImport.length === 0) {
          setErrorModal({
            show: true,
            title: duplicateCount > 0 ? "Duplicates Found" : "No Records Created",
            message:
              duplicateCount > 0
                ? `Skipped ${duplicateCount} duplicate suppliers.`
                : "No valid supplier rows were found. Check your column headers match your layout rules.",
            type: "info",
          });
          return;
        }

        // ============================================
        // UPDATE STATE
        // ============================================
        const updatedSupList = [...(supList || []), ...finalSupsToImport];
        const newLog = logActivity(
          "Bulk Import",
          `Imported ${finalSupsToImport.length} suppliers.`
        );

        setSupList(updatedSupList);
        console.log("UPDATED SUP LIST:", updatedSupList);
        console.log("TOTAL COUNT:", updatedSupList.length);
        if (typeof setActivities === "function") {
          setActivities([newLog, ...(activities || [])]);
        }

        // ============================================
        // LOCAL STORAGE & CLOUD BACKEND SYNC
        // ============================================
        if (user?.companyId) {
          await storage.set(
            user.companyId,
            projects || [],
            allUsers,
            [newLog, ...(activities || [])],
            updatedSupList,
            user.plan,
            user.email,
            darkMode ? "dark" : "light"
          );

          const response = await fetch(`${BACKEND_URL}/api/suppliers/bulk`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
            body: JSON.stringify({
              suppliers: finalSupsToImport,
              companyId: user.companyId,
            }),
          });

          if (!response.ok) {
            throw new Error("Cloud Sync Failed");
          }
        }

        setErrorModal({
          show: true,
          title: "Import Successful",
          message: `Successfully imported ${finalSupsToImport.length} suppliers.`,
          type: "success",
        });
      } catch (err) {
        console.error("❌ Import Error:", err);
        setErrorModal({
          show: true,
          title: "Import Error",
          message: err.message || "Failed to import suppliers.",
          type: "error",
        });
      }
    };

    // =====================================================
    // UNIFIED FILE READER ENGINE (XLSX & CSV)
    // =====================================================
    const reader = new FileReader();

    reader.onload = async (event) => {

      try {

        let workbook;

        // ============================================

        // EXCEL FILES

        // ============================================

        if (

          file.name.endsWith(".xlsx") ||

          file.name.endsWith(".xls")

        ) {

          const data = new Uint8Array(event.target.result);

          workbook = XLSX.read(data, {

            type: "array",

            cellDates: true,

            raw: false,

          });

        }

        // ============================================

        // CSV FILES

        // ============================================

        else if (file.name.endsWith(".csv")) {

          const text = event.target.result;

          workbook = XLSX.read(text, {

            type: "string",

            raw: false,

          });

        } else {

          throw new Error("Unsupported file type.");

        }

        const sheetName = workbook.SheetNames[0];

        if (!sheetName) {

          throw new Error("No worksheet found.");

        }

        const sheet = workbook.Sheets[sheetName];

        const rawRows = XLSX.utils.sheet_to_json(sheet, {

          defval: "",

          raw: false,

          blankrows: false,

        });

        console.log("✅ Parsed Rows:", rawRows);

        if (!rawRows || rawRows.length === 0) {

          throw new Error(

            "No readable supplier rows found in this file."

          );

        }

        await processImportedData(rawRows);

      } catch (err) {

        console.error("❌ Parse Error:", err);

        setErrorModal({

          show: true,

          title: "Import Failed",

          message:

            err.message ||

            "Could not read supplier file.",

          type: "error",

        });

      } finally {

        // VERY IMPORTANT

        e.target.value = "";

      }

    };
    // ============================================
    // READ FILE
    // ============================================
    if (

      file.name.endsWith(".xlsx") ||

      file.name.endsWith(".xls")

    ) {

      reader.readAsArrayBuffer(file);

    } else {

      reader.readAsText(file);

    }
  };

  //LOADING THE PROJECT'S ITEMS AND QUOTE ITEMS AFTER PAGE HAS BEEN RELOADED
  useEffect(() => {
    if (currentProject) {
      localStorage.setItem("lastProjectId", currentProject);
    }
  }, [currentProject, projects]); // Automatically saves to memory whenever the state changes

  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////
  //                                                //
  // 🚩 THE MASTER SYNC: COORDINATING UI & DATABASE //
  //                                                //
  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////
  ////////////////////////////////////////////////////

  // Add a ref to track if the initial data load has completed
  const isInitialLoad = useRef(true);

  useEffect(() => {
    // 1. HARD GUARD: Don't do anything if we don't have a user or project
    if (
      !user?.companyId ||
      !currentProject ||
      !projects ||
      projects.length === 0
    ) {
      return;
    }

    // 2. Find the active project
    const active = projects.find(
      (p) => String(p.id) === String(currentProject)
    );
    if (!active) return;

    // --- PART A: DOWNSTREAM (UI Hydration) ---
    const supsChanged = JSON.stringify(active.sups) !== JSON.stringify(sups);
    const quoteChanged = JSON.stringify(active.quote) !== JSON.stringify(quote);

    if (supsChanged) setSups(active.sups || []);
    if (quoteChanged) setQuote(active.quote || []);

    // --- PART B: UPSTREAM (Safe Auto-Save) ---
    // We use a timeout (Debounce) to prevent rapid-fire saves
    // and to ensure we don't save "empty" states during transitions.
    const timeoutId = setTimeout(async () => {
      // 🚩 THE WIPE-GUARD:
      // If we are in the first 2 seconds of the app loading, DON'T AUTO-SAVE.
      // This prevents the empty local state from overwriting the DB.
      if (isInitialLoad.current) {
        isInitialLoad.current = false;
        return;
      }

      // 🚩 DATA INTEGRITY CHECK:
      // If 'sups' exists in the master list but is empty here, and we haven't
      // explicitly called a delete action, block the sync.
      if (active.sups && active.sups.length === 0 && sups.length > 0) {
        console.warn(
          "Wipeout prevented: Attempted to sync empty sups over populated state."
        );
        return;
      }

      try {
        await fetch(`${BACKEND_URL}/api/projects/sync`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ projectData: active }),
        });
      } catch (err) {
        console.error("Master Sync persistence failed:", err);
      }
    }, 1500); // 1.5 second debounce

    return () => clearTimeout(timeoutId);
  }, [projects, currentProject, user?.companyId]);

  // 🚩 NEW TARGETED SYNC FUNCTION
  const syncProjectToDatabase = async (projectObject) => {
    try {
      await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: projectObject }),
      });
      // Silent success for auto-saves to avoid toast spam
    } catch (err) {
      console.error("Auto-sync failed:", err);
    }
  };

  const handleUpdatePlan = async (planId) => {
    try {
      setIsUpdatingPlan(true);
      setLoading(true);

      const response = await fetch(`${BACKEND_URL}/api/workspace/update-plan`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ companyId: user.companyId, plan: planId }),
      });

      if (response.ok) {
        // 1. Determine direction
        const planRanks = { starter: 1, pro: 2, businessPlus: 3 };
        const oldPlan = user.plan || "starter";

        let direction = "Updated";
        if (planRanks[planId] > planRanks[oldPlan]) {
          direction = "Upgraded";
        } else if (planRanks[planId] < planRanks[oldPlan]) {
          direction = "Downgraded";
        }

        const planName = planId.charAt(0).toUpperCase() + planId.slice(1);

        // 2. Create the reference object for the updated state
        const updatedUser = { ...user, plan: planId };

        // 3. LOG & NOTIFY (Move these UP before state changes to ensure 'user' context is valid)
        // If triggerNotification uses 'user.companyId' internally, we use 'updatedUser' values
        await logActivity(
          "Plan Change",
          `Workspace was ${direction.toLowerCase()} to ${planName}.`
        );

        await triggerNotification(
          "limit",
          `Plan ${direction}`,
          `The workspace has been ${direction.toLowerCase()} to the ${planName} plan.`
        );

        // 4. Update the current user state and local storage AFTER notification triggers
        setUser(updatedUser);
        localStorage.setItem("quo_pro_session", JSON.stringify(updatedUser));

        // 5. Update the 'allUsers' list locally
        setAllUsers((prev) => {
          const source = Array.isArray(prev) ? prev : Object.values(prev || {});
          const updated = {};
          source.forEach((u) => {
            updated[u.email.replace(/\./g, "_")] = { ...u, plan: planId };
          });
          return updated;
        });

        setPendingPlan(null);
        toast.success(`Plan ${direction.toLowerCase()} successfully!`);

        setTimeout(() => setIsUpdatingPlan(false), 5000);
      }
    } catch (err) {
      console.error("Update failed", err);
      setIsUpdatingPlan(false);
    } finally {
      setLoading(false);
    }
  };

  const SUPPLIER_LIMITS = {
    starter: 5,
    pro: 55,
    businessPlus: Infinity,
  };
  // 🚩 Place the logic here
  const remaining =
    user?.plan === "businessPlus"
      ? Infinity
      : (SUPPLIER_LIMITS[user?.plan] || 0) - (supList?.length || 0);

  const badgeColor = remaining <= 0 ? "text-rose-500" : "text-emerald-500";

  const dropdownRef = useRef(null);

  // 2. Add this Effect to handle clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getAverageProjectLeadTime = () => {
    if (!sups || sups.length === 0) return 0;

    const sortedSups = [...sups].sort((a, b) => {
      const totalA = quote.reduce(
        (sum, item) =>
          sum +
          (Number(a.quotes[item.ref]?.price) || 0) * (Number(item.qty) || 0),
        0
      );
      const totalB = quote.reduce(
        (sum, item) =>
          sum +
          (Number(b.quotes[item.ref]?.price) || 0) * (Number(item.qty) || 0),
        0
      );
      return totalA - totalB;
    });

    const topSup = sortedSups[0];
    const pricedItems = quote.filter(
      (item) => Number(topSup.quotes[item.ref]?.price) > 0
    );
    if (pricedItems.length === 0) return 0;

    const totalDays = pricedItems.reduce(
      (sum, item) => sum + (Number(topSup.quotes[item.ref]?.days) || 0),
      0
    );
    return Math.round(totalDays / pricedItems.length);
  };

  const openQuoteModal = (supplier) => {
    setActiveModalSup(supplier);
    setSelectedSupplierForModal(supplier);
    setIsQuoteModalOpen(true);
  };

  const handleOpenModal = (supplier) => {
    // We spread the supplier data from the DB into our local state.
    // This ensures deliveryFee, insuranceFee, etc., are loaded if they exist.
    setSelectedSupplierForModal({
      ...supplier,
      deliveryFee: supplier.deliveryFee || 0,
      insuranceFee: supplier.insuranceFee || 0,
      handlingFee: supplier.handlingFee || 0,
      miscFee: supplier.miscFee || 0,
      isVatInclusive: supplier.isVatInclusive || false,
    });
    setIsQuoteModalOpen(true);
  };

  const isBudgetValid = projectBudget && Number(projectBudget) > 0;
  // Update your form validation line to this:
  const isFormValid = projectName?.trim() && isBudgetValid && isDeadlineValid;

  const updateUserRole = async (targetEmail, newRole) => {
    try {
      // 1. Create a copy of all users and update the target
      const updatedUsers = { ...allUsers };

      // Find the key for the user with this email
      const userKey = Object.keys(updatedUsers).find(
        (key) =>
          updatedUsers[key].email.toLowerCase() === targetEmail.toLowerCase()
      );

      if (!userKey) return;

      // Update the role (and optionally set isOwner if role is 'Owner')
      updatedUsers[userKey] = {
        ...updatedUsers[userKey],
        role: newRole,
        isOwner: newRole.toLowerCase() === "owner",
      };

      // 2. Optimistically update local state
      setAllUsers(updatedUsers);

      // 3. Sync to Cloud Storage
      const freshData = await storage.get(user.companyId);
      await storage.set(
        user.companyId,
        freshData.projects,
        updatedUsers, // Push the modified user object
        freshData.activities,
        freshData.suppliers,
        user.plan
      );

      triggerNotification(
        "system",
        "Permissions Updated",
        `${targetEmail} is now a ${newRole}.`
      );
    } catch (err) {
      console.error("Role update failed:", err);
      alert("Could not update role. Check your connection.");
    }
  };

  const createProject = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    // 1. Basic Validation Logic
    const isNameValid = projectName && projectName.trim().length > 0;
    const isBudgetValid = projectBudget && Number(projectBudget) > 0;
    const isDeadlineValid = projectDeadline && projectDeadline.length === 10;

    if (!isNameValid || !isBudgetValid || !isDeadlineValid) return;

    // 🛡️ 2. UPDATED UNIQUENESS GUARD (Step 3 Logic)
    const normalizedNewName = projectName.trim().toLowerCase();

    // Check existing projects: Only block if the project is NOT cancelled
    const isDuplicateProject = projects.some(
      (p) =>
        p.name.toLowerCase().trim() === normalizedNewName &&
        p.status?.toUpperCase() !== "CANCELLED"
    );

    // Check pending workflows: Only block if the workflow is NOT cancelled
    const isDuplicateWorkflow = workflows.some(
      (w) =>
        (w.projectName || w.name || "").toLowerCase().trim() === normalizedNewName &&
        w.status?.toUpperCase() !== "CANCELLED"
    );

    if (isDuplicateProject || isDuplicateWorkflow) {
      setErrorModal({
        show: true,
        title: "Duplicate Name",
        message: isDuplicateProject
          ? `An active project named "${projectName.trim()}" already exists.`
          : `A request for "${projectName.trim()}" is already pending approval.`,
      });
      return;
    }

    // 3. Plan Limits (Ignore cancelled projects in the count)
    const activeProjectsCount = projects.filter(p => p.status?.toUpperCase() !== "CANCELLED").length;
    const limit = user?.plan === "pro" ? 30 : user?.plan === "businessPlus" ? Infinity : 2;

    if (activeProjectsCount >= limit) {
      setErrorModal({
        show: true,
        title: "Limit Reached",
        message: "You have reached your active project limit. Upgrade your plan or cancel unused projects to create more.",
      });
      return;
    }

    if (isCreating || showSuccess) return;
    setIsCreating(true);

    // 🛠️ CRITICAL: Synchronized Numeric ID
    const numericId = Date.now();
    const generatedWorkflowId = `WF-${numericId}`;

    try {
      // Convert Date for Backend
      const dateParts = projectDeadline.split('/');
      const isoDeadline = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

      // --- 🚀 STAGE 1: INITIALIZE WORKFLOW ---
      const response = await fetch(`${BACKEND_URL}/api/workflows`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          workflowId: generatedWorkflowId,
          id: generatedWorkflowId,
          workspaceId: user.companyId,
          requester: user.email,
          projectName: projectName.trim(),
          targetEntityId: numericId, // Send as Number
          snapshotValue: Number(projectBudget) || 0,
          deadline: isoDeadline,
          details: `Budget: R${projectBudget} | Deadline: ${projectDeadline}`,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server Error (${response.status}): ${errorText}`);
      }

      // 🚩 FIX: Define workflowData clearly here
      const workflowData = await response.json();

      // --- 📦 STAGE 2: LOCAL SHADOW UPDATE ---
      const shadowProject = {
        id: numericId,
        name: projectName.trim(),
        status: "Pending Approval",
        budget: Number(projectBudget),
        deadline: projectDeadline,
        createdBy: user.email,
        companyId: user.companyId,
        lastUpdated: new Date().toISOString(),
        lastUpdatedBy: user.name
      };

      // --- 📦 STAGE 3: LOGGING & GLOBAL SYNC ---
      const newLog = {
        id: numericId + 1,
        user: user.name || user.email,
        action: "Project Requested",
        details: `"${projectName}" submitted for approval.`,
        timestamp: new Date().toISOString(),
        type: "WORKFLOW_START",
      };

      const freshData = await storage.get(user.companyId);

      // Deduplicate with Map to prevent "Ghost" duplicates
      const projectMap = new Map();
      (freshData?.projects || projects || []).forEach(p => projectMap.set(String(p.id), p));
      projectMap.set(String(shadowProject.id), shadowProject);

      const updatedProjectList = Array.from(projectMap.values());
      const mergedActivities = [newLog, ...(Array.isArray(freshData?.activities) ? freshData.activities : [])];

      await storage.set(
        user.companyId,
        updatedProjectList,
        freshData?.users || allUsers,
        mergedActivities,
        freshData?.suppliers || [],
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // --- ✨ STAGE 4: UI UPDATE ---
      // Ensure we check if the workflow exists in the response
      if (workflowData && workflowData.workflow) {
        setWorkflows((prev) => [workflowData.workflow, ...prev]);
      }

      setProjects(updatedProjectList);
      setActivities(mergedActivities);

      setShowSuccess(true);
      setIsCreating(false);

      // Final Clean up
      setTimeout(() => {
        setShowProjectModal(false);
        setShowSuccess(false);
        setProjectName("");
        setProjectBudget("");
        setProjectDeadline("");
        setIsInRevisionMode(false);
      }, 1000);

    } catch (err) {
      console.error("❌ Workflow error:", err);
      setIsCreating(false);
      setErrorModal({
        show: true,
        title: "Request Failed",
        message: err.message,
      });
    }
  };

  const handleUpdateProjectDetails = async () => {
    if (projects.length === 0 && supList.length === 0) {
      console.warn("Sync Blocked: Preventing an empty-state overwrite.");
      return;
    }
    // 1. Basic Validation
    if (!editName || editName.trim().length === 0) return;
    if (!editBudget || Number(editBudget) <= 0) return;

    // 🛡️ FRONTEND UNIQUENESS GUARD
    const isDuplicateLocal = projects.some(
      (p) =>
        p.name.toLowerCase().trim() === editName.toLowerCase().trim() &&
        String(p.id) !== String(selectedProject.id)
    );

    if (isDuplicateLocal) {
      setErrorModal({
        show: true,
        title: "Duplicate Name",
        message: `A project named "${editName.trim()}" already exists. Please choose a unique name for this workspace.`,
      });
      return;
    }

    setIsSaving(true);
    setIsSaved(false);

    try {
      // 2. Prepare the updated object
      const updatedProject = {
        ...selectedProject,
        name: editName.trim(),
        budget: Number(editBudget),
        deadline: editDeadline || selectedProject.deadline,
        lastUpdated: new Date().toISOString(),
        lastUpdatedBy: user.name
      };

      // 3. Create Activity Log
      const updateLog = {
        id: Date.now(),
        user: user.name || user.email,
        action: "Project Modified",
        details: `Updated specs for "${updatedProject.name}".`,
        timestamp: new Date().toISOString(),
        type: "PROJECT_UPDATE",
      };

      // 4. Fetch Fresh Data for Atomic Sync
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Could not retrieve workspace data");

      // 🛡️ DATABASE UNIQUENESS GUARD
      const dbProjects = Array.isArray(freshData.projects)
        ? freshData.projects
        : [];
      const isDuplicateDB = dbProjects.some(
        (p) =>
          p.name.toLowerCase().trim() === editName.toLowerCase().trim() &&
          String(p.id) !== String(selectedProject.id)
      );

      if (isDuplicateDB) {
        setIsSaving(false);
        setErrorModal({
          show: true,
          title: "Conflict Detected",
          message:
            "Another user just created or renamed a project with this exact name. Please try a different name.",
        });
        return;
      }

      // 🛡️ User Protection Guard
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // 🛡️ SUPPLIER PROTECTION GUARD:
      // Ensure we use fresh DB suppliers, but fallback to local supList to prevent wiping.
      const supplierSync =
        freshData.suppliers && freshData.suppliers.length > 0
          ? freshData.suppliers
          : supList;

      // 5. Merge Projects
      const mergedProjects = dbProjects.map((p) =>
        String(p.id) === String(selectedProject.id) ? updatedProject : p
      );

      // 6. Merge Activities
      const dbActivities = Array.isArray(freshData.activities)
        ? freshData.activities
        : [];
      const mergedActivities = [updateLog, ...dbActivities];

      // 7. Atomic Storage Sync - FIX: Pass supplierSync instead of freshData.suppliers || []
      await storage.set(
        user.companyId,
        mergedProjects,
        userSync,
        mergedActivities,
        supplierSync, // <--- PROTECTED
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 8. Update Local State
      setProjects(mergedProjects);
      setActivities(mergedActivities);
      setSelectedProject(updatedProject);

      // 9. Success Animation & Cleanup
      setIsSaving(false);
      setIsSaved(true);

      setTimeout(() => {
        setIsEditing(false);
        setIsSaved(false);
      }, 1500);

      if (typeof triggerNotification === "function") {
        triggerNotification(
          "success",
          "Project Updated",
          `Changes to ${updatedProject.name} saved.`
        );
      }
    } catch (err) {
      console.error("❌ Failed to update project:", err);
      setIsSaving(false);
      setErrorModal({
        show: true,
        title: "Update Failed",
        message:
          "We couldn't save these changes. Please check your connection.",
      });
    }
  };

  // 🛡️ Optimized Permission Check
  const isAuthorized = useMemo(() => user?.isOwner === true, [user?.isOwner]);

  // ⏳ Optimized Urgency Logic
  const urgency = useMemo(() => {
    if (!selectedProject?.deadline) return { isUrgent: false, parts: [], expired: false };
    const now = new Date();
    const end = new Date(selectedProject.deadline);
    const diffMs = end - now;
    const diffHrs = diffMs / (1000 * 60 * 60);

    if (diffMs <= 0) return { expired: true, isUrgent: false, parts: [] };

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return {
      isUrgent: diffHrs > 0 && diffHrs < 24,
      parts: days > 0 ? [{ val: days, label: "Days" }, { val: hours, label: "Hrs" }] : [{ val: hours, label: "Hrs" }, { val: mins, label: "Mins" }],
      expired: false
    };
  }, [selectedProject?.deadline]);

  // 💰 Optimized Supplier Math (The biggest performance fix)
  const supplierData = useMemo(() => {
    if (!selectedProject?.sups) return { list: [], winnerId: null };

    const qtyMap = {};
    (selectedProject.quote || []).forEach(item => { qtyMap[item.ref] = Number(item.qty) || 0; });

    const supsWithTotals = selectedProject.sups.map(s => {
      const total = Object.entries(s.quotes || {}).reduce((acc, [ref, qData]) => {
        return acc + (Number(qData.price) || 0) * (qtyMap[ref] || 0);
      }, 0);
      return { ...s, trueTotal: total };
    });

    const sorted = [...supsWithTotals].filter(s => s.trueTotal > 0).sort((a, b) => a.trueTotal - b.trueTotal);
    return { list: supsWithTotals, winnerId: sorted[0]?.sid || sorted[0]?.id };
  }, [selectedProject?.sups, selectedProject?.quote]);

  const updateProjectStatus = async (status) => {
    // 1. Validation & Standardizing
    // If the input is "Active" but you want "Draft", "Pending", etc.,
    // we ensure we are using the value passed from the <select>
    if (!status || !user?.companyId) return;

    const projectToUpdate = projects.find(
      (p) => String(p.id) === String(currentProject)
    );
    if (!projectToUpdate) return;

    const timestamp = new Date().toISOString();
    const displayStatus = status.charAt(0).toUpperCase() + status.slice(1); // Standardize casing

    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Status Updated",
      details: `Project "${projectToUpdate.name
        }" changed to ${displayStatus.toUpperCase()}.`,
      timestamp: timestamp,
    };

    // 🚩 OPTIMISTIC UI: Update the local list immediately
    // We ensure the 'status' property is explicitly overwritten
    const localProjects = projects.map((p) =>
      String(p.id) === String(currentProject)
        ? { ...p, status: status, lastUpdated: timestamp, lastUpdatedBy: user.name }
        : p
    );
    setProjects(localProjects);

    try {
      const freshData = await storage.get(user.companyId);
      if (!freshData) return;

      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting status update sync."
        );
        return;
      }

      const dbActivities = Array.isArray(freshData.activities)
        ? freshData.activities
        : [];
      const mergedActivities = [newLog, ...dbActivities];

      const dbProjects = Array.isArray(freshData.projects)
        ? freshData.projects
        : [];

      // Update the DB version of the project list
      const mergedProjects = dbProjects.map((p) =>
        String(p.id) === String(currentProject)
          ? { ...p, status: status, lastUpdated: timestamp, lastUpdatedBy: user.name }
          : p
      );

      // 2. ATOMIC SYNC
      await storage.set(
        user.companyId,
        mergedProjects,
        userSync,
        mergedActivities,
        freshData.suppliers || freshData.supList || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 3. Sync Local UI State
      setProjects(mergedProjects);
      setActivities(mergedActivities);

      if (typeof triggerNotification === "function") {
        await triggerNotification(
          "project",
          "Status Changed",
          `'${projectToUpdate.name}' is now ${displayStatus}.`
        );
      }
    } catch (err) {
      console.error("❌ Sync failed:", err);
      // Fallback: Revert UI if sync fails (Optional)
      // setProjects(projects);
    }
  };

  const triggerDelete = (id) => {
    setProjectToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDeleteProject = async () => {
    if (!projectToDelete) return;
    setIsDeleting(true);

    // 1. Capture details for the log and notification before deletion
    const targetProject = projects.find(
      (p) => String(p.id) === String(projectToDelete)
    );
    const capturedName = targetProject?.name || "Unknown Project";

    // 2. Prepare the new Log entry
    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Project Deleted",
      details: `"${capturedName}" (Ref: ${projectToDelete}) was removed from the workspace.`,
      timestamp: new Date().toISOString(),
    };

    // 3. OPTIMISTIC UI: Update local state immediately
    const localUpdatedProjects = projects.filter(
      (p) => String(p.id) !== String(projectToDelete)
    );
    setProjects(localUpdatedProjects);
    setActivities((prev) => [newLog, ...prev]);

    try {
      const freshData = await storage.get(user.companyId);
      if (!freshData)
        throw new Error("Could not connect to workspace storage.");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // STOP: If both sources are empty, the workspace is at risk.
      // Do not proceed with the deletion sync.
      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting delete sync to prevent wipe."
        );
        setIsDeleting(false);
        setErrorModal({
          show: true,
          title: "Safety Lock Triggered",
          message:
            "A potential data loss risk was detected. Project deletion aborted to protect your team list. Please refresh and try again.",
        });
        return;
      }

      // 1. MERGE PROJECTS (Filter DB list)
      const dbProjects = freshData.projects || projects;
      const mergedProjects = dbProjects.filter(
        (p) => String(p.id) !== String(projectToDelete)
      );

      // 2. MERGE ACTIVITIES
      const dbActivities = freshData.activities || [];
      const mergedActivities = [newLog, ...dbActivities];

      // 3. THE SAFE ATOMIC SYNC
      if (user?.companyId) {
        await storage.set(
          user.companyId,
          mergedProjects,
          userSync, // FIXED: Validated user list
          mergedActivities,
          freshData.suppliers || freshData.supList || supList,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );
      }

      // 4. Post-Delete Logic
      if (String(currentProject) === String(projectToDelete)) {
        setCurrentProject(mergedProjects[0]?.id || null);
      }

      setShowDeleteModal(false);
      setProjectToDelete(null);

      await triggerNotification(
        "project",
        "Project Removed",
        `'${capturedName}' has been removed.`
      );
    } catch (err) {
      // ... error handling
    } finally {
      setIsDeleting(false);
    }
  };

  // --- Inside App.js ---
  const switchProject = async (id, clearWinnersCallback) => {
    console.log("🔄 Switching Project to ID:", id);

    // 1. Update global selection
    setCurrentProject(id);

    // 2. Execute the callback to clear winners (Fixes the ReferenceError)
    if (typeof clearWinnersCallback === "function") {
      clearWinnersCallback();
    }

    setIsDropdownOpen(false);

    // 3. 🚩 FORCE RE-FETCH: Load items from DB immediately
    try {
      const companyId = user?.companyId?.toUpperCase().trim();
      if (companyId) {
        const freshData = await storage.get(companyId);
        if (freshData?.projects) {
          setProjects(freshData.projects); // Updates the projects array globally
        }
      }
    } catch (err) {
      console.error("Failed to sync project items:", err);
    }
  };

  const addItem = async () => {
    // 1. Create the unique item locally
    const newItem = {
      id: `item-${Date.now()}`,
      ref: "REF-000",
      desc: "",
      qty: 1,
      unit: "pcs",
    };

    // 2. Prepare the Log entry
    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Item Added",
      details: `New line item added to project (Ref: ${currentProject}).`,
      timestamp: new Date().toISOString(),
    };

    // 3. OPTIMISTIC UI: Update local state immediately
    // 🚩 REWRITTEN: [newItem, ...spread] puts it at the TOP
    const localUpdatedQuote = [newItem, ...(quote || [])];
    const localUpdatedProjects = projects.map((p) =>
      String(p.id) === String(currentProject)
        ? { ...p, quote: localUpdatedQuote }
        : p
    );

    setQuote(localUpdatedQuote);
    setProjects(localUpdatedProjects);
    setActivities((prev) => [newLog, ...prev]);

    // 4. THE ATOMIC FETCH-MERGE-SYNC
    if (user?.companyId) {
      try {
        const freshData = await storage.get(user.companyId);
        if (!freshData)
          throw new Error("Sync failed: No workspace data found.");

        const userSync =
          freshData?.users && Object.keys(freshData.users).length > 0
            ? freshData.users
            : allUsers;

        if (!userSync || Object.keys(userSync).length === 0) {
          console.error("CRITICAL: User list is empty. Aborting sync.");
          return;
        }

        const dbProjects = freshData.projects || projects;
        const mergedProjects = dbProjects.map((p) => {
          if (String(p.id) === String(currentProject)) {
            // 🚩 REWRITTEN: [newItem, ...spread] ensures cloud order matches UI
            const dbQuote = p.quote || [];
            return { ...p, quote: [newItem, ...dbQuote] };
          }
          return p;
        });

        const dbActivities = freshData.activities || [];
        const mergedActivities = [newLog, ...dbActivities];

        await storage.set(
          user.companyId,
          mergedProjects,
          userSync,
          mergedActivities,
          freshData.suppliers || freshData.supList || supList,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );

        console.log("✅ Line item and Audit Log synced successfully.");
      } catch (err) {
        console.error("❌ Cloud Sync Failed on addItem:", err);
        setErrorModal({
          show: true,
          title: "Sync Delay",
          message:
            "Item added locally, but cloud sync failed. Please check your connection.",
        });
      }
    }
  };

  // 1. SAVE A SINGLE ROW
  const saveItem = async (itemId) => {
    if (!user?.companyId) return;

    const itemToLog = quote.find((i) => i.id === itemId);

    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Line Item Saved",
      details: `Manual save for "${itemToLog?.desc || "unnamed item"
        }" in Project ${currentProject}.`,
      timestamp: new Date().toISOString(),
    };

    try {
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Connection failed");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      if (!userSync || Object.keys(userSync).length === 0) {
        console.error("CRITICAL: User list is empty. Aborting save.");
        setErrorModal({
          show: true,
          title: "Safety Lock",
          message:
            "Data sync paused to protect your team list. Please wait a moment and try again.",
        });
        return;
      }

      const dbProjects = freshData.projects || projects;
      const mergedProjects = dbProjects.map((p) =>
        String(p.id) === String(currentProject)
          ? { ...p, quote: quote, lastUpdated: new Date().toISOString(), lastUpdatedBy: user.name }
          : p
      );

      const mergedActivities = [newLog, ...(freshData.activities || [])];

      await storage.set(
        user.companyId,
        mergedProjects,
        userSync,
        mergedActivities,
        freshData.suppliers || freshData.supList || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      setActivities(mergedActivities);

      // 🚩 TRIGGER BUBBLE NOTIFICATION
      console.log("TRYING TO SHOW BUBBLE NOW..."); // Look for this in F12
      setSaveStatus({ show: true, message: "Changes saved to cloud" });
      setTimeout(() => setSaveStatus({ show: false, message: "" }), 2000);

      console.log("✅ Row saved to cloud.");
    } catch (err) {
      console.error("❌ Save failed:", err);
      alert("Could not sync row to cloud.");
    }
  };

  const saveAllItems = async () => {
    if (!user?.companyId || !currentProject) return;

    // 1. Calculate how many items actually changed
    const originalProject = projects.find(
      (p) => String(p.id) === String(currentProject)
    );
    const originalQuote = originalProject?.quote || [];

    // We count items that are either new (don't exist in original)
    // or have different values than the original
    const updatedCount = quote.filter((item) => {
      const originalItem = originalQuote.find((oi) => oi.id === item.id);
      if (!originalItem) return true; // It's a newly added item
      return JSON.stringify(item) !== JSON.stringify(originalItem); // It's been modified
    }).length;

    if (updatedCount === 0) {
      console.log("No changes detected.");
      return;
    }

    setIsSaving(true);

    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Bulk Save",
      details: `${updatedCount} line item(s) updated for Project Ref: ${currentProject}.`,
      timestamp: new Date().toISOString(),
    };

    try {
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Sync failed");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // STOP: If both sources are empty, the workspace is at risk.
      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting Bulk Save to prevent team wipe."
        );
        setIsSaving(false);
        setErrorModal({
          show: true,
          title: "Safety Lock Triggered",
          message:
            "We detected a synchronisation issue that could risk your team's access. Bulk save aborted. Please refresh the page and try again.",
        });
        return; // EXIT IMMEDIATELY
      }

      const dbProjects = freshData.projects || projects;
      const mergedProjects = dbProjects.map((p) =>
        String(p.id) === String(currentProject)
          ? { ...p, quote: quote, lastUpdated: new Date().toISOString(), lastUpdatedBy: user.name }
          : p
      );

      const mergedActivities = [newLog, ...(freshData.activities || [])];

      // SAFE ATOMIC SYNC
      await storage.set(
        user.companyId,
        mergedProjects,
        userSync, // FIXED: Validated user list
        mergedActivities,
        freshData.suppliers || freshData.supList || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      setActivities(mergedActivities);

      // 🚩 DYNAMIC NOTIFICATION
      // 1. Get the project name for the notification
      const projectName = originalProject?.name || "the project";

      // 2. Trigger the dynamic notification
      await triggerNotification(
        "project",
        "Project Items Update",
        `${updatedCount} item${updatedCount > 1 ? "s" : ""
        } in "${projectName}" ${updatedCount > 1 ? "have" : "has"
        } been successfully updated.`
      );
    } catch (err) {
      console.error("❌ Bulk Save failed:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const clearProjectItems = async () => {
    if (!user?.companyId || !currentProject) return;

    // 1. Log Setup
    const targetProject = projects.find(
      (p) => String(p.id) === String(currentProject)
    );
    const projectName = targetProject?.name || "Project";

    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Project Cleared",
      details: `Wiped all items from [${projectName}].`,
      timestamp: new Date().toISOString(),
    };

    try {
      // 1. FETCH THE TRUTH
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Cloud unreachable");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      // We identify the best source for users
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // STOP: Pull the brake if the team list is empty to prevent a wipe
      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting clear operation to protect team."
        );
        toast.error(
          "Security Lock: Could not verify team list. Please refresh and try again."
        );
        return;
      }

      // 2. PREPARE DATA SOURCES
      const dbActivities =
        freshData.activities ||
        freshData.activity ||
        freshData.logs ||
        activities ||
        [];
      const dbProjects = freshData.projects || projects || [];
      const dbSuppliers =
        freshData.supList || freshData.suppliers || supList || [];

      // 3. MERGE - Clear items for the specific project
      const mergedProjects = dbProjects.map((p) => {
        if (String(p.id) === String(currentProject)) {
          return {
            ...p,
            quote: [],
            lastUpdated: new Date().toISOString(),
            lastUpdatedBy: user.name
          };
        }
        return p;
      });

      const mergedActivities = [newLog, ...dbActivities].slice(0, 100);

      // 4. ATOMIC SAVE - SAFE VERSION
      await storage.set(
        user.companyId,
        mergedProjects,
        userSync, // FIXED: Using the validated list
        mergedActivities,
        dbSuppliers,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 5. Update Local State
      setProjects(mergedProjects);
      setActivities(mergedActivities);
      setQuote([]);

      toast.success(`Cleared items for ${projectName}`);
    } catch (err) {
      console.error("❌ Sync Failed:", err);
      toast.error("Sync Error: Data might not have saved correctly.");
    }
  };

  const clearAllSuppliers = async () => {
    if (!user?.companyId) return false;

    const newLog = {
      id: Date.now(),
      user: user.name || user.email || "User",
      action: "Database Purge",
      details: "Complete wipe of supplier registry and project links.",
      timestamp: new Date().toISOString(),
    };

    try {
      // 1. FETCH THE TRUTH
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Cloud unreachable");

      // 🛡️ SECURITY GUARD: Use fresh data for users/projects to prevent data loss
      const userSync = freshData?.users && Object.keys(freshData.users).length > 0
        ? freshData.users
        : allUsers;

      const dbProjects = freshData.projects || projects || [];
      const dbActivities = freshData.activities || activities || [];

      // 2. THE PURGE LOGIC
      // We must map through ALL projects and empty their 'sups' arrays 
      // otherwise they will ghost back in via project references.
      const purgedProjects = dbProjects.map((p) => ({
        ...p,
        sups: [], // Clear all supplier assignments in projects
      }));

      const mergedActivities = [newLog, ...dbActivities].slice(0, 100);

      // 3. ATOMIC CLOUD SYNC
      // We pass purgedProjects and an EXPLICIT empty array for supList
      await storage.set(
        user.companyId,
        purgedProjects,
        userSync,
        mergedActivities,
        [], // 🚩 TARGET ACQUIRED: supList is now empty
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 4. NUCLEAR UI RESET
      setSupList([]);      // Clear registry
      setProjects(purgedProjects); // Clear project links
      setActivities(mergedActivities);

      // Clear current project view if active
      if (typeof setSups === "function") setSups([]);

      toast.success("System Purged: All suppliers and links removed.");
      return true; // 🚩 Signal for modal to close
    } catch (err) {
      console.error("❌ Nuclear Wipe Failed:", err);
      toast.error("Wipe Failed: Cloud sync error.");
      throw err;
    }
  };

  const handleClearAllQuotes = async () => {
    if (!user?.companyId || !currentProjectData?.id) {
      toast.error("Error: Missing project or company context.");
      return;
    }

    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Project Quotes Wiped",
      details: `Cleared all quote cards from project: ${currentProjectData.name}`,
      timestamp: new Date().toISOString(),
    };

    try {
      setIsSaving?.(true);

      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Could not reach storage provider.");

      let targetProjectForSync = null;

      //SUPPLIER WIPE
      const updatedProjects = (freshData.projects || projects).map((proj) => {
        if (String(proj.id) === String(currentProjectData.id)) {
          // 🛡️ SAFE TRANSFORMATION BLOCK
          const sanitizedProj = {
            ...proj,
            // 🟢 KEEP EXISTING SUPPLIERS: Prioritize fresh incoming sups, fall back to current local sups, default to [] if both are missing
            sups: freshData.projects
              ? (proj.sups || [])
              : (currentProjectData.sups || proj.sups || []),

            // Merge only the safe metadata updates from your source
            name: currentProjectData.name || proj.name,
            status: currentProjectData.status || proj.status,

            lastUpdated: new Date().toISOString(),
            lastUpdatedBy: user?.name || "System Sync"
          };

          targetProjectForSync = sanitizedProj;
          return sanitizedProj;
        }
        return proj;
      });

      // 🚀 STAGE A: SYNC STANDALONE ENTITY (MongoDB)
      if (targetProjectForSync) {
        const standaloneResponse = await fetch(
          `${BACKEND_URL}/api/projects/sync`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              projectData: targetProjectForSync,
              allowEmpty: true, // 🚩 CRITICAL: Bypasses the Integrity Guard
            }),
          }
        );

        if (!standaloneResponse.ok) {
          throw new Error("Failed to clear the standalone database record.");
        }
      }

      // 🚀 STAGE B: SYNC WORKSPACE (Local + Global DB)
      const mergedActivities = [newLog, ...(freshData.activities || [])].slice(
        0,
        100
      );

      // Force update the Workspace container
      await storage.set(
        user.companyId,
        updatedProjects,
        freshData.users || {},
        mergedActivities,
        freshData.suppliers || [],
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 🚩 ADDITION: Force save to the main Workspace DB route
      await fetch(`${BACKEND_URL}/api/save-data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyId: user.companyId,
          projects: updatedProjects,
          activities: mergedActivities,
          allowEmpty: true, // 🚩 Also needed here if you added the guard to save-data
        }),
      });

      // 4. Update UI States
      setSups([]);
      setProjects(updatedProjects);
      setActivities(mergedActivities);

      toast.success(`Project "${currentProjectData.name}" has been cleared.`);
      setShowClearConfirmQuoteCard(false);
    } catch (err) {
      console.error("❌ Massive Wipe Failure:", err);
      toast.error(`Wipe Failed: ${err.message}`);
    } finally {
      setIsSaving?.(false);
    }
  };

  // --- PULSE AI CHAT LOGIC ---
  const sendMessage = () => {
    // 1. Don't send empty messages
    if (!chatInput.trim()) return;

    // 2. Add User's message to the feed
    const userMsg = { role: "user", text: chatInput };
    setMessages((prev) => [...prev, userMsg]);

    // 3. Clear the input field immediately
    setChatInput("");

    // 4. Simulate Pulse AI "Thinking" and responding
    setTimeout(() => {
      const aiResponse = {
        role: "ai",
        text: `I'm analysing the workspace... I see you have ${projects.length} projects and ${supList.length} suppliers in your network. How can I assist?`,
      };
      setMessages((prev) => [...prev, aiResponse]);
    }, 800);
  };

  const removeItem = async (itemId) => {
    if (!user?.companyId || !currentProject) return;

    // 1. Log Setup
    const itemToDelete = quote.find((i) => i.id === itemId);
    const activeProject = projects.find(
      (p) => String(p.id) === String(currentProject)
    );
    const projectName = activeProject?.name || "Unknown Project";
    const newLog = {
      id: Date.now(),
      user: user.name || user.email,
      action: "Item Removed",
      details: `Removed [${itemToDelete?.ref}] from Project: '${projectName}'.`,
      timestamp: new Date().toISOString(),
    };

    try {
      // 2. FETCH THE TRUTH
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Cloud unreachable");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // STOP: The "Brake" to prevent workspace wiping
      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting removeItem to prevent team wipe."
        );
        toast.error(
          "Security Lock: Could not verify team data. Refresh the page before deleting items."
        );
        return;
      }

      // 3. PREPARE DATA
      const dbProjects = freshData.projects || projects;
      const dbActivities = freshData.activities || activities;
      const dbSuppliers = freshData.supList || freshData.suppliers || supList;

      // 4. MERGE
      const mergedProjects = dbProjects.map((p) => {
        if (String(p.id) === String(currentProject)) {
          return {
            ...p,
            quote: (p.quote || []).filter((i) => i.id !== itemId),
            lastUpdated: new Date().toISOString(),
            lastUpdatedBy: user.name
          };
        }
        return p;
      });
      const mergedActivities = [newLog, ...(dbActivities || [])].slice(0, 100);

      // 5. ATOMIC SAVE (Using userSync)
      await storage.set(
        user.companyId,
        mergedProjects,
        userSync, // FIXED: Validated team list
        mergedActivities,
        dbSuppliers,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 6. Update Local State
      setProjects(mergedProjects);
      setActivities(mergedActivities);
      const updatedProject = mergedProjects.find(
        (p) => String(p.id) === String(currentProject)
      );
      if (updatedProject) setQuote(updatedProject.quote);
    } catch (err) {
      console.error("Sync Failed:", err);
      toast.error("Connection lost. Changes were not saved to the cloud.");
    }
  };

  const supplierStats = useMemo(() => {
    // 1. Initial Safety Guard
    if (!sups || !quote || !Array.isArray(sups)) return [];

    return (
      sups
        .map((s) => {
          // Find the supplier name/profile from your master list (if available in this scope)
          const profile = supList?.find((v) => String(v.id) === String(s.sid));

          // 2. Identify priced items safely
          const priced = quote.filter((q) => {
            const price = s.quotes?.[q.ref]?.price;
            return price !== undefined && Number(price) > 0;
          });

          // 3. Calculate total with "NaN" protection
          const total = priced.reduce((acc, q) => {
            const price = Number(s.quotes[q.ref].price) || 0;
            const qty = Number(q.qty) || 1;
            return acc + price * qty;
          }, 0);

          return {
            sid: s.sid,
            name: profile?.name || "Unknown Vendor", // Added for easier display in UI
            itemsFilled: priced.length,
            total,
          };
        })
        // 4. Sort by most items filled (Primary) then by total value (Secondary)
        .sort((a, b) => b.itemsFilled - a.itemsFilled || a.total - b.total)
    );
  }, [sups, quote, supList]); // 🚩 Make sure supList is in the dependency array

  //MEMO FOR SUPPLIER ITEM SPLIT MATRIX MODAL

  const qp_FinalWinnerV2 = useMemo(() => {
    // Use the pre-calculated supplierStats if they exist, otherwise fallback to sups
    // We need to find the supplier with the lowest total from your ranking logic
    if (!supplierStats || supplierStats.length === 0) return null;

    // The first item in supplierStats is your winner (Rank 1)
    const winningSid = supplierStats[0].sid;

    // Find the full supplier object that matches this SID
    return sups.find((s) => String(s.sid) === String(winningSid)) || null;
  }, [sups, supplierStats]);

  const matrixData = useMemo(() => {
    // 🚩 ADDED LOGS: Check your console to see which one is failing
    if (!quote || !sups || !qp_FinalWinnerV2) {
      /*console.log("Matrix Data missing dependencies:", {
        quote: !!quote,
        sups: !!sups,
        winner: !!qp_FinalWinnerV2,
      });*/
      return [];
    }

    return quote.map((item) => {
      const itemQuotes = sups
        .map((s) => {
          const rank = (supplierStats || []).findIndex(
            (r) => String(r.sid) === String(s.sid)
          );

          // Match by SID string for safety
          const isOverallWinner =
            String(s.sid) === String(qp_FinalWinnerV2.sid);

          return {
            sid: s.sid,
            price: Number(s.quotes?.[item.ref]?.price || 0),
            rank: rank === -1 ? 999 : rank,
            isOverallWinner,
          };
        })
        .filter((q) => q.price > 0);

      const best = itemQuotes.sort((a, b) => {
        if (a.price !== b.price) return a.price - b.price;
        if (a.isOverallWinner) return -1;
        if (b.isOverallWinner) return 1;
        return a.rank - b.rank;
      })[0];

      return {
        ...item,
        // 🚩 CRITICAL: Map 'description' to 'desc' if your SplitMatrixRow expects 'desc'
        desc: item.description || item.desc,
        bestSupplier: best?.sid,
        price: best?.price || 0,
        supplierName:
          supList.find((v) => String(v.id) === String(best?.sid))?.name ||
          "Unassigned",
        isFromOverallWinner: best?.isOverallWinner || false,
      };
    });
  }, [quote, sups, supplierStats, supList, qp_FinalWinnerV2]);

  //MODAL UI FOR ITEMS AND ROWS

  /*const memoizedMatrixRows = useMemo(() => {
    return (matrixData || []).map((item, idx) => (
      <SplitMatrixRow
        key={`${item.ref}-${idx}`}
        item={item}
        winner={qp_FinalWinnerV2} // ✅ Safely initialized above!
        idx={idx}
      />
    ));
  }, [matrixData, qp_FinalWinnerV2]);*/

  const memoizedMatrixRows = useMemo(() => {
    return (matrixData || [])
      .filter((item) => {
        // If search is empty, show everything
        if (!searchTerm) return true;

        const query = searchTerm.toLowerCase();
        // Match against Reference, Description (item.desc), or Vendor (item.supplierName)
        return (
          item.ref?.toLowerCase().includes(query) ||
          item.desc?.toLowerCase().includes(query) ||
          item.supplierName?.toLowerCase().includes(query)
        );
      })
      .map((item, idx) => (
        <SplitMatrixRow
          key={`${item.ref}-${idx}`}
          item={item}
          winner={qp_FinalWinnerV2}
          idx={idx}
        />
      ));
  }, [matrixData, qp_FinalWinnerV2, searchTerm]); // ✅ Added searchTerm here

  const addSup = async () => {
    if (projects.length === 0 && supList.length === 0) {
      console.warn("Sync Blocked: Preventing an empty-state overwrite.");
      return;
    }
    const newId = Date.now().toString();

    const newSupplier = {
      id: newId,
      name: "",
      email: "",
      phone: "",
      beeLevel: "Non-Compliant",
      attachment: null,
    };

    const newLog = logActivity("Supplier Added", `Created slot ${newId}`);

    if (user?.companyId) {
      try {
        // 1. FETCH THE TRUTH FIRST
        const freshData = await storage.get(user.companyId);
        if (!freshData) throw new Error("Cloud unreachable");

        // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
        const userSync =
          freshData?.users && Object.keys(freshData.users).length > 0
            ? freshData.users
            : allUsers;

        if (!userSync || Object.keys(userSync).length === 0) {
          console.error("CRITICAL: User list empty. Aborting addSup.");
          return;
        }

        // 2. MERGE DATA
        const dbSuppliers =
          freshData.suppliers || freshData.supList || supList || [];
        const updatedSupList = [newSupplier, ...dbSuppliers];

        const dbActivities = freshData.activities || activities || [];
        const updatedActivities = [newLog, ...dbActivities];

        // 3. ATOMIC SYNC
        await storage.set(
          user.companyId,
          freshData.projects || projects, // Use Cloud projects to prevent overwriting teammate work
          userSync,
          updatedActivities,
          updatedSupList,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );

        // 4. Update UI state only after successful sync
        setSupList(updatedSupList);
        setActivities(updatedActivities);

        console.log("✅ Supplier and Log synced successfully");

        await triggerNotification(
          "system",
          "Supplier Added",
          `A new supplier slot has been added to the Network.`
        );
      } catch (error) {
        console.error("Failed to sync supplier:", error);
        toast.error("Sync Error: Could not add supplier to cloud.");
      }
    }
  };

  const handleUpdateSupplierGlobal = React.useCallback(
    (id, updatedSupplier) => {
      setSupList((prev) =>
        prev.map((s) => (s.id === id ? updatedSupplier : s))
      );
    },
    []
  );

  const saveSingleSupplier = async (supId) => {
    if (projects.length === 0 && supList.length === 0) {
      console.warn("Sync Blocked: Preventing an empty-state overwrite.");
      return;
    }
    const supplier = supList.find((s) => s.id === supId);

    // REGEX VALIDATION GUARD
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (supplier.email && !emailRegex.test(supplier.email)) {
      setErrorModal({
        show: true,
        title: "Validation Error",
        message: "Please enter a valid email address before saving.",
      });
      return; // Stop the save
    }

    if (!supplier.name) {
      setErrorModal({
        show: true,
        title: "Validation Error",
        message: "Supplier name is required.",
      });
      return;
    }

    if (!user?.companyId || window.isLoggingOut) return;

    const targetSup = supList.find((s) => s.id === supId);
    if (!targetSup) return;

    try {
      // 1. Fetch fresh data
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Could not reach database for sync.");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // STOP: If both sources are empty, the workspace is at risk.
      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting supplier save to prevent team wipe."
        );
        setErrorModal({
          show: true,
          title: "Safety Sync Blocked",
          message:
            "We couldn't verify your team list. Save aborted to prevent accidental data loss. Please refresh.",
        });
        return; // EXIT IMMEDIATELY
      }

      // 2. Merge Suppliers
      const currentCloudSups = freshData.supList || freshData.suppliers || [];
      const mergedSuppliers = currentCloudSups.map((s) =>
        String(s.id) === String(supId) ? targetSup : s
      );

      // If supplier isn't in cloud yet, add it
      if (!currentCloudSups.find((s) => String(s.id) === String(supId))) {
        mergedSuppliers.push(targetSup);
      }

      // 3. SECURE LOGGING
      const newLog = {
        id: Date.now(),
        user: user.name || user.email,
        action: "Supplier Updated",
        details: `Manual save for: ${targetSup.name || "Unnamed"}.`,
        timestamp: new Date().toISOString(),
      };
      const updatedActivities = [newLog, ...(freshData.activities || [])].slice(
        0,
        100
      );

      // 4. ATOMIC SAVE: Safe from user-wiping
      await storage.set(
        user.companyId,
        freshData.projects || projects || [],
        userSync, // FIXED: Validated team list
        updatedActivities,
        mergedSuppliers,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 5. Update local UI state
      setActivities(updatedActivities);
      // Optional: update local supList if it differs from mergedSuppliers
      setSupList(mergedSuppliers);

      triggerNotification(
        "supplier",
        "Supplier Saved",
        `Registry for "${targetSup.name}" updated.`
      );
    } catch (err) {
      console.error("Manual Supplier Save Failed:", err);
      alert("Sync Error: Your changes were not saved to the cloud.");
    }
  };

  const delSup = async (id) => {
    const targetId = String(id);
    const supplierToDelete = supList.find((s) => String(s.id) === targetId);
    if (!supplierToDelete) return;

    const supplierName = supplierToDelete.name || "Unknown Supplier";

    // We scan every project to see if this supplier ID exists in any 'sups' slot
    // 🛡️ SAFETY NET: Dependency Check
    const linkedProjects = projects.filter((proj) =>
      (proj.sups || []).some((slot) => String(slot.sid || slot.id) === targetId)
    );

    if (linkedProjects.length > 0) {
      // 🚩 TRIGGER MODAL INSTEAD OF ALERT
      setSupDeleteWarning({
        show: true,
        name: supplierName,
        projects: linkedProjects.map((p) => p.name || "Untitled Project"),
      });
      return; // 🛑 Stop the deletion process
    }

    try {
      if (user?.companyId) {
        // 1. FETCH THE TRUTH
        const freshData = await storage.get(user.companyId);
        if (!freshData) throw new Error("Cloud unreachable");

        // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
        const userSync =
          freshData?.users && Object.keys(freshData.users).length > 0
            ? freshData.users
            : allUsers;

        if (!userSync || Object.keys(userSync).length === 0) {
          console.error("CRITICAL: User list empty. Aborting delete.");
          return;
        }

        // 2. PREPARE CLEAN LISTS (Since we passed the check, we know they aren't in slots)
        const dbSuppliers =
          freshData.supList || freshData.suppliers || supList || [];
        const mergedSupList = dbSuppliers.filter(
          (s) => String(s.id) !== targetId
        );

        const dbProjects = freshData.projects || projects || [];
        // Note: We still filter projects just in case of a race condition
        const mergedProjects = dbProjects.map((p) => ({
          ...p,
          sups: (p.sups || []).filter(
            (s) => String(s.sid || s.id) !== targetId
          ),
        }));

        const newLog = {
          id: Date.now(),
          user: user?.name || user?.email || "User",
          action: "Supplier Removed",
          details: `Removed "${supplierName}" from the registry.`,
          timestamp: new Date().toISOString(),
        };

        const mergedActivities = [
          newLog,
          ...(freshData.activities || activities || []),
        ].slice(0, 100);

        // 3. ATOMIC CLOUD SYNC
        await storage.set(
          user.companyId,
          mergedProjects,
          userSync,
          mergedActivities,
          mergedSupList,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );

        // 4. Update UI state
        setSupList(mergedSupList);
        setProjects(mergedProjects);
        setActivities(mergedActivities);

        // Sync active view if looking at a project
        const active = mergedProjects.find(
          (p) => String(p.id) === String(currentProject)
        );
        setSups(active ? active.sups : []);

        console.log(`✅ Success: ${supplierName} removed.`);

        if (typeof triggerNotification === "function") {
          await triggerNotification(
            "supplier",
            "Deleted",
            `"${supplierName}" removed.`
          );
        }
      }
    } catch (err) {
      console.error("❌ Deletion Sync Failed:", err);
      setErrorModal({
        show: true,
        title: "Sync Failure",
        message: "Could not sync deletion. Check connection.",
      });
    }
  };

  /*const addQuote = async () => {
    const currentProjectIdStr = String(currentProject);
    const localProject = projects.find(
      (p) => String(p.id) === currentProjectIdStr
    );
    if (!localProject) return;

    // 1. Plan & Registry Checks
    if (!supList?.length)
      return setErrorModal({
        show: true,
        title: "Supplier Registry Empty",
        message: "Add suppliers first in the Suppliers tab.",
      });

    const userPlan = (typeof PLANS !== "undefined" ? PLANS : []).find(
      (p) => p.id === user?.plan
    ) || { name: "Starter", sups: 5 };

    if ((localProject.sups || []).length >= userPlan.sups)
      return setErrorModal({
        show: true,
        title: "Limit Reached",
        message: `Your ${userPlan.name} plan only allows ${userPlan.sups} suppliers per project.`,
      });

    // 2. Create Master Truth locally
    const newSlot = { id: Date.now(), sid: "", quotes: {} };
    const updatedProjects = projects.map((p) =>
      String(p.id) === currentProjectIdStr
        ? { ...p, sups: [...(p.sups || []), newSlot] }
        : p
    );

    // 3. Update UI Immediately
    setProjects(updatedProjects);
    setSups([...(localProject.sups || []), newSlot]);

    // 4. SYNC WITH MASTER TRUTH LOGIC
    try {
      if (!user?.companyId) return;

      // FETCH FRESH DATA (Consistency Check)
      const freshData = await storage.get(user.companyId);

      // VALIDATE LISTS (The userSync / mergedSupList logic)
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      const mergedSupList = freshData?.suppliers || supList;

      // LOGGING
      const newLog = {
        id: Date.now(),
        user: user.name || user.email,
        action: "Quote Slot Added",
        details: `New slot added to ${localProject.name}`,
        timestamp: new Date().toISOString(),
      };
      const mergedActivities = [
        newLog,
        ...(freshData.activities || activities || []),
      ].slice(0, 50);

      // PERFORM SYNC
      await storage.set(
        user.companyId,
        updatedProjects, // Master projects list
        userSync, // FIXED: Validated list
        mergedActivities, // FIXED: Trimmed logs
        mergedSupList, // FIXED: Fresh registry
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // Local UI Update for logs
      setActivities(mergedActivities);
    } catch (err) {
      console.error("Sync Error in addQuote:", err);
      toast.error("Failed to sync new slot to database.");
    }
  };*/

  const addQuote = async () => {
    if (!user?.companyId || !currentProject) return;

    const newSlot = {
      id: Date.now(),
      sid: "",
      name: "Select Supplier...",
      quotes: {},
      totalLandedCost: 0,
      lastUpdated: new Date().toISOString(),
    };

    // 1. Update Projects list
    const updatedProjects = projects.map((p) => {
      if (String(p.id) === String(currentProject)) {
        return { ...p, sups: [...(p.sups || []), newSlot], lastUpdatedBy: user.name };
      }
      return p;
    });

    // 2. Set the master state - The useEffect will handle setSups automatically
    setProjects(updatedProjects);

    try {
      const thisProject = updatedProjects.find(
        (p) => String(p.id) === String(currentProject)
      );

      // 3. Sync to MongoDB
      await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: thisProject }),
      });

      // 4. Sync to Workspace
      const freshData = await storage.get(user.companyId);
      await storage.set(
        user.companyId,
        updatedProjects,
        freshData?.users || allUsers,
        freshData?.activities || activities,
        freshData?.suppliers || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );
    } catch (err) {
      console.error("Critical Sync Error:", err);
    }
  };

  const handleAddQuoteClick = () => {
    // 1. Check for Items (Current Project Quote)
    const hasItems = quote && quote.length > 0;

    // 2. Check for Suppliers
    const hasSuppliers = supList && supList.length > 0;

    if (!hasItems || !hasSuppliers) {
      let missingInfo;

      // Define shared classes for the bold highlights to keep code clean
      const highlightClass = "font-bold text-amber-700 dark:text-amber-400";

      if (!hasItems && !hasSuppliers) {
        missingInfo = (
          <span>
            Your <b className={highlightClass}>project</b> is empty and you
            haven't added any <b className={highlightClass}>suppliers</b> to
            your network.
          </span>
        );
      } else if (!hasItems) {
        missingInfo = (
          <span>
            You haven't added any <b className={highlightClass}>items</b> to the
            current selected <b className={highlightClass}>project</b> yet.
          </span>
        );
      } else {
        missingInfo = (
          <span>
            You need to add at least one{" "}
            <b className={highlightClass}>supplier</b> to your registry first.
          </span>
        );
      }

      setErrorModal({
        show: true,
        title: "Information Required",
        message: (
          <div className="space-y-3 text-slate-600 dark:text-slate-300">
            <div className="p-3 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-500/20">
              <p className="text-sm leading-relaxed">{missingInfo}</p>
            </div>
            <p className="text-xs opacity-80">
              Before you can generate a quote, please complete these steps to
              proceed.
            </p>
          </div>
        ),
        type: "warning",
      });
      return;
    }

    // If validation passes, run your original addQuote logic
    addQuote();
  };

  const updQuoteSup = async (targetSlotId, newSupplierId) => {
    if (!user?.companyId || !currentProject) return;

    // 1. Prepare the IDs and Name lookup
    const cleanSid = newSupplierId === "" ? "" : String(newSupplierId);
    const selectedSup = supList.find((s) => String(s.id) === cleanSid);
    const supplierName = selectedSup ? selectedSup.name : "Select Supplier...";

    // 2. Map the updated projects array first (Single Source of Truth)
    const updatedProjects = projects.map((p) => {
      if (String(p.id) === String(currentProject)) {
        const updatedSups = (p.sups || []).map((slot) =>
          String(slot.id) === String(targetSlotId)
            ? { ...slot, sid: cleanSid, name: supplierName }
            : slot
        );
        return {
          ...p,
          sups: updatedSups,
          lastUpdated: new Date().toISOString(),
          lastUpdatedBy: user.name,
        };
      }
      return p;
    });

    // 3. Find the specific project object for the DB sync payload
    const targetProjectForSync = updatedProjects.find(
      (p) => String(p.id) === String(currentProject)
    );

    // 🚩 CRITICAL: Update UI State immediately to prevent the "Vanish"
    setProjects(updatedProjects);
    setSups(targetProjectForSync.sups);

    try {
      // 4. Sync to MongoDB (Standalone)
      const res = await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: targetProjectForSync }),
      });

      if (!res.ok) throw new Error("Database Sync Failed");

      // 5. Sync to Workspace Storage
      const freshData = await storage.get(user.companyId);
      await storage.set(
        user.companyId,
        updatedProjects,
        freshData?.users || allUsers,
        freshData?.activities || activities,
        freshData?.suppliers || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      console.log(`✅ ${supplierName} synced to DB and Workspace.`);
    } catch (err) {
      console.error("❌ Sync Error:", err);
      toast.error("Cloud sync failed, but local change kept.");
    }
  };

  const updQuote = async (slotId, itemRef, field, value) => {
    // 1. Update the local 'sups' state for instant typing
    const updatedSups = sups.map((s) => {
      if (String(s.id) === String(slotId)) {
        return {
          ...s,
          quotes: {
            ...s.quotes,
            [itemRef]: {
              ...(s.quotes[itemRef] || { price: 0, days: 0 }),
              [field]: value === "" ? "" : parseFloat(value) || 0,
            },
          },
        };
      }
      return s;
    });

    setSups(updatedSups);

    // 2. Prepare the full projects list for the DB
    const updatedProjects = projects.map((p) =>
      String(p.id) === String(currentProject) ? { ...p, sups: updatedSups } : p
    );
    setProjects(updatedProjects);

    // 3. Debounced Cloud Sync (8-Carriage Version)
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);

    saveTimerRef.current = setTimeout(async () => {
      try {
        if (user?.companyId) {
          // 1. FETCH THE LATEST TRUTH FROM CLOUD
          const freshData = await storage.get(user.companyId);
          if (!freshData) return; // Exit if cloud is unreachable

          // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
          const userSync =
            freshData?.users && Object.keys(freshData.users).length > 0
              ? freshData.users
              : allUsers;

          // STOP: Pull the emergency brake if the team list is empty
          if (!userSync || Object.keys(userSync).length === 0) {
            console.error(
              "CRITICAL: User list empty. Aborting auto-sync to prevent wipe."
            );
            return;
          }

          // 2. MERGE QUOTES INTO FRESH DATA (Concurrency Protection)
          // We use freshData.projects to ensure we don't wipe teammate updates
          const dbProjects = freshData.projects || projects || [];
          const mergedProjects = dbProjects.map((p) => {
            if (String(p.id) === String(currentProject)) {
              return { ...p, sups: updatedSups }; // Apply our latest typing changes
            }
            return p;
          });

          const dbActivities = freshData.activities || activities || [];
          const dbSuppliers =
            freshData.supList || freshData.suppliers || supList || [];

          // 3. ATOMIC CLOUD SYNC
          await storage.set(
            user.companyId,
            mergedProjects,
            userSync, // FIXED: Validated list
            dbActivities,
            dbSuppliers,
            user.plan || "starter",
            user.email || "",
            darkMode ? "dark" : "light"
          );

          console.log("☁️ Project quotes auto-synced safely to cloud");
        }
      } catch (err) {
        console.error("❌ Debounced Sync Failed:", err);
      }
    }, 1500); // Increased slightly to reduce server load
  };

  const delQuoteSup = async (idToDelete) => {
    if (isSaving) return;
    setIsSaving(true);
    if (!user?.companyId || !currentProject) return;

    // 1. Filter out the supplier from the local 'sups' state
    const updatedSups = sups.filter(
      (s) => String(s.id).trim() !== String(idToDelete).trim()
    );

    // 2. Create the updated project object
    const projectToUpdate = projects.find(
      (p) => String(p.id) === String(currentProject)
    );
    if (!projectToUpdate) return;

    const updatedProjectObject = {
      ...projectToUpdate,
      sups: updatedSups,
      lastUpdated: new Date().toISOString(),
      lastUpdatedBy: user.name
    };

    // 3. Update the master projects array (for the Workspace)
    const updatedProjects = projects.map((p) =>
      String(p.id) === String(currentProject) ? updatedProjectObject : p
    );

    // 🚩 4. TRIGGER UI UPDATES
    // This kicks off the Master Sync Effect for the standalone Project DB
    setSups(updatedSups);
    setProjects(updatedProjects);

    try {
      // 🚀 SYNC A: Standalone Project Entity
      await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: updatedProjectObject }),
      });

      // 🚀 SYNC B: Workspace Entity
      const freshData = await storage.get(user.companyId);
      await storage.set(
        user.companyId,
        updatedProjects,
        freshData?.users || allUsers, // Use your state 'allUsers'
        freshData?.activities || activities, // Use your state 'activities'
        freshData?.suppliers || supList, // 🚩 FIX: Use your state 'supList'
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // Explicitly call your save-data endpoint if you want to be 100% sure
      await fetch(`${BACKEND_URL}/api/save-data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          companyId: user.companyId,
          projects: updatedProjects,
        }),
      });
    } catch (err) {
      console.error("Dual-Sync Delete Error:", err);
      throw err; // Pass to the button's catch block
    } finally {
      setIsSaving(false);
    }
  };

  const uploadQuoteItems = async (file, slotId) => {
    console.log("🚀 Import Started", { fileName: file?.name, slotId });

    // 1. Initial Checks
    if (!file || !user?.companyId || !currentProject) {
      console.error("❌ Context Check Failed", {
        hasFile: !!file,
        companyId: user?.companyId,
        currentProject
      });
      return;
    }

    try {
      console.log("Reading ArrayBuffer...");
      const data = await file.arrayBuffer();

      console.log("XLSX parsing...");
      if (typeof XLSX === 'undefined') {
        throw new Error("XLSX library not loaded. Check your imports.");
      }

      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Identify the header row containing "ref"
      const headerRowIndex = rawRows.findIndex((r) =>
        r.some((c) => String(c || "").toLowerCase().includes("ref"))
      );

      if (headerRowIndex === -1) {
        console.error("❌ Header 'Ref' not found in Excel file.");
        return;
      }

      const cleanData = XLSX.utils.sheet_to_json(worksheet, { range: headerRowIndex });

      // 2. Build the Quotes Object
      const newQuotes = {};
      cleanData.forEach((row) => {
        const keys = Object.keys(row);
        const refKey = keys.find((k) => k.toLowerCase().includes("ref"));
        const priceKey = keys.find((k) => k.toLowerCase().includes("price") || k.toLowerCase().includes("rate"));
        const daysKey = keys.find((k) => k.toLowerCase().includes("days") || k.toLowerCase().includes("lead"));
        const descKey = keys.find((k) => k.toLowerCase().includes("desc") || k.toLowerCase().includes("detail"));

        if (refKey && row[refKey]) {
          const refValue = String(row[refKey]).trim();
          const rawPrice = String(row[priceKey] || "0").replace(/[^0-9.]/g, "");

          newQuotes[refValue] = {
            price: parseFloat(rawPrice) || 0,
            days: parseInt(row[daysKey]) || 0,
            desc: String(row[descKey] || "").trim(),
          };
        }
      });

      console.log("Processed Quotes:", newQuotes);

      // 3. Project Mapping Logic
      let targetProjectForSync = null;
      const updatedProjects = projects.map((p) => {
        if (String(p.id) === String(currentProject)) {
          const projectItems = p.quote || p.items || [];
          const updatedSups = (p.sups || []).map((supSlot) => {
            if (String(supSlot.id) === String(slotId)) {
              const updatedSupplierTemp = { ...supSlot, quotes: newQuotes };

              // Calculate total cost based on quantities
              const baseTotal = projectItems.reduce((sum, item) => {
                const price = parseFloat(newQuotes[item.ref]?.price) || 0;
                const qty = parseFloat(item.qty) || 0;

                // 1. Calculate line total
                const lineTotal = price * qty;

                // 2. Add to sum (Keep precision here, but ensure inputs were clean)
                return sum + lineTotal;
              }, 0);

              const delivery = parseFloat(supSlot.deliveryFee) || 0;
              const insurance = parseFloat(supSlot.insuranceFee) || 0;
              const handling = parseFloat(supSlot.handlingFee) || 0;
              const misc = parseFloat(supSlot.miscFee) || 0;

              // Subtotal before Tax
              let subTotal = baseTotal + delivery + insurance + handling + misc;

              let finalLanded;
              if (supSlot.isVatInclusive) {
                // 🚩 SA VAT Calculation (Standardize to 2 decimals at the VAT step)
                // Some systems calculate VAT on the rounded subtotal
                finalLanded = Math.round((subTotal * 1.15) * 100) / 100;
              } else {
                finalLanded = Math.round(subTotal * 100) / 100;
              }

              return {
                ...updatedSupplierTemp,
                totalLandedCost: finalLanded, // 🚩 Clean number, no .toFixed string conversion issues
              };
            }
            return supSlot;
          });

          targetProjectForSync = { ...p, sups: updatedSups, lastUpdated: new Date().toISOString(), lastUpdatedBy: user.name };
          return targetProjectForSync;
        }
        return p;
      });

      // 🚀 Step 4: MongoDB Sync
      console.log("Syncing to MongoDB...");
      const dbRes = await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: targetProjectForSync }),
      });

      if (!dbRes.ok) throw new Error("Database rejected the quote import.");

      // 🚀 Step 5: Local Storage Update
      console.log("Updating Local Storage...");
      const freshData = await storage.get(user.companyId);
      await storage.set(
        user.companyId,
        updatedProjects,
        freshData?.users || allUsers,
        freshData?.activities || activities,
        freshData?.suppliers || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 🚀 Step 6: UI Update (The "Triple-Sync")

      // 1. Update the Master List (The big array of all projects)
      setProjects(updatedProjects);

      // 2. Update the "Active" Project context
      // This is usually the state that feeds your current view/dashboard
      if (typeof setCurrentProjectData === 'function') {
        setCurrentProjectData({ ...targetProjectForSync });
      }

      // 3. Update the specific Supplier Slots for this card
      // We use a spread [...array] to force React to see a "New" reference in memory
      if (typeof setSups === 'function') {
        setSups([...targetProjectForSync.sups]);
      }

      console.log("✅ UI State Synced. Items updated:", Object.keys(newQuotes).length);

      console.log("✅ Import Successfully Completed!");

    } catch (err) {
      console.error("❌ FATAL IMPORT ERROR:", err);
    }
  };

  const syncSupplierQuotes = async (slotId, newQuotes) => {
    const loadingToast = toast.loading("Syncing AI data to QuoPro...");

    try {
      let targetProjectForSync = null;

      const updatedProjects = projects.map((p) => {
        if (String(p.id) === String(currentProject)) {
          const projectItems = p.quote || p.items || [];

          const updatedSups = (p.sups || []).map((s) => {
            if (String(s.id) === String(slotId)) {
              // Calculate totals exactly like your Excel logic
              const baseTotal = projectItems.reduce((sum, item) => {
                const price = parseFloat(newQuotes[item.ref]?.price) || 0;
                const qty = parseFloat(item.qty) || 0;
                return sum + price * qty;
              }, 0);

              let finalLanded = baseTotal +
                (parseFloat(s.deliveryFee) || 0) +
                (parseFloat(s.insuranceFee) || 0) +
                (parseFloat(s.handlingFee) || 0) +
                (parseFloat(s.miscFee) || 0);

              if (s.isVatInclusive) finalLanded *= 1.15;

              return {
                ...s,
                quotes: newQuotes,
                totalLandedCost: Number(finalLanded.toFixed(2)),
              };
            }
            return s;
          });

          targetProjectForSync = { ...p, sups: updatedSups, lastUpdated: new Date().toISOString(), lastUpdatedBy: user.name };
          return targetProjectForSync;
        }
        return p;
      });

      // Sync to MongoDB
      const dbRes = await fetch(`${BACKEND_URL}/api/projects/sync`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ projectData: targetProjectForSync }),
      });

      if (!dbRes.ok) throw new Error("Database rejected the AI sync.");

      // Update Local Storage & UI
      await storage.set(user.companyId, updatedProjects); // Simplify args based on your storage helper
      setProjects(updatedProjects);
      setSups(targetProjectForSync.sups);

      toast.dismiss(loadingToast);
      toast.success("AI Import Successful!");
    } catch (err) {
      toast.dismiss(loadingToast);
      toast.error(`Sync Failed: ${err.message}`);
    }
  };

  // Add this helper before the return
  const canEditProject = () => {
    if (!currentProject || !projects) return false;

    // Support both object and ID-only currentProject states
    const activeId = currentProject.id || currentProject;
    const project = projects.find(p => String(p.id) === String(activeId));

    if (!project || !project.status) return false;

    const status = project.status.trim().toLowerCase();
    const allowed = ["draft", "in progress", "awaiting quotes", "analysing", "completed"];

    return allowed.includes(status);
  };

  const canEditFinance = user?.role === "OWNER" || user?.role === "LEAD";

  const upload = async (e, type) => {
    const file = e.target.files?.[0];
    if (!file || !user?.companyId || !currentProject) {
      alert("Please ensure a project is selected before importing.");
      return;
    }

    // 🚩 START LOADING
    setIsImporting(true);

    const parseFile = (file) => {
      return new Promise((resolve, reject) => {
        const fileName = file.name.toLowerCase();
        if (fileName.endsWith(".csv")) {
          Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (res) => resolve(res.data),
            error: (err) => reject(err),
          });
        } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
          const reader = new FileReader();
          reader.onload = (f) => {
            try {
              const data = f.target.result;
              const workbook = XLSX.read(data, { type: "binary" });
              const json = XLSX.utils.sheet_to_json(
                workbook.Sheets[workbook.SheetNames[0]]
              );
              resolve(json);
            } catch (err) {
              reject(err);
            }
          };
          reader.readAsBinaryString(file);
        } else {
          reject(new Error("Unsupported format."));
        }
      });
    };

    try {
      const rawData = await parseFile(file);

      // 1. Map and Validate Data
      const processedItems = rawData
        .map((row, index) => {
          const values = Object.values(row);
          const ref = row.Reference || row.Ref || row["Ref #"] || values[0];
          const desc = row.Description || row.Desc || values[1];
          const qty = row.Quantity || row.Qty || row["QTY"] || values[2];

          return {
            id: `item-${Date.now()}-${index}`,
            ref: String(ref || "").trim(),
            desc: String(desc || "").trim(),
            qty: Number(qty) || 1,
            unit: row.Unit || "pcs",
          };
        })
        .filter((item) => item.ref && item.desc);

      if (processedItems.length === 0) {
        alert("No valid items found.");
        setIsImporting(false); // Ensure loading stops
        return;
      }

      // 🚩 STEP 1: FETCH FRESH DATA
      const freshData = await storage.get(user.companyId);
      if (!freshData) throw new Error("Connection failed");

      // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
      const userSync =
        freshData?.users && Object.keys(freshData.users).length > 0
          ? freshData.users
          : allUsers;

      // EMERGENCY BRAKE: If both sources are empty, stop to prevent team wipe
      if (!userSync || Object.keys(userSync).length === 0) {
        console.error(
          "CRITICAL: User list is empty. Aborting save to prevent workspace wipe."
        );
        setErrorModal({
          show: true,
          title: "Security Lock",
          message:
            "We couldn't verify your team list. Import aborted to protect your workspace. Please refresh.",
        });
        setIsImporting(false);
        return;
      }

      const targetProject = (freshData.projects || projects).find(
        (p) => String(p.id) === String(currentProject)
      );
      const projectName = targetProject?.name || "the project";

      // 🚩 STEP 2: PREPARE MERGED DATA
      const newLog = {
        id: Date.now(),
        user: user.name || user.email,
        action: "Items Imported",
        details: `Imported ${processedItems.length} items to "${projectName}" from ${file.name}`,
        timestamp: new Date().toISOString(),
      };

      const dbProjects = freshData.projects || projects;
      const mergedProjects = dbProjects.map((p) => {
        if (String(p.id) === String(currentProject)) {
          const existingQuote = Array.isArray(p.quote) ? p.quote : [];
          return {
            ...p,
            quote: [...existingQuote, ...processedItems],
            lastUpdated: new Date().toISOString(),
            lastUpdatedBy: user.name
          };
        }
        return p;
      });

      const mergedActivities = [newLog, ...(freshData.activities || [])];

      // 🚩 STEP 3: ATOMIC SYNC (SAFE VERSION)
      await storage.set(
        user.companyId,
        mergedProjects,
        userSync, // Validated User List
        mergedActivities,
        freshData.suppliers || freshData.supList || supList,
        user.plan || "starter",
        user.email || "",
        darkMode ? "dark" : "light"
      );

      // 🚩 STEP 4: UPDATE UI
      const updatedProjectInList = mergedProjects.find(
        (p) => String(p.id) === String(currentProject)
      );
      setProjects(mergedProjects);
      setQuote(updatedProjectInList?.quote || []);
      setActivities(mergedActivities);

      await triggerNotification(
        "project",
        "Import Successful",
        `${processedItems.length} items added to "${projectName}" from ${file.name}`
      );
    } catch (err) {
      console.error("Import Error:", err);
      alert("Import failed. Check console for details.");
    } finally {
      // 🚩 STOP LOADING
      setIsImporting(false);
      if (e.target) e.target.value = "";
    }
  };

  // Step 1: Open the modal and "stage" the user for deletion
  const removeTeammate = (targetEmail) => {
    // --- HARD VALIDATION ---
    let emailToMatch = "";
    if (typeof targetEmail === "string") {
      emailToMatch = targetEmail;
    } else if (targetEmail && targetEmail.email) {
      emailToMatch = targetEmail.email;
    }

    if (!emailToMatch || emailToMatch === "[object Object]") {
      console.error("❌ Invalid email:", targetEmail);
      return alert("Error: Could not determine the user's email.");
    }

    if (!user?.isOwner) return alert("Access Denied.");

    const safeEmailKey = emailToMatch.toLowerCase().trim().replace(/\./g, "_");
    const capturedName = allUsers[safeEmailKey]?.name || emailToMatch;

    // Instead of window.confirm, we update state to show your custom UI
    setPendingDeletion({
      email: emailToMatch,
      name: capturedName,
      key: safeEmailKey
    });
    setShowRevokeModal(true);
  };

  // Step 2: The actual execution (Called by the modal's "Confirm" button)
  const handleFinalRevoke = async () => {
    if (isDeleting) return; // Extra safety layer

    setIsDeleting(true); // Start animation
    const { email, name, key } = pendingDeletion;
    // Use the reason from your dropdown state
    const reasonText = `${revokeReason}${revokeNote ? `: ${revokeNote}` : ""}`;

    try {
      if (user?.companyId) {
        // STEP A: FETCH THE TRUTH BEFORE DELETING
        const freshData = await storage.get(user.companyId);
        if (!freshData) throw new Error("Could not reach cloud to verify team.");

        if (!freshData.users || Object.keys(freshData.users).length === 0) {
          throw new Error("Could not verify current team list. Aborting.");
        }

        // STEP B: API Call to Auth Collection
        const delResponse = await fetch(
          `${BACKEND_URL}/api/auth/user/${encodeURIComponent(email)}?companyId=${user.companyId}`,
          { method: "DELETE" }
        );
        if (!delResponse.ok) throw new Error("Failed to delete user account");

        // STEP C: Prepare updated state
        const updatedUsers = { ...freshData.users };
        delete updatedUsers[key];

        // STEP D: ATOMIC SYNC
        await storage.set(
          user.companyId,
          freshData.projects || projects,
          updatedUsers,
          freshData.activities || activities,
          freshData.suppliers || freshData.supList || supList,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );

        // STEP E: Local UI Update
        setAllUsers(updatedUsers);

        // 3. LOG & NOTIFY (Including the reason!)
        await logActivity(
          "Team Member Removed",
          `${name} removed. Reason: ${reasonText}`
        );

        if (typeof triggerNotification === "function") {
          await triggerNotification("user", "User Removed", `'${name}' removed.`);
        }

        setRemovalSuccess(name);
        setShowRevokeModal(false); // Close modal on success
      }
    } catch (err) {
      console.error("Removal Failed:", err);
      alert("Error: " + err.message);
    } finally {
      setIsDeleting(false); // Reset state regardless of outcome
    }
  };

  const generateFullAuditPDF = () => {
    try {
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = 210;

      const project = projects?.find(
        (p) => String(p.id) === String(currentProject)
      );
      const winner = qp_FinalWinner;

      const formatCurr = (val) =>
        new Intl.NumberFormat("en-GB", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(val) || 0);

      // --- 1. THE MODERN HEADER ---
      doc.setFillColor(15, 23, 42);
      doc.rect(0, 0, pageWidth, 50, "F");
      doc.setFillColor(16, 185, 129); // Emerald Green Accent Bar
      doc.rect(0, 50, pageWidth, 1.5, "F");

      doc
        .setFont("helvetica", "bold")
        .setFontSize(26)
        .setTextColor(255, 255, 255);
      doc.text("Quo", 105, 20, { align: "right" });
      doc.setTextColor(34, 211, 238);
      doc.text("Pro", 105, 20, { align: "left" });

      doc
        .setFontSize(9)
        .setFont("helvetica", "normal")
        .setTextColor(148, 163, 184);
      doc.text("PROCUREMENT AUDIT & SELECTION REPORT", pageWidth / 2, 28, {
        align: "center",
      });

      // Project Info Bar
      doc.setFillColor(30, 41, 59);
      doc.roundedRect(14, 35, 182, 10, 2, 2, "F");
      doc
        .setTextColor(255, 255, 255)
        .setFontSize(8)
        .setFont("helvetica", "bold");
      doc.text(`PROJECT: ${project?.name?.toUpperCase() || "N/A"}`, 20, 41.5);
      doc.text(`DATE: ${new Date().toLocaleDateString()}`, 190, 41.5, {
        align: "right",
      });

      // --- 2. INTEGRATED GREEN WINNER BUBBLE ---
      let currentY = 65;
      if (winner) {
        // Main Glass Container
        doc.setFillColor(248, 250, 252);
        doc.setDrawColor(226, 232, 240);
        doc.roundedRect(14, currentY, 182, 55, 8, 8, "FD");

        // THE FIX: Integrated Green Accent (Rounded to match the container's left edge)
        doc.setFillColor(16, 185, 129); // Emerald 500
        // We draw a small rounded rect that sits perfectly flush against the left curve
        doc.roundedRect(14, currentY, 4, 55, 8, 8, "F");
        // Then we draw a small white/bg rectangle to "cut" the right side of the green bar
        // making it look like a clean vertical strip that follows the outer curve
        doc.setFillColor(248, 250, 252);
        doc.rect(16.5, currentY, 2, 55, "F");

        // Winner Identity
        doc
          .setTextColor(15, 23, 42)
          .setFontSize(18)
          .setFont("helvetica", "bold");
        doc.text(winner.name || "Selected Vendor", 24, currentY + 15);

        // Status Badge (Green Theme)
        doc.setFillColor(16, 185, 129);
        doc.roundedRect(24, currentY + 20, 35, 5, 1, 1, "F");
        doc
          .setTextColor(255)
          .setFontSize(7)
          .text("PRIMARY SELECTION", 41.5, currentY + 23.5, {
            align: "center",
          });

        // Info Row
        doc.setTextColor(100).setFontSize(9).setFont("helvetica", "normal");
        doc.text(
          `B-BBEE Status: ${winner.beeLabel || "N/A"}`,
          24,
          currentY + 32
        );
        doc.text(`Match Coverage: ${winner.coverage || 0}%`, 80, currentY + 32);
        doc.text(`Lead Time: ${winner.leadTime || 0} Days`, 130, currentY + 32);

        // Divider Line
        doc.setDrawColor(241, 245, 249);
        doc.line(24, currentY + 38, 180, currentY + 38);

        // Final Total
        doc
          .setTextColor(15, 23, 42)
          .setFontSize(13)
          .setFont("helvetica", "bold");
        doc.text(`TOTAL AUDITED COST:`, 24, currentY + 48);
        doc.setTextColor(16, 185, 129); // Matching Green for the price
        const finalCost = winner.total || winner.cost || 0;
        doc.text(`R ${formatCurr(finalCost)}`, 190, currentY + 48, {
          align: "right",
        });
      }

      // --- 3. MATRIX TABLE (Source Sync) ---
      currentY += 70;
      doc.setTextColor(15, 23, 42).setFontSize(11).setFont("helvetica", "bold");
      doc.text("COMPARATIVE ANALYSIS MATRIX", 14, currentY);

      const tableHeaders = [
        "REF",
        "DESCRIPTION",
        ...sups.map((s) => {
          const found = supList?.find((sl) => String(sl.id) === String(s.sid));
          return found?.name?.toUpperCase() || "VENDOR";
        }),
      ];

      const tableBody = quote.map((item) => [
        item.ref,
        item.desc,
        ...sups.map((s) => {
          const p = parseFloat(s.quotes?.[item.ref]?.price || 0);
          const q = parseFloat(item.qty || 1);
          return p > 0 ? `R ${formatCurr(p * q)}` : "-";
        }),
      ]);

      autoTable(doc, {
        startY: currentY + 5,
        head: [tableHeaders],
        body: tableBody,
        theme: "grid",
        headStyles: {
          fillColor: [15, 23, 42],
          fontSize: 7,
          textColor: [255],
          halign: "center",
        },
        styles: { fontSize: 7, cellPadding: 3, lineColor: [226, 232, 240] },
        margin: { left: 14, right: 14 },
      });

      doc.save(`${project?.name || "Project"}_Audit_Report.pdf`);
    } catch (err) {
      console.error(err);
      alert("Audit Export Error: " + err.message);
    }
  };

  const exportProjectRegistryPDF = () => {
    try {
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = 210;

      // --- 1. PREMIUM HEADER (MATCHING ANALYST/AUDIT REPORTS) ---
      // Dark Background
      doc.setFillColor(15, 23, 42); // Slate 900
      doc.rect(0, 0, pageWidth, 45, "F");

      // Indigo Accent Line
      doc.setFillColor(79, 70, 229); // Indigo 600
      doc.rect(0, 45, pageWidth, 2, "F");

      // PERFECTLY CENTERED BRANDING
      // Centering "Quo" and "Pro" at the 105mm mark
      doc.setFont("helvetica", "bold");
      doc.setFontSize(24);
      doc.setTextColor(255, 255, 255);
      doc.text("Quo", 105, 18, { align: "right" });
      doc.setTextColor(129, 140, 248); // Indigo 400
      doc.text("Pro", 105, 18, { align: "left" });

      // CENTERED TITLES
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(18);
      doc.text("Master Project Registry", pageWidth / 2, 28, {
        align: "center",
      });

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(148, 163, 184); // Slate 400
      doc.text(
        "STRATEGIC PORTFOLIO OVERVIEW & ACTIVITY LOG",
        pageWidth / 2,
        34,
        { align: "center" }
      );

      // Metadata Row
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(9);
      doc.text(`TOTAL ACTIVE PROJECTS: ${projects.length}`, 14, 41);
      doc.text(
        `GENERATED: ${new Date().toLocaleDateString("en-ZA")}`,
        196,
        41,
        {
          align: "right",
        }
      );

      // --- 2. REGISTRY TABLE (MATCHING THE GRID THEME) ---
      const tableRows = projects.map((p) => [
        p.name.toUpperCase(),
        p.status || "ACTIVE",
        p.sups?.length || 0,
        p.lastUpdated
          ? new Date(p.lastUpdated).toLocaleDateString("en-ZA")
          : "N/A",
      ]);

      autoTable(doc, {
        startY: 55,
        head: [["PROJECT NAME", "STATUS", "SUPPLIERS", "LAST ACTIVITY"]],
        body: tableRows,
        theme: "grid",
        headStyles: {
          fillColor: [15, 23, 42], // Slate 900
          textColor: [255, 255, 255],
          fontSize: 9,
          fontStyle: "bold",
          halign: "center",
          cellPadding: 4,
        },
        styles: {
          fontSize: 8,
          cellPadding: 3,
          textColor: [71, 85, 105], // Slate 600
          lineColor: [241, 245, 249], // Slate 100
        },
        columnStyles: {
          0: { fontStyle: "bold", textColor: [79, 70, 229], width: 80 },
          1: { halign: "center" },
          2: { halign: "center" },
          3: { halign: "right" },
        },
        alternateRowStyles: {
          fillColor: [252, 253, 255],
        },
        margin: { left: 14, right: 14 },
      });

      // --- 3. FOOTER & PAGE NUMBERS ---
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        doc.text(
          `Page ${i} of ${pageCount} | QUOPRO_MASTER_REGISTRY_PORTFOLIO`,
          pageWidth / 2,
          285,
          { align: "center" }
        );
      }

      doc.save(
        `QuoPro_Master_Project_Registry_${new Date().toISOString().split("T")[0]
        }.pdf`
      );
      // LOG TO MONGODB: Keep a trail of who exported the master list
      logActivity(
        "Registry Exported",
        `The Master Project Registry PDF was generated. Total projects in report: ${projects.length}`
      );
    } catch (err) {
      console.error(err);
      alert("Registry Export Error. See console for details.");
    }
  };

  const deleteItemQuote = async (quoteEntryId, itemRef) => {
    // 1. Identify the target for the audit log
    const targetSup = sups.find((s) => s.id === quoteEntryId);
    const registryEntry = supList.find(
      (reg) => String(reg.id) === String(targetSup?.sid)
    );
    const supplierName = registryEntry?.name || "Unknown Supplier";

    try {
      if (user?.companyId) {
        // STEP A: FETCH THE TRUTH
        const freshData = await storage.get(user.companyId);
        if (!freshData) throw new Error("Cloud unreachable");

        // 🛡️ CRITICAL SECURITY GUARD: USER LIST PROTECTION
        const userSync =
          freshData?.users && Object.keys(freshData.users).length > 0
            ? freshData.users
            : allUsers;

        // EMERGENCY BRAKE
        if (!userSync || Object.keys(userSync).length === 0) {
          console.error(
            "CRITICAL: User list empty. Aborting to prevent team wipe."
          );
          return;
        }

        // STEP B: MERGE DELETION INTO FRESH DATA
        const dbProjects = freshData.projects || projects || [];
        const mergedProjects = dbProjects.map((p) => {
          if (String(p.id) === String(currentProject)) {
            // Map through the fresh supplier slots from the cloud
            const updatedSups = (p.sups || []).map((s) => {
              if (s.id === quoteEntryId) {
                const newQuotes = { ...s.quotes };
                delete newQuotes[itemRef]; // The surgical removal
                return { ...s, quotes: newQuotes };
              }
              return s;
            });
            return { ...p, sups: updatedSups };
          }
          return p;
        });

        const dbActivities = freshData.activities || activities || [];
        const dbSuppliers =
          freshData.supList || freshData.suppliers || supList || [];

        // STEP C: FULL 8-CARRIAGE ATOMIC SAVE
        await storage.set(
          user.companyId,
          mergedProjects,
          userSync, // FIXED: Validated team list
          dbActivities,
          dbSuppliers,
          user.plan || "starter",
          user.email || "",
          darkMode ? "dark" : "light"
        );

        // STEP D: UPDATE UI STATE
        const activeProject = mergedProjects.find(
          (p) => String(p.id) === String(currentProject)
        );
        setProjects(mergedProjects);
        if (activeProject) setSups(activeProject.sups);

        // 5. Audit Logging
        await logActivity(
          "Quote Item Update",
          `The pricing for item [${itemRef}] from ${supplierName} has been deleted.`
        );

        console.log("☁️ Cloud sync: Quote value removed safely.");
      }
    } catch (err) {
      console.error("❌ Failed to sync quote deletion:", err);
      if (typeof toast !== "undefined")
        toast.error("Sync failed. Check connection.");
    }
  };

  const countryList = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
    "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
    "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
    "Denmark", "Djibouti", "Dominica", "Dominican Republic",
    "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
    "Fiji", "Finland", "France",
    "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guyana",
    "Haiti", "Honduras", "Hungary",
    "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
    "Jamaica", "Japan", "Jordan",
    "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan",
    "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
    "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
    "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway",
    "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
    "Qatar", "Romania", "Russia", "Rwanda",
    "Saint Kitts and Nevis", "Saint Lucia", "Samoa", "San Marino", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
    "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
    "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
    "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
  ];

  const getCompletionRate = () => {
    if (projects.length === 0) return 0;
    const completedCount = projects.filter(
      (p) => p.status === "Completed"
    ).length;
    return Math.round((completedCount / projects.length) * 100);
  };

  const process = (data, type) => {
    if (!data || !Array.isArray(data)) return type === "main" ? [] : {};

    if (type === "main") {
      return data
        .map((r, i) => ({
          id: Date.now() + i,
          ref: String(r["Reference"] || r["Ref"] || "").trim(),
          desc: String(r["Description"] || r["Item"] || "").trim(),
          qty: isNaN(parseFloat(r["Quantity"] || r["Qty"]))
            ? 1
            : parseFloat(r["Quantity"] || r["Qty"]),
          unit: String(r["Unit"] || "").trim(),
        }))
        .filter((item) => item.ref !== "");
    } else {
      const quoteMap = {};
      data.forEach((r) => {
        // Find the reference value (handles "Ref", "REF", "Reference", etc)
        const rowKeys = Object.keys(r);
        const refKey = rowKeys.find((k) =>
          ["reference", "ref"].includes(k.toLowerCase().trim())
        );
        const ref = String(r[refKey] || "").trim();

        if (ref) {
          // 1. Find the Price Key and Value
          const priceKey = rowKeys.find((k) =>
            [
              "price",
              "rate",
              "zar",
              "amount",
              "cost",
              "unit price",
              "unitcost",
            ].includes(
              k.toLowerCase().trim().replace(/\s/g, "") // removes spaces for comparison
            )
          );

          // 2. Find the Lead Time Key and Value
          const timeKey = rowKeys.find((k) => {
            const normalized = k.toLowerCase().trim();
            return (
              normalized.includes("days") ||
              normalized.includes("lead time") ||
              normalized.includes("leadtime") ||
              normalized.includes("delivery") ||
              normalized.includes("period")
            );
          });

          // 3. Extract the Price
          const rawPrice = r[priceKey];
          const parsedPrice = isNaN(parseFloat(rawPrice))
            ? 0
            : parseFloat(rawPrice);

          // 4. Extract the Lead Time (The Fix)
          const rawTimeValue = r[timeKey];
          let parsedDays = 0;

          if (rawTimeValue !== undefined && rawTimeValue !== null) {
            if (typeof rawTimeValue === "number") {
              parsedDays = rawTimeValue;
            } else {
              // This regex grabs the first number it sees in the string
              const match = String(rawTimeValue).match(/\d+/);
              parsedDays = match ? parseInt(match[0]) : 0;
            }
          }

          quoteMap[ref] = {
            price: parsedPrice,
            days: parsedDays,
          };
        }
      });
      console.log("FINAL MAP:", quoteMap);
      return quoteMap;
    }
  };

  const handleThemeToggle = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);

    if (newMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    const userKey = user.email.replace(/\./g, "_");
    const updatedUsers = { ...allUsers };

    if (updatedUsers[userKey]) {
      updatedUsers[userKey] = {
        ...updatedUsers[userKey],
        theme: newMode ? "dark" : "light",
      };
      setAllUsers(updatedUsers);

      // FIX: Pass ALL 8 arguments to match the storage.set definition
      storage.set(
        user.companyId, // 1
        projects, // 2
        updatedUsers, // 3
        activities, // 4
        supList, // 5
        user.plan, // 6
        user.email, // 7 (CRITICAL: Added this)
        newMode ? "dark" : "light" // 8 (CRITICAL: Added this)
      );
    }
  };

  const handleAuditDownload = () => {
    if (isFreePlan) {
      setErrorModal({
        show: true,
        title: "Plan Limitations",
        message:
          "The Audit Reports feature is only available for the Pro and Business Plus+ Plans. Please upgrade your plan in Settings to unlock.",
      });
    } else {
      // Only runs if NOT on 'starter' plan
      generateFullAuditPDF();
    }
  };

  const handleSummaryExportDownload = () => {
    if (isFreePlan) {
      setErrorModal({
        show: true,
        title: "Plan Limitations",
        message:
          "The Export Summary feature is only available for the Pro and Business Plus+ Plans. Please upgrade your plan in Settings to unlock.",
      });
    } else {
      // Only runs if NOT on 'starter' plan
      generatePDF();
    }
  };

  const handleExportSupplierQuotes = () => {
    // We use supCalcs because it already contains the "Actual Values" shown in your table
    if (!supCalcs || supCalcs.length === 0) {
      console.error("OpenModal Export Error: No calculated data available to export.");
      return;
    }


    // 1. Define Professional Headers
    const headers = [
      "Supplier Name",
      "Supplier ID",
      "Items Priced",
      "Progress (%)",
      "B-BBEE Level",
      "Compliance Status",
      "Avg Lead Time (Days)",
      "Base Material Total (ZAR)",
      "Total Quoted Landed (ZAR)"
    ];

    // 2. Map supCalcs directly to rows
    const rows = supCalcs.map(s => {
      // Determine Compliance Status based on your Level 1-8 logic
      let compliance = "N/A";
      const level = parseInt(s.beeLevel);
      if (level >= 1 && level <= 2) compliance = "High";
      else if (level >= 3 && level <= 5) compliance = "Medium";
      else if (level >= 6 && level <= 8) compliance = "Low";

      return [
        `"${s.vendorName}"`,                         // Supplier Name
        `"${String(s.id).slice(-6)}"`,              // Short ID
        `"${s.pricedCount} / ${quote.length}"`,      // Items Priced vs Total
        `"${s.completionPercentage}%"`,             // Progress
        s.beeLevel || "N/A",                        // B-BBEE Level
        compliance,                                  // Status (Red/Orange/Green)
        s.avgLeadTime > 0 ? s.avgLeadTime : "0",     // Lead Time
        s.materialBase.toFixed(2),                   // Base Price
        s.finalTotal.toFixed(2)                      // Landed Price
      ].join(",");
    });

    // 3. Create the CSV File (Excel Compatible)
    const csvContent = [headers.join(","), ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Supplier_Quote_Export${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPDFDownload = () => {
    if (isFreePlan) {
      setErrorModal({
        show: true,
        title: "Plan Limitations",
        message:
          "The Export PDF feature is only available for the Pro and Business Plus+ Plans. Please upgrade your plan in Settings to unlock.",
      });
    } else {
      // Only runs if NOT on 'starter' plan
      exportProjectRegistryPDF();
    }
  };

  const handleViewMatrixClick = () => {
    if (isFreePlan) {
      setErrorModal({
        show: true,
        title: "Plan Limitations",
        message:
          "The Strategic Split Analysis Matrix feature is only available for the Pro and Business Plus+ Plans. Please upgrade your plan in Settings to unlock.",
      });
    } else {
      setShowSplitModal(true);
    }
  };

  const getGlobalReportData = () => {
    const statusCounts = projects.reduce((acc, p) => {
      acc[p.status] = (acc[p.status] || 0) + 1;
      return acc;
    }, {});

    const statusData = STATUS_OPTIONS.map((s) => {
      // 🚩 Map status names to specific hex colors
      const colorMap = {
        Draft: "#94a3b8", // slate-400
        "In Progress": "#3b82f6", // blue-500
        "Awaiting Quotes": "#a855f7", // purple-500
        Analysing: "#f59e0b", // amber-500
        Completed: "#10b981", // emerald-500
      };

      return {
        name: s,
        value: Number(statusCounts[s]) || 0,
        color: colorMap[s] || "#cbd5e1", // Fallback to slate-300 if status doesn't match
      };
    }).filter((item) => item.value > 0);

    return { statusData };
  };

  const handleExportItems = () => {
    // 1. Define the headers based on your item structure
    const headers = ["Item Ref", "Description", "Quantity", "Unit"];

    // 2. Map the quote/items data
    // Assuming 'quote' is your array of items
    const rows = quote.map((item) => [
      `"${item.ref || ""}"`,
      `"${item.desc || ""}"`,
      item.qty || 0,
      `"${item.unit || "ea"}"`,
    ]);

    // 3. Assemble CSV content
    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");

    // 4. Create download trigger
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `Project_Items_Export_${new Date().toLocaleDateString()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // LOG TO MONGODB: Just to keep the audit trail honest
    logActivity(
      "Items Exported",
      `The Bill of Quantities was exported as a CSV file.`
    );
  };

  const { winner, runnerUp } = useMemo(() => {
    if (!sups || sups.length === 0 || !quote || quote.length === 0) {
      return { winner: null, runnerUp: null };
    }

    const supsWithTotals = sups.map((s) => {
      const profile = (supList || []).find(
        (v) => String(v.id) === String(s.sid || s.id)
      );

      // 1. Calculate Raw Material Total (Fallback)
      const rawMaterialTotal = quote.reduce((acc, item) => {
        const price = parseFloat(s.quotes?.[item.ref]?.price || 0);
        const qty = parseFloat(item.qty || 0);
        return acc + price * qty;
      }, 0);

      // 🚩 THE FIX: Use the Landed Cost if it exists, otherwise use raw material total
      // This ensures your R317,733 (landed) beats the raw calculation.
      const finalTotal =
        Number(s.totalLandedCost) > 0
          ? Number(s.totalLandedCost)
          : rawMaterialTotal;

      const itemsQuoted = Object.keys(s.quotes || {}).length;
      const coverage = ((itemsQuoted / quote.length) * 100).toFixed(0);

      return {
        ...s,
        name: profile?.name || "Unassigned Vendor",
        calculatedTotal: finalTotal, // 🚩 Use the prioritized total here
        itemCoverage: coverage,
      };
    });

    const activeSups = supsWithTotals.filter((s) => s.calculatedTotal > 0);
    const sorted = [...activeSups].sort(
      (a, b) => a.calculatedTotal - b.calculatedTotal
    );

    return {
      winner: sorted[0] || null,
      runnerUp: sorted[1] || null,
    };
  }, [sups, quote, supList]);

  const procurementStats = useMemo(() => {
    if (!quote || quote.length === 0 || !sups || sups.length === 0) {
      return {
        winnerTotal: 0,
        rawDiff: 0,
        splitMin: 0,
        savingsPct: 0,
        rank1Name: "Target Vendor",
      };
    }

    // 1. DYNAMICALLY FIND THE LOWEST TOTAL QUOTE (The Baseline)
    // We map through all suppliers and calculate their raw material total (excluding fees)
    const allSupplierTotals = sups.map((s) => {
      const total = quote.reduce((acc, item) => {
        const itemKey = item.ref || item.id || item._id;
        const quoteEntry = s.quotes?.[itemKey];
        const p = parseFloat(quoteEntry?.price || quoteEntry?.unitPrice || 0);
        const qty = parseFloat(item.qty || item.quantity || 1);
        return acc + (p * qty);
      }, 0);
      return { name: s.name || s.vendorName, total };
    });

    // Find the absolute lowest single-vendor total
    const lowestSingleQuote = Math.min(...allSupplierTotals.map(s => s.total));
    const bestVendor = allSupplierTotals.find(s => s.total === lowestSingleQuote);

    // 2. CALCULATE THE SPLIT-OPTIMIZED FLOOR (Item-by-Item)
    const splitMin = quote.reduce((acc, item) => {
      const itemKey = item.ref || item.id || item._id;
      const qty = parseFloat(item.qty || item.quantity || 1);

      const prices = sups.map((s) => {
        const quoteEntry = s.quotes?.[itemKey];
        const p = parseFloat(quoteEntry?.price || quoteEntry?.unitPrice || 0);
        return isNaN(p) || p <= 0 ? Infinity : p;
      });

      const minPrice = Math.min(...prices);
      const lineMin = minPrice === Infinity ? 0 : minPrice * qty;
      return acc + lineMin;
    }, 0);

    // 3. FINAL CALCULATIONS & ROUNDING
    const winnerTotal = Math.round((lowestSingleQuote + Number.EPSILON) * 100) / 100;
    const roundedSplitMin = Math.round((splitMin + Number.EPSILON) * 100) / 100;

    // How much we save by splitting vs the single best quote
    const rawDiff = winnerTotal - roundedSplitMin;
    const finalDiff = rawDiff > 0 ? Math.round((rawDiff + Number.EPSILON) * 100) / 100 : 0;
    const savingsPct = winnerTotal > 0 ? (finalDiff / winnerTotal) * 100 : 0;

    return {
      winnerTotal,
      splitMin: roundedSplitMin,
      rawDiff: finalDiff,
      savingsPct,
      rank1Name: bestVendor?.name || "Lowest Bidder",
    };
  }, [quote, sups]); // Removed 'winner' dependency to rely solely on the raw list of suppliers

  const rankedList = useMemo(() => {
    return (supList || [])
      .map((s) => ({ ...s, count: Object.keys(s.quotes || {}).length }))
      .sort((a, b) => b.count - a.count);
  }, [supList]);

  const topSupplier = rankedList[0];
  const runnerUpByCount = rankedList[1];

  const calculateAwards = () => {
    let results = {
      cheapest: { name: "", total: Infinity },
      beeLeader: { name: "", level: 10, total: Infinity },
      fastest: { name: "", leadTime: Infinity, total: Infinity },
      mostComplete: { name: "", coverage: 0 },
    };

    if (!sups || !Array.isArray(sups) || sups.length === 0) return results;

    sups.forEach((s) => {
      if (!s.sid) return;

      const supplierInfo = supList?.find(
        (sl) => String(sl.id) === String(s.sid)
      );
      const supplierName = supplierInfo?.name || "Unknown";

      let currentProjectTotal = 0;
      let currentLeadTimeSum = 0;
      let itemsQuotedCount = 0;

      // --- ROBUST LOOKUP ---
      quote.forEach((item) => {
        // 1. Identify the item's unique key and convert to String
        const rawKey = item.id || item.ref || item.key || item.uid;
        if (!rawKey) return;

        const lookupKey = String(rawKey);

        // 2. Access the quote using the String key
        const itemQuote = s.quotes ? s.quotes[lookupKey] : null;

        if (itemQuote) {
          const price = parseFloat(itemQuote.price);
          // Check both 'qty' and 'quantity'
          const qty = parseFloat(item.qty || item.quantity || 1);
          const lead = parseFloat(itemQuote.leadTime || 0);

          if (!isNaN(price) && price > 0) {
            currentProjectTotal += price * qty;
            currentLeadTimeSum += lead;
            itemsQuotedCount++;
          }
        }
      });

      const totalItemsInProject = quote.length || 0;
      const coveragePercent =
        totalItemsInProject > 0
          ? (itemsQuotedCount / totalItemsInProject) * 100
          : 0;
      const avgLeadTime =
        itemsQuotedCount > 0 ? currentLeadTimeSum / itemsQuotedCount : Infinity;

      // BEE Level Parsing (Strict 1-8)
      let beeLevel = 10;
      if (supplierInfo?.bee) {
        const cleanedBee = String(supplierInfo.bee).replace(/[^0-9]/g, "");
        beeLevel = cleanedBee ? parseInt(cleanedBee, 10) : 10;
        if (beeLevel > 8 || beeLevel < 1) beeLevel = 10;
      }

      // --- WINNER SELECTION ---
      if (
        currentProjectTotal > 0 &&
        currentProjectTotal < results.cheapest.total
      ) {
        results.cheapest = { name: supplierName, total: currentProjectTotal };
      }

      if (beeLevel >= 1 && beeLevel <= 8) {
        if (
          beeLevel < results.beeLeader.level ||
          (beeLevel === results.beeLeader.level &&
            currentProjectTotal < results.beeLeader.total)
        ) {
          results.beeLeader = {
            name: supplierName,
            level: beeLevel,
            total: currentProjectTotal,
          };
        }
      }

      if (itemsQuotedCount > 0) {
        if (
          avgLeadTime < results.fastest.leadTime ||
          (avgLeadTime === results.fastest.leadTime &&
            currentProjectTotal < results.fastest.total)
        ) {
          results.fastest = {
            name: supplierName,
            leadTime: avgLeadTime,
            total: currentProjectTotal,
          };
        }
      }

      if (
        coveragePercent > 0 &&
        coveragePercent >= results.mostComplete.coverage
      ) {
        results.mostComplete = {
          name: supplierName,
          coverage: coveragePercent,
        };
      }
    });

    return {
      cheapest: results.cheapest.total === Infinity ? null : results.cheapest,
      beeLeader: results.beeLeader.level === 10 ? null : results.beeLeader,
      fastest: results.fastest.leadTime === Infinity ? null : results.fastest,
      mostComplete:
        results.mostComplete.coverage === 0 ? null : results.mostComplete,
    };
  };

  const awards = React.useMemo(() => {
    return calculateAwards();
  }, [sups, quote, supList]);

  // 3. THIRD: Helper assignments
  const stats = procurementStats;

  //NVOICE GENERATION PDF FUNC
  const generatePDFDocument = async (
    vendorName,         // String: e.g. sup.displayName
    items,              // Array: activeProject.quote
    vendorProfile,      // Object: The complete 'sup' object mapped in availableSuppliers
    docType,            // String: e.g. "advice"
    project,            // Object: activeProject
    selectionMode = "optimal" // String: selectionMode state ("optimal" or "overall")
  ) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    const safeParse = (val) => {
      if (val === undefined || val === null) return 0;
      if (typeof val === 'number') return isNaN(val) ? 0 : val;
      const cleaned = val.toString().replace(/[R\s,]/gi, '');
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? 0 : parsed;
    };

    const supplier = vendorProfile || {};
    const allProjectSups = project?.sups || [];

    // Resolve project-specific supplier slot where the real quote fees live
    const supplierSlot = allProjectSups.find(
      (s) => s.name === vendorName || s.supplierName === vendorName || String(s.sid || s.id) === String(supplier.sid || supplier.id)
    );

    // Defensive lookup across project slot and general profile
    const deliveryFee = safeParse(supplierSlot?.deliveryFee || supplierSlot?.delivery_fee || supplierSlot?.freight || supplier.deliveryFee || supplier.delivery_fee);
    const insuranceFee = safeParse(supplierSlot?.insuranceFee || supplierSlot?.insurance_fee || supplier.insuranceFee || supplier.insurance_fee);
    const handlingFee = safeParse(supplierSlot?.handlingFee || supplierSlot?.handling_fee || supplier.handlingFee || supplier.handling_fee);
    const miscFee = safeParse(supplierSlot?.miscFee || supplierSlot?.misc_fee || supplier.miscFee || supplier.misc_fee);
    const vatAmount = safeParse(supplierSlot?.vatAmount || supplierSlot?.vat_amount || supplierSlot?.vat || supplier.vatAmount || supplier.vat_amount);

    let itemsToRender = [];
    if (selectionMode === "optimal") {
      itemsToRender = (items || []).filter((mItem) => {
        const itemRef = String(mItem.ref || "").trim();
        let cheapestSid = null;
        let minPrice = Infinity;

        allProjectSups.forEach((s) => {
          const price = safeParse(s.quotes?.[itemRef]?.price);
          if (price > 0 && price < minPrice) {
            minPrice = price;
            cheapestSid = String(s.sid || s.id);
          }
        });

        const currentSid = String(supplierSlot?.sid || supplierSlot?.id || supplier.sid || supplier.id || "");
        if (currentSid && cheapestSid) {
          return cheapestSid === currentSid;
        }

        let cheapestName = null;
        let minPriceName = Infinity;
        allProjectSups.forEach((s) => {
          const price = safeParse(s.quotes?.[itemRef]?.price);
          if (price > 0 && price < minPriceName) {
            minPriceName = price;
            cheapestName = s.name || s.supplierName;
          }
        });
        return cheapestName === vendorName;
      });
    } else {
      itemsToRender = items || [];
    }

    let runningItemsSubtotal = 0;

    const tableBody = itemsToRender.map((item) => {
      const qty = safeParse(item.qty || item.quantity);
      const itemRef = String(item.ref || "").trim();
      const unitPrice = selectionMode === "optimal"
        ? safeParse(supplierSlot?.quotes?.[itemRef]?.price || supplier.quotes?.[itemRef]?.price)
        : safeParse(supplierSlot?.quotes?.[itemRef]?.price || item.price || item.unitPrice);

      const calculatedRowTotal = qty * unitPrice;
      runningItemsSubtotal += calculatedRowTotal;

      return [
        item.ref || "-",
        item.desc || item.description || "N/A",
        qty,
        `R ${unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        `R ${calculatedRowTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      ];
    });

    const dynamicGrandTotal = selectionMode === "optimal"
      ? (runningItemsSubtotal + deliveryFee + insuranceFee + handlingFee + miscFee + vatAmount)
      : safeParse(supplierSlot?.fullLandedTotal || supplier.fullLandedTotal || (runningItemsSubtotal + deliveryFee + insuranceFee + handlingFee + miscFee + vatAmount));

    const formatCurrency = (num) => `R ${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    // ==========================================
    // PAGE 1: HEADER & PRIMARY LINE ITEMS MATRIX
    // ==========================================

    // Top Accent Brand Banner Line
    doc.setFillColor(79, 70, 229); // Modern Purple Accent
    doc.rect(0, 0, pageWidth, 4, "F");

    // Corporate Header Typography
    doc.setFont("helvetica", "bold");
    doc.setFontSize(26);
    doc.setTextColor(15, 23, 42); // Slate 900
    doc.text("QuoPro", 14, 22);

    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(79, 70, 229); // Violet 600
    doc.text("FINANCIAL PROCUREMENT LOGISTICS", 14, 29);

    // Decorative Context Layout Header Dividers
    doc.setDrawColor(241, 245, 249); // Slate 100
    doc.setLineWidth(0.5);
    doc.line(14, 35, pageWidth - 14, 35);

    // ------------------------------------------
    // METADATA ARCHITECTURE BLOCK (NEW COLUMN LAYOUT)
    // ------------------------------------------
    doc.setTextColor(148, 163, 184); // Slate 400 Labels
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");

    // Column 1 Labels (Left Stack)
    doc.text("WORKSPACE ID:", 14, 44);
    doc.text("PROJECT DESTINATION HUB:", 14, 58);
    doc.text("PREPARED FOR VENDOR:", 14, 72);

    // Column 2 Labels (Right Stack)
    doc.text("DOCUMENT TYPE:", 115, 44);
    doc.text("GENERATION TIMESTAMP:", 115, 58);

    // Primary Text Values Generation Mapping
    doc.setTextColor(30, 41, 59); // Slate 800 Values
    doc.setFontSize(9.5);

    // Column 1 Values Execution (Defensive lookup routing block to guarantee resolution)
    const resolvedWorkspaceId = String(project?.workspaceId || project?.workspace || project?.wsid || project?.id || "PENDING RESOLUTION");
    doc.text(resolvedWorkspaceId.toUpperCase(), 14, 50);
    doc.text((project?.name || "N/A").toUpperCase(), 14, 64);
    doc.text((vendorName || "N/A").toUpperCase(), 14, 78);

    // Column 2 Values Execution
    doc.text(String(docType || "PAYMENT ADVICE").toUpperCase().replace(/-/g, " "), 115, 50);
    doc.setFont("helvetica", "normal");
    doc.text(new Date().toLocaleString('en-ZA', { timeZone: 'Africa/Johannesburg' }), 115, 64);

    // Primary Interactive Content Table Matrix Grid Placement
    autoTable(doc, {
      startY: 92, // Pushed down slightly to give the elements air space
      head: [["Ref", "Item Description", "Qty", "Unit Price", "Total"]],
      body: tableBody,
      theme: "striped",
      headStyles: { fillColor: [15, 23, 42], textColor: [255, 255, 255], fontSize: 8, fontStyle: "bold", halign: "left" },
      columnStyles: {
        0: { cellWidth: 30 },
        1: { cellWidth: 70 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "right", cellWidth: 32 },
        4: { halign: "right", fontStyle: "bold", cellWidth: 30 }
      },
      styles: { fontSize: 8, cellPadding: 4, textColor: [51, 65, 85] },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      margin: { left: 14, right: 14 },
    });

    // Page Footer Indexing
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(148, 163, 184);
    doc.text("Page 1 of 2 — Generated securely via QuoPro Engine", 14, pageHeight - 10);

    // ==========================================
    // PAGE 2: COST BREAKDOWN & SIGN-OFF
    // ==========================================
    doc.addPage();

    // Re-establish Top Accent Brand Banner Line on Page 2
    doc.setFillColor(79, 70, 229);
    doc.rect(0, 0, pageWidth, 4, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(15, 23, 42);
    doc.text("Financial Breakdown", 14, 25);

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    doc.text("Itemised overhead variances and verified landing totals allocation ledger.", 14, 31);

    doc.setDrawColor(241, 245, 249);
    doc.line(14, 37, pageWidth - 14, 37);

    let breakdownY = 50;

    if (selectionMode === "optimal") {
      // Create a sophisticated structural table matrix layout for overhead items
      const feeRows = [
        ["Base Allocation Subtotal", formatCurrency(runningItemsSubtotal)],
        ["Freight / Delivery Charge", formatCurrency(deliveryFee)],
        ["Surcharge Insurance Escrow", formatCurrency(insuranceFee)],
        ["Logistics Handling Fee", formatCurrency(handlingFee)],
        ["Miscellaneous / Contingency", formatCurrency(miscFee)],
        ["Value Added Tax (VAT Amount)", formatCurrency(vatAmount)]
      ];

      autoTable(doc, {
        startY: breakdownY,
        head: [["LEDGER LINE CATEGORY", "VALUATION METRIC (ZAR)"]],
        body: feeRows,
        theme: "plain",
        headStyles: { fillColor: [79, 70, 229], textColor: [255, 255, 255], fontSize: 9, fontStyle: "bold" },
        columnStyles: {
          0: { cellWidth: 120, fontStyle: "normal" },
          1: { halign: "right", cellWidth: 62, fontStyle: "bold" }
        },
        styles: { fontSize: 9.5, cellPadding: 5, textColor: [30, 41, 59] },
        didParseCell: function (data) {
          // Subtle horizontal grid borders inside the breakdown layout table
          data.cell.styles.borderBottomWidth = 0.5;
          data.cell.styles.borderBottomColor = [241, 245, 249];
        },
        margin: { left: 14, right: 14 }
      });

      breakdownY = doc.lastAutoTable.finalY + 15;
    } else {
      // Expanded structural breakdown tracking matrix layout for overall project mode summaries
      const comprehensiveOverallRows = [
        ["Gross Aggregated Items Subtotal", formatCurrency(runningItemsSubtotal)],
        ["Freight / Delivery Charge", formatCurrency(deliveryFee)],
        ["Surcharge Insurance Escrow", formatCurrency(insuranceFee)],
        ["Logistics Handling Fee", formatCurrency(handlingFee)],
        ["Miscellaneous / Contingency", formatCurrency(miscFee)],
        ["Value Added Tax (VAT Amount)", formatCurrency(vatAmount)],
        ["Full Consolidated Landed Valuation", formatCurrency(dynamicGrandTotal)]
      ];

      autoTable(doc, {
        startY: breakdownY,
        head: [["CONSOLIDATED OVERALL METRIC BREAKDOWN", "VALUATION METRIC (ZAR)"]],
        body: comprehensiveOverallRows,
        theme: "plain",
        headStyles: { fillColor: [100, 116, 139], textColor: [255, 255, 255], fontSize: 9, fontStyle: "bold" },
        columnStyles: {
          0: { cellWidth: 120, fontStyle: "normal" },
          1: { halign: "right", cellWidth: 62, fontStyle: "bold" }
        },
        styles: { fontSize: 9.5, cellPadding: 5, textColor: [30, 41, 59] },
        didParseCell: function (data) {
          // Distinct highlights on the summary layout rows inside overall tables
          data.cell.styles.borderBottomWidth = 0.5;
          data.cell.styles.borderBottomColor = [241, 245, 249];
          if (data.row.index === comprehensiveOverallRows.length - 1) {
            data.cell.styles.textColor = [79, 70, 229];
          }
        },
        margin: { left: 14, right: 14 }
      });

      breakdownY = doc.lastAutoTable.finalY + 15;
    }

    // Modern Total Invoicing Callout Card Block
    doc.setFillColor(248, 250, 252); // Soft tint slate 50 background
    doc.roundedRect(14, breakdownY, pageWidth - 28, 28, 4, 4, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text("COMPILING TOTAL ALLOCATION VALUE (ZAR)", 22, breakdownY + 11);

    doc.setFontSize(18);
    doc.setTextColor(79, 70, 229);
    doc.text(formatCurrency(dynamicGrandTotal), 22, breakdownY + 21);

    // Bottom Decorative Secure Stamp Block Metadata Element Container
    let stampY = breakdownY + 45;

    // Fallback to prevent layout breaking on page boundary limits
    if (stampY > pageHeight - 50) {
      stampY = pageHeight - 55;
    }

    doc.setDrawColor(226, 232, 240); // Slate 200 Border outline layout frame 
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(14, stampY, 90, 32, 3, 3, "FD");

    // Dynamic Secure Verification Indicator Elements
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(148, 163, 184); // Gray Label Accent Meta Text
    doc.text("PROCUREMENT COMPLIANCE STATUS", 20, stampY + 8);

    doc.setFontSize(11);
    doc.setTextColor(16, 185, 129); // Vibrant Compliance Green Success Badge text
    doc.text("✓ AUDITED & RECORDED", 20, stampY + 16);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(51, 65, 85);
    doc.text(`Pipeline State: System Finalized`, 20, stampY + 23);
    doc.text(`Ref: INV-${String(project?.id || "").slice(-3)}-SECURE`, 20, stampY + 28);

    // Sign-Off Placeholder Line Architecture Layout Anchor Points
    doc.setDrawColor(203, 213, 225);
    doc.line(130, stampY + 23, pageWidth - 14, stampY + 23);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.setTextColor(148, 163, 184);
    doc.text("AUTHORIZED CONTROLLER SIGNATURE", 130, stampY + 28);

    // Page 2 Footer Indexing
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(148, 163, 184);
    doc.text("Page 2 of 2 — Generated securely via QuoPro Engine", 14, pageHeight - 10);

    // Trigger local client document resource download downstream securely
    const safeFileName = (vendorName || "Invoice").replace(/\s+/g, "_");
    doc.save(`QuoPro_Invoice_${safeFileName}.pdf`);
  };

  const generatePDF = () => {
    try {
      // Landscape A4 (297mm x 210mm)
      const doc = new jsPDF("l", "mm", "a4");
      const project = projects.find((p) => p.id === currentProject);
      const pName = project?.name || "Project";
      const pageWidth = 297;

      // Currency Formatting Helper
      const formatCurr = (val) =>
        new Intl.NumberFormat("en-GB", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(val) || 0);

      const stats = supplierStats().sort(
        (a, b) => b.itemsFilled - a.itemsFilled
      );
      const best = stats[0];
      const runner = stats[1];

      // --- 1. PREMIUM HEADER ---
      doc.setFillColor(15, 23, 42); // Slate 900
      doc.rect(0, 0, pageWidth, 45, "F");

      doc.setFillColor(79, 70, 229); // Indigo 600
      doc.rect(0, 45, pageWidth, 2, "F");

      // PERFECTLY CENTERED BRANDING
      // Split "Quo" and "Pro" at the center line (148.5mm)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(24);
      doc.setTextColor(255, 255, 255);
      doc.text("Quo", 148.5, 18, { align: "right" });
      doc.setTextColor(129, 140, 248); // Indigo 400
      doc.text("Pro", 148.5, 18, { align: "left" });

      // CENTERED TITLES
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(18);
      doc.text("Analytical Procurement Report", pageWidth / 2, 28, {
        align: "center",
      });

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(148, 163, 184);
      doc.text(
        "STRATEGIC COMMERCIAL ANALYSIS & SELECTION MATRIX",
        pageWidth / 2,
        34,
        { align: "center" }
      );

      // Metadata
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(9);
      doc.text(`PROJECT: ${pName.toUpperCase()}`, 22, 41);
      doc.text(`DATE: ${new Date().toLocaleDateString()}`, 275, 41, {
        align: "right",
      });

      // --- 2. SELECTION CARDS ---
      let currentY = 60;
      if (best) {
        doc.setFillColor(248, 250, 252);
        doc.setDrawColor(226, 232, 240);
        doc.roundedRect(22, currentY, 125, 35, 4, 4, "FD");
        doc.setFillColor(79, 70, 229);
        doc.rect(22, currentY, 2, 35, "F");
        doc.setTextColor(79, 70, 229);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text("PRIMARY RECOMMENDATION", 30, currentY + 8);
        doc.setTextColor(15, 23, 42);
        doc.setFontSize(14);
        doc.text(best.name, 30, currentY + 18);
        doc.setTextColor(71, 85, 105);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(
          `Total Commercial Value: R ${formatCurr(best.total)}`,
          30,
          currentY + 28
        );
        doc.setFillColor(238, 242, 255);
        doc.roundedRect(95, currentY + 5, 45, 7, 2, 2, "F");
        doc.setTextColor(67, 56, 202);
        doc.setFontSize(7);
        doc.text("RANKING OPTIMIZED", 117.5, currentY + 10, {
          align: "center",
        });
      }

      if (runner) {
        doc.setFillColor(255, 255, 255);
        doc.setDrawColor(226, 232, 240);
        doc.roundedRect(152, currentY, 125, 35, 4, 4, "FD");
        doc.setFillColor(148, 163, 184);
        doc.rect(152, currentY, 2, 35, "F");
        doc.setTextColor(100);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text("RUNNER-UP ALTERNATIVE", 160, currentY + 8);
        doc.setTextColor(15, 23, 42);
        doc.setFontSize(14);
        doc.text(runner.name, 160, currentY + 18);
        doc.setTextColor(71, 85, 105);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        const diff = runner.total - best.total;
        doc.text(`Price Variance: + R ${formatCurr(diff)}`, 160, currentY + 28);
      }

      // --- 3. CHART ---
      currentY += 55;
      doc.setTextColor(30, 41, 59);
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("TOTAL COMMERCIAL VALUE COMPARISON", 22, currentY);
      const chartX = 22;
      const maxVal = Math.max(...stats.map((s) => s.total)) * 1.2;
      stats.forEach((s, i) => {
        const yPos = currentY + 10 + i * 18;
        doc.setFillColor(241, 245, 249);
        doc.roundedRect(chartX + 75, yPos, 180, 8, 4, 4, "F");
        const barWidth = (s.total / maxVal) * 180;
        doc.setFillColor(79, 70, 229);
        doc.roundedRect(chartX + 75, yPos, barWidth, 8, 4, 4, "F");
        doc.setTextColor(15, 23, 42);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(s.name, chartX, yPos + 6);
        doc.setTextColor(79, 70, 229);
        doc.setFontSize(9);
        doc.text(`R ${formatCurr(s.total)}`, chartX + 80 + barWidth, yPos + 6);
        doc.setTextColor(148, 163, 184);
        doc.setFontSize(7);
        doc.text(
          `${s.itemsCovered || s.itemsFilled} Items Covered`,
          chartX,
          yPos + 10
        );
      });

      // --- PAGE 2 ---
      doc.addPage();
      doc.setFillColor(15, 23, 42);
      doc.rect(0, 0, pageWidth, 25, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(255, 255, 255);
      doc.text("Quo", 148.5, 12, { align: "right" });
      doc.setTextColor(129, 140, 248);
      doc.text("Pro", 148.5, 12, { align: "left" });
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(12);
      doc.text("Master Item Schedule & Pricing Matrix", pageWidth / 2, 19, {
        align: "center",
      });

      const headers = [
        "REF",
        "DESCRIPTION",
        "QTY",
        ...sups.map(
          (s) =>
            supList.find((sl) => sl.id === s.sid)?.name?.toUpperCase() ||
            "VENDOR"
        ),
      ];
      const body = quote.map((item) => [
        item.ref,
        item.desc,
        item.qty,
        ...sups.map((s) =>
          s.quotes[item.ref]?.price ? formatCurr(s.quotes[item.ref].price) : "-"
        ),
      ]);

      autoTable(doc, {
        startY: 35,
        margin: { left: 22, right: 22 },
        head: [headers],
        body: body,
        theme: "grid",
        headStyles: {
          fillColor: [15, 23, 42],
          textColor: [255, 255, 255],
          fontSize: 8,
          halign: "center",
        },
        columnStyles: {
          0: { fontStyle: "bold", textColor: [79, 70, 229], width: 20 },
          1: { width: 80 },
        },
      });

      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        doc.text(
          `Page ${i} of ${pageCount} | ${pName.toUpperCase()}_SUMMARY_REPORT`,
          pageWidth / 2,
          200,
          { align: "center" }
        );
      }
      doc.save(`${pName}_Summary_Report.pdf`);
    } catch (err) {
      console.error(err);
      alert("Export Error.");
    }
  };

  const handleRequestResetLink = async (e) => {
    e.preventDefault();
    setLoadingForgotPassword(true);

    try {
      // 2. Log it to the console so you can see exactly where it's trying to send
      console.log("Attempting to send reset link to:", `${BACKEND_URL}/api/auth/forgot-password`);

      await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, {
        email: recoveryEmail.toLowerCase().trim()
      });

      setLinkSent(true);
    } catch (err) {
      console.error("Full Reset Error Object:", err);

      // 3. Provide more specific feedback
      const errorMessage = err.response?.data?.message || "Server connection failed. Check your internet or backend status.";
      alert(errorMessage);
    } finally {
      setLoadingForgotPassword(false);
    }
  };

  const handleFinalReset = async (e) => {
    e.preventDefault();
    setLoadingForgotPassword(true);
    try {
      const API_BASE = "https://quopro-backend.onrender.com";
      await axios.patch(`${API_BASE}/api/auth/reset-password/${resetToken}`, {
        password: newPassword
      });
      alert("✅ Password reset successful! You can now log in.");
      setModeForgotPassword("FORGOT");
      setShowForgotPassword(false);
      // Clean up URL so the user doesn't accidentally trigger it again
      window.history.replaceState({}, document.title, "/");
    } catch (err) {
      alert(err.response?.data?.message || "Token invalid or expired.");
    } finally {
      setLoadingForgotPassword(false);
    }
  };


  /*const getEfficiencyData = () => {
    if (!sups || sups.length === 0 || !quote || quote.length === 0) return [];

    const results = sups
      .map((s) => {
        let cost = 0;
        let items = 0;
        let leadTimes = []; // Array to collect item lead times

        quote.forEach((q) => {
          const entry = s.quotes?.[q.ref];
          if (entry) {
            // 1. Price/Cost Logic
            if (Number(entry.price) > 0) {
              cost += Number(entry.price) * (Number(q.qty) || 1);
              items++;

              // 2. LEAD TIME LOGIC: Look for the "days" field from your schema
              // We collect all 'days' values into the leadTimes array
              const itemDays = parseFloat(entry.days || 0);
              if (itemDays > 0) {
                leadTimes.push(itemDays);
              }
            }
          }
        });

        if (items === 0) return null;

        const master = supList.find(
          (sl) => String(sl.id) === String(s.sid || s.id)
        );

        const bee = master?.beeLevel
          ? parseInt(master.beeLevel.replace(/\D/g, ""))
          : 9;

        const coverage = (items / quote.length) * 100;

        // 1. Try to get the max from items (what we collected in the loop)
        const totalDays = leadTimes.reduce((acc, curr) => acc + curr, 0);
        const averageLeadTime = items > 0 ? (totalDays / items).toFixed(1) : 0;

        let finalLeadTime = leadTimes.length > 0 ? Math.max(...leadTimes) : 0;

        // 2. If item-level is 0, check the SUPPLIER root or master profile
        if (finalLeadTime === 0) {
          finalLeadTime = parseFloat(
            s.leadTime ||
              s.avgLeadTime ||
              master?.leadTime ||
              master?.avg_delivery || // Check common naming variations
              0
          );
        }

        return {
          id: s.sid || s.id,
          name: master?.name || s.name,
          cost,
          coverage,
          beeLevel: bee,
          beeLabel: master?.beeLevel || "Level 9",
          leadTime: parseFloat(averageLeadTime),
        };
      })
      .filter(Boolean);

    // ORDER OF IMPORTANCE: PRICE > BEE > COVERAGE
    return results.sort((a, b) => {
      if (a.cost !== b.cost) return a.cost - b.cost;
      if (a.beeLevel !== b.beeLevel) return a.beeLevel - b.beeLevel;
      return b.coverage - a.coverage;
    });
  };*/

  const getEfficiencyData = () => {
    if (!sups || sups.length === 0 || !quote || quote.length === 0) return [];

    const results = sups
      .map((s) => {
        let materialCost = 0;
        let itemsCount = 0;
        let leadTimes = [];

        quote.forEach((q) => {
          const entry = s.quotes?.[q.ref];
          if (entry && Number(entry.price) > 0) {
            materialCost +=
              Number(entry.price) * (Number(q.qty) || Number(q.quantity) || 0);
            itemsCount++;

            const itemDays = parseFloat(entry.days || 0);
            if (itemDays > 0) leadTimes.push(itemDays);
          }
        });

        if (itemsCount === 0) return null;

        const master = supList.find(
          (sl) => String(sl.id) === String(s.sid || s.id)
        );

        // --- THE FIX: Landed Cost Priority ---
        // If totalLandedCost exists (the R317k), use it. Otherwise, use calculated materialCost.
        const finalCalculatedCost =
          Number(s.totalLandedCost) > 0
            ? Number(s.totalLandedCost)
            : materialCost;

        const bee = master?.beeLevel
          ? parseInt(String(master.beeLevel).replace(/\D/g, ""))
          : 9;

        const coverage = (itemsCount / quote.length) * 100;
        const totalDays = leadTimes.reduce((acc, curr) => acc + curr, 0);
        const averageLeadTime =
          leadTimes.length > 0 ? (totalDays / leadTimes.length).toFixed(1) : 0;

        return {
          id: s.sid || s.id,
          name: master?.name || s.name || "Unknown Supplier",
          cost: finalCalculatedCost, // 🚩 This is now the Landed Cost (R317k)
          coverage,
          beeLevel: bee,
          beeLabel: master?.beeLevel || "Level 9",
          leadTime: parseFloat(averageLeadTime),
          pricedCount: itemsCount,
        };
      })
      .filter(Boolean);

    // ORDER OF IMPORTANCE: LANDED COST > BEE > COVERAGE
    return results.sort((a, b) => {
      if (a.cost !== b.cost) return a.cost - b.cost;
      if (a.beeLevel !== b.beeLevel) return a.beeLevel - b.beeLevel;
      return b.coverage - a.coverage;
    });
  };
  const qp_stats = getEfficiencyData();
  const qp_FinalWinner = qp_stats[0] || null;
  const qp_secondary = qp_stats.length > 1 ? qp_stats[1] : null;

  const readSingleNotification = async (notifId) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/notifications/${notifId}/read`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data.success) {
        // Option A: If you want the notification to vanish instantly from the list:
        setNotifications((prev) => prev.filter((n) => n._id !== notifId));

        // Option B: If you keep read notifications in the list but style them as unread/read:
        // setNotifications((prev) => prev.map((n) => n._id === notifId ? { ...n, isRead: true } : n));
      } else {
        console.error("❌ Failed to dismiss notification:", data.message);
      }
    } catch (error) {
      console.error("🚨 Network error dismissing notification:", error);
    }
  };

  const readAllNotifications = async () => {
    if (!user?.companyId) return;
    setIsReadingAll(true);
    try {
      const response = await fetch(
        `${BACKEND_URL}/api/notifications/workspace/${user.companyId}/read-all`,
        { method: "PUT" }
      );

      if (response.ok) {
        // Optimistically clear the UI
        setNotifications([]);
        triggerNotification(
          "system",
          "Archive Cleaned",
          "All workspace notifications dismissed."
        );
      }
    } catch (err) {
      console.error("Read all failed:", err);
    } finally {
      setIsReadingAll(false);
    }
  };

  const StatusProgress = ({ currentStatus }) => {
    const currentIndex = STATUS_OPTIONS.indexOf(currentStatus);
    const totalSteps = STATUS_OPTIONS.length - 1;
    const progressPercentage = (currentIndex / totalSteps) * 100;
    const activeColor = getStatusProgressColor(currentStatus);

    // 1. BUILT-IN SAFETY: The "Safe Glow" Helper
    const getGlowRGB = (status) => {
      // If status is undefined, null, or not a string, return default Indigo
      if (!status || typeof status !== "string") return "79, 70, 229";

      if (status.includes("Completed") || status.includes("Success"))
        return "16, 185, 129"; // Emerald
      if (
        status.includes("Missing") ||
        status.includes("Warning") ||
        status.includes("empty")
      )
        return "245, 158, 11"; // Amber/Orange
      if (status.includes("Data") || status.includes("Info"))
        return "59, 130, 246"; // Blue

      return "79, 70, 229"; // Default Indigo
    };

    // Get glow for the main bar (ensure currentStatus isn't undefined)
    const mainGlow = getGlowRGB(currentStatus);

    return (
      <div className="w-full mt-16 px-6 mb-20">
        <div className="relative h-2.5 w-full bg-slate-200 dark:bg-slate-800/60 rounded-full overflow-visible">
          {/* 1. Dynamic Glowing Fill */}
          <div
            className={`absolute h-full ${activeColor} transition-all duration-1000 cubic-bezier(0.4, 0, 0.2, 1) rounded-full z-10`}
            style={{
              width: `${progressPercentage}%`,
              boxShadow: `0 0 25px rgba(${mainGlow}, 0.5), 0 0 10px rgba(${mainGlow}, 0.3)`,
            }}
          />

          <div className="absolute inset-0 flex justify-between items-center z-20">
            {STATUS_OPTIONS.map((status, index) => {
              const isReached = index <= currentIndex;
              const isCurrent = index === currentIndex;

              // 2. SAFETY: Get node-specific glow safely inside the map
              const nodeGlow = getGlowRGB(status);

              return (
                <div
                  key={status}
                  className="relative flex flex-col items-center"
                >
                  {/* Node Dot */}
                  <div
                    className={`w-7 h-7 rounded-full border-2 transition-all duration-700 flex items-center justify-center ${isReached
                      ? `${activeColor} border-white dark:border-slate-400 scale-110`
                      : "bg-white dark:bg-slate-900 border-slate-300 dark:border-slate-700 scale-90"
                      }`}
                    style={
                      isReached
                        ? { boxShadow: `0 0 15px rgba(${nodeGlow}, 0.4)` }
                        : {}
                    }
                  >
                    {isReached && !isCurrent && (
                      <Check size={12} className="text-white font-black" />
                    )}

                    {isCurrent && (
                      <>
                        <div className="relative flex items-center justify-center w-5 h-5">
                          {/* 1. The Aura: A soft, steady glow that doesn't move, just 'breathes' */}
                          <div
                            className={`absolute inset-0 rounded-full ${activeColor} opacity-20 blur-md animate-pulse duration-[4000ms]`}
                          />

                          {/* 2. The Inner Ring: Gives it a 'hollow' sophisticated look */}
                          <div
                            className={`absolute w-3.5 h-3.5 rounded-full border-2 ${activeColor} opacity-30`}
                          />

                          {/* 3. The Core: The actual 'bulb' */}
                          <div
                            className={`relative w-2 h-2 rounded-full ${activeColor} shadow-[0_0_10px_rgba(255,255,255,0.4)]`}
                          >
                            {/* Subtle highlight for a 3D effect */}
                            <div className="absolute top-[1px] left-[1px] w-0.5 h-0.5 bg-white/80 rounded-full" />
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Labels Section */}
                  <div className="absolute top-12 flex flex-col items-center">
                    <span
                      className={`text-[10px] font-black uppercase tracking-[0.25em] whitespace-nowrap transition-all duration-500 ${isCurrent
                        ? "text-slate-900 dark:text-white scale-110"
                        : isReached
                          ? "text-slate-600 dark:text-slate-300"
                          : "text-slate-400 dark:text-slate-600"
                        }`}
                    >
                      {status}
                    </span>

                    {/* Dynamic Underline */}
                    {isCurrent && (
                      <div
                        className={`h-1.5 w-10 rounded-full mt-3 ${activeColor} transition-all duration-500`}
                        style={{
                          boxShadow: `0 4px 12px rgba(${mainGlow}, 0.6)`,
                        }}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  /////////////////                       //////////////////
  /////////////////                       //////////////////
  ///////////////// SUPPLIER QUOTE CALCS  //////////////////
  /////////////////                       //////////////////
  /////////////////                       //////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////

  const supCalcs = useMemo(() => {
    if (!sups || !quote) return [];

    // 1. Process all raw supplier data first
    const processed = sups.map((s) => {
      const vendor = supList.find((sl) => String(sl.id) === String(s.sid));

      // --- B-BBEE Logic ---
      const rawBee =
        vendor?.beeLevel || vendor?.bee_level || vendor?.BEE || vendor?.level;
      const beeLevel = rawBee
        ? Number(String(rawBee).replace(/\D/g, ""))
        : null;
      const beePercentage =
        beeLevel && beeLevel <= 8 ? ((9 - beeLevel) / 8) * 100 : 0;

      let beeColor = "bg-slate-200";
      if (beeLevel >= 1 && beeLevel <= 2) beeColor = "bg-green-500";
      else if (beeLevel >= 3 && beeLevel <= 5) beeColor = "bg-orange-500";
      else if (beeLevel >= 6 && beeLevel <= 8) beeColor = "bg-red-500";

      // --- 🚩 STEP 1: Calculate Robust Material Total (The R318k) ---
      const materialTotal = quote.reduce((acc, item) => {
        const entry = s.quotes?.[item.ref];
        const price = Number(entry?.price || 0);
        const qty = Number(item.qty || item.quantity || 0);

        const lineTotal =
          Math.round((price * qty + Number.EPSILON) * 100) / 100;
        return acc + lineTotal;
      }, 0);

      const roundedMaterialTotal =
        Math.round((materialTotal + Number.EPSILON) * 100) / 100;

      // --- 🚩 STEP 2: Parse Fees ---
      const delivery = Number(s.deliveryFee || 0);
      const insurance = Number(s.insuranceFee || 0);
      const handling = Number(s.handlingFee || 0);
      const misc = Number(s.miscFee || 0);
      const totalFees = delivery + insurance + handling + misc;

      // --- 🚩 STEP 3: The "FinalTotal" Alignment Logic ---

      // 1. Calculate the Subtotal (Materials + Fees)
      const subtotal = roundedMaterialTotal + totalFees;

      // 2. Apply VAT only if the slot is marked as VAT Inclusive
      // This MUST match the logic in your uploadQuoteItems function
      let calculatedLanded = subtotal;
      if (s.isVatInclusive) {
        calculatedLanded = Math.round((subtotal * 1.15 + Number.EPSILON) * 100) / 100;
      } else {
        calculatedLanded = Math.round((subtotal + Number.EPSILON) * 100) / 100;
      }

      // 3. TRUST THE CALCULATION
      // We no longer "guess" between DB and Calc. 
      // If the math is right, finalTotal should be the calculated value.
      const finalTotal = calculatedLanded;

      // --- Progress & Lead Time ---
      const priced = quote.filter(
        (i) => (Number(s.quotes[i.ref]?.price) || 0) > 0
      );
      const itemsWithLead = quote.filter(
        (i) => (Number(s.quotes[i.ref]?.days) || 0) > 0
      );
      const avgLead =
        itemsWithLead.length > 0
          ? (
            itemsWithLead.reduce(
              (acc, i) => acc + Number(s.quotes[i.ref]?.days || 0),
              0
            ) / itemsWithLead.length
          ).toFixed(1)
          : 0;

      return {
        ...s,
        vendorName: vendor?.name || "Unassigned Supplier",
        beeLevel,
        beePercentage,
        beeColor,
        pricedCount: priced.length,
        completionPercentage: (priced.length / quote.length) * 100,
        finalTotal, // 🚩 This is now the perfected R318k+
        avgLeadTime: Number(avgLead),
        materialBase: roundedMaterialTotal,
        totalFees,
        hasAdditionalFees: totalFees > 0,
      };
    });

    // 2. Determine the "Winner" value
    const minVal = Math.min(
      ...processed.map((p) => p.finalTotal).filter((t) => t > 0)
    );

    // 3. Sorting logic remains the same
    const sortedData = [...processed].sort((a, b) => {
      let aVal = a[matrixSort.key];
      let bVal = b[matrixSort.key];
      if (typeof aVal === "string") aVal = aVal.toLowerCase();
      if (typeof bVal === "string") bVal = bVal.toLowerCase();
      if (aVal === 0 || aVal === null) return 1;
      if (bVal === 0 || bVal === null) return -1;
      if (aVal < bVal) return matrixSort.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return matrixSort.direction === "asc" ? 1 : -1;
      return 0;
    });

    // 4. Tag the winner
    return sortedData.map((p) => ({
      ...p,
      isWinner: p.finalTotal === minVal && p.finalTotal > 0,
    }));
  }, [sups, quote, supList, matrixSort]);

  ///////////////////////////////////////////

  const filteredSuppliers = supList.filter((s) => {
    const query = (supSearchQuery || "").toLowerCase();
    return (
      (s?.name || "").toLowerCase().includes(query) ||
      (s?.email || "").toLowerCase().includes(query) ||
      (s?.beeLevel || "").toLowerCase().includes(query) // Now they can search "Level 1"
    );
  });

  const [timeLeft, setTimeLeft] = React.useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  React.useEffect(() => {
    const targetDate = new Date("June 1, 2026 00:00:00").getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });

      if (distance < 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const getPasswordStrength = (pass) => {
    if (!pass) return { score: 0, color: "bg-slate-100", label: "Empty" };

    let score = 0;
    // 1. More than 8 characters
    if (pass.length > 8) score += 1;
    // 2. Has a Capital letter
    if (/[A-Z]/.test(pass)) score += 1;
    // 3. Has a number
    if (/[0-9]/.test(pass)) score += 1;
    // 4. Has a special character
    if (/[!@#$%^&*(),.?":{}|<>]/.test(pass)) score += 1;
    // 5. Bonus: Length > 12 (for the final green level)
    if (pass.length > 12) score += 1;

    const mapping = {
      0: { color: "bg-slate-200", label: "Very Weak" },
      1: { color: "bg-red-500", label: "Weak" },
      2: { color: "bg-orange-500", label: "Fair" },
      3: { color: "bg-yellow-400", label: "Good" },
      4: { color: "bg-lime-500", label: "Strong" },
      5: { color: "bg-emerald-500", label: "Super Strong" },
    };

    return { score, ...mapping[score] };
  };

  const [activeFeature, setActiveFeature] = useState(null);
  const FEATURE_DETAILS = {
    intelligence: {
      title: "Smart Supplier Network",
      tag: "Supplier Management",
      description:
        "Centralise your entire procurement ecosystem within a single high-performance dashboard. This unified space allows you to effortlessly manage compliance, track B-BBEE status, and scale your vendor list using intelligent search and bulk-import tools.",
      videoPlaceholder: {
        thumbnail_1: "/SupplierNetwork/SupplierNetwork_2.png", // Correct: Points directly to public root
        thumbnail_2: "/SupplierNetwork/SupplierNetwork_1", // Correct: Points directly to public root
        videoUrl: "",
        label: "",
      },
      stats: [
        "24/7 Compliance Monitoring",
        "Real-time Identity Verification",
        "Zero-Touch Audit Trails",
      ],
    },
    audit: {
      title: "Immutable Audit Log",
      tag: "Security First",
      description:
        "Built on a foundation of cryptographic integrity, every quote modification and supplier interaction is hashed and secured within a private ledger. This immutable record transforms raw data into a definitive audit trail, ensuring total transparency.",
      videoPlaceholder: {
        thumbnail_1: "/AuditLog/AuditLog_2.png", // Correct: Points directly to public root
        thumbnail_2: "/AuditLog/AuditLog_1.png", // Correct: Points directly to public root
        videoUrl: "",
        label: "",
      },
      stats: [
        "Zero-Deletion Policy",
        "Cryptographic Hashing",
        "Exportable PDF Logs",
      ],
    },
    splitMatrix: {
      title: "Finance Overview",
      tag: "Monetary Precision",
      description:
        "Our Split Cost Matrix acts as an intelligent procurement consultant, scanning every line item to identify the most competitive market rates across your entire supplier network. Once your optimal vendors are selected, you can finalise the deal and generate professional invoices.",
      videoPlaceholder: {
        thumbnail_1: "/FinanceHub/FinanceHub_2.png", // Correct: Points directly to public root
        thumbnail_2: "/FinanceHub/FinanceHub_1.png", // Correct: Points directly to public root
        videoUrl: "",
        label: "",
      },
      stats: [
        "Financial Transparency",
        "Budget Alignment",
        "Strategic Planning",
      ],
    },
    reporting: {
      title: "Reporting & Analytics",
      tag: "Decision Ready",
      description:
        "Transform your operational data into a strategic advantage by tracking project velocity, completion rates, and supplier lead times in real-time. This automated performance intelligence ensures you eliminate guesswork and build a trustworthy supply-chain.",
      videoPlaceholder: {
        thumbnail_1: "/Reporting/Report_2.png", // Correct: Points directly to public root
        thumbnail_2: "/Reporting/Report_1.png", // Correct: Points directly to public root
        videoUrl: "",
        label: "",
      },
      stats: ["One-Click Export", "Detail Driven", "Stakeholder Sharing"],
    },
    AI: {
      title: "AI Integration",
      tag: "Smart-AI Quote Conversion",
      description:
        "Save time by transforming static supplier quotes into living data in seconds. Simply drop your PDF into our neural processing engine, and let our AI instantly analyse, categorise, and sync the document directly to your project dashboard.",
      videoPlaceholder: {
        thumbnail_1: "/AISnaps/AI_2.png", // Correct: Points directly to public root
        thumbnail_2: "/AISnaps/AI_1.png", // Correct: Points directly to public root
        videoUrl: "",
        label: "",
      },
      stats: ["AI", "Speed", "Comfort"],
    },
    workflow: {
      title: "Workflow Management",
      tag: "Workflow & Notification Alerts",
      description:
        "Eliminate the friction of fragmented email chains and manual follow-ups with a unified, real-time command center. Gain absolute visibility into every workspace interaction, allowing you to track progress and synchronize with your team directly from within QuoPro.",
      videoPlaceholder: {
        thumbnail_1: "/WFSnaps/WF_2.png", // Correct: Points directly to public root
        thumbnail_2: "/WFSnaps/WF_1.png", // Correct: Points directly to public root
        videoUrl: "",
        label: "",
      },
      stats: ["Workflow", "Notification", "Alerts"],
    },
  };

  //TESTTEST
  // --- Inside your Component function ---
  useEffect(() => {
    // 100ms delay ensures the DOM is ready
    const timer = setTimeout(() => {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      }, observerOptions);

      const elements = document.querySelectorAll(".reveal-card");
      elements.forEach((el) => observer.observe(el));

      return () => observer.disconnect();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };
  const [isFocused, setIsFocused] = useState(false);
  const scrollRef = React.useRef(null); // Create the ref

  // Auto-scroll logic
  React.useEffect(() => {
    if (activeFeature && scrollRef.current) {
      // We use a slight timeout to allow the transition-all 1000ms 
      // to begin so the scroll feels natural with the animation
      const timer = setTimeout(() => {
        scrollRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [activeFeature]);

  const scrollRef_ = useRef(null);

  const scroll = (direction) => {
    if (scrollRef_.current) {
      const { scrollLeft, clientWidth } = scrollRef_.current;
      const scrollTo = direction === 'left'
        ? scrollLeft - clientWidth
        : scrollLeft + clientWidth;

      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  // Hardcoded hash for: "QuoProTester2026"
  const [password, setPassword] = useState("");

  // --- 2. TIMER LOGIC (Prevents "timeLeft is undefined" error) ---
  useEffect(() => {
    const timer = setInterval(() => {
      // Mock countdown logic - adjust to your actual launch date
      setTimeLeft({ days: 0, hours: 12, minutes: 45, seconds: 30 });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Base64 encoded version of "QuoProTester2026"
  const UAT_KEY = "UXVvUHJvVGVzdGVyMjAyNg==";

  const handleAccessAttempt = (e) => {
    e.preventDefault();

    // 1. Clean the input
    const cleanPassword = password.trim();

    // 2. Convert input to Base64
    // btoa is standard in all browsers for basic string encoding
    const encodedInput = btoa(cleanPassword);

    // 3. Compare
    if (encodedInput === UAT_KEY) {
      setIsMaintenanceMode(false);
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
      setPassword("");
    }
  };

  const [activeIndex, setActiveIndex] = React.useState(0);
  const features = [
    {
      title: "Manage your",
      subtitle: "Supplier Network.",
      desc: "Centralise your entire procurement ecosystem within a single high-performance dashboard. Effortlessly manage compliance and track B-BBEE status.",
      video: "supplierNetworkvideo",
      gradient: "from-indigo-600 to-cyan-500",
      border: "group-hover:border-indigo-200"
    },
    {
      title: "Feel in total control",
      subtitle: "of your finances.",
      desc: "Our Split Cost Matrix acts as an intelligent procurement consultant, scanning line items to identify competitive market rates.",
      video: "FinanceHub",
      gradient: "from-emerald-600 to-green-500",
      border: "group-hover:border-emerald-200"
    },
    {
      title: "Save time and money",
      subtitle: "with our Smart-AI.",
      desc: "Transform static supplier quotes into living data. Drop your PDF into our neural engine for instant categorization and sync.",
      video: "AIParse",
      gradient: "from-red-600 via-rose-500 to-orange-500",
      border: "group-hover:border-red-200"
    },
    {
      title: "Receive and Approve",
      subtitle: "Workflows and Alerts",
      desc: "Eliminate the friction of fragmented email chains with a unified command center. Gain absolute visibility into every interaction.",
      video: "wfNotif",
      gradient: "from-indigo-600 to-cyan-500",
      border: "group-hover:border-indigo-200"
    },
    {
      title: "Have an Immutable",
      subtitle: "Audit Trail",
      desc: "Built on a foundation of cryptographic integrity, every interaction is hashed and secured within a private ledger.",
      video: "auditLog",
      gradient: "from-emerald-600 to-emerald-400",
      border: "group-hover:border-emerald-200"
    }
  ];

  const [isVisible, setIsVisible] = useState(false);
  const scrollTriggerRef = useRef(null);

  // 2. The URL Listener (useEffect)
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('reset-password/')) {
      const token = path.split('/').pop();
      if (token) {
        setResetToken(token);
        setMode("RESET_FINAL"); // Switch the modal view
        setShowForgotPassword(true); // Open the modal automatically
      }
    }
  }, []);

  useEffect(() => {
    // Option A: Intersection Observer (The modern way)
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (scrollTriggerRef.current) observer.observe(scrollTriggerRef.current);

    // Option B: Scroll Listener (The "Never-Fail" backup)
    const handleScroll = () => {
      if (scrollTriggerRef.current) {
        const rect = scrollTriggerRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          setIsVisible(true);
          window.removeEventListener('scroll', handleScroll);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (scrollRef.current) {
      const index = Math.round(scrollRef.current.scrollLeft / scrollRef.current.clientWidth);
      setActiveIndex(index);
    }
  };

  const scrollTo = (direction) => {
    if (scrollRef.current) {
      const width = scrollRef.current.clientWidth;
      scrollRef.current.scrollBy({ left: direction === 'left' ? -width : width, behavior: 'smooth' });
    }
  };



  const [currency, setCurrency] = useState('ZAR');

  // Conversion Rates (Approximate mid-market)
  const rates = { ZAR: 1, USD: 0.063, EUR: 0.052, GBP: 0.045 };
  const symbols = { ZAR: 'R ', USD: '$', EUR: '€', GBP: '£' };

  // Helper to format and convert price
  const formatPrice = (baseMonthly, yearlyTotal) => {
    if (baseMonthly === 0) return "Free";

    // Use your pre-calculated yearly totals if yearly is active, else use monthly
    const priceInZar = isYearly ? yearlyTotal : baseMonthly;
    const converted = priceInZar * rates[currency];

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(converted);
  };

  const activePlanPBP = (workspace?.plan || user?.plan || "starter").toLowerCase().trim();
  const isPremium = activePlanPBP === "pro" || activePlanPBP === "businessplus";
  const isBusinessPlus = activePlanPBP === "businessplus";

  // --- 4. RENDER LOGIC ---
  if (isMaintenanceMode) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white overflow-hidden font-sans">
        {/* ATMOSPHERIC BACKGROUND LAYER */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,transparent_30%,rgba(15,23,42,0.08)_100%)]" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-indigo-500/10 rounded-full blur-[120px]" />
        </div>

        {/* THE "NICE AND NEAT" BOX */}
        <div className="relative max-w-2xl w-full mx-6 z-10">
          <div className="bg-white/80 backdrop-blur-2xl border border-slate-200 rounded-[48px] p-12 md:p-20 shadow-[0_40px_100px_-20px_rgba(15,23,42,0.15),0_20px_40px_-15px_rgba(15,23,42,0.1)] text-center">
            <div className="relative flex flex-col items-center mb-5 -mt-[50px]">
              {/* Logo Container forced to 15x15 */}
              <br />
              <div className="w-[65px] h-[65px] relative z-10">
                <img
                  src="/logo.png"
                  className="w-full h-full object-contain"
                  alt="QuoPro Logo"
                />
              </div>
            </div>
            {/* BRANDING ASSEMBLY */}
            <h1 className="text-6xl md:text-7xl tracking-tighter leading-none text-slate-900 mb-8">
              <span
                className="font-bold text-slate-900"
                style={{
                  filter: `
              drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
              drop-shadow(0 0 3px rgba(15, 23, 42, 0.25)) 
              drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                }}
              >
                Quo
              </span>
              <span className="font-bold bg-gradient-to-r from-indigo-600 to-cyan-500 bg-clip-text text-transparent pr-1 drop-shadow-[0_0_8px_rgba(34,211,238,0.4)]">
                Pro
              </span>
              <br />
              <span
                className="font-bold text-slate-900"
                style={{
                  filter: `
              drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
              drop-shadow(0 0 3px rgba(15, 23, 42, 0.25)) 
              drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                }}
              >
                Maintenance
              </span>
            </h1>

            <p className="text-slate-500 text-sm md:text-base font-medium max-w-sm mx-auto mb-12 leading-relaxed opacity-80">
              We are currently calibrating the system.
            </p>

            {/* UAT ACCESS PORTAL */}
            <div className="max-w-xs mx-auto">
              <form onSubmit={handleAccessAttempt}>
                <input
                  type="password"
                  autoComplete="off"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Access Key"
                  className={`w-full bg-slate-50/50 border ${error ? 'border-red-500 animate-shake' : 'border-slate-200'} rounded-2xl px-6 py-4 text-center text-[10px] font-black uppercase tracking-[0.3em] text-slate-700 focus:outline-none focus:ring-4 focus:ring-indigo-500/10 transition-all duration-300 placeholder:text-slate-300`}
                />
              </form>

              <div className="mt-8 flex items-center justify-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
                <p className="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em]">
                  System Status: <span className="text-amber-400 font-bold">Maintenance</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const [isOpen, setIsOpen] = useState(false);

  // State variables for interactive sliders
  const [monthlySpend, setMonthlySpend] = useState(100000); // R150,000 baseline
  const [monthlyRfqs, setMonthlyRfqs] = useState(4); // 4 major tenders/RFQs
  const [hoursPerRfq, setHoursPerRfq] = useState(8); // 8 hours manual Excel labour
  const [hourlyWage, setHourlyWage] = useState(250); // R250/hr procurement officer cost

  // Constants based on QuoPro core benchmarks
  const OPTIMISER_EFFICIENCY = 0.15; // Conservative 15% cost-split saving matrix baseline
  const QUOPRO_PROCESS_TIME = 0.5; // Only 30 mins to ingest and match quotes via Ref Codes
  const QUOPRO_ANNUAL_COST = 22788; // Estimated Business Plus premium tier price benchmark (R1,500 * 12)

  // Calculations
  const monthlyMaterialSavings = monthlySpend * OPTIMISER_EFFICIENCY;
  const annualMaterialSavings = monthlyMaterialSavings * 12;

  const hoursSavedPerRfq = Math.max(0, hoursPerRfq - QUOPRO_PROCESS_TIME);
  const monthlyLaborSavings = monthlyRfqs * hoursSavedPerRfq * hourlyWage;
  const annualLaborSavings = monthlyLaborSavings * 12;

  const totalAnnualSavings = annualMaterialSavings + annualLaborSavings;
  const netProfitCreated = Math.max(0, totalAnnualSavings - QUOPRO_ANNUAL_COST);
  const totalRoiPercentage = ((totalAnnualSavings - QUOPRO_ANNUAL_COST) / QUOPRO_ANNUAL_COST) * 100;

  // Helper formatting for South African Rand (ZAR)
  const formatRand = (val) => {
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: 'ZAR',
      maximumFractionDigits: 0
    }).format(val);
  };
  //PASSWORD: QuoProTester2026

  //TYPEWRITER CODE
  const phrases = [
    "Improve your Procurement.",
    "Choose the Best Supplier.",
    "Save with Optimal Splits."
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = React.useState(0);
  const [displayedText, setDisplayedText] = React.useState("");
  const [typingSpeed, setTypingSpeed] = React.useState(100);

  React.useEffect(() => {
    const currentFullText = phrases[currentPhraseIndex];

    const handleType = () => {
      if (!isDeleting) {
        // Typing phase
        setDisplayedText(currentFullText.substring(0, displayedText.length + 1));
        setTypingSpeed(80); // Speed while drawing characters

        if (displayedText === currentFullText) {
          // Pause at the end of a full sentence before deleting
          setTypingSpeed(2500);
          setIsDeleting(true);
        }
      } else {
        // Deleting phase
        setDisplayedText(currentFullText.substring(0, displayedText.length - 1));
        setTypingSpeed(40); // Faster delete speed for a snappy feel

        if (displayedText === "") {
          setIsDeleting(false);
          setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
          setTypingSpeed(300); // Small breath pause before typing next sentence
        }
      }
    };

    const timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayedText, isDeleting, currentPhraseIndex]);

  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////
  ////////////                              /////////////
  ////////////    Support Badge Float       /////////////
  ////////////                              /////////////
  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////

  const [isOpenSupport, setIsOpenSupport] = useState(false);
  const [formState, setFormState] = useState({ name: '', email: '', subject: 'System Issue', message: '' });
  const [status, setStatus] = useState('idle'); // 'idle' | 'submitting' | 'success' | 'error'

  const handleChangeSupportTicket = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  //SUPPORT TICKET
  const handleSubmitSupportTicket = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const BACKEND_API_URL = "https://quopro-backend.onrender.com/api/support-ticket";

      const response = await fetch(BACKEND_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          subject: formState.subject,
          message: formState.message,
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString()
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStatus('success');
        setFormState({ name: '', email: '', subject: 'System Issue', message: '' });

        setTimeout(() => {
          setIsOpen(false);
          setStatus('idle');
        }, 3000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  //NEEDED FUNCTION
  const [showLeftChevron, setShowLeftChevron] = useState(false);
  const [showRightChevron, setShowRightChevron] = useState(true);

  // 🧪 Scroll check logic
  const checkScrollPosition = () => {
    if (scrollRef_.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef_.current;

      // Show left chevron if we have scrolled more than 5px away from the start
      setShowLeftChevron(scrollLeft > 5);

      // Show right chevron if the remaining scrollable distance is greater than 5px
      // (Using a 5px buffer prevents sub-pixel rounded math bugs on high-res displays)
      setShowRightChevron(scrollLeft + clientWidth < scrollWidth - 5);
    }
  };

  // Attach listener on mount and whenever visibility toggles
  useEffect(() => {
    const container = scrollRef_.current;
    if (container) {
      container.addEventListener('scroll', checkScrollPosition);
      // Run once initially to set correct state
      checkScrollPosition();
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', checkScrollPosition);
      }
    };
  }, [showAboutVideo]);

  // Click handlers for smooth manual chevron paging
  const scrollCard = (direction) => {
    if (scrollRef_.current) {
      const offset = direction === 'left' ? -420 : 420;
      scrollRef_.current.scrollBy({ left: offset, behavior: 'smooth' });
    }
  };

  if (!isAuth)

    return (
      <div className="relative min-h-screen bg-white font-sans selection:bg-indigo-100 selection:text-indigo-700 overflow-x-hidden">
        {/* PHASE 1: PRE-LOADER (Pure White Layer) */}

        {isLaunching && (
          <div className="fixed inset-0 z-[1000] bg-white flex items-center justify-center">
            {/* 2. THE growing LOGO SECTION - Added negative margin to lift it up */}
            <div className="relative flex flex-col items-center mb-5 -mt-[50px]">
              {/* Logo - Synced to 1s Tailwind Bounce */}
              <br />
              <div className="w-24 h-24 relative z-10 animate-[breathe_1.5s_ease-in-out_infinite]">
                <img
                  src="/logo.png"
                  className="w-full h-full object-contain"
                  alt="QuoPro Logo"
                />
              </div>

              <style>
                {`
                @keyframes breathe {
                  0%, 100% { transform: scale(1); }
                  50% { transform: scale(1.1); }
                }
              `}
              </style>
            </div>

            <style dangerouslySetInnerHTML={{
              __html: `
              @keyframes shadowSync {
                0%, 100% {
                  transform: translateX(-50%) scale(0.4);
                  opacity: 0.1;
                  filter: blur(12px);
                  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
                }
                50% {
                  transform: translateX(-50%) scale(1.2);
                  opacity: 0.5;
                  filter: blur(4px);
                  animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
                }
              }
            ` }} />
          </div>
        )}

        {/* PHASE 2: CONTENT GATEKEEPER */}
        {!isLaunching && (
          <div className="animate-in fade-in duration-1000">
            {showWebsite ? (

              /* --- THE WEBSITE --- */
              <div className="relative bg-white overflow-y-auto scroll-smooth overflow-x-hidden">
                {/* --- GLOBAL ATMOSPHERIC OVERLAY (Full Website Stretch) --- */}
                <div className="fixed inset-0 pointer-events-none z-0 bg-[#F8FAFC]">
                  {/* 1. THE PRISTINE CANVAS: A very faint diagonal tint to prevent "flat" white */}
                  <div className="absolute inset-0 bg-gradient-to-br from-white via-white to-slate-100/50" />

                  {/* 2. THE ETHEREAL GLOW: Soft, high-positioned white-indigo light */}
                  <div className="absolute top-[-10%] left-1/2 -translate-x-1/2 
  w-[100vw] h-[70vh] bg-indigo-500/[0.04] rounded-full blur-[120px]" />

                  {/* 3. THE TEXTURE: Subtle grid or dot pattern to add "Engineering" depth */}
                  <div
                    className="absolute inset-0 opacity-[0.015]"
                    style={{ backgroundImage: `radial-gradient(#000 1px, transparent 1px)`, backgroundSize: '32px 32px' }}
                  />

                  {/* 5. TOP GLASS EDGE: A hairline highlight to separate the header area */}
                  <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200/60 to-transparent" />
                </div>
                <nav
                  className={`fixed top-0 left-0 right-0 z-[110] transition-all duration-500 border-b px-8 py-4 overflow-x-hidden ${scrollProgress > 2
                    ? "bg-white/50 backdrop-blur-xl py-3 border-slate-100 shadow-sm text-black"
                    : "bg-transparent border-transparent text-black"
                    }`}
                >
                  {/* Scroll Progress Bar */}
                  <div
                    className="absolute bottom-0 left-0 h-[2px] w-full bg-gradient-to-r from-indigo-600 to-cyan-400 transition-transform duration-150 ease-out origin-left"
                    style={{
                      transform: `scaleX(${scrollProgress / 100})`,
                      willChange: 'transform'
                    }}
                  >
                    {/* The Lead Glow - adds to the liquid effect */}
                    <div className="absolute right-0 top-0 h-full w-20 bg-cyan-300 blur-md opacity-30" />
                  </div>

                  <div className="max-w-7xl mx-auto flex justify-between items-center">
                    {/* LOGO / HOME LINK */}
                    <a
                      href="#hero"
                      className="flex items-center gap-2 group cursor-pointer"
                    >
                      <div className="w-10 h-10 flex items-center justify-center group-hover:scale-110 transition-all duration-500">
                        <img
                          src="/logo.png"
                          alt="QuoPro Logo"
                          className="w-full h-full object-contain drop-shadow-[0_10px_15px_rgba(99,102,241,0.2)] group-hover:rotate-12 transition-all duration-500"
                        />
                      </div>
                      <h1 className={`text-[32px] font-medium md:text-[26px] flex items-center tracking-tighter transition-all duration-300 ${scrollProgress > 3 ? "text-slate-900" : "text-slate-900"
                        }`}>
                        Quo
                        <span className="font-bold bg-gradient-to-r from-indigo-600 to-cyan-300 bg-clip-text text-transparent pr-1 transition-all duration-500 drop-shadow-[0_0_8px_rgba(34,211,238,0.4)]">
                          Pro
                        </span>
                      </h1>
                    </a>

                    {/* RIGHT SIDE NAVIGATION & ACTIONS */}
                    <div className="flex items-center gap-10">
                      {/* SECTION LINKS (Desktop Only) */}
                      <div className="font-bold hidden md:flex items-center gap-8 mr-4">
                        {["features", "plans", "connect"].map((item) => (
                          <a
                            key={item}
                            href={`#${item}`}
                            onClick={(e) => {
                              e.preventDefault();
                              const element = document.getElementById(item);
                              if (element) {
                                element.scrollIntoView({
                                  behavior: "smooth",
                                  block: "start",
                                });
                              }
                            }}
                            className={`font-bold cursor-pointer text-[12px] tracking-[0.2em] text-slate-600 transition-all duration-300 ease-out hover:tracking-[0.25em] cursor-default ${scrollProgress > 3
                              ? "text-slate-900 hover:text-slate-900 hover:drop-shadow-[0_0_8px_rgba(15,23,42,0.1)]"
                              : "hover:text-slate-900 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]"
                              }`}
                          >
                            {item.charAt(0).toUpperCase() + item.slice(1)}
                          </a>
                        ))}
                      </div>

                      {/* SIGN IN BUTTON (With Elite Hover) */}
                      <button
                        onClick={() => setShowWebsite(false)}
                        className={`font-bold group relative px-7 py-2.5 rounded-xl text-[10px] tracking-widest transition-all duration-500 ease-out 
    hover:scale-105 active:scale-95 z-[100] ${scrollProgress > 3
                            ? "bg-slate-900 text-white shadow-[0_0_15px_rgba(15,23,42,0.3)] hover:shadow-[0_0_20px_rgba(15,23,42,0.5)]"
                            : "bg-white text-black shadow-[0_0_15px_rgba(0,0,0,0.15)] hover:shadow-[0_0_20px_rgba(0,0,0,0.25)]"
                          }`}
                      >
                        <span className="text-[13px] relative z-10 font-black">Sign In</span>

                        {/* Subtle Rim Highlight for a 3D physical feel */}
                        <div className={`absolute inset-0 rounded-xl border pointer-events-none transition-colors duration-500 ${scrollProgress > 3 ? "border-white/5" : "border-slate-200/50"
                          }`} />
                      </button>
                    </div>
                  </div>
                </nav>

                <section
                  id="hero"
                  className="relative min-h-screen flex items-center justify-center px-6"
                >

                  <div
                    className={`absolute inset-0 flex items-center justify-center transition-all duration-1000 ease-in-out z-50 ${showAboutVideo ? "opacity-100 scale-100 blur-0" : "opacity-0 scale-110 blur-2xl pointer-events-none"
                      }`}
                  >
                    <div className="max-w-6xl w-full px-6 mt-22 flex flex-col items-center max-h-[90vh] isolate">

                      {/* --- THE EXECUTIVE BRIEFING CARD --- */}
                      <div className="mt-[30px] relative w-full bg-white/80 backdrop-blur-3xl rounded-[48px] p-1 md:p-1.5 transition-all duration-700 shadow-[0_50px_100px_-20px_rgba(15,23,42,0.12),0_0_0_1px_rgba(255,255,255,0.7),0_0_0_2px_rgba(226,232,240,0.5)]">
                        <div className="relative w-full h-full bg-white/40 rounded-[44px] p-8 md:p-14 overflow-visible">

                          {/* CLOSE BUTTON */}
                          <button
                            onClick={() => setShowAboutVideo(false)}
                            className="absolute top-8 right-8 p-3 rounded-2xl text-slate-400 hover:text-rose-500 hover:bg-rose-50/80 border border-transparent hover:border-rose-100 transition-all duration-300 group/close z-50"
                            aria-label="Close"
                          >
                            <X size={22} className="group-hover/close:rotate-180 transition-transform duration-700" />
                          </button>

                          {/* 1. Header Section */}
                          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 mb-14 border-b border-slate-200/50 pb-10">
                            <div className="max-w-xl">
                              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tighter leading-[1.1]">
                                <span
                                  className="text-slate-900 font-bold"
                                  style={{
                                    filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                  }}
                                >
                                  Intelligence, amplified.
                                </span>
                                <br />
                                <span className="ml-10 font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 filter drop-shadow-[0_0_10px_rgba(79,70,229,0.4)]">
                                  Execution, simplified.
                                </span>
                              </h2>
                            </div>
                          </div>

                          {/* 2. Pillars Stack Container */}
                          <div className="relative group/container max-w-[85rem] mx-auto rounded-[32px] mt-[-60px] mb-[-60px]">

                            {/* ◀️ LEFT CHEVRON OVERLAY */}
                            <button
                              onClick={() => scrollCard('left')}
                              className={`absolute left-[-20px] bottom-[0%] -translate-y-1/2 z-40 bg-white/90 backdrop-blur-md border border-slate-200/60 text-slate-700 p-3 rounded-2xl shadow-[0_10px_30px_-5px_rgba(15,23,42,0.15)] transition-all duration-300 hover:bg-slate-900 hover:text-white active:scale-95 
    opacity-0 scale-90 pointer-events-none
    ${showLeftChevron ? 'group-hover/container:opacity-100 group-hover/container:scale-100 group-hover/container:pointer-events-auto' : ''}`}
                              aria-label="Scroll left"
                            >
                              <ChevronLeft size={20} strokeWidth={2.5} />
                            </button>

                            {/* ▶️ RIGHT CHEVRON OVERLAY */}
                            <button
                              onClick={() => scrollCard('right')}
                              className={`absolute right-[-20px] bottom-[0%] -translate-y-1/2 z-40 bg-white/90 backdrop-blur-md border border-slate-200/60 text-slate-700 p-3 rounded-2xl shadow-[0_10px_30px_-5px_rgba(15,23,42,0.15)] transition-all duration-300 hover:bg-slate-900 hover:text-white active:scale-95 
    opacity-0 scale-90 pointer-events-none
    ${showRightChevron ? 'group-hover/container:opacity-100 group-hover/container:scale-100 group-hover/container:pointer-events-auto' : ''}`}
                              aria-label="Scroll right"
                            >
                              <ChevronRight size={20} strokeWidth={2.5} />
                            </button>

                            {/* 🧪 SCROLLABLE CONTAINER */}
                            <div
                              ref={scrollRef_}
                              className="flex flex-nowrap gap-8 pb-20 pt-10 px-12 mx-[-3rem] overflow-x-auto snap-x snap-mandatory scroll-smooth no-scrollbar"
                              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}
                            >
                              {/* --- Pillar 1: Supplier Central --- */}
                              <div className="overflow-hidden min-w-[290px] md:min-w-[330px] snap-center group relative p-8 rounded-[36px] bg-white border border-slate-100 transition-all duration-500 ease-out hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(15,23,42,0.18)] flex flex-col h-[275px] cursor-default">
                                <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-indigo-500 to-cyan-400 rounded-t-[36px]" />
                                <div className="relative space-y-6 z-10">
                                  <div className="mb-[-10px] w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 text-indigo-600 shadow-inner group-hover:scale-110">
                                    <Target size={26} strokeWidth={1.5} />
                                  </div>
                                  <div className="space-y-2">
                                    <h3 className="text-xl font-bold text-slate-900 tracking-tight leading-none">Centralised Hub</h3>
                                    <p className="text-[14px] text-slate-600 leading-relaxed font-light">
                                      Step into the digital age. QuoPro centralises everything, from quote imports to supplier management, inside a unified dashboard built for peak performance.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* --- Pillar 2: Smart-AI Engine --- */}
                              <div className="overflow-hidden min-w-[290px] md:min-w-[330px] snap-center group relative p-8 rounded-[36px] bg-white border border-slate-100 transition-all duration-500 ease-out hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(15,23,42,0.18)] flex flex-col h-[270px] cursor-default">
                                <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-rose-500 to-orange-400 rounded-t-[36px]" />
                                <div className="relative space-y-6 z-10">
                                  <div className="mb-[-10px] w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 text-rose-600 shadow-inner group-hover:scale-110">
                                    <BrainCircuit size={26} strokeWidth={1.5} />
                                  </div>
                                  <div className="space-y-2">
                                    <h3 className="text-xl font-bold text-slate-900 tracking-tight leading-none">Smart-AI</h3>
                                    <p className="text-[14px] text-slate-600 leading-relaxed font-light">
                                      Our Smart-AI engine handles the heavy lifting, from instantly converting PDFs & CSVs into actionable data, to identifying the most profitable quotes in your pipeline.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* --- Pillar 3: Financials --- */}
                              <div className="overflow-hidden min-w-[290px] md:min-w-[330px] snap-center group relative p-8 rounded-[36px] bg-white border border-slate-100 transition-all duration-500 ease-out hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(15,23,42,0.18)] flex flex-col h-[270px] cursor-default">
                                <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-emerald-500 to-teal-400 rounded-t-[36px]" />
                                <div className="relative space-y-6 z-10">
                                  <div className="mb-[-10px] w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 text-emerald-600 shadow-inner group-hover:scale-110">
                                    <Receipt size={26} strokeWidth={1.5} />
                                  </div>
                                  <div className="space-y-2">
                                    <h3 className="text-xl font-bold text-slate-900 tracking-tight leading-none">Financials</h3>
                                    <p className="text-[14px] text-slate-600 leading-relaxed font-light">
                                      Drive profitability with instant Cost Split Analysis. Pinpoint savings as quotes arrive, pick the best supplier, and generate final invoices without ever leaving your dashboard.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* --- Pillar 4: Automations --- */}
                              <div className="overflow-hidden min-w-[290px] md:min-w-[330px] snap-center group relative p-8 rounded-[36px] bg-white border border-slate-100 transition-all duration-500 ease-out hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(15,23,42,0.18)] flex flex-col h-[270px] cursor-default">
                                <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-violet-500 to-purple-400 rounded-t-[36px]" />
                                <div className="relative space-y-6 z-10">
                                  <div className="mb-[-10px] w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 text-violet-600 shadow-inner group-hover:scale-110">
                                    <Workflow size={26} strokeWidth={1.5} />
                                  </div>
                                  <div className="space-y-2">
                                    <h3 className="text-xl font-bold text-slate-900 tracking-tight leading-none">Stay Informed</h3>
                                    <p className="text-[14px] text-slate-600 leading-relaxed font-light">
                                      QuoPro optimises procurement by automating workflows and alerts. The system eliminates manual follow-ups by notifying stakeholders the moment an official approval is required.
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* --- Pillar 5: Audit Shield --- */}
                              <div className="overflow-hidden min-w-[290px] md:min-w-[330px] snap-center group relative p-8 rounded-[36px] bg-white border border-slate-100 transition-all duration-500 ease-out hover:scale-105 hover:shadow-[0_20px_60px_-15px_rgba(15,23,42,0.18)] flex flex-col h-[270px] cursor-default">
                                <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-amber-500 to-yellow-400 rounded-t-[36px]" />
                                <div className="relative space-y-6 z-10">
                                  <div className="mb-[-10px] w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 text-amber-600 shadow-inner group-hover:scale-110">
                                    <BarChart3 size={26} strokeWidth={1.5} />
                                  </div>
                                  <div className="space-y-2">
                                    <h3 className="text-xl font-bold text-slate-900 tracking-tight leading-none">Analyse Your Data</h3>
                                    <p className="text-[14px] text-slate-600 leading-relaxed font-light">
                                      Have the ability to view your Master Project Registry and export it for tender evaluation and verification purposes. QuoPro features intelligent analytics and visual tracking, providing real-time project oversight.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* 3. Footer Branding */}
                          <div className="mt-14 pt-8 border-t border-slate-100 flex justify-start items-center overflow-hidden">
                            <div className="flex items-center gap-4"></div>
                            <p className="text-[9px] font-bold text-slate-300 uppercase tracking-[0.4em] text-left">
                              An <span className="font-black text-slate-400">openModal©</span> Product
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 3. CONTENT WRAPPER */}
                  <div className="max-w-7xl mx-auto text-center relative z-30 px-4">
                    <h1 className={`font-bold text-5xl md:text-[100px] tracking-tighter leading-[0.80] text-white mb-8 transition-all duration-1000 ease-in-out ${showAboutVideo ? "-translate-x-[120%] opacity-0" : "translate-x-0 opacity-100"
                      }`}>
                      <span
                        className="font-bold text-slate-900"
                        style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(15, 23, 42, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}
                      >
                        Precision.
                      </span>
                      <br />
                      <span
                        className="inline-block"
                        style={{
                          filter: `
      drop-shadow(0 0 10px rgba(99, 102, 241, 0.5)) 
      drop-shadow(0 0 22px rgba(6, 182, 212, 0.2))
    `
                        }}
                      >
                        <span className="font-bold pr-4 pb-2 text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 animate-shimmer bg-[length:100%_auto]">
                          Procurement.
                        </span>
                      </span>
                    </h1>

                    <h1 className={`font-bold text-2xl md:text-3xl tracking-tighter text-slate-900 leading-[2.0] mb-4 ml-36 transition-all duration-1000 delay-75 ease-in-out ${showAboutVideo ? "translate-x-[120%] opacity-0" : "translate-x-0 opacity-100"
                      }`}>

                      {/* 🔒 STATIC ANCHOR: Forced inline-block with a right margin to anchor it perfectly */}
                      <span
                        className="font-bold text-slate-900 inline-block mr-2 ml-6"
                        style={{
                          filter: `
        /* Layer 1: Core definition (slightly crisper) */
        drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
        /* Layer 2: Mid-range body (darker for depth) */
        drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
        /* Layer 3: Outer soft glow (expanded for 5% boost) */
        drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}
                      >
                        {"    "}Compare Quotes {"  &  "}
                      </span>

                      {/* 🧪 RESILIENT TYPEWRITER BOX: Absorbs character length recalculations seamlessly */}
                      <span
                        className="inline-block text-left min-w-[280px] sm:min-w-[420px] lg:min-w-[500px] align-baseline"
                        style={{
                          filter: `
        drop-shadow(0 0 12px rgba(244, 63, 94, 0.4)) 
        drop-shadow(0 0 25px rgba(249, 115, 22, 0.2))`
                        }}
                      >
                        <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-600 via-rose-500 to-orange-500 relative inline-block">
                          {displayedText}
                          {/* 💡 Flashing typehead caret cursor */}
                          <span
                            className="ml-1 inline-block w-[3px] h-[1em] bg-rose-500 align-middle animate-[pulse_0.8s_infinite]"
                            style={{ WebkitTextFillColor: '#f43f5e' }}
                          />
                        </span>
                      </span>

                    </h1>

                    <p className={`text-[20px] font-light text-slate-600 max-w-3xl mx-auto mb-16 transition-all duration-1000 delay-150 ease-in-out ${showAboutVideo ? "-translate-x-[120%] opacity-0" : "translate-x-0 opacity-85"
                      }`}>
                      QuoPro eliminates manual procurement bottlenecks by automating supplier quote imports and financial analysis for faster, smarter buying decisions.
                    </p>

                    <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 mt-2 w-full transition-all duration-500 ${showAboutVideo ? "opacity-0 scale-95 pointer-events-none" : "opacity-100 scale-100"
                      }`}>
                      <button
                        onClick={() => setShowAboutVideo(true)}
                        className="group relative w-full sm:w-52 px-7 py-5 bg-white text-slate-900 rounded-2xl text-lg transition-all duration-500 ease-out hover:scale-105 active:scale-95 hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25),0_0_20px_rgba(79,70,229,0.1)] shadow-md"
                      >
                        <span
                          className="font-bold text-slate-900"
                          style={{
                            filter: `
      drop-shadow(0 0 0px rgba(15, 23, 42, 0.45)) 
      drop-shadow(0 0 1px rgba(165, 169, 179, 0.25)) 
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.15))`
                          }}
                        ><span className="font-bold">Why QuoPro?</span></span>
                      </button>

                      <button
                        onClick={() => setShowWebsite(false)}
                        className="group relative w-full sm:w-52 px-7 py-5 bg-white text-slate-900 rounded-2xl text-lg transition-all duration-500 ease-out hover:scale-105 active:scale-95 hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25),0_0_20px_rgba(79,70,229,0.1)] shadow-md overflow-hidden"
                      >
                        <span
                          className="font-bold text-slate-900"
                          style={{
                            filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 0px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 1px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.15))`
                          }}
                        ><span className="font-bold relative z-10">Get Started {">"}</span></span>
                      </button>
                    </div>
                  </div>
                </section>

                {/* 3. BENTO GRID FEATURES (With Staggered Hover) */}
                <section id="features" className="py-32 px-6 max-w-7xl mx-auto">
                  {/* 2. THE CONTENT (Higher Z-index and Relative) */}
                  <div className="relative z-20 flex flex-col mb-20">

                    <h2 className="font-bold text-5xl md:text-6xl text-slate-900 mb-6 tracking-tight leading-[1.1]">
                      <span
                        className="font-bold text-slate-900"
                        style={{
                          filter: `
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}
                      >Features that drive</span><br />
                      <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 filter drop-shadow-[0_0_10px_rgba(79,70,229,0.4)]">
                        Competitive Advantage
                      </span>
                    </h2>
                    <p className="text-xl text-slate-500 max-w-2xl leading-relaxed">
                      Strategic procurement, simplified. Command your operations with a refined toolkit built to turn complex data into your competitive advantage.
                    </p>
                  </div>

                  <div className="relative group/carousel w-full max-w-7xl mx-auto py-20 px-4 mt-[-55px]">
  {/* Left Navigation Arrow */}
  <button
    onClick={() => scrollTo('left')}
    className={`absolute -left-20 top-[45%] -translate-y-1/2 z-50 p-5 rounded-full bg-white shadow-2xl border border-slate-100 opacity-0 group-hover/carousel:opacity-100 transition-all hover:bg-slate-900 hover:text-white hover:scale-110 active:scale-95 hidden lg:flex items-center justify-center ${
      activeIndex === 0 ? 'pointer-events-none !opacity-0' : ''
    }`}
  >
    <ChevronLeft size={28} strokeWidth={2.5} />
  </button>

  {/* Right Navigation Arrow */}
  <button
    onClick={() => scrollTo('right')}
    className={`absolute -right-20 top-[45%] -translate-y-1/2 z-50 p-5 rounded-full bg-white shadow-2xl border border-slate-100 opacity-0 group-hover/carousel:opacity-100 transition-all hover:bg-slate-900 hover:text-white hover:scale-110 active:scale-95 hidden lg:flex items-center justify-center ${
      activeIndex === 5 ? 'pointer-events-none !opacity-0' : ''
    }`}
  >
    <ChevronRight size={28} strokeWidth={2.5} />
  </button>

                    {/* The Carousel Container - Increased padding to ensure shadows never clip during scroll */}
                    <div
                      ref={scrollRef}
                      onScroll={handleScroll}
                      className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar gap-12 pb-24 p-20 -m-20"
                      style={{
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        contain: 'layout',
                        /* Subtle Fade: Only masks the outer 5% of the container edges */
                        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)',
                        maskImage: 'linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)',
                      }}
                    >
                      {/* Card Wrapper helper: We use a relative container to hold the snap point */}

                      {/* CARD 1: SMART AI */}
                      <div className="snap-center shrink-0 w-full group relative grid grid-cols-1 md:grid-cols-12 gap-12 items-center bg-white rounded-[48px] p-6 md:p-12 border border-slate-100 shadow-2xl transition-all duration-700">
                        <div className="md:col-span-5 space-y-10 pr-4 z-20">
                          <h2 className="text-[40px] font-bold text-slate-900 tracking-tighter leading-[1.1] transition-all duration-500 group-hover:translate-x-2">
                            <span
                              className="font-bold text-slate-900"
                              style={{
                                filter: `
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45))
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}
                            >Save time and money</span><br />
                            <span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-red-600 via-rose-500 to-orange-500">with our Smart-AI.</span>
                          </h2>

                          <p className="text-lg text-slate-500 leading-relaxed max-w-sm border-l-2 border-slate-50 pl-6 group-hover:border-red-200 transition-colors duration-700">
                            Save time by transforming static supplier quotes into living data in seconds. Simply drop your PDF into our neural processing engine, and let our AI instantly analyse, categorise, and sync the document directly to your project dashboard.
                          </p>
                        </div>
                        <div className="md:col-span-7 relative aspect-video rounded-[32px] overflow-hidden bg-slate-900 transition-all duration-700 group-hover:scale-[1.10] shadow-2xl">

                          {/* VIDEO COMPONENT: High-visibility settings */}
                          <video
                            loop
                            muted
                            playsInline
                            autoPlay
                            preload="auto"
                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 brightness-[0.9] group-hover:brightness-110 scale-100 group-hover:scale-105"
                          >
                            <source src="/Videos/AIParse.webm" type="video/webm" />
                            <source src="/Videos/AIParse.mp4" type="video/mp4" />
                          </video>

                          {/* OVERLAY: Sharp Technical Border */}
                          <div className="absolute inset-0 pointer-events-none rounded-[32px] transition-colors duration-700 z-30" />
                        </div>
                      </div>

                      {/* CARD 2: FINANCE HUB */}
                      <div className="snap-center shrink-0 w-full group relative grid grid-cols-1 md:grid-cols-12 gap-12 items-center bg-white rounded-[48px] p-6 md:p-12 border border-slate-100 shadow-2xl transition-all duration-700">
                        <div className="md:col-span-7 relative aspect-video rounded-[32px] overflow-hidden bg-slate-900 transition-all duration-700 group-hover:scale-[1.10] shadow-2xl">

                          {/* VIDEO COMPONENT: High-visibility settings */}
                          <video
                            loop
                            muted
                            playsInline
                            autoPlay
                            preload="auto"
                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 brightness-[0.9] group-hover:brightness-110 scale-100 group-hover:scale-105"
                          >
                            <source src="/Videos/FinanceHub.webm" type="video/webm" />
                            <source src="/Videos/FinanceHub.mp4" type="video/mp4" />
                          </video>

                          {/* OVERLAY: Sharp Technical Border */}
                          <div className="absolute inset-0 pointer-events-none rounded-[32px] transition-colors duration-700 z-30" />
                        </div>
                        <div className="md:col-span-5 relative space-y-10 z-20 pl-10 md:order-2">
                          <h2 className="text-[40px] font-bold text-slate-900 tracking-tighter leading-[1.1] transition-all duration-500 group-hover:translate-x-2">
                            <span
                              className="font-bold text-slate-900"
                              style={{
                                filter: `
              drop-shadow(0 0 1px rgba(15, 23, 42, 0.45))
              drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
              drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}
                            >Identify your</span><br />
                            <span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-emerald-600 to-green-500">Winning Supplier!</span>
                          </h2>

                          <p className="text-lg text-slate-500 leading-relaxed max-w-sm border-l-2 border-slate-50 pl-6 group-hover:border-emerald-200 transition-colors duration-700">
                            Our <span className="font-bold">Split Cost Matrix</span> acts as an intelligent procurement consultant, scanning every line item to <span className="font-bold">identify</span> the most competitive market rates across your entire supplier network. Once your <span className="font-bold">optimal vendors</span> are selected, you can finalise the deal and generate professional invoices.
                          </p>
                        </div>
                      </div>

                      {/* CARD 3: SUPPLIER NETWORK */}
                      <div className="snap-center shrink-0 w-full group relative grid grid-cols-1 md:grid-cols-12 gap-12 items-center bg-white rounded-[48px] p-6 md:p-12 border border-slate-100 shadow-2xl transition-all duration-700">
                        <div className="md:col-span-5 space-y-10 pr-4 z-20">
                          <h2 className="text-[40px] font-bold text-slate-900 tracking-tighter leading-[1.1] transition-all duration-500 group-hover:translate-x-2">
                            <span
                              className="font-bold text-slate-900"
                              style={{
                                filter: `
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45))
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}
                            >Manage your </span><br />
                            <span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500">Supplier Network.</span>
                          </h2>

                          <p className="text-lg text-slate-500 leading-relaxed max-w-sm border-l-2 border-slate-50 pl-6 group-hover:border-indigo-200 transition-colors duration-700">
                            Centralise your entire procurement ecosystem within a single high-performance dashboard. This unified space allows you to effortlessly manage compliance, track B-BBEE status, and scale your vendor list using intelligent search and bulk-import tools.
                          </p>
                        </div>
                        <div className="md:col-span-7 relative aspect-video rounded-[32px] overflow-hidden bg-slate-900 transition-all duration-700 group-hover:scale-[1.10] shadow-2xl">

                          {/* VIDEO COMPONENT: High-visibility, crisp playback */}
                          <video
                            loop
                            muted
                            playsInline
                            autoPlay
                            preload="auto"
                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 brightness-[0.9] group-hover:brightness-110 scale-100 group-hover:scale-105"
                          >
                            <source src="/Videos/supplierNetworkvideo.webm" type="video/webm" />
                            <source src="/Videos/supplierNetworkvideo.mp4" type="video/mp4" />
                          </video>

                          {/* CLEAN OVERLAY: Border removed, strictly using the rounded corners of the parent for definition */}
                          <div className="absolute inset-0 pointer-events-none rounded-[32px] z-30" />
                        </div>
                      </div>

                      {/* CARD 4: WORKFLOW */}
                      <div className="snap-center shrink-0 w-full group relative grid grid-cols-1 md:grid-cols-12 gap-12 items-center bg-white rounded-[48px] p-6 md:p-12 border border-slate-100 shadow-2xl transition-all duration-700">
                        <div className="md:col-span-7 relative aspect-video rounded-[32px] overflow-hidden bg-slate-900 transition-all duration-700 group-hover:scale-[1.10] shadow-2xl">
                          <video
                            loop
                            muted
                            playsInline
                            autoPlay
                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 brightness-[0.9] group-hover:brightness-110"
                          >
                            <source src="/Videos/wfNotif.webm" type="video/webm" />
                            <source src="/Videos/wfNotif.mp4" type="video/mp4" />
                          </video>
                        </div>
                        <div className="md:col-span-5 relative space-y-10 z-20 pl-10 md:order-2">
                          <h2 className="text-[40px] font-bold text-slate-900 tracking-tighter leading-[1.1] transition-all duration-500 group-hover:translate-x-2">
                            <span
                              className="font-bold text-slate-900"
                              style={{
                                filter: `
              drop-shadow(0 0 1px rgba(15, 23, 42, 0.45))
              drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
              drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}
                            >Receive and Approve</span><br />
                            <span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-red-600 via-rose-500 to-orange-500">Workflows and Alerts</span>
                          </h2>

                          <p className="text-lg text-slate-500 leading-relaxed max-w-sm border-l-2 border-slate-50 pl-6 group-hover:border-red-200 transition-colors duration-700">
                            Eliminate the friction of fragmented email chains and manual follow-ups with a unified, real-time command center. Gain absolute visibility into every workspace interaction, allowing you to track progress and synchronize with your team directly from within QuoPro.
                          </p>
                        </div>
                      </div>

                      {/* CARD 5: AUDIT TRAIL */}
                      <div className="snap-center shrink-0 w-full group relative grid grid-cols-1 md:grid-cols-12 gap-12 items-center bg-white rounded-[48px] p-6 md:p-12 border border-slate-100 shadow-2xl transition-all duration-700">
                        <div className="md:col-span-5 space-y-10 pr-4 z-20">
                          <h2 className="text-[40px] font-bold text-slate-900 tracking-tighter leading-[1.1] transition-all duration-500 group-hover:translate-x-2">
                            <span
                              className="font-bold text-slate-900"
                              style={{
                                filter: `
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45))
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}
                            >Have an Immutable</span><br />
                            <span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-emerald-600 to-emerald-400">Audit Trail</span>
                          </h2>

                          <p className="text-lg text-slate-500 leading-relaxed max-w-sm border-l-2 border-slate-50 pl-6 group-hover:border-emerald-200 transition-colors duration-700">
                            Built on a foundation of cryptographic integrity, every quote modification and supplier interaction is hashed and secured within a private ledger. This immutable record transforms raw data into a definitive audit trail, ensuring total transparency.
                          </p>
                        </div>
                        <div className="md:col-span-7 relative aspect-video rounded-[32px] overflow-hidden bg-slate-900 transition-all duration-700 group-hover:scale-[1.10] shadow-2xl">

                          {/* VIDEO COMPONENT: High-visibility settings */}
                          <video
                            loop
                            muted
                            playsInline
                            autoPlay
                            preload="auto"
                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 brightness-[0.9] group-hover:brightness-110 scale-100 group-hover:scale-105"
                          >
                            <source src="/Videos/auditLog.webm" type="video/webm" />
                            <source src="/Videos/auditLog.mp4" type="video/mp4" />
                          </video>

                          {/* OVERLAY: Sharp Technical Border */}
                          <div className="absolute inset-0 pointer-events-none rounded-[32px] transition-colors duration-700 z-30" />
                        </div>
                      </div>

                      {/* CARD 6: REPORTING */}
                      <div className="snap-center shrink-0 w-full group relative grid grid-cols-1 md:grid-cols-12 gap-12 items-center bg-white rounded-[48px] p-6 md:p-12 border border-slate-100 shadow-2xl transition-all duration-700">
                        <div className="md:col-span-7 relative aspect-video rounded-[32px] overflow-hidden bg-slate-900 transition-all duration-700 group-hover:scale-[1.10] shadow-2xl">

                          {/* VIDEO COMPONENT: High-visibility settings */}
                          <video
                            loop
                            muted
                            playsInline
                            autoPlay
                            preload="auto"
                            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-all duration-700 brightness-[0.9] group-hover:brightness-110 scale-100 group-hover:scale-105"
                          >
                            <source src="/Videos/reporting.webm" type="video/webm" />
                            <source src="/Videos/reporting.mp4" type="video/mp4" />
                          </video>

                          {/* OVERLAY: Sharp Technical Border */}
                          <div className="absolute inset-0 pointer-events-none rounded-[32px] transition-colors duration-700 z-30" />
                        </div>
                        <div className="md:col-span-5 space-y-10 z-20 pl-10">
                          <h2 className="text-[40px] font-bold text-slate-900 tracking-tighter leading-[1.1] transition-all duration-500 group-hover:translate-x-2">
                            <span
                              className="font-bold text-slate-900"
                              style={{
                                filter: `
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45))
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25))
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}
                            >Have insight</span><br />
                            <span className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500">With Reporting.</span>
                          </h2>

                          <p className="text-lg text-slate-500 leading-relaxed max-w-sm border-l-2 border-slate-50 pl-6 group-hover:border-indigo-200 transition-colors duration-700">
                            Transform your operational data into a strategic advantage by tracking project velocity, completion rates, and supplier lead times in real-time. This automated performance intelligence ensures you eliminate guesswork and build a trustworthy supply-chain.
                          </p>
                        </div>
                      </div>

                    </div>
                    <div><br /><br /></div>
                    {/* Progress Indicators */}
                    <div className="flex justify-center gap-3 mt-4">
                      {[...Array(6)].map((_, i) => (
                        <div
                          key={i}
                          className={`h-1.5 transition-all duration-500 rounded-full ${activeIndex === i ? 'w-12 bg-slate-900' : 'w-3 bg-slate-200'}`}
                        />
                      ))}
                    </div>
                  </div>
                </section>


                {/* 4. PRICING SECTION (Previous Styles Retained + Subtle Animation) */}
                <section
                  id="plans"
                  className="reveal-on-scroll mt-[-100px] py-32 px-2 relative overflow-hidden z-20"
                >
                  <div className="max-w-7xl mx-auto relative z-10">
                    {/* HEADER SECTION */}
                    <div className="text-center mb-16 opacity-100 translate-y-0">
                      <h2 className="font-bold text-4xl md:text-6xl text-slate-900 mb-6 tracking-tight">
                        <span
                          className="font-bold text-slate-900"
                          style={{
                            filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                          }}
                        >Choose Your</span>{" "}
                        <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 pr-1 filter drop-shadow-[0_0_15px_rgba(79,70,229,0.35)]">
                          Plan
                        </span>
                      </h2>

                      <p className="text-xl text-slate-500 mb-10">
                        Choose the plan that fits your procurement needs.
                      </p>
                      <div><br /></div>
                      {/* BILLING TOGGLE */}
                      <div className="flex flex-col items-center gap-8 max-w-5xl mx-auto">

                        {/* --- REFINED TOGGLE & CURRENCY SELECTOR --- */}
                        <div className="flex flex-col md:flex-row items-center gap-8 mb-12 -mt-8 bg-white/40 p-1.5 rounded-[24px] border border-white/60 shadow-[0_8px_32px_rgba(0,0,0,0.04)] backdrop-blur-md w-fit mx-auto">

                          {/* Pricing Toggle Group */}
                          <div className="flex items-center gap-4 px-4 py-2">
                            <span className={`text-[10px] font-black uppercase tracking-[0.15em] transition-all duration-300 ${!isYearly ? "text-slate-950 scale-105" : "text-slate-400"}`}>
                              Monthly
                            </span>

                            <button
                              onClick={() => setIsYearly(!isYearly)}
                              className={`group w-14 h-7 rounded-full relative p-1 transition-all duration-500 ease-in-out shadow-inner ${isYearly ? "bg-blue-600 shadow-blue-900/20" : "bg-slate-200"}`}
                            >
                              {/* Dynamic Glow behind the switch */}
                              <div className={`absolute inset-0 rounded-full transition-opacity duration-500 ${isYearly ? "opacity-40 shadow-[0_0_12px_rgba(37,99,235,0.8)]" : "opacity-0"}`} />

                              <div className={`w-5 h-5 bg-white rounded-full shadow-[0_2px_4px_rgba(0,0,0,0.2)] transition-transform duration-500 cubic-bezier(0.34, 1.56, 0.64, 1) ${isYearly ? "translate-x-7" : "translate-x-0"}`} />
                            </button>

                            <div className="flex items-center gap-2">
                              <span className={`text-[10px] font-black uppercase tracking-[0.15em] transition-all duration-300 ${isYearly ? "text-blue-600 scale-105" : "text-slate-400"}`}>
                                Annually
                              </span>
                              <span className="flex items-center justify-center text-[9px] font-black bg-blue-600 text-white px-2.5 py-0.5 rounded-full shadow-[0_4px_12px_rgba(37,99,235,0.3)] animate-pulse">
                                SAVE 15%
                              </span>
                            </div>
                          </div>

                          {/* Elegant Vertical Divider */}
                          <div className="hidden md:block w-[1px] h-6 bg-gradient-to-b from-transparent via-slate-200 to-transparent" />

                          {/* Refined Currency Selector */}
                          <div className="relative group px-4 py-2">
                            <div className="flex items-center gap-2 cursor-pointer">
                              <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Currency</span>
                              <div className="relative flex items-center">
                                <select
                                  value={currency}
                                  onChange={(e) => setCurrency(e.target.value)}
                                  className="appearance-none bg-transparent text-[11px] font-black uppercase tracking-[0.1em] text-slate-900 pl-1 pr-6 py-1 cursor-pointer focus:outline-none z-10"
                                >
                                  <option value="ZAR">ZAR (R)</option>
                                  <option value="USD">USD ($)</option>
                                  <option value="EUR">EUR (€)</option>
                                  <option value="GBP">GBP (£)</option>
                                </select>
                                <ChevronDown
                                  size={12}
                                  className="absolute right-0 top-1/2 -translate-y-1/2 text-blue-600 group-hover:translate-y-[-40%] transition-transform duration-300"
                                  strokeWidth={3}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* PLAN CARDS */}

                        <div className="relative w-full py-20 px-4 mt-[-50px]">
                          {/* THIS IS THE TRIGGER: It sits 100px above the grid to start the animation early */}
                          <div ref={scrollTriggerRef} className="absolute top-0 h-10 w-full pointer-events-none" />

                          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch w-full max-w-7xl mx-auto relative">

                            {/* 1. Starter Plan - LEFT */}
                            <div
                              className={`group relative p-8 rounded-[32px] border-2 border-emerald-500 bg-white flex flex-col transition-all duration-1000 ease-out
        ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-24'}
        hover:-translate-y-2 hover:shadow-[0_40px_50px_-12px_rgba(16,185,129,0.15)]`}
                            >
                              <div className="mb-8">
                                <h4 className="text-emerald-500 font-black uppercase tracking-[0.2em] text-[9px] mb-3">Starter</h4>
                                <span className="text-5xl font-black text-slate-900 tracking-tight" style={{
                                  filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                }}>Free</span>
                              </div>
                              <ul className="space-y-3.5 mb-10 flex-1">
                                {["2 Projects*", "5 Suppliers*", "Basic Analytics", "Core Dashboard"].map((feat) => (
                                  <li key={feat} className="flex items-center gap-2.5 text-[12px] font-bold text-slate-500">
                                    <CheckCircle size={14} className="text-emerald-500" /> {feat}
                                  </li>
                                ))}
                              </ul>
                              <button onClick={() => setShowWebsite(false)} className="w-full py-3.5 bg-white border border-slate-200 text-slate-900 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-emerald-500 hover:text-white transition-all">
                                Get Started
                              </button>
                            </div>

                            {/* 2. Pro Plan - BOTTOM */}
                            <div
                              className={`group relative p-8 rounded-[32px] border-2 border-blue-600 bg-white flex flex-col lg:scale-110 z-10 transition-all duration-1000 delay-200 ease-out
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-32'}
        shadow-[0_20px_50px_rgba(37,99,235,0.1)] 
        hover:-translate-y-4 hover:shadow-[0_40px_60px_-15px_rgba(37,99,235,0.2)]`}
                            >
                              <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-5 py-1.5 rounded-full text-[8px] font-black uppercase tracking-[0.2em] shadow-xl z-20">Scale Ready</div>
                              <div className="mb-8 text-center">
                                <h4 className="text-blue-600 font-black uppercase tracking-[0.2em] text-[9px] mb-3">Professional</h4>
                                <div className="flex items-baseline justify-center gap-1">
                                  <span className="text-5xl font-black text-slate-900 tracking-tight" style={{
                                    filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                  }}>
                                    {symbols[currency]}{formatPrice(1899, 19370)}
                                  </span>
                                  <span className="text-slate-400 font-black text-xs uppercase">{isYearly ? "/yr" : "/mo"}</span>
                                </div>
                              </div>
                              <ul className="space-y-3.5 mb-10 flex-1">
                                {["30 Projects*", "55 Suppliers*", "Cost Split Optimiser", "AI Quote Tool", "Workflow Management", "Audit Log"].map((feat) => (
                                  <li key={feat} className="flex items-center gap-2.5 text-[12px] font-bold text-slate-700">
                                    <CheckCircle size={14} className="text-blue-600" /> {feat}
                                  </li>
                                ))}
                              </ul>
                              <button onClick={() => setShowWebsite(false)} className="w-full py-4 bg-blue-600 text-white rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-blue-700 transition-all">
                                Activate Pro
                              </button>
                            </div>

                            {/* 3. Business Plus+ - RIGHT */}
                            <div
                              className={`group relative p-8 rounded-[32px] border-2 border-black bg-white flex flex-col transition-all duration-1000 delay-500 ease-out
        ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-24'}
        hover:-translate-y-2 hover:shadow-[0_40px_50px_-12px_rgba(0,0,0,0.2)]`}
                            >
                              <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-black text-white px-5 py-1.5 rounded-full text-[8px] font-black uppercase tracking-[0.2em] shadow-xl z-20">Unlimited Power</div>
                              <div className="mb-8">
                                <h4 className="text-black font-black uppercase tracking-[0.2em] text-[9px] mb-3">Business Plus+</h4>
                                <div className="flex items-baseline justify-center gap-1">
                                  <span className="text-5xl font-black text-slate-900 tracking-tight" style={{
                                    filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                  }}>
                                    {symbols[currency]}{formatPrice(4399, 44870)}
                                  </span>
                                  <span className="text-slate-400 text-xs uppercase">{isYearly ? "/yr" : "/mo"}</span>
                                </div>
                              </div>
                              <ul className="space-y-3.5 mb-10 flex-1">
                                {["Unlimited Projects", "Unlimited Suppliers", "AI Quote Tool", "Generate Invoices", "Cost Split Optimiser", "Workflow Management", "Audit Log", "Project Registry Export"].map((feat) => (
                                  <li key={feat} className="flex items-center gap-2.5 text-[12px] font-bold text-slate-700">
                                    <CheckCircle size={14} className="text-black" /> {feat}
                                  </li>
                                ))}
                              </ul>
                              <button onClick={() => setShowWebsite(false)} className="w-full py-3.5 bg-white border border-slate-200 text-black rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-black hover:text-white transition-all">
                                Activate Plus+
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-[9px] text-center w-full mt-[-45px] mb-[-40px] text-slate-900 tracking-[0.15em] uppercase font-medium">
                    * total projects/suppliers available (once-off) for a registered workspace
                  </p>
                  <div className="mt-24 mb-[-100px] pb-0 flex flex-col sm:flex-row justify-center items-center w-full z-40 gap-4">

                    {/* BUTTON 1: MATRIX VIEW */}
                    <button
                      onClick={() => setShowPricingTableModal(true)}
                      className={`group relative flex items-center justify-between gap-4 px-7 py-6 rounded-xl transition-all duration-500 ease-out 
      hover:scale-105 active:scale-95 z-[100] w-full max-w-[240px] ${scrollProgress > 3
                          ? "bg-slate-900 text-white shadow-[0_0_15px_rgba(15,23,42,0.3)] hover:shadow-[0_0_20px_rgba(15,23,42,0.5)]"
                          : "bg-white text-black shadow-[0_0_15px_rgba(0,0,0,0.15)] hover:shadow-[0_0_20px_rgba(0,0,0,0.25)]"
                        }`}
                    >
                      {/* Content Layer */}
                      <div className="flex flex-col items-start text-left relative z-10">
                        <span className="text-[10px] font-black uppercase tracking-[0.15em]">
                          Compare Features
                        </span>
                        <span className={`text-[8px] font-bold uppercase tracking-widest opacity-70 ${scrollProgress > 3 ? "text-blue-300" : "text-blue-600"
                          }`}>
                          Matrix View
                        </span>
                      </div>

                      <div className={`w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-500 relative z-10 ${scrollProgress > 3
                        ? "bg-white/10 group-hover:bg-white group-hover:text-blue-600 text-white"
                        : "bg-slate-100 group-hover:bg-blue-600 group-hover:text-white text-slate-900"
                        }`}>
                        <LayoutGrid size={20} />
                      </div>

                      {/* Subtle Rim Highlight */}
                      <div className={`absolute inset-0 rounded-xl border pointer-events-none transition-colors duration-500 ${scrollProgress > 3 ? "border-white/5" : "border-slate-200/50"
                        }`} />
                    </button>

                    {/* BUTTON 2: ROI CALCULATOR */}
                    <button
                      onClick={() => setIsOpen(true)}
                      className={`group relative flex items-center justify-between gap-4 px-7 py-6 rounded-xl transition-all duration-500 ease-out 
      hover:scale-105 active:scale-95 z-[100] w-full max-w-[240px] ${scrollProgress > 3
                          ? "bg-slate-900 text-white shadow-[0_0_15px_rgba(15,23,42,0.3)] hover:shadow-[0_0_20px_rgba(15,23,42,0.5)]"
                          : "bg-white text-black shadow-[0_0_15px_rgba(0,0,0,0.15)] hover:shadow-[0_0_20px_rgba(0,0,0,0.25)]"
                        }`}
                    >
                      {/* Content Layer */}
                      <div className="flex flex-col items-start text-left relative z-10">
                        <span className="text-[10px] font-black uppercase tracking-[0.15em]">
                          ROI Calculator
                        </span>
                        <span className={`text-[8px] font-bold uppercase tracking-widest opacity-70 ${scrollProgress > 3 ? "text-blue-300" : "text-blue-600"
                          }`}>
                          Savings Projection
                        </span>
                      </div>

                      <div className={`w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-500 relative z-10 ${scrollProgress > 3
                        ? "bg-white/10 group-hover:bg-white group-hover:text-blue-600 text-white"
                        : "bg-slate-100 group-hover:bg-blue-600 group-hover:text-white text-slate-900"
                        }`}>
                        <TrendingUp size={20} />
                      </div>

                      {/* Subtle Rim Highlight */}
                      <div className={`absolute inset-0 rounded-xl border pointer-events-none transition-colors duration-500 ${scrollProgress > 3 ? "border-white/5" : "border-slate-200/50"
                        }`} />
                    </button>
                  </div>
                </section>
                {isOpen && (
                  <div className="fixed inset-0 z-[300] flex items-center justify-center px-4 md:px-10 py-4 bg-slate-900/40 backdrop-blur-xl animate-in fade-in duration-500">
                    <div className="bg-white w-full max-w-6xl max-h-[92vh] rounded-[40px] shadow-[0_32px_64px_-16px_rgba(15,23,42,0.25)] overflow-hidden flex flex-col relative border border-slate-100">

                      {/* 1. ABSOLUTE CLOSE BUTTON */}
                      <button
                        onClick={() => setIsOpen(false)}
                        className="absolute top-6 right-6 p-3 rounded-full text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-all duration-300 group/close z-50"
                        aria-label="Close"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="w-5 h-5 group-hover/close:rotate-90 transition-transform duration-500"
                        >
                          <line x1="18" y1="6" x2="6" y2="18" />
                          <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                      </button>

                      {/* 2. HEADER SECTION (Aligned horizontally to match the grid below) */}
                      <div className="pt-10 md:pt-12 pb-4 px-6 md:px-10 bg-white relative">
                        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-slate-100 pb-4">
                          <div className="flex-1">
                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 border border-indigo-100 mb-4 animate-pulse">
                              <svg viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 text-indigo-600">
                                <path d="M11 21v-6H5v6h6zm2 0h6v-10h-6v10zM11 13V3H5v10h6zm2-8v4h6V5h-6z" />
                              </svg>
                              <span className="text-[9px] font-black uppercase tracking-widest text-indigo-600">Value Engineering</span>
                            </div>
                            <h3 className="text-4xl md:text-5xl text-slate-900 tracking-tightest leading-none">
                              <span
                                className="font-bold text-slate-900"
                                style={{
                                  filter: `
                    drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
                    drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
                    drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                }}
                              >ROI </span>
                              <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 filter drop-shadow-[0_0_15px_rgba(79,70,229,0.35)]">
                                Calculator
                              </span>
                            </h3>
                            <div className="max-w mt-4 md:mb-2">
                              <p className="text-xs font-bold uppercase tracking-wide text-slate-400 leading-normal">
                                See exactly how much leakage the Cost Split Optimiser plugs, and how many hours your team will reclaim from manual spreadsheet assembly.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* 3. INTERACTIVE CONTENT GRID AREA (Paddings match the header exactly) */}
                      <div className="px-6 md:px-10 pb-6 overflow-y-auto custom-scrollbar bg-white flex-1">
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch relative z-10 pt-2">

                          {/* 🎛️ LEFT PANEL: CONTROL SLIDERS */}
                          <div className="lg:col-span-7 bg-slate-50/50 border border-slate-100 rounded-[2rem] p-6 flex flex-col justify-between gap-4 shadow-sm relative z-10">

                            {/* SLIDER 1: MONTHLY PROCUREMENT SPEND */}
                            <div className="space-y-2">
                              <div className="flex justify-between items-center">
                                <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                  Monthly Material & Vendor Spend
                                </label>
                                <span className={`text-xs font-black px-2.5 py-1 rounded-xl border tracking-tight transition-all duration-300 ${monthlySpend <= 250000
                                  ? "bg-emerald-50 border-emerald-200 text-emerald-700 shadow-sm"
                                  : monthlySpend <= 1000000
                                    ? "bg-amber-50 border-amber-200 text-amber-700 shadow-sm"
                                    : "bg-rose-50 border-rose-200 text-rose-700 shadow-sm"
                                  }`}>
                                  {formatRand(monthlySpend)}
                                </span>
                              </div>
                              <input
                                type="range"
                                min="50000"
                                max="10000000"
                                step="10000"
                                value={monthlySpend}
                                onChange={(e) => setMonthlySpend(Number(e.target.value))}
                                className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-indigo-600 focus:outline-none"
                              />
                              <div className="flex justify-between text-[9px] font-bold text-slate-400 px-0.5">
                                <span>R50k</span>
                                <span>R10M+</span>
                              </div>
                            </div>

                            <div className="h-px bg-slate-200/60" />

                            {/* SLIDER 2: MONTHLY RFQS RUN */}
                            <div className="space-y-2">
                              <div className="flex justify-between items-center">
                                <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                  Major Procurement Cycles / RFQs Per Month
                                </label>
                                <span className={`text-xs font-black px-2.5 py-1 rounded-xl border tracking-tight transition-all duration-300 ${monthlyRfqs <= 6
                                  ? "bg-emerald-50 border-emerald-200 text-emerald-700"
                                  : monthlyRfqs <= 12
                                    ? "bg-amber-50 border-amber-200 text-amber-700"
                                    : "bg-rose-50 border-rose-200 text-rose-700"
                                  }`}>
                                  {monthlyRfqs} {monthlyRfqs === 1 ? "Cycle" : "Cycles"}
                                </span>
                              </div>
                              <input
                                type="range"
                                min="1"
                                max="50"
                                step="1"
                                value={monthlyRfqs}
                                onChange={(e) => setMonthlyRfqs(Number(e.target.value))}
                                className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-indigo-600 focus:outline-none"
                              />
                              <div className="flex justify-between text-[9px] font-bold text-slate-400 px-0.5">
                                <span>1 Cycle</span>
                                <span>50 Cycles</span>
                              </div>
                            </div>

                            <div className="h-px bg-slate-200/60" />

                            {/* SLIDER 3: MANUAL PROCESS HOURS */}
                            <div className="space-y-2">
                              <div className="flex justify-between items-center">
                                <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                  Manual Excel Compilation Time (Hours per RFQ)
                                </label>
                                <span className={`text-xs font-black px-2.5 py-1 rounded-xl border tracking-tight transition-all duration-300 ${hoursPerRfq <= 8
                                  ? "bg-emerald-50 border-emerald-200 text-emerald-700"
                                  : hoursPerRfq <= 14
                                    ? "bg-amber-50 border-amber-200 text-amber-700"
                                    : "bg-rose-50 border-rose-200 text-rose-700"
                                  }`}>
                                  {hoursPerRfq} Hours
                                </span>
                              </div>
                              <input
                                type="range"
                                min="2"
                                max="80"
                                step="1"
                                value={hoursPerRfq}
                                onChange={(e) => setHoursPerRfq(Number(e.target.value))}
                                className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-indigo-600 focus:outline-none"
                              />
                              <div className="flex justify-between text-[9px] font-bold text-slate-400 px-0.5">
                                <span>Short (2h)</span>
                                <span>Complex Overhead (40h)</span>
                              </div>
                            </div>

                            <div className="h-px bg-slate-200/60" />

                            {/* SLIDER 4: PROCUREMENT OFFICER WAGE */}
                            <div className="space-y-2">
                              <div className="flex justify-between items-center">
                                <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                  Procurement Officer Cost / Hourly Rate
                                </label>
                                <span className="text-xs font-black text-slate-900 bg-white px-2.5 py-1 rounded-xl border border-slate-200 shadow-sm">
                                  {formatRand(hourlyWage)}/hr
                                </span>
                              </div>
                              <input
                                type="range"
                                min="100"
                                max="1600"
                                step="25"
                                value={hourlyWage}
                                onChange={(e) => setHourlyWage(Number(e.target.value))}
                                className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-indigo-600 focus:outline-none"
                              />
                              <div className="flex justify-between text-[9px] font-bold text-slate-400 px-0.5">
                                <span>R100/hr</span>
                                <span>R1600/hr</span>
                              </div>
                            </div>

                          </div>

                          {/* 📊 RIGHT PANEL: LIVE ROI DISPLAY */}
                          <div className="lg:col-span-5 flex flex-col justify-between gap-4 isolate">
                            <div className="p-6 bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 rounded-[2rem] text-white shadow-xl space-y-6 relative overflow-hidden border border-slate-800 flex-1 flex flex-col justify-between">
                              <div className="absolute -top-12 -right-12 w-48 h-48 bg-cyan-500/10 blur-[60px] rounded-full pointer-events-none" />
                              <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-indigo-500/10 blur-[60px] rounded-full pointer-events-none" />

                              <div>
                                <span className="text-[9px] font-black text-indigo-400 uppercase tracking-[0.25em] block mb-1" >
                                  Net Annual Value Returned
                                </span>
                                <h3
                                  className="text-3xl md:text-4xl font-black text-white tracking-tight"
                                  style={{
                                    filter: `
      /* Layer 1: Sharp high-contrast outline for text crispness */
      drop-shadow(0 2px 2px rgba(2, 6, 23, 0.85)) 
      /* Layer 2: Medium contextual ambient halo using your theme color */
      drop-shadow(0 0 12px rgba(99, 102, 241, 0.35)) 
      /* Layer 3: Ultra-soft wide black dispersion to add visual separation */
      drop-shadow(0 4px 20px rgba(0, 0, 0, 0.65))`
                                  }}
                                >
                                  {formatRand(netProfitCreated)}
                                </h3>
                                <p className="text-[9px] font-bold text-slate-400 mt-1 uppercase tracking-wider opacity-80">
                                  After factoring in platform license overheads
                                </p>
                              </div>

                              {/* LIVE ROI PERCENTAGE BADGES */}
                              <div className="grid grid-cols-2 gap-4 cursor-default">
                                <div className="p-4 bg-white/[0.02] border border-white/5 rounded-2xl backdrop-blur-sm hover:shadow-lg hover:scale-[1.03] cursor-default">
                                  <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest block mb-1 cursor-default">
                                    Projected ROI
                                  </span>
                                  <span className="text-2xl font-black text-emerald-400 tracking-tight cursor-default">
                                    {totalRoiPercentage.toFixed(0)}%
                                  </span>
                                </div>
                                <div className="p-4 bg-white/[0.02] border border-white/5 rounded-2xl backdrop-blur-sm hover:shadow-lg hover:scale-[1.03] cursor-default">
                                  <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest block mb-1 cursor-default">
                                    Hours Reclaimed
                                  </span>
                                  <span className="text-2xl font-black text-indigo-400 tracking-tight">
                                    {(hoursSavedPerRfq * monthlyRfqs * 12).toFixed(0)} <span className="text-[10px] font-normal text-slate-400 cursor-default">hrs/yr</span>
                                  </span>
                                </div>
                              </div>

                              <div className="h-px bg-slate-800" />

                              {/* SAVINGS STREAM SUMMARY BREAKDOWN */}
                              <div className="space-y-3">
                                <div className="flex justify-between items-center text-xs">
                                  <div className="flex items-center gap-2 text-slate-300 font-semibold">
                                    <span className="w-2 h-2 rounded-full bg-emerald-400 shadow-sm" />
                                    Annual Split-Optimiser Savings
                                  </div>
                                  <span className="font-black text-white text-sm">{formatRand(annualMaterialSavings)}</span>
                                </div>

                                <div className="flex justify-between items-center text-xs">
                                  <div className="flex items-center gap-2 text-slate-300 font-semibold">
                                    <span className="w-2 h-2 rounded-full bg-indigo-400 shadow-sm" />
                                    Annual Admin Labor Returned
                                  </div>
                                  <span className="font-black text-white text-sm">{formatRand(annualLaborSavings)}</span>
                                </div>

                                <a
                                  href="mailto:support@quopromanager.co.za?subject=Request%20for%20Procurement%20Leakage%20Audit"
                                  className="inline-flex items-center justify-center w-full py-3.5 bg-indigo-600 hover:bg-indigo-700 text-white font-black text-xs uppercase tracking-widest rounded-xl transition-all hover:shadow-lg hover:scale-[1.03]"
                                >
                                  Request ROI Audit
                                </a>
                              </div>
                            </div>
                          </div>

                        </div>
                        <br />
                        <p className="text-[9px] tracking-wide text-slate-400 leading-normal">
                          <p className="text-[9px] tracking-wide text-red-600 leading-normal font-bold">Please Note*</p>
                          <ul>
                            <li><span className="font-bold">{"> "}Optomiser Efficiency: </span>Conservative 15% cost-split saving matrix baseline</li>
                            <li><span className="font-bold">{"> "}QuoPro Process Time: </span> The user will spend minimum, 30 mins to import and match quotes</li>
                            <li><span className="font-bold">{"> "}QuoPro Annual Cost: </span> R22 788 (Estimated Professional Plan price benchmark (R1899 * 12)/pm)</li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {showPricingTableModal && (
                  <div className="fixed inset-0 z-[300] flex items-center justify-center px-4 md:px-10 py-4 bg-slate-900/40 backdrop-blur-xl animate-in fade-in duration-500">
                    <div className="bg-white w-full max-w-6xl max-h-[90vh] rounded-[40px] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.2)] overflow-hidden flex flex-col relative border border-white/20">

                      {/* 1. ABSOLUTE CLOSE BUTTON */}
                      <button
                        onClick={() => setShowPricingTableModal(false)}
                        className="absolute top-6 right-6 p-3 rounded-full text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-all duration-300 group/close z-50"
                        aria-label="Close"
                      >
                        <X size={20} className="group-hover/close:rotate-90 transition-transform duration-500" />
                      </button>

                      {/* 2. HEADER SECTION */}
                      <div className="p-10 md:p-12 pb-8 bg-white relative">
                        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                          <div className="flex-1">
                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 border border-slate-200 mb-4">
                              <Zap size={12} className="text-slate-900 fill-slate-900" />
                              <span className="text-[9px] font-black uppercase tracking-widest text-slate-900">Feature Matrix</span>
                            </div>
                            <h3 className="text-5xl text-slate-900 tracking-tightest leading-none">
                              <span
                                className="font-bold text-slate-900"
                                style={{
                                  filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                }}
                              >Plan </span><span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 filter drop-shadow-[0_0_15px_rgba(79,70,229,0.35)]">
                                Breakdown
                              </span>
                            </h3>
                          </div>

                          {/* SEARCH BAR */}
                          <div className="relative w-full max-w-sm md:mb-[-4px] md:mr-16">
                            <Search size={14} className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400" />
                            <input
                              type="text"
                              placeholder="Search capabilities..."
                              value={featureSearchQuery}
                              onChange={(e) => setFeatureSearchQuery(e.target.value)}
                              className="w-full pl-12 pr-6 py-3.5 bg-slate-50 border-none rounded-xl text-xs font-bold text-slate-700 placeholder:text-slate-400 focus:ring-2 focus:ring-indigo-500/20 focus:bg-white transition-all outline-none"
                            />
                          </div>
                        </div>
                      </div>

                      {/* 3. TABLE AREA */}
                      <div className="overflow-y-auto px-10 md:px-12 pb-14 custom-scrollbar bg-white">
                        <table className="w-full border-separate border-spacing-0 table-fixed">
                          <thead className="sticky top-0 z-30">
                            <tr>
                              <th className="w-[34%] py-6 text-left text-[13px] font-black uppercase tracking-widest text-slate-900 border-b border-slate-100 bg-white">Capabilities</th>
                              <th className="w-[22%] py-6 text-center bg-emerald-500 rounded-t-2xl text-[12px] font-black uppercase tracking-widest text-white">Starter</th>
                              <th className="w-[22%] py-6 text-center bg-indigo-600 rounded-t-2xl text-[12px] font-black uppercase tracking-widest text-white">Professional</th>
                              <th className="w-[22%] py-6 text-center bg-slate-900 rounded-t-2xl text-[12px] font-black uppercase tracking-widest text-white">Business Plus+</th>
                            </tr>
                          </thead>

                          <tbody className="divide-y divide-slate-50">
                            {[
                              { name: "Project Registry*", desc: "Project entry limit", s: "2", p: "30", e: "Unlimited", level: 1 },
                              { name: "Supplier Registry*", desc: "Supplier entry limit", s: "5", p: "55", e: "Unlimited", level: 1 },
                              { name: "Team View", desc: "Overview of active Team Members", s: "Yes", p: "Yes", e: "Yes", level: 1 },
                              { name: "2FA Security", desc: "Enforced Security Access", s: "Yes", p: "Yes", e: "Yes", level: 1 },
                              { name: "Quotation Imports", desc: "Smart Quote Import", s: "Yes", p: "Yes", e: "Yes", level: 1 },
                              { name: "Smart-AI Quotation Import", desc: "Import PDF Quotes", s: "-", p: "Yes", e: "Yes", level: 1 },
                              { name: "Top Vendor Overview", desc: "View Established Winning Vendor", s: "Yes", p: "Yes", e: "Yes", level: 1 },
                              { name: "Top Vendor Reporting", desc: "View Winning Vendor Details", s: "-", p: "-", e: "Yes", level: 1 },
                              { name: "Runner-up Vendor Visibility", desc: "View Runner-Up Vendor Details", s: "-", p: "Yes", e: "Yes", level: 1 },
                              { name: "Vendor Comparison Tool", desc: "Compare Vendor Quotes", s: "-", p: "-", e: "Yes", level: 1 },
                              { name: "Notification Centre", desc: "Receive System Notifications", s: "-", p: "Yes", e: "Yes", level: 1 },
                              { name: "Workflow Management", desc: "Manage Project Workflows", s: "-", p: "Yes", e: "Yes", level: 1 },
                              { name: "Cost Split Optimiser", desc: "View Optimal Project Savings", s: "-", p: "Yes", e: "Yes", level: 1 },
                              { name: "Generate Invoices", desc: "Generate in-house QuoPro Invoices", s: "-", p: "-", e: "Yes", level: 1 },
                              { name: "Audit Log", desc: "History & Compliance", s: "-", p: "Yes", e: "Yes", level: 1 },
                              { name: "Project Registry Export", desc: "Winner Vendor and Project Registry Export", s: "-", p: "-", e: "Yes", level: 1 },
                            ]
                              .filter(r => r.name.toLowerCase().includes(featureSearchQuery.toLowerCase()))
                              .map((row, i) => (
                                <tr key={i} className="group transition-colors duration-150">
                                  <td className="py-6 pr-8 border-b border-slate-50 group-hover:bg-slate-50/80 transition-colors">
                                    <div className="flex flex-col">
                                      <span className="text-[14px] font-black text-slate-900 uppercase tracking-tight">{row.name}</span>
                                      <span className="text-[12px] text-slate-400 font-bold uppercase tracking-tighter mt-0.5">{row.desc}</span>
                                    </div>
                                  </td>

                                  {/* Column backgrounds also react to the row hover */}
                                  <td className="py-6 text-center bg-emerald-100/20 border-x border-emerald-100/50 group-hover:bg-emerald-100/50 transition-colors">
                                    <span className="text-[13px] font-bold text-emerald-600 tabular-nums tracking-tight">{row.s}</span>
                                  </td>

                                  <td className="py-6 text-center bg-indigo-100/20 border-x border-indigo-100/50 group-hover:bg-indigo-100/30 transition-colors">
                                    <span className="text-[13px] font-black text-indigo-600 tabular-nums tracking-tight">{row.p}</span>
                                  </td>

                                  <td className="py-6 text-center bg-slate-100/20 border-x border-slate-100/50 group-hover:bg-slate-100/60 transition-colors">
                                    <span className={`text-[13px] font-black tabular-nums tracking-tight ${row.level <= 2 ? "text-slate-600" :
                                      row.level <= 5 ? "text-orange-600" :
                                        "text-rose-500"
                                      }`}>
                                      {row.e}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <p className="text-[9px] text-center w-full mt-8 mb-[-40px] text-slate-900 tracking-[0.15em] uppercase font-medium">
                          * total projects/suppliers available (once-off) for a registered workspace
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                <section
                  id="connect"
                  className="py-32 px-6 bg-transparent relative overflow-hidden"
                >
                  {/* Ambient background glow */}
                  <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-indigo-50/50 rounded-full blur-3xl -ml-64 -mb-64 pointer-events-none" />

                  <div className="max-w-7xl mx-auto relative z-10">
                    {/* HEADER SECTION - Now always visible */}
                    <div className="mb-20 flex flex-col items-end text-right">
                      <h2 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
                        <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 filter drop-shadow-[0_0_15px_rgba(79,70,229,0.35)]">
                          Connect
                        </span>{" "}
                        <span
                          className="font-bold text-slate-900"
                          style={{
                            filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                          }}
                        >with QuoPro</span>
                      </h2>
                      <p className="text-xl text-slate-500 max-w-lg leading-relaxed">
                        Whether you're scaling a startup or optimizing business
                        procurement, our team is ready to assist.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
                      {/* 1. CONTACT FORM (8 Cols) */}


                      {/* 2. INFO CARDS (5 Cols) */}
                      <div className="lg:col-span-5 space-y-8">
                        {/* Digital Infrastructure Card */}
                        <div className="p-8 bg-white border border-slate-100 rounded-[40px] shadow-sm group hover:border-indigo-100 transition-all relative overflow-hidden">
                          {/* The Giant Ghost Icon - Globe representing Cloud Operations */}
                          <div className="absolute -bottom-6 -right-6 text-slate-900 opacity-[0.03] group-hover:opacity-[0.08] group-hover:scale-150 group-hover:-rotate-12 transition-all duration-700 ease-out pointer-events-none">
                            <Globe size={160} strokeWidth={1} />
                          </div>

                          <div className="relative z-10">
                            <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 mb-6 group-hover:scale-110 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-500">
                              <Globe size={24} />
                            </div>

                            <h4 className="text-xl font-black text-slate-900 mb-2">Global Operations</h4>
                            <p className="text-slate-500 font-bold leading-relaxed mb-1">South Africa Strategic Hub</p>
                            <span className="text-[10px] font-black uppercase tracking-[0.15em] text-indigo-500 px-3 py-1 bg-indigo-50 rounded-full">
                              Cloud-Native Environment
                            </span>
                          </div>
                        </div>

                        {/* Instant Support Card */}
                        <div className="p-8 bg-slate-900 rounded-[40px] shadow-xl text-white group hover:bg-indigo-600 transition-all relative overflow-hidden">
                          {/* The Giant Ghost Icon - Zap representing Instant Support */}
                          <div className="absolute -bottom-10 -right-8 text-white opacity-[0.03] group-hover:opacity-[0.07] group-hover:scale-150 group-hover:rotate-12 transition-all duration-700 ease-out pointer-events-none">
                            <Zap size={180} strokeWidth={1} />
                          </div>

                          <div className="relative z-10">
                            <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center text-indigo-300 mb-6 group-hover:scale-110 group-hover:bg-white group-hover:text-indigo-600 transition-all duration-500">
                              <Zap size={24} />
                            </div>

                            <h4 className="text-xl font-black mb-2">Instant Channels</h4>
                            <p className="text-slate-400 font-medium mb-4 text-sm">Our global support team is available virtually for technical and billing inquiries.</p>

                            <a href="mailto:support@quopromanager.co.za" className="inline-flex items-center gap-2 text-white font-black text-xs uppercase tracking-widest hover:text-indigo-200 transition-colors">
                              support@quopromanager.co.za
                              <ArrowUpRight size={14} />
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="lg:col-span-7 relative group min-h-[600px] flex items-center justify-center overflow-hidden rounded-[3.5rem] bg-white/40 backdrop-blur-2xl border border-white/80 p-8 md:p-14 shadow-[0_32px_80px_-20px_rgba(0,0,0,0.1)] transition-all duration-500 hover:shadow-[0_45px_100px_-20px_rgba(99,102,241,0.15)] hover:-translate-y-1">
                        {/* Sub-pixel Top Highlight */}
                        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white to-transparent" />

                        {/* 🟢 FIXED: Evaluating submitStatus state instead of unmapped isSubmitted variable */}
                        {submitStatus !== "success" ? (
                          <form onSubmit={handleSubmit} className="space-y-10 w-full relative z-10">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                              {/* Full Name Field */}
                              <div className="group space-y-3">
                                <label className="text-[10px] font-black uppercase tracking-[0.25em] text-slate-400 ml-2 group-focus-within:text-slate-900 transition-colors">
                                  Full Name
                                </label>
                                <div className="relative">
                                  <input
                                    required
                                    type="text"
                                    placeholder="Name and Surname"
                                    value={form.name}
                                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                                    className="w-full px-8 py-5 bg-white/50 border border-slate-200 rounded-2xl focus:outline-none focus:ring-1 focus:ring-slate-900 focus:border-slate-900 transition-all duration-300 text-slate-900 font-semibold placeholder:text-slate-400/50 shadow-inner"
                                  />
                                </div>
                              </div>

                              {/* Corporate Email Field */}
                              <div className="group space-y-3">
                                <label className="text-[10px] font-black uppercase tracking-[0.25em] text-slate-400 ml-2 group-focus-within:text-slate-900 transition-colors">
                                  Corporate Email
                                </label>
                                <div className="relative">
                                  <input
                                    required
                                    type="email"
                                    placeholder="info@company.com"
                                    value={form.email}
                                    onFocus={() => setIsFocused(true)}
                                    onBlur={() => {
                                      setIsFocused(false);
                                      setForm({ ...form, emailTouched: true });
                                    }}
                                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                                    className={`w-full px-8 py-5 bg-white/50 border rounded-2xl outline-none transition-all duration-300 font-semibold text-slate-900 placeholder:text-slate-400/50 shadow-inner 
                ${isFocused && form.email
                                        ? validateEmail(form.email)
                                          ? "border-emerald-500 ring-1 ring-emerald-500 shadow-[0_0_15px_rgba(16,185,129,0.15)] text-emerald-700"
                                          : "border-rose-500 ring-1 ring-rose-500 shadow-[0_0_15px_rgba(244,63,94,0.15)] text-rose-600"
                                        : "border-slate-200 focus:border-slate-900 focus:ring-1 focus:ring-slate-900"
                                      }`}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-[-20px]">
                              {/* Line of Business Field */}
                              <div className="group space-y-3">
                                <label className="text-[10px] font-black uppercase tracking-[0.25em] text-slate-400 ml-2 group-focus-within:text-slate-900 transition-colors">
                                  Line of Business
                                </label>
                                <div className="relative">
                                  <select
                                    required
                                    value={form.businessLine}
                                    onChange={(e) => setForm({ ...form, businessLine: e.target.value })}
                                    className="w-full px-8 py-5 bg-white/50 border border-slate-200 rounded-2xl focus:outline-none focus:ring-1 focus:ring-slate-900 focus:border-slate-900 transition-all duration-300 text-slate-900 font-semibold appearance-none shadow-inner cursor-pointer"
                                  >
                                    <option value="" disabled>Select your industry...</option>

                                    <optgroup label="Construction & Trades">
                                      <option value="general_contracting">General Contracting</option>
                                      <option value="hvac_mechanical">HVAC & Mechanical</option>
                                      <option value="electrical">Electrical Services</option>
                                      <option value="plumbing">Plumbing & Piping</option>
                                      <option value="civil_engineering">Civil Engineering</option>
                                    </optgroup>

                                    <optgroup label="Professional Services">
                                      <option value="it_consulting">IT Consulting</option>
                                      <option value="architecture_design">Architecture & Design</option>
                                      <option value="legal_services">Legal & Compliance</option>
                                      <option value="marketing_agency">Marketing & Creative Agency</option>
                                    </optgroup>

                                    <optgroup label="Manufacturing & Supply Chain">
                                      <option value="manufacturing">Industrial Manufacturing</option>
                                      <option value="logistics_dist">Logistics & Distribution</option>
                                      <option value="wholesale_trade">Wholesale Trade</option>
                                      <option value="procurement">Procurement & Sourcing</option>
                                    </optgroup>

                                    <optgroup label="Energy & Technology">
                                      <option value="renewable_energy">Renewable Energy & Solar</option>
                                      <option value="software_saas">Software & SaaS</option>
                                      <option value="telecommunications">Telecommunications</option>
                                    </optgroup>

                                    <optgroup label="Other">
                                      <option value="other">Other Business Line</option>
                                    </optgroup>
                                  </select>

                                  {/* Custom Dropdown Arrow */}
                                  <div className="absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                      <path d="m6 9 6 6 6-6" />
                                    </svg>
                                  </div>
                                </div>
                              </div>

                              {form.businessLine === "other" ? (
                                <div className="group space-y-3 animate-in fade-in slide-in-from-left-4 duration-500">
                                  <label className="text-[10px] font-black uppercase tracking-[0.25em] text-slate-400 ml-2 transition-colors">
                                    Please Specify Line of Business
                                  </label>
                                  <div className="relative">
                                    <input
                                      required
                                      type="text"
                                      placeholder="e.g. Specialized Aviation Logistics"
                                      value={form.customBusinessLine || ""}
                                      onChange={(e) => setForm({ ...form, customBusinessLine: e.target.value })}
                                      className="w-full px-8 py-5 bg-white/50 border border-slate-200 rounded-2xl focus:outline-none focus:ring-1 focus:ring-slate-900 focus:border-slate-900 transition-all duration-300 text-slate-900 font-semibold placeholder:text-slate-400/50 shadow-inner"
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div />
                              )}
                            </div>

                            {/* Message Field */}
                            <div className="group space-y-3">
                              <label className="text-[10px] font-black uppercase tracking-[0.25em] text-slate-400 ml-2 group-focus-within:text-slate-900 transition-colors">
                                Message
                              </label>
                              <div className="relative">
                                <textarea
                                  required
                                  rows="5"
                                  placeholder="How can we assist you?"
                                  value={form.message}
                                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                                  className="w-full px-8 py-5 bg-white/50 border border-slate-200 rounded-2xl focus:outline-none focus:ring-1 focus:ring-slate-900 focus:border-slate-900 transition-all duration-300 text-slate-900 font-semibold placeholder:text-slate-400/50 shadow-inner resize-none"
                                ></textarea>
                              </div>
                            </div>

                            {/* Error Alert Feedback (Only shows if Render api rejects the post query) */}
                            {submitStatus === "error" && (
                              <div className="p-4 bg-rose-50 dark:bg-rose-950/20 text-rose-600 text-xs font-bold rounded-2xl border border-rose-100 animate-in fade-in duration-300">
                                🚨 Failed to submit inquiry. Please double-check details or try again later.
                              </div>
                            )}

                            {/* Action Button */}
                            <div className="flex justify-center w-full pt-4">
                              <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`group relative flex items-center justify-center gap-4 w-full md:w-fit px-14 py-6 bg-slate-900 text-white rounded-2xl font-black text-[11px] uppercase tracking-[0.25em] transition-all duration-300 shadow-2xl hover:shadow-indigo-500/40 ${isSubmitting ? "opacity-60 cursor-not-allowed scale-95" : "hover:scale-[1.02] active:scale-95"
                                  }`}
                              >
                                {isSubmitting ? "Sending..." : "Send Message"}
                                {!isSubmitting && (
                                  <Send
                                    size={18}
                                    className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                                  />
                                )}
                              </button>
                            </div>
                          </form>
                        ) : (
                          /* Success State Layout Layer */
                          <div className="text-center animate-in zoom-in-95 fade-in duration-700 relative z-10">
                            <div className="relative mx-auto w-28 h-28 mb-10">
                              <div className="absolute inset-0 bg-emerald-500/20 rounded-full animate-ping"></div>
                              <div className="relative w-28 h-28 bg-gradient-to-tr from-emerald-500 to-teal-400 rounded-full flex items-center justify-center shadow-2xl shadow-emerald-200">
                                <Check size={48} className="text-white" strokeWidth={4} />
                              </div>
                            </div>
                            <h3 className="text-4xl md:text-5xl font-black text-slate-900 mb-4 tracking-tight">Message Sent.</h3>
                            <p className="text-lg text-slate-500 mb-12 max-w-sm mx-auto leading-relaxed">
                              Your inquiry is being routed to our experts. <br />We'll be in touch shortly.
                            </p>
                            <button
                              onClick={() => setSubmitStatus(null)}
                              className="group text-[10px] font-black uppercase tracking-[0.25em] text-slate-400 hover:text-indigo-600 transition-colors flex items-center gap-3 mx-auto"
                            >
                              <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                              Send another message
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>

                {/* 6. ELITE FOOTER */}
                <footer className="py-24 bg-slate-950 text-white relative overflow-hidden">
                  {/* Top Border Glow */}
                  <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />

                  <div className="max-w-7xl mx-auto px-8">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8 items-start">
                      {/* 1. BRAND COLUMN */}
                      <div className="md:col-span-5 space-y-6">
                        <div className="flex items-center gap-2">
                          <div className="w-10 h-10 flex items-center justify-center group-hover:scale-110 transition-all duration-500">
                            <img
                              src="/logo.png"
                              alt="QuoPro Logo"
                              className="w-full h-full object-contain drop-shadow-[0_10px_15px_rgba(99,102,241,0.2)] group-hover:rotate-12 transition-all duration-500"
                            />
                          </div>
                          <span className="text-xl text-white font-bold ">
                            Quo
                            <span className="font-bold bg-gradient-to-r from-indigo-400 to-cyan-300  bg-clip-text text-transparent px-2 -mx-2 drop-shadow-[0_0_8px_rgba(34,211,238,0.4)]">
                              Pro
                            </span>
                          </span>
                        </div>
                        <p className="text-slate-400 max-w-sm text-l font-thin leading-relaxed">
                          Built for precision, designed for speed.
                        </p>
                      </div>

                      {/* 2. NAVIGATION/SOCIAL COLUMN */}
                      <div className="md:col-span-4 flex flex-col gap-6">
                        <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-500">
                          Connect
                        </h4>
                        <div className="flex items-center gap-3">
                          {[
                            { icon: <Linkedin size={18} />, label: "LinkedIn" },
                            { icon: <Instagram size={18} />, label: "X" },
                            { icon: <Github size={18} />, label: "GitHub" },
                          ].map((social) => (
                            <a
                              key={social.label}
                              href="#"
                              className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:bg-indigo-600 hover:border-indigo-500 transition-all duration-300"
                            >
                              {social.icon}
                            </a>
                          ))}
                        </div>
                      </div>

                      {/* 3. LEGAL/COPYRIGHT COLUMN */}
                      <div className="md:col-span-3 flex flex-col md:items-end gap-6">
                        <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-500 text-right">
                          Legal
                        </h4>
                        <div className="flex gap-6 text-slate-400 text-xs font-bold uppercase tracking-widest">
                          <span
                            onClick={() => setShowTerms(true)}
                            className="font-bold hover:text-indigo-400 cursor-pointer transition-colors"
                          >
                            Terms & Privacy
                          </span>
                          {showTerms && (
                            <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
                              {/* BACKDROP - Heavily blurred for focus */}
                              <div
                                className="absolute inset-0 bg-slate-900/40 backdrop-blur-xl transition-opacity"
                                onClick={() => setShowTerms(false)}
                              />

                              {/* MODAL CONTAINER */}
                              <div className="relative w-full max-w-5xl bg-white rounded-[3rem] shadow-[0_30px_100px_-20px_rgba(0,0,0,0.3)] flex flex-col max-h-[90vh] border border-slate-200 overflow-hidden">

                                {/* 1. PREMIUM HEADER */}
                                <div className="p-10 border-b border-slate-100 flex justify-between items-start bg-white z-10">
                                  <div>
                                    <div className="flex items-center gap-3 mb-2">
                                      <div className="w-2 h-2 rounded-full bg-indigo-600 animate-pulse" />
                                      <span className="text-[10px] font-black text-indigo-600 uppercase tracking-[0.3em]">Legal Framework</span>
                                    </div>
                                    <h4 className="text-3xl font-black text-slate-900 tracking-tight">
                                      Terms of Service & Privacy Policy
                                    </h4>
                                    <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mt-2">
                                      QuoPro Legal & Privacy Policy Agreement
                                    </p>
                                  </div>

                                  <button
                                    onClick={() => setShowTerms(false)}
                                    className="group flex items-center gap-3 px-6 py-3 bg-slate-900 text-white rounded-2xl text-[11px] font-black uppercase tracking-widest transition-all hover:bg-indigo-600 hover:scale-105 active:scale-95 shadow-lg"
                                  >
                                    <X size={16} className="transition-transform group-hover:rotate-90" />
                                    Close
                                  </button>
                                </div>

                                {/* 2. EXPANDED LEGAL CONTENT */}
                                <div className="p-12 overflow-y-auto space-y-12 bg-slate-50/50 custom-scrollbar">

                                  {/* INTRODUCTION */}
                                  <section className="max-w-3xl">
                                    <p className="text-[13px] text-slate-600 leading-relaxed italic">
                                      This Master Service Agreement ("Agreement") governs the access to and use of QuoPro’s cloud-based procurement optimisation platform. By accessing the platform, you acknowledge that you have read, understood, and agreed to be bound by the protocols defined herein.
                                    </p>
                                  </section>

                                  {/* SECTION 1: PROVISION OF SERVICE */}
                                  <section className="space-y-4">
                                    <h5 className="text-[11px] font-black text-indigo-600 uppercase tracking-[0.2em]">
                                      01. SCOPE OF ARCHITECTURE & SERVICE PROVISION
                                    </h5>
                                    <div className="grid md:grid-cols-2 gap-8">
                                      <p className="text-[12px] text-slate-500 leading-relaxed">
                                        QuoPro grants a non-exclusive, non-transferable right to access the platform. We maintain the absolute right to modify, update, or sunset specific algorithmic features to ensure optimal system performance and security compliance.
                                      </p>
                                      <p className="text-[12px] text-slate-500 leading-relaxed">
                                        Service uptime is targeted at 99.9%, excluding scheduled maintenance windows or Force Majeure events including but not limited to regional internet backbone failures.
                                      </p>
                                    </div>
                                  </section>

                                  {/* SECTION 2: LIABILITY (HIGH VISIBILITY) */}
                                  <section className="p-8 bg-white rounded-[2rem] border border-slate-200 shadow-sm space-y-4">
                                    <h5 className="text-[11px] font-black text-rose-600 uppercase tracking-[0.2em]">
                                      02. LIMITATION OF LIABILITY & INDEMNITY
                                    </h5>
                                    <p className="text-[12px] text-slate-600 leading-relaxed font-bold">
                                      UNDER NO CIRCUMSTANCES SHALL QUOPRO, ITS DIRECTORS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM (I) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICE; (II) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICE.
                                    </p>
                                    <p className="text-[11px] text-slate-400 leading-relaxed">
                                      In no event shall QuoPro's aggregate liability exceed the amounts actually paid by you to QuoPro for the service in the twelve (12) month period immediately preceding the event giving rise to such claim.
                                    </p>
                                  </section>

                                  {/* SECTION 3: DATA PRIVACY & ENCRYPTION */}
                                  <section className="space-y-4">
                                    <h5 className="text-[11px] font-black text-indigo-600 uppercase tracking-[0.2em]">
                                      03. DATA SOVEREIGNTY & INTELLECTUAL PROPERTY
                                    </h5>
                                    <div className="space-y-4 text-[12px] text-slate-500 leading-relaxed">
                                      <p>
                                        <strong className="text-slate-900">User Data:</strong> You retain all rights, title, and interest in the data you upload. QuoPro is granted a limited license to host and process this data solely for providing the service.
                                      </p>
                                      <p>
                                        <strong className="text-slate-900">Platform IP:</strong> The QuoPro source code, UI logic, design patterns, and "Tunnel" background architecture are the exclusive property of QuoPro and protected by international copyright laws.
                                      </p>
                                    </div>
                                  </section>

                                  {/* SECTION 4: TERMINATION */}
                                  <section className="space-y-4">
                                    <h5 className="text-[11px] font-black text-indigo-600 uppercase tracking-[0.2em]">
                                      04. TERMINATION OF ACCOUNT & DATA RETENTION
                                    </h5>
                                    <p className="text-[12px] text-slate-500 leading-relaxed">
                                      Either party may terminate this agreement at any time. Upon termination, QuoPro will maintain your encrypted data for a period of 30 days, after which all records will be permanently purged from our active nodes unless a manual data-export is requested.
                                    </p>
                                  </section>

                                  {/* FOOTER STAMP */}
                                  <div className="pt-10 flex flex-col items-center justify-center text-center border-t border-slate-100">
                                    <p className="text-[9px] font-medium text-slate-400 uppercase tracking-[0.4em]">
                                      Protected by End-to-End Encryption & International Trade Law
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* SUB-FOOTER */}
                    <div className="mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6">
                      {/* Left: Copyright */}
                      <p className="text-[10px] font-black text-slate-600 uppercase tracking-[0.4em] cursor-default">
                        QuoPro | developed by <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 transition-colors">
                          OpenModal©
                        </span>
                      </p>

                      {/* Center/Right: Trust & Status */}
                      <div className="flex flex-wrap items-center gap-8">

                        {/* Merchant Stack */}
                        <div className="flex items-center gap-4 border-r border-white/10 pr-8">
                          <div className="flex flex-col items-start">
                            <span className="text-[7px] font-black text-slate-500 uppercase tracking-[0.2em] mb-1">
                              Merchant of Record
                            </span>
                            <div className="flex items-center gap-2 group cursor-default">
                              <img
                                src="/LS.png"
                                alt="Lemon Squeezy"
                                className="w-5 h-5 object-contain transition-transform duration-500 group-hover:rotate-12"
                              />
                              <span className="text-[11px] font-bold text-slate-400 group-hover:text-slate-200 transition-colors">
                                Lemon Squeezy
                              </span>
                            </div>
                          </div>

                          <div className="flex flex-col items-center group/stripe cursor-default">
                            <span className="text-[6px] font-black text-slate-500 uppercase tracking-[0.2em] leading-none mb-1 opacity-100 transition-opacity duration-300">
                              Powered by
                            </span>
                            <img
                              src="/Stripe.png"
                              alt="Stripe"
                              className="w-10 h-auto object-contain opacity-100 transition-all duration-500"
                            />
                          </div>
                        </div>

                        {/* System Status */}
                        <div className="flex items-center gap-3">
                          <div className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                          </div>
                          <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                            System Status: <span className="text-emerald-500/80 font-bold">Stable</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            ) : (
              <div id="loginScreen" className="h-screen w-full overflow-hidden bg-white flex flex-col md:flex-row animate-in fade-in duration-700">
                <div
                  className="h-screen w-full bg-white flex flex-col md:flex-row overflow-hidden font-sans animate-quo-entrance"
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                >
                  {/* 1. THE LEFT SIDE: Now height-locked to the screen (h-full of the h-screen parent) */}
                  <div
                    onClick={() =>
                      setCurrentSlide((prev) => (prev + 1) % slides.length)
                    }
                    className="hidden md:flex md:w-1/2 bg-slate-950 p-12 lg:p-20 flex-col justify-between relative overflow-hidden h-full border-r border-white/5 cursor-default select-none z-0"
                  >
                    <div className="absolute top-[20%] left-[20%] w-[60%] h-[60%] rounded-full bg-indigo-800/20 mix-blend-screen blur-[140px] animate-pulse" style={{ animationDelay: '1s', animationDuration: '8s' }} />

                    <div className="relative z-10">
                      {/* LOGO - Playful hover */}
                      <div className="flex justify-between items-center w-full">
                        {/* LOGO SECTION (Left) */}
                        <button
                          onClick={() => setShowWebsite(true)}
                          className="flex items-center gap-2 group cursor-pointer w-fit outline-none bg-transparent border-none p-0 focus:outline-none animate-in fade-in slide-in-from-top-4 duration-1000 ease-out"
                        >
                          <div className="w-10 h-10 flex items-center justify-center group-hover:scale-110 transition-all duration-500">
                            <img
                              src="/logo.png"
                              alt="QuoPro Logo"
                              className="w-full h-full object-contain drop-shadow-[0_10px_15px_rgba(99,102,241,0.2)] group-hover:rotate-12 transition-all duration-500"
                            />
                          </div>

                          <h1 className="font-bold text-5xl md:text-3xl flex items-center tracking-tighter transition-all duration-300">
                            <span className="font-bold text-white">Quo</span>
                            <span className="font-bold bg-gradient-to-r from-indigo-600 to-cyan-300 dark:from-indigo-400 dark:to-cyan-400 bg-clip-text text-transparent pr-1 transition-all duration-500 drop-shadow-[0_0_8px_rgba(34,211,238,0.4)]">
                              Pro
                            </span>
                          </h1>
                        </button>

                        {/* INDICATOR/TEXT SECTION (Right) */}
                      </div>
                      <div><br /><br /><br /></div>


                      {/* SLIDE CONTENT */}
                      <div className="relative h-[300px]">
                        {slides.map((slide, index) => (
                          <div
                            key={index}
                            className={`absolute inset-0 transition-all duration-700 ease-in-out ${index === currentSlide
                              ? "opacity-100 translate-y-0"
                              : "opacity-0 translate-y-4 pointer-events-none"
                              }`}
                          >
                            {/* Header: Pro but Chilled */}
                            <h2 className=" text-6xl font-extrabold text-white leading-[0.95] tracking-tight mb-8">
                              {slide.title} <br />
                              <span className="font-bold relative bg-gradient-to-r from-indigo-500 to-cyan-300 bg-clip-text text-transparent 
                                            filter drop-shadow-[0_0_15px_rgba(99,102,241,0.3)] 
                                            drop-shadow-[0_0_30px_rgba(34,211,238,0.2)]">
                                {slide.highlight}
                              </span>
                            </h2>

                            {/* Description: Playful "Chilled" styling */}
                            <p className="text-slate-400 text-lg font-medium max-w-sm leading-relaxed opacity-90">
                              <span className=" text-indigo-500 font-black text-2xl leading-none mr-2">
                                “
                              </span>
                              {slide.description}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* FOOTER STATS - Glassmorphism & Playful Skew */}
                    <div className="relative z-10 space-y-8">
                      <div className="flex gap-1.5 items-center">
                        {slides.map((_, i) => (
                          <div
                            key={i}
                            className={`h-1.5 rounded-full transition-all duration-500 ${i === currentSlide
                              ? "w-10 bg-indigo-500"
                              : "w-1.5 bg-slate-800"
                              }`}
                          />
                        ))}
                      </div>

                      <div className="flex gap-4">
                        {[
                          {
                            val: slides[currentSlide].stat,
                            lab: slides[currentSlide].label,
                            // Fixed: Using full class for indigo glow/bg to ensure Tailwind picks it up
                            dotClass: "bg-indigo-400 shadow-[0_0_10px_#818cf8]",
                            textClass: "text-indigo-400",
                          },
                          {
                            // Fixed: Simplified logic for the heartbeat card
                            val: "LIVE",
                            lab: "System Sync",
                            dotClass: "bg-emerald-400 shadow-[0_0_10px_#34d399] animate-pulse",
                            textClass: "text-emerald-400",
                          },
                        ].map((card, idx) => (
                          <div
                            key={idx}
                            className="relative flex-1 group cursor-pointer"
                          >
                            <div className="relative bg-white/[0.03] backdrop-blur-md border border-white/10 p-5 rounded-[1.5rem] transition-all duration-500 group-hover:-translate-y-1 group-hover:bg-white/[0.06] group-hover:border-white/20">

                              {/* Value with the Indigo/Emerald Filter we fixed earlier */}
                              <div
                                className="text-3xl font-black text-white tracking-tighter mb-1"
                                style={{
                                  filter: `drop-shadow(0 0 2px rgba(255, 255, 255, 0.2))`
                                }}
                              >
                                {card.val}
                              </div>

                              <div className="flex items-center gap-2">
                                {/* Status Dot */}
                                <div className={`w-1.5 h-1.5 rounded-full ${card.dotClass}`} />

                                <div className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                  {card.lab}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div>
                        <p className="text-[10px] font-black text-slate-600 uppercase tracking-[0.4em]">
                          QuoPro<span>{" "}</span> | <span>{" "}</span>developed by OpenModal©
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 2. THE RIGHT SIDE: This is now an independent scroll container */}
                  <div className="w-full md:w-1/2 h-full overflow-hidden bg-slate-50 relative">
                    {/* 1. ENHANCED AMBIENT GLOWS */}
                    <div className="absolute inset-0 z-0 pointer-events-none">
                      <div className="absolute top-[20%] left-[20%] w-[60%] h-[60%] rounded-full bg-slate-600/20 mix-blend-screen blur-[100px]" />
                    </div>

                    {/* 2. SCALE & ALIGNMENT WRAPPER 
      - items-center justify-center: Vertically and horizontally middled
      - transform scale-80: Maintains the zoomed-out aesthetic
  */}
                    <div className="h-full flex items-center justify-center p-6 relative z-10 transform origin-center">

                      {/* 3. THE COMPACT GLASS CARD 
        - max-w-sm: Resized to be smaller/slimmer
        - shadow stack: Provides the "depth" effect
        - transition: Handles the hover lift
    */}
                      <div className="w-full max-w-sm bg-white/80 backdrop-blur-3xl border border-white/40 ring-1 ring-white/20 p-8 md:p-10 rounded-[3.5rem] shadow-[0_10px_20px_-5px_rgba(0,0,0,0.04),0_40px_80px_-15px_rgba(0,0,0,0.1),0_0_50px_-10px_rgba(79,70,229,0.08)] transition-all duration-500 hover:shadow-[0_50px_100px_-20px_rgba(0,0,0,0.15)] hover:scale-[1.01]">

                        {!showMfaChallenge ? (
                          /* --- NORMAL LOGIN / SIGNUP FLOW --- */
                          <>
                            <div className="mb-8 text-center">
                              <div className="relative -mt-16 mb-6 flex flex-col items-center">
                                <div className="w-16 h-16 bg-white rounded-[1.8rem] flex items-center justify-center group transition-all duration-500 hover:scale-110 shadow-xl border border-slate-100">
                                  <div className="w-10 h-10 bg-slate-50 rounded-xl shadow-inner flex items-center justify-center text-indigo-600">
                                    {mode === "login" ? <LogIn size={20} /> : <UserPlus size={20} />}
                                  </div>
                                </div>
                              </div>

                              <span
                                className="font-bold text-slate-900"
                                style={{
                                  filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                }}
                              ><h2 className="text-3xl font-[900] mb-2 tracking-tighter text-slate-900">
                                  {mode === "login" ? "Welcome." : "Get Started."}
                                </h2></span>
                              <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">
                                {mode === "login" ? "Access Workspace" : "Create or Join Account"}
                              </p>
                            </div>

                            {/* MODE TOGGLE */}
                            <div className="bg-gray-100/80 p-1 rounded-[20px] flex gap-1 mb-6">
                              <button
                                onClick={() => setMode("login")}
                                className={`flex-1 py-3 rounded-[16px] text-[9px] font-black uppercase tracking-widest transition-all ${mode === "login" ? "bg-white text-indigo-600 shadow-sm" : "text-slate-400"
                                  }`}
                              >
                                Login
                              </button>
                              <button
                                onClick={() => setMode("signup")}
                                className={`flex-1 py-3 rounded-[16px] text-[9px] font-black uppercase tracking-widest transition-all ${mode === "signup" ? "bg-white text-indigo-600 shadow-sm" : "text-slate-400"
                                  }`}
                              >
                                Sign Up
                              </button>
                            </div>

                            <div className="space-y-4">
                              {mode === "signup" && (
                                <div className="animate-in fade-in slide-in-from-top-2 duration-400">
                                  <label className="text-[9px] font-black uppercase tracking-widest text-slate-400 ml-4 mb-2 block">Account Type</label>
                                  <div className="bg-gray-100/80 p-1 rounded-[20px] flex gap-1">
                                    <button type="button" onClick={() => setRegMode("create")} className={`flex-1 py-2.5 rounded-[15px] text-[9px] font-black uppercase tracking-widest transition-all ${regMode === "create" ? "bg-white text-indigo-600 shadow-sm" : "text-slate-400"}`}>Create</button>
                                    <button type="button" onClick={() => setRegMode("join")} className={`flex-1 py-2.5 rounded-[15px] text-[9px] font-black uppercase tracking-widest transition-all ${regMode === "join" ? "bg-white text-indigo-600 shadow-sm" : "text-slate-400"}`}>Join</button>
                                  </div>
                                </div>
                              )}

                              {mode === "signup" && (
                                <div className="group animate-in fade-in slide-in-from-top-2 duration-300">
                                  <label className="text-[9px] font-black uppercase tracking-widest text-slate-400 ml-4 mb-1.5 block">Full Name</label>
                                  <input type="text" placeholder="Name and Surname" value={form.name || ""} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-5 py-3.5 bg-gray-50 border border-gray-100 rounded-[20px] outline-none focus:border-slate-900 transition-all font-bold text-slate-700 text-xs" />
                                </div>
                              )}

                              <div className="relative">
                                <label className="text-[9px] font-black uppercase tracking-widest text-slate-400 ml-4 mb-1.5 block">Work Email</label>
                                <input
                                  type="email"
                                  placeholder="info@company.com"
                                  value={form.email || ""}
                                  onFocus={() => setIsFocused(true)}
                                  onBlur={() => {
                                    setIsFocused(false);
                                    setForm({ ...form, emailTouched: true });
                                  }}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setForm({ ...form, email: val });
                                  }}
                                  className={`w-full px-5 py-3.5 bg-gray-50 border rounded-[20px] outline-none transition-all font-bold text-slate-700 text-xs ${isFocused && form.email
                                    ? validateEmail(form.email)
                                      ? "border-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.1)] text-emerald-700"
                                      : "border-rose-500 shadow-[0_0_10px_rgba(244,63,94,0.1)]"
                                    : "border-gray-100 focus:border-slate-900"
                                    }`}
                                />
                              </div>

                              <div className="space-y-1.5">
                                <div className="flex justify-between items-center ml-4">
                                  <label className="text-[9px] font-black uppercase tracking-widest text-slate-400">Password</label>
                                  {mode === "login" && <button type="button" onClick={() => setShowForgotPassword(true)} className="text-[9px] font-black text-indigo-500 uppercase tracking-widest">Forgot Password?</button>}
                                </div>
                                <div className="relative">
                                  <input type={showPassword ? "text" : "password"} placeholder="••••••••" value={form.password || ""} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-5 py-3.5 bg-gray-50 border border-gray-100 rounded-[20px] outline-none focus:border-slate-900 transition-all font-bold text-slate-700 text-xs" />
                                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-indigo-500 transition-colors">
                                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                                  </button>
                                </div>

                                {mode === "signup" && form.password && (
                                  <div className="px-4 pt-2 animate-in fade-in slide-in-from-top-1 duration-500">
                                    {/* Label with dynamic color */}
                                    <div className="flex justify-between items-center mb-2">
                                      <span className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400">
                                        Security Level
                                      </span>
                                      <span className={`text-[9px] font-black uppercase tracking-widest transition-colors duration-500 ${getPasswordStrength(form.password).color.replace('bg-', 'text-')}`}>
                                        {getPasswordStrength(form.password).label}
                                      </span>
                                    </div>

                                    {/* The 5-Bar System */}
                                    <div className="flex gap-1.5 h-1.5 w-full">
                                      {[1, 2, 3, 4, 5].map((level) => {
                                        const strength = getPasswordStrength(form.password);
                                        const isFilled = level <= strength.score;

                                        return (
                                          <div
                                            key={level}
                                            className={`h-full flex-1 rounded-full transition-all duration-700 ease-out ${isFilled
                                              ? strength.color
                                              : "bg-slate-100"
                                              }`}
                                            style={{
                                              // Adding a slight glow to the active bars
                                              boxShadow: isFilled ? `0 0 12px ${strength.color.replace('bg-', 'rgba(').replace('-500', ', 0.3)')}` : 'none'
                                            }}
                                          />
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="group">
                                <label className="text-[9px] font-black uppercase tracking-widest text-slate-400 ml-4 mb-1.5 block">Workspace ID</label>
                                <input type="text" placeholder="COMPANY-ID" value={form.companyId || ""} onChange={(e) => setForm((prev) => ({ ...prev, companyId: e.target.value.toUpperCase().replace(/\s/g, "") }))} className="w-full px-5 py-3.5 bg-gray-50 border border-gray-100 rounded-[20px] outline-none focus:border-slate-900 transition-all font-bold text-slate-700 text-xs" />
                              </div>

                              {error && (
                                <div className="p-3 bg-red-50 rounded-xl border border-red-100 text-red-600 text-[10px] font-black uppercase tracking-wider flex items-center gap-2">
                                  <AlertCircle size={14} /> {error}
                                </div>
                              )}

                              <button
                                type="button"
                                onClick={(e) => { e.preventDefault(); mode === "login" ? login() : signup(); }}
                                disabled={loading}
                                className="w-full py-4 rounded-[20px] font-extrabold text-[10px] uppercase tracking-[0.2em] transition-all bg-slate-900 text-white active:scale-[0.98] disabled:opacity-50 mt-2 hover:shadow-xl hover:shadow-slate-900/10"
                              >
                                {loading ? <Loader className="animate-spin mx-auto" size={16} /> : mode === "login" ? "Enter Workspace" : "Create Account"}
                              </button>
                            </div>
                          </>
                        ) : (
                          /* --- 🛡️ MFA CHALLENGE --- */
                          <div className={`animate-in fade-in zoom-in-95 duration-700 flex flex-col items-center text-center max-w-sm mx-auto ${error ? 'animate-shake' : ''}`}>
                            {/* --- 1. ICON ASSEMBLY --- */}
                            <div className="relative mb-8">
                              <div className={`absolute inset-0 rounded-full scale-150 blur-2xl transition-colors duration-500 ${error ? 'bg-rose-500/20' : 'bg-indigo-500/20 animate-pulse'}`} />
                              <div className="relative w-20 h-20 bg-white dark:bg-slate-900 rounded-[2.5rem] flex items-center justify-center shadow-[0_20px_40px_-12px_rgba(0,0,0,0.1)] border border-slate-100 dark:border-white/5 transition-all duration-500">
                                {error ? (
                                  <ShieldAlert size={32} className="text-rose-600 dark:text-rose-500" strokeWidth={2.5} />
                                ) : (
                                  <ShieldCheck size={32} className="text-indigo-600 dark:text-indigo-400" strokeWidth={2.5} />
                                )}
                              </div>
                              {!error && <div className="absolute inset-0 border-2 border-indigo-500/30 rounded-[2.5rem] animate-[ping_2.5s_linear_infinite]" />}
                            </div>

                            {/* --- 2. TYPOGRAPHY & ERROR BADGE --- */}
                            <div className="space-y-2 mb-8">
                              <div className="flex flex-col items-center gap-3">
                                {error ? (
                                  <div className="flex items-center gap-2 px-3 py-1 mt-4 rounded-full bg-rose-50 dark:bg-rose-500/10 border border-rose-100 dark:border-rose-500/20 animate-in slide-in-from-top-2">
                                    <p className="text-[10px] font-black text-rose-600 dark:text-rose-500 uppercase tracking-[0.2em]">
                                      Invalid Security Token
                                    </p>
                                  </div>
                                ) : (

                                  <div className="flex items-center gap-2 px-3 py-1 mt-4 rounded-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/5">
                                    <p className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                                      MFA Authentication Required
                                    </p>
                                  </div>
                                )}
                                <p className="text-[11px] font-medium text-slate-500 max-w-[220px] leading-relaxed">
                                  {error ? "The code you entered is incorrect or has expired. Please try again." : "Enter the 6-digit security token generated by your authenticator app."}
                                </p>
                              </div>
                            </div>

                            {/* --- 3. INPUT & ACTIONS --- */}
                            <div className="w-full space-y-6">
                              <div className="relative group">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  autoFocus
                                  maxLength={6}
                                  value={mfaToken}
                                  onChange={(e) => {
                                    if (error) setError("");
                                    setMfaToken(e.target.value.replace(/\D/g, ""));
                                  }}
                                  /* FIX: Added 'pl-[0.5em]' to counteract the 'tracking-[0.5em]'.
                                     This balances the extra spacing on the right of the last digit,
                                     ensuring the string is mathematically centered.
                                  */
                                  className={`w-full py-6 bg-slate-50/50 dark:bg-slate-950 border-2 rounded-[2rem] text-center text-4xl font-black tracking-[0.5em] pl-[0.5em] outline-none transition-all placeholder:opacity-20 shadow-inner caret-transparent selection:bg-transparent ${error
                                    ? 'border-rose-500/50 text-rose-600 focus:ring-rose-500/10'
                                    : 'border-slate-100 dark:border-white/5 text-slate-900 dark:text-white focus:border-indigo-500 focus:ring-indigo-500/5'
                                    }`}
                                  placeholder="000000"
                                />
                                <div className="absolute inset-0 rounded-[2rem] bg-indigo-500/5 opacity-0 group-focus-within:opacity-100 pointer-events-none transition-opacity" />
                              </div>

                              <div className="space-y-3">
                                <button
                                  onClick={handleVerifyMfaLogin}
                                  disabled={loading || mfaToken.length !== 6}
                                  className={`w-full py-5 text-white rounded-2xl font-black uppercase tracking-[0.25em] text-[10px] transition-all hover:scale-[1.02] active:scale-95 disabled:opacity-30 disabled:grayscale flex items-center justify-center gap-3 ${error ? 'bg-rose-600 shadow-[0_20px_40px_-10px_rgba(225,29,72,0.3)]' : 'bg-slate-900 dark:bg-indigo-600 shadow-[0_20px_40px_-10px_rgba(79,70,229,0.3)]'
                                    }`}
                                >
                                  {loading ? (
                                    <Loader className="animate-spin" size={16} />
                                  ) : (
                                    <span className="font-bold">{error ? "Try Again" : "Enter Workspace"}</span>
                                  )}
                                </button>

                                <button
                                  onClick={() => {
                                    setShowMfaChallenge(false);
                                    setMfaToken("");
                                    setError("");
                                  }}
                                  className="w-full py-3 text-slate-400 dark:text-slate-600 hover:text-rose-500 dark:hover:text-rose-400 text-[9px] font-black uppercase tracking-[0.3em] transition-all"
                                >
                                  Cancel Request
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* PASSWORD MODAL RESET */}

                  {showForgotPassword && (
                    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
                      {/* Backdrop with heavy blur */}
                      <div
                        className="absolute inset-0 bg-slate-900/60 backdrop-blur-xl animate-in fade-in duration-500"
                        onClick={() => {
                          setShowForgotPassword(false);
                          setModeForgotPassword("FORGOT"); // Reset on close
                        }}
                      />

                      <div className="relative w-full max-w-md bg-white rounded-[2.5rem] p-10 shadow-[0_32px_64px_-12px_rgba(0,0,0,0.2)] border border-white/20 animate-in zoom-in-95 duration-300">

                        {/* 🟢 LEVEL 1-2: REQUEST LINK VIEW */}
                        {(modeForgotPassword === "FORGOT" || !modeForgotPassword) && !linkSent && (
                          <form onSubmit={handleRequestResetLink} className="space-y-6">
                            <div className="text-center mb-8">
                              <div className="w-20 h-20 bg-emerald-50 rounded-[2rem] flex items-center justify-center mx-auto mb-6 border border-emerald-100/50">
                                <div className="w-12 h-12 bg-emerald-500 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-emerald-200">
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                  </svg>
                                </div>
                              </div>
                              <h3 className="text-3xl font-black text-slate-900 tracking-tight">Forgot Password?</h3>
                              <p className="mt-[10px] text-[11px] font-black text-slate-400 tracking-[0.2em] uppercase">Please provide your work email below</p>
                            </div>

                            <div className="space-y-2">
                              <label className="text-[10px] font-black uppercase text-slate-400 ml-5 tracking-widest">Work Email</label>
                              <input
                                type="email"
                                value={recoveryEmail}
                                onChange={(e) => setRecoveryEmail(e.target.value)}
                                className="w-full px-8 py-5 bg-slate-50 border border-slate-100 rounded-[24px] outline-none focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500 transition-all font-bold text-slate-900"
                                placeholder="name@company.com" required
                              />
                            </div>

                            <button
                              type="submit"
                              disabled={loadingForgotPassword}
                              className="w-full bg-slate-900 text-white py-6 rounded-[24px] font-black text-xs uppercase tracking-[0.2em] hover:bg-emerald-600 hover:shadow-2xl hover:shadow-emerald-200 transition-all active:scale-[0.98] flex items-center justify-center gap-3 disabled:opacity-70 disabled:cursor-not-allowed"
                            >
                              {loadingForgotPassword ? (
                                <>
                                  <Loader2 className="animate-spin" size={18} />
                                  <span className="font-bold">Working on it...</span>
                                </>
                              ) : (
                                "Request Reset Link"
                              )}
                            </button>
                          </form>
                        )}

                        {/* 🟠 LEVEL 3-5: SUCCESS STATE */}
                        {modeForgotPassword === "FORGOT" && linkSent && (
                          <div className="text-center py-4 animate-in slide-in-from-bottom-4 duration-500">
                            <div className="w-24 h-24 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-8 relative">
                              <div className="absolute inset-0 rounded-full bg-orange-200 animate-ping opacity-20" />
                              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center text-white relative z-10 shadow-xl shadow-orange-200">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
                                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                              </div>
                            </div>
                            <h3 className="text-3xl font-black text-slate-900 mb-3">Link Sent!</h3>
                            <p className="text-[11px] font-black text-slate-500 uppercase tracking-[0.2em] mb-6">Head to your inbox and continue to reset your password</p>
                            <div className="bg-slate-50 rounded-3xl p-6 mb-8 border border-slate-100">
                              <p className="text-slate-500 font-bold text-xs leading-relaxed">
                                We've dispatched a secure token to <span className="text-slate-900">{recoveryEmail}</span>.
                                Valid for <span className="text-slate-900 font-black">60 minutes</span>.
                              </p>
                            </div>
                            <button onClick={() => setShowForgotPassword(false)} className="w-full bg-slate-900 text-white py-6 rounded-[24px] font-black text-xs uppercase tracking-widest transition-all">
                              Understood
                            </button>
                          </div>
                        )}

                        {/* Footer link for "Back to login" - only shows in FORGOT mode */}
                        {modeForgotPassword === "FORGOT" && (
                          <button
                            onClick={() => setShowForgotPassword(false)}
                            className="w-full mt-6 text-[10px] font-black text-slate-400 uppercase tracking-widest hover:text-slate-900 transition-colors"
                          >
                            Cancel and return to login
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                  {showPricingModal && (
                    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-md z-[999] flex items-center justify-center p-4 animate-in fade-in duration-300">
                      <div className="bg-[#F8FAFF] rounded-[2.5rem] md:rounded-[3.5rem] shadow-[0_32px_128px_-20px_rgba(0,0,0,0.3)] w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col animate-in zoom-in-95 slide-in-from-bottom-8 duration-500 border border-white/40 relative">

                        {/* Compact Header */}
                        <div className="px-6 pt-10 pb-4 text-center relative flex-shrink-0">
                          <button
                            onClick={() => setShowPricingModal(false)}
                            className="absolute top-6 right-6 h-10 w-10 flex items-center justify-center text-slate-400 hover:bg-rose-50 hover:text-rose-500 rounded-xl transition-all duration-300 group"
                          >
                            <X size={20} className="group-hover:rotate-90 transition-transform duration-300" />
                          </button>

                          <h2 className="text-[45px] tracking-tighter text-slate-900" >
                            <span className="font-bold" style={{
                              filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                            }}>Choose your</span>{" "}
                            <span className="font-bold bg-gradient-to-r from-indigo-500 to-cyan-400 bg-clip-text text-transparent px-1 drop-shadow-[0_0_8px_rgba(99,102,241,0.3)]">
                              workspace power.
                            </span>
                          </h2>
                          <div className="mt-4">
                            <div><br /><br /></div>
                            {/* --- MASTER PRICING CONTROL BAR --- */}
                            <div className="flex flex-col md:flex-row items-center gap-8 mb-12 -mt-8 bg-white/40 p-1.5 rounded-[24px] border border-white/60 shadow-[0_8px_32px_rgba(0,0,0,0.04)] backdrop-blur-md w-fit mx-auto transition-all duration-700">

                              {/* 1. Pricing Toggle Group (Monthly vs Annual) */}
                              <div className="flex items-center gap-4 px-4 py-2">
                                <span className={`text-[10px] font-black uppercase tracking-[0.15em] transition-all duration-300 ${!isYearly ? "text-slate-950 scale-105" : "text-slate-400"}`}>
                                  Monthly
                                </span>

                                <button
                                  onClick={() => setIsYearly(!isYearly)}
                                  className={`group w-14 h-7 rounded-full relative p-1 transition-all duration-500 ease-in-out shadow-inner ${isYearly ? "bg-blue-600 shadow-blue-900/20" : "bg-slate-200"}`}
                                >
                                  {/* Dynamic Glow behind the switch */}
                                  <div className={`absolute inset-0 rounded-full transition-opacity duration-500 ${isYearly ? "opacity-40 shadow-[0_0_12px_rgba(37,99,235,0.8)]" : "opacity-0"}`} />

                                  <div className={`w-5 h-5 bg-white rounded-full shadow-[0_2px_4px_rgba(0,0,0,0.2)] transition-transform duration-500 cubic-bezier(0.34, 1.56, 0.64, 1) ${isYearly ? "translate-x-7" : "translate-x-0"}`} />
                                </button>

                                <div className="flex items-center gap-2">
                                  <span className={`text-[10px] font-black uppercase tracking-[0.15em] transition-all duration-300 ${isYearly ? "text-blue-600 scale-105" : "text-slate-400"}`}>
                                    Annually
                                  </span>
                                  <span className="flex items-center justify-center text-[9px] font-black bg-blue-600 text-white px-2.5 py-0.5 rounded-full shadow-[0_4px_12px_rgba(37,99,235,0.3)] animate-pulse">
                                    SAVE 15%
                                  </span>
                                </div>
                              </div>

                              {/* Elegant Vertical Divider */}
                              <div className="hidden md:block w-[1px] h-6 bg-gradient-to-b from-transparent via-slate-200 to-transparent" />

                              {/* 2. Refined Currency Selector */}
                              <div className="relative group px-4 py-2">
                                <div className="flex items-center gap-2 cursor-pointer">
                                  <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Currency</span>
                                  <div className="relative flex items-center">
                                    <select
                                      value={currency}
                                      onChange={(e) => setCurrency(e.target.value)}
                                      className="appearance-none bg-transparent text-[11px] font-black uppercase tracking-[0.1em] text-slate-900 pl-1 pr-6 py-1 cursor-pointer focus:outline-none z-10"
                                    >
                                      <option value="ZAR">ZAR (R)</option>
                                      <option value="USD">USD ($)</option>
                                      <option value="EUR">EUR (€)</option>
                                      <option value="GBP">GBP (£)</option>
                                    </select>
                                    <ChevronDown
                                      size={12}
                                      className="absolute right-0 top-1/2 -translate-y-1/2 text-blue-600 group-hover:translate-y-[-40%] transition-transform duration-300"
                                      strokeWidth={3}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Refined Grid with Card Hover Effects */}
                        <div className="px-6 pb-10 overflow-y-auto flex-1 custom-scrollbar">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 items-start max-w-4xl mx-auto py-6">
                            {PLANS.map((plan) => {
                              // 🚩 LOGIC FIX: Use 'isYearly' to determine the price and period
                              const isFree = plan.priceMonthly === 0 || plan.id === "starter";

                              // Calculate display price based on currency and cycle
                              const formatPrice = () => {
                                if (isFree) return "Free";

                                // Get base monthly price in selected currency (assuming PLANS has these or you have a converter)
                                // For this example, we'll use a standard rate logic or your existing plan keys
                                let base = isYearly ? plan.priceYearly : plan.priceMonthly;

                                // If your DB only has ZAR, you'd apply conversion here:
                                // if(currency === "USD") base = base / 19; 

                                return `${symbols[currency]}${base.toLocaleString()}`;
                              };

                              const price = formatPrice();
                              const isPro = plan.id === "pro";
                              const isExpanded = expandedPlans[plan.id];
                              const visibleFeatures = isExpanded ? plan.features : plan.features?.slice(0, 4);

                              return (
                                <div
                                  key={plan.id}
                                  className={`group relative flex flex-col rounded-[2.5rem] transition-all duration-500 p-7 md:p-8 border-2 max-w-xs mx-auto w-full 
          ${isPro
                                      ? "bg-white shadow-[0_20px_50px_rgba(79,70,229,0.1)] border-indigo-600/20 scale-105 z-10 hover:-translate-y-2 hover:shadow-[0_30px_70px_rgba(79,70,229,0.18)]"
                                      : "bg-white/40 border-slate-200/50 hover:bg-white/80 hover:-translate-y-1 hover:shadow-2xl hover:border-slate-300/60"
                                    }`}
                                >
                                  {/* CENTERED HEADER & PRICE */}
                                  <div className="mb-6 text-center">
                                    <h3 className="text-xl font-black text-slate-900 mb-1 tracking-tight" style={{
                                      filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                    }}>
                                      {plan.name}
                                    </h3>
                                    <div className="flex items-baseline justify-center gap-1">
                                      <span className="text-3xl font-black text-slate-900 tracking-tighter" style={{
                                        filter: `drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                      }}>
                                        {price}
                                      </span>
                                      {!isFree && (
                                        <span className="text-slate-400 text-[10px] font-bold uppercase">
                                          {isYearly ? "/yr" : "/mo"}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  {/* FEATURE LIST */}
                                  <div className="flex-1 mb-6 flex flex-col items-center">
                                    <ul className="space-y-3 w-fit">
                                      {visibleFeatures?.map((feature, idx) => (
                                        <li key={idx} className="flex items-start gap-3 text-[12px] font-bold text-slate-600 leading-tight">
                                          <div className={`flex-shrink-0 w-4 h-4 rounded-full flex items-center justify-center mt-0.5 ${isPro ? "bg-indigo-600 text-white" : "bg-emerald-100 text-emerald-600"}`}>
                                            <Check size={8} strokeWidth={4} />
                                          </div>
                                          {feature}
                                        </li>
                                      ))}
                                    </ul>

                                    {plan.features?.length > 4 && (
                                      <button
                                        onClick={() => setExpandedPlans(prev => ({ ...prev, [plan.id]: !prev[plan.id] }))}
                                        className="mt-4 flex items-center gap-1.5 text-[9px] font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-700 transition-colors"
                                      >
                                        {isExpanded ? "Show Less" : `+${plan.features.length - 4} More`}
                                      </button>
                                    )}
                                  </div>

                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      // 🚩 Lock in the selection and trigger the modal
                                      setSelection({
                                        planId: plan.id,
                                        isYearly,
                                        currency
                                      });
                                      setShowConfirm(true);
                                    }}
                                    className={`w-full py-4 rounded-2xl font-bold text-[11px] uppercase tracking-[0.2em] transition-all duration-300 active:scale-95 flex items-center justify-center gap-2 group
    ${isPro
                                        ? "bg-indigo-600 text-white shadow-[0_10px_25px_-5px_rgba(79,70,229,0.4)] hover:bg-indigo-700 hover:shadow-[0_15px_30px_-5px_rgba(79,70,229,0.5)]"
                                        : "bg-slate-900 text-white hover:bg-indigo-600 shadow-lg shadow-slate-900/10"
                                      }`}
                                  >
                                    <span className="font-bold">{isFree ? "Start for Free" : "Let's Go"}</span>

                                    {/* Subtle arrow icon that slides in on hover */}
                                    <ArrowRight
                                      size={14}
                                      strokeWidth={3}
                                      className="transition-all duration-300 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0"
                                    />
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {showConfirm && selection && (
                    <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
                      {/* Deep Backdrop Blur - Increased darkness for better contrast against the pricing modal */}
                      <div
                        className="absolute inset-0 bg-slate-950/70 backdrop-blur-xl animate-in fade-in duration-500"
                        onClick={() => setShowConfirm(false)}
                      />

                      {/* Modal Container */}
                      <div className="relative w-full max-w-[380px] bg-white dark:bg-slate-900 rounded-[40px] shadow-[0_32px_128px_-20px_rgba(0,0,0,0.5)] border border-white dark:border-white/5 overflow-hidden animate-in zoom-in-95 duration-300">

                        {/* Premium Accent Header */}
                        <div className="h-2 w-full bg-gradient-to-r from-indigo-500 via-purple-500 to-cyan-400" />

                        <div className="p-10">
                          {/* Animated Icon Header */}
                          <div className="mb-8 flex justify-center">
                            <div className="relative">
                              <div className="absolute inset-0 bg-indigo-500/20 rounded-3xl blur-xl animate-pulse" />
                              <div className="relative w-16 h-16 bg-white dark:bg-slate-800 rounded-3xl shadow-xl flex items-center justify-center border border-slate-100 dark:border-white/5">
                                <Zap size={32} className="text-indigo-600 fill-indigo-600/10" strokeWidth={2.5} />
                              </div>
                            </div>
                          </div>

                          <div className="text-center mb-10">
                            <h3 className="text-2xl font-black text-slate-900 dark:text-white mb-3 tracking-tight">
                              Finalise Setup
                            </h3>
                            <p className="text-slate-500 dark:text-slate-400 text-[13px] font-medium leading-relaxed px-2">
                              You're about to activate the following configuration for your workspace:
                            </p>
                          </div>

                          {/* Selection Summary Card */}
                          <div className="bg-slate-50 dark:bg-white/[0.03] rounded-3xl p-5 border border-slate-100 dark:border-white/5 mb-8">
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Selected Plan</span>
                              <span className="text-[10px] font-black uppercase tracking-widest text-indigo-600 bg-indigo-50 dark:bg-indigo-500/10 px-2 py-0.5 rounded-lg">
                                {selection.planId}
                              </span>
                            </div>
                            <div className="flex items-center justify-between">
                              <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Billing Cycle</span>
                              <span className="text-[11px] font-bold text-slate-900 dark:text-slate-200">
                                {selection.isYearly ? "Annually" : "Monthly"}
                              </span>
                            </div>
                          </div>

                          {/* Action Stack */}
                          <div className="flex flex-col gap-3">
                            <button
                              onClick={() => {
                                finalizeSignup(selection.planId, selection.isYearly, selection.currency);
                                setShowConfirm(false);
                                setShowPricingModal(false);
                              }}
                              className="group relative w-full py-5 bg-indigo-600 text-white rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] shadow-[0_20px_40px_-10px_rgba(79,70,229,0.4)] hover:bg-indigo-700 hover:shadow-[0_25px_50px_-12px_rgba(79,70,229,0.5)] active:scale-[0.97] transition-all duration-300"
                            >
                              Confirm & Activate
                            </button>

                            <button
                              onClick={() => setShowConfirm(false)}
                              className="w-full py-3 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 font-bold text-[10px] uppercase tracking-widest transition-colors duration-200"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>

                        {/* Subtle Bottom Branding */}
                        <div className="py-5 bg-slate-50/50 dark:bg-white/[0.02] border-t border-slate-100 dark:border-white/5 text-center">
                          <p className="text-[9px] font-black text-slate-300 dark:text-slate-600 uppercase tracking-[0.3em]">
                            Secure Infrastructure Powered by QuoPro
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* THE BULLETPROOF BUBBLE */}
                  {saveStatus.show && (
                    <div
                      style={{ zIndex: 999999 }}
                      className="fixed bottom-12 left-0 right-0 flex justify-center pointer-events-none animate-in fade-in slide-in-from-bottom-4 duration-300"
                    >
                      <div className="bg-slate-900 text-white px-6 py-3 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.4)] border border-emerald-500/50 flex items-center gap-3 pointer-events-auto">
                        <div className="flex items-center justify-center w-5 h-5 bg-emerald-500 rounded-full">
                          <Check size={12} className="text-white stroke-[4]" />
                        </div>
                        <span className="text-[10px] font-black uppercase tracking-[0.2em]">
                          {saveStatus.message}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
            }
          </div >
        )}
      </div >
    );

  const exportToCSV = () => {
    const details = matrixData;
    if (details.length === 0) return alert("No items to export");

    const rows = details.map((i) => [
      `"${i.ref}"`,
      `"${i.desc}"`,
      i.qty || 0,
      `"${i.supplierName || "N/A"}"`,
      (Number(i.price) || 0).toFixed(2), // Force to number
      i.days || 0,
      ((Number(i.price) || 0) * (Number(i.qty) || 0)).toFixed(2), // Force to number
    ]);

    const headers = [
      "Reference",
      "Description",
      "Quantity",
      "Winner",
      "Unit Price",
      "Lead Time",
      "Line Total",
    ];

    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Optimal_Procurement_${new Date().toISOString().split("T")[0]
      }.csv`;
    link.click();
  };

  const handleLogout = async () => {
    // 1. Trigger the visual overlay immediately
    setIsLoggingOut(true);

    try {
      // 2. Clear local session data
      localStorage.removeItem("userEmail");
      localStorage.removeItem("companyId");

      // 3. Reset the Master State (Important for security)
      setProjects([]);
      setSups([]);
      setActivities([]);
      setUser(null);

      // 4. Brief delay so the user sees the "Securing Data" state
      await new Promise((resolve) => setTimeout(resolve, 1200));

      // 5. Hard redirect to the login gate
      setShowWebsite(false);
    } catch (err) {
      console.error("Logout error:", err);
      // If it fails, we still want them out
      window.location.reload();
    }
  };



  const selectLocked = isStatusUpdating || currentProjectData?.status === "Pending Approval";

  const selectClassName = `w-full lg:w-72 px-6 py-4 bg-white dark:bg-slate-900 border-2 rounded-2xl font-black text-[10px] uppercase tracking-[0.2em] outline-none appearance-none transition-all shadow-sm ${selectLocked
    ? "border-slate-100 dark:border-white/5 text-slate-400 cursor-not-allowed opacity-60"
    : "border-slate-100 dark:border-white/5 text-slate-900 dark:text-white cursor-pointer hover:border-indigo-400"
    }`;

  const handleLeadTimeChange = (supId, itemRef, newValue) => {
    setSups((prev) =>
      prev.map((s) => {
        if (s.sid === supId) {
          return {
            ...s,
            quotes: {
              ...s.quotes,
              [itemRef]: { ...(s.quotes[itemRef] || {}), days: newValue },
            },
          };
        }
        return s;
      })
    );
  };

  const handleExportSuppliers = () => {
    // 1. Cleaned Headers: Only ID, Name, BEE Level, Number, and Email
    const headers = [
      "ID",
      "Supplier Name",
      "BEE Level",
      "Contact Number",
      "Email Address",
    ];

    // 2. Map data - Removed Category and Contact Person
    const rows = supList.map((sup) => [
      sup.id,
      `"${sup.name || ""}"`,
      sup.beeLevel || "N/A",
      // Prefixing with ' ensures Excel doesn't strip the leading zero from phone numbers
      `'${sup.contactNumber || sup.phone || ""}`,
      sup.email || "",
    ]);

    // 3. Join headers and rows
    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");

    // 4. Download Trigger
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `Suppliers_List_${new Date().toISOString().split("T")[0]}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const validateDate = (dateString) => {
    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    if (!regex.test(dateString)) return false;

    const [_, d, m, y] = dateString.match(regex);
    const day = parseInt(d, 10);
    const month = parseInt(m, 10);
    const year = parseInt(y, 10);

    if (month < 1 || month > 12) return false;

    // Checks actual days in that month (e.g., Feb 29)
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) return false;

    const inputDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return inputDate >= today;
  };

  //START
  // --- 🚩 THE LOCK LOGIC ---
  const planKey = user?.plan?.toLowerCase() || "";
  const isPaidTier = planKey === "pro" || planKey === "businessplus";
  // Handle boolean false or string "false"
  const subIsInactive = workspace?.subscriptionActive === false || workspace?.subscriptionActive === "false";

  const shouldShowLock = isAuth && isPaidTier && subIsInactive;

  //MAIN APP WILL LOAD HERE
  return (
    <>
      {(!appReady || !renderingReady) && (
        <QuoProLoader progress={loadProgress} />
      )}
      {shouldShowLock && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 overflow-hidden">
          {/* Backdrop - Complete barrier */}
          <div className="absolute inset-0 bg-slate-950/95 backdrop-blur-2xl animate-in fade-in duration-500" />

          <div className="relative w-full max-w-md bg-white dark:bg-slate-900 rounded-[40px] shadow-2xl border border-slate-200 dark:border-white/5 overflow-hidden animate-in zoom-in-95 duration-500">

            {/* Level 8 Urgency: Red Header Bar */}
            <div className="h-2.5 w-full bg-rose-500" />

            <div className="p-10 text-center">
              <div className="mb-6 flex justify-center text-rose-500">
                <ShieldAlert size={56} strokeWidth={2.5} className="animate-pulse" />
              </div>

              <h3 className="text-2xl font-black text-slate-900 dark:text-white mb-2 tracking-tight">
                Workspace Inactive
              </h3>

              <p className="text-slate-500 dark:text-slate-400 text-[15px] leading-relaxed mb-10 font-medium px-4">
                The workspace <span className="font-bold text-slate-900 dark:text-white">{user?.companyId}</span> requires activation. Finalise your <span className="uppercase font-black text-rose-500">{user?.plan}</span> plan to continue.
              </p>

              {/* VARIANT UPDATE */}
              <div className="flex flex-col gap-3">
                <button
                  onClick={async () => {
                    const checkoutMap = {
                      pro: {
                        monthly: "https://quopro.lemonsqueezy.com/buy/d44434e9-e250-4985-b603-393bb6bb97a0",
                        annually: "https://quopro.lemonsqueezy.com/buy/da329224-382c-41c9-9212-22b387440071",
                      },
                      businessPlus: {
                        monthly: "https://quopro.lemonsqueezy.com/buy/34df84b4-1b89-44fe-a452-e9cd741d3647",
                        annually: "https://quopro.lemonsqueezy.com/buy/b4502404-db50-4d32-846a-bc480d6550c7",
                      },
                    };

                    const planId = user?.plan || "pro";
                    const cycle = user?.billingCycle === "annually" ? "annually" : "monthly";
                    const checkoutUrl = checkoutMap[planId]?.[cycle];

                    if (!checkoutUrl) {
                      console.error("Missing checkout URL for:", planId, cycle);
                      return;
                    }

                    // --- 🚩 NEW: UPDATE WORKSPACE IN BACKEND BEFORE REDIRECT ---
                    try {
                      console.log("🔄 Synchronizing workspace status before checkout...");
                      const syncResponse = await fetch(`${BACKEND_URL}/api/workspace/${user?.companyId}/update-status`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                          subscriptionActive: false, // Remains false until webhook confirms payment
                          subscriptionStatus: "pending_payment",
                          nextBillDate: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(), // Default placeholder
                        }),
                      });

                      if (!syncResponse.ok) throw new Error("Failed to update workspace status");
                      console.log("✅ Workspace status pre-set to pending.");
                    } catch (err) {
                      // We log the error but don't stop the user from paying
                      console.error("⚠️ Workspace sync failed, but proceeding to checkout:", err);
                    }
                    // --- 🏁 END SYNC ---

                    const params = new URLSearchParams({
                      "checkout[email]": user?.email || "",
                      "checkout[name]": user?.name || "",
                      "checkout[custom][companyId]": user?.companyId || "",
                      "checkout[custom][plan]": planId,
                      "checkout[custom][billingCycle]": cycle,
                      "checkout[billing_address][country]": "ZA",
                      "embed": "1",
                    });

                    const finalCheckoutUrl = `${checkoutUrl}?${params.toString()}`;

                    if (
                      window.LemonSqueezy &&
                      window.LemonSqueezy.Url &&
                      typeof window.LemonSqueezy.Url.Open === "function"
                    ) {
                      window.LemonSqueezy.Url.Open(finalCheckoutUrl);
                    } else {
                      window.location.href = finalCheckoutUrl;
                    }
                  }}
                  className="w-full bg-rose-600 hover:bg-rose-700 text-white font-black py-6 rounded-2xl shadow-xl shadow-rose-600/20 transition-all active:scale-[0.98] flex items-center justify-center gap-3 text-[11px] uppercase tracking-widest"
                >
                  Activate Now
                </button>
                <button
                  onClick={async () => {
                    // 1. Guard rail: If the URL is already present in state, use it instantly
                    if (user?.subscription?.updateUrl) {
                      window.open(user.subscription.updateUrl, "_blank");
                      return;
                    }

                    // 2. Fallback: Fetch live from backend if undefined
                    try {
                      const API_BASE = "https://quopro-backend.onrender.com";
                      const response = await axios.post(`${API_BASE}/api/payments/portal-link`, {
                        companyId: user?.companyId
                      });

                      // 🟢 FIXED: Check all variations of response properties dynamically
                      const targetUrl = response.data?.portalUrl || response.data?.portalLink || response.data?.url;

                      if (targetUrl) {
                        window.open(targetUrl, "_blank");
                      } else {
                        alert("Billing system link could not be generated. Please contact support.");
                      }
                    } catch (err) {
                    }
                  }}
                  className="w-full bg-slate-900 hover:bg-[#FFC233] text-white hover:text-slate-950 dark:bg-white dark:hover:bg-[#FFC233] dark:text-slate-900 dark:hover:text-slate-950 py-5 rounded-2xl font-black text-[11px] uppercase tracking-[0.15em] transition-all duration-300 shadow-xl shadow-slate-950/10 dark:shadow-none active:scale-[0.97] flex items-center justify-center gap-2"
                >
                  Go to Billing Portal
                  <ArrowUpRight size={16} strokeWidth={3} />
                </button>

                <button
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/login";
                  }}
                  className="w-full py-4 text-slate-400 font-bold text-[10px] uppercase tracking-[0.2em] hover:text-slate-600 transition-colors"
                >
                  Sign Out & Exit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {view === "dashboard" ? (
        <div className="min-h-screen dark:bg-slate-950 bg-gray-100 p-4 md:p-6 relative font-sans text-gray-900 overflow-x-hidden">
          <div className="max-w-7xl mx-auto">
            {/* Top Navbar */}
            <div className="sticky top-0 z-[100] bg-white/95 dark:bg-slate-950 backdrop-blur-2xl rounded-3xl p-4 mb-6 flex justify-between items-center border border-slate-200/50 dark:border-white/5 shadow-[0_20px_50px_rgba(0,0,0,0.05)] transition-all duration-700">
              {/* 🚩 SUBTLE MESH GLOW: Tightened opacity for that high-end 'hint' of color */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(99,102,241,0.03),transparent_80%)] dark:bg-[radial-gradient(circle_at_50%_50%,rgba(99,102,241,0.08),transparent_80%)] pointer-events-none" />

              {/* 🚩 THE RAZOR EDGE: The signature thin architectural line highlight */}
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/10 dark:via-indigo-400/25 to-transparent" />

              {/* CONTENT LAYER */}
              <div className="relative z-[100] flex w-full justify-between items-center">

                <div className="flex items-center gap-2 group">

                  {/* The Logo with group-hover animation applied to the container */}
                  <div className="w-10 h-10 flex items-center justify-center transition-all duration-500 ease-out group-hover:scale-110 group-hover:drop-shadow-[0_15px_30px_rgba(79,70,229,0.5)]">
                    <img
                      src="/logo.png"
                      alt="QuoPro Logo"
                      className="w-full h-full object-contain transition-transform duration-500 ease-out group-hover:rotate-12"
                    />
                  </div>



                  {/* The "QuoPro" text button */}
                  <button
                    className="block text-left"
                    onClick={() => {
                      setView("dashboard");
                      setTab("main");
                    }}
                  >
                    <h1 className="text-[40px] font-bold md:text-[26px] flex items-center dark:text-white tracking-tighter text-slate-900 transition-all duration-300" >
                      Quo
                      <span className="font-bold bg-gradient-to-r from-indigo-600 to-cyan-300 dark:from-indigo-400 dark:to-cyan-400 bg-clip-text text-transparent pr-1 transition-all duration-500 drop-shadow-[0_0_8px_rgba(34,211,238,0.4)]">
                        Pro
                      </span>
                    </h1>
                  </button>
                </div>

                <div className="flex items-center gap-4">
                  <div className="hidden md:flex flex-col items-end relative pr-4 transition-all">
                    {/* Label */}
                    <span className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] leading-tight">
                      Logged in as:
                    </span>

                    {/* Name */}
                    <span className="font-black text-slate-700 dark:text-slate-100 text-sm tracking-tight">
                      {user?.name}
                    </span>
                  </div>

                  <div className="flex items-center gap-1.5 p-1.5 bg-slate-50/50 dark:bg-transparent border border-slate-100 dark:border-white/10 rounded-[22px]">
                    {/* SETTINGS */}
                    <button
                      onClick={() => setShowSettingsModal(true)}
                      className="p-2.5 bg-white dark:bg-slate-900 border border-slate-100 dark:border-white/5 rounded-2xl text-slate-400 dark:text-slate-500 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-indigo-50/50 dark:hover:bg-indigo-500/10 hover:shadow-sm dark:hover:shadow-[0_0_15px_rgba(99,102,241,0.2)] transition-all duration-300 relative group"
                      title="Manage QuoPro Settings"
                    >
                      <Settings
                        size={20}
                        className="group-hover:rotate-90 transition-transform duration-500"
                      />
                    </button>

                    {/* FINANCE / WALLET */}
                    <button
                      onClick={() => {
                        if (isBusinessPlus) {
                          setView("finance");
                        } else {
                          setShowPricingModal(true);
                        }
                      }}
                      className={`p-2.5 bg-white dark:bg-slate-900 border rounded-2xl transition-all duration-300 relative group ${isBusinessPlus
                        ? "border-slate-100 dark:border-white/5 text-slate-400 dark:text-slate-500 hover:text-emerald-600 dark:hover:text-emerald-400  dark:hover:bg-emerald-500/10 hover:shadow-sm dark:hover:shadow-[0_0_15px_rgba(16,185,129,0.2)]"
                        : "border-slate-100 dark:border-white/5 text-slate-400 dark:text-slate-500 hover:text-amber-500 dark:hover:text-amber-400 dark:hover:bg-amber-500/10 hover:shadow-sm dark:hover:shadow-[0_0_15px_rgba(245,158,11,0.2)]"
                        }`}
                      title={isBusinessPlus ? "Manage QuoPro Invoices" : "Unlock Invoicing (BusinessPlus+ Feature)"}
                    >
                      <div className="relative w-5 h-5 flex items-center justify-center">
                        {/* The standard receipt icon handles the normal rotation on hover for owners, */}
                        {/* but fades out completely on hover if they are a lower tier */}
                        <Receipt
                          size={20}
                          className={`absolute transition-all duration-300 ${isBusinessPlus
                            ? "group-hover:rotate-12 group-hover:scale-110 dark:text-slate-500 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-emerald-50/50 dark:hover:bg-emerald-500/10 hover:shadow-sm"
                            : "group-hover:opacity-0 group-hover:scale-50 dark:text-slate-500 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-emerald-50/50 dark:hover:bg-emerald-500/10 hover:shadow-sm"
                            }`}
                        />

                        {/* The lock icon is invisible by default and scales into view ONLY on hover when not BusinessPlus */}
                        {!isBusinessPlus && (
                          <span className="absolute text-xl opacity-0 scale-50 transition-all duration-300 group-hover:opacity-100 group-hover:scale-110">
                            🔒
                          </span>
                        )}
                      </div>
                    </button>

                    {/* WORKFLOW BUTTON */}
                    <button
                      onClick={() => {
                        if (isPremium) {
                          setShowWorkflowModal(true);
                        } else {
                          setShowPricingModal(true);
                        }
                      }}
                      title={isPremium ? "View Workflow Manager" : "Unlock Workflow Manager (Premium Feature)"}
                      className={`relative p-2.5 bg-white dark:bg-slate-900 border rounded-2xl transition-all duration-300 group ${isPremium
                        ? "border-slate-100 dark:border-white/5 text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50/50 dark:hover:bg-amber-500/10 hover:shadow-sm hover:shadow-[0_0_15px_rgba(99,102,241,0.2)]" // 🌟 YOUR EXACT ORIGINAL STYLING PRESERVED
                        : "border-slate-100 dark:border-white/5 text-slate-400 dark:text-slate-500 hover:text-amber-500 dark:hover:text-amber-400 dark:hover:bg-amber-500/10 hover:shadow-sm hover:shadow-[0_0_15px_rgba(245,158,11,0.2)]"
                        }`}
                    >
                      <div className="relative w-5 h-5 flex items-center justify-center">
                        {/* Standard list icon rotates normally on hover for premium tiers, */}
                        {/* but shrinks and scales away out of view on hover for starter users */}
                        <ClipboardList
                          size={20}
                          className={`absolute transition-all duration-300 ${isPremium
                            ? "group-hover:rotate-12 group-hover:scale-110"
                            : "group-hover:opacity-0 group-hover:scale-50"
                            }`}
                        />

                        {/* The lock icon scales smoothly into the center of the canvas on hover if not premium */}
                        {!isPremium && (
                          <span className="absolute text-xl opacity-0 scale-50 transition-all duration-300 group-hover:opacity-100 group-hover:scale-110">
                            🔒
                          </span>
                        )}
                      </div>

                      {/* Show the pending notification count badge ONLY if they have premium access to workflows */}
                      {isPremium && workflowStats.pending.length > 0 && (
                        <span className="absolute -top-1.5 -right-1.5 flex h-[18px] w-[18px] z-30">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                          <span className="relative min-w-[18px] h-[18px] px-1 bg-rose-600 rounded-full border-2 border-white dark:border-slate-900 shadow-sm flex items-center justify-center">
                            <span className="text-[9px] font-black text-white leading-none">
                              {workflowStats.pending.length > 99 ? "99+" : workflowStats.pending.length}
                            </span>
                          </span>
                        </span>
                      )}
                    </button>

                    {/* NOTIFICATIONS BUTTON */}
                    <button
                      onClick={() => setShowNotifs(!showNotifs)}
                      title="View Notifications"
                      className="relative p-2.5 bg-white dark:bg-slate-900 border border-slate-100 dark:border-white/5 rounded-2xl text-slate-400 dark:text-slate-500 hover:text-rose-600 dark:hover:text-rose-400 hover:bg-rose-50/50 dark:hover:bg-emerald-500/10 hover:shadow-sm dark:hover:shadow-[0_0_15px_rgba(16,185,129,0.2)] transition-all duration-300 group"
                    >
                      <Bell
                        size={20}
                        className="transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110"
                      />
                      {notifications.length > 0 && (
                        < span className="absolute -top-1.5 -right-1.5 flex h-[18px] w-[18px] z-30">
                          {/* Subtle outer pulse to show active syncing */}
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>

                          <span className="relative min-w-[18px] h-[18px] px-1 bg-rose-600 rounded-full border-2 border-white dark:border-slate-900 shadow-sm flex items-center justify-center">
                            <span className="text-[9px] font-black text-white leading-none">
                              {notifications.length > 99
                                ? "99+"
                                : notifications.length}
                            </span>
                          </span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Context Bar */}
            {/* 🚩 MAIN COCKPIT CONTAINER */}
            <div className="group bg-white dark:bg-slate-950 p-8 rounded-[40px] shadow-[0_32px_64px_-12px_rgba(0,0,0,0.08)] dark:shadow-[0_32px_64px_-12px_rgba(0,0,0,0.6)] border border-slate-100 dark:border-white/5 relative transition-all duration-500 mb-12">
              {/* 🚩 DEPTH LAYER: Consistent Mesh Glow */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_50%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.1),transparent_50%)] pointer-events-none" />
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

              <div className="relative flex flex-col gap-8">
                <div className="flex flex-col lg:flex-row gap-6 items-center">
                  {/* WRAPPER FOR SELECTOR & TOOLS */}
                  <div className="w-full flex flex-col lg:flex-row items-center gap-4 bg-slate-50/50 dark:bg-white/[0.02] p-3 rounded-[32px] border border-slate-100 dark:border-white/5 shadow-inner">
                    {/* LEFT SECTION: Project Selector */}
                    <div className="flex-1 w-full flex items-center gap-3">
                      <div className="flex-1 relative" ref={dropdownRef}>
                        <button
                          type="button"
                          onClick={() => {
                            setIsDropdownOpen(!isDropdownOpen);
                            setProjectSearch("");
                          }}
                          className={`
                w-full flex items-center justify-between pl-14 pr-6 py-4 
                bg-white dark:bg-slate-900 border-2 transition-all duration-500 rounded-2xl outline-none
                ${isDropdownOpen
                              ? "border-indigo-500 shadow-[0_10px_40px_-10px_rgba(99,102,241,0.4)] scale-[1.01]"
                              : "border-slate-100 dark:border-white/5 shadow-sm hover:border-indigo-400 dark:hover:border-indigo-500/50"
                            }
              `}
                        >
                          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-indigo-600 rounded-xl shadow-lg shadow-indigo-200 dark:shadow-indigo-900/40">
                            <FolderOpen size={18} className="text-white" />
                          </div>

                          <span
                            className={`font-black text-sm truncate ${currentProject
                              ? "text-slate-900 dark:text-white"
                              : "text-slate-400"
                              }`}
                          >
                            {currentProject
                              ? projects.find(
                                (p) => String(p.id) === String(currentProject)
                              )?.name
                              : "Select a Project..."}
                          </span>

                          <ChevronDown
                            size={20}
                            className={`text-indigo-500 transition-transform duration-500 ${isDropdownOpen ? "rotate-180" : ""
                              }`}
                          />
                        </button>

                        {/* THE FLOATING MENU */}
                        {isDropdownOpen && (
                          <div
                            className="absolute top-[115%] left-0 w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-white/10 rounded-[24px] shadow-2xl z-[9999] animate-in fade-in slide-in-from-top-4 duration-300 overflow-hidden"
                          /* 🚩 Added overflow-hidden back ONLY to the parent to clip the sharp edges of the inner list */
                          >
                            {/* Search Header */}
                            <div className="px-4 pt-4 pb-3 border-b border-slate-100 dark:border-white/5">
                              <div className="relative">
                                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} />
                                <input
                                  autoFocus
                                  type="text"
                                  placeholder="Search projects..."
                                  value={projectSearchQuery}
                                  onChange={(e) => setProjectSearchQuery(e.target.value)}
                                  className="w-full pl-9 pr-4 py-2 bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 rounded-xl text-xs font-bold text-slate-900 dark:text-white outline-none focus:outline-none focus:border-transparent focus:ring-2 focus:ring-indigo-500/20 transition-all shadow-none"
                                />
                              </div>
                            </div>

                            {/* 🛡️ Scrollable Project List */}
                            <div
                              className="max-h-[188px] overflow-y-auto overflow-x-hidden custom-scrollbar overscroll-contain pr-1.5"
                            >
                              {filteredAndSortedProjects.map((p, index) => {
                                const isPending = p.status?.toLowerCase() === "pending approval";
                                const isSelected = String(currentProject?.id || currentProject) === String(p.id);

                                return (
                                  <button
                                    key={p.id}
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      switchProject(p.id);
                                      setIsDropdownOpen(false);
                                    }}
                                    className={`w-full text-left px-5 py-3.5 text-[11px] font-black tracking-widest transition-all flex items-center justify-between group 
              ${isSelected
                                        ? "bg-indigo-600 text-white"
                                        : "text-slate-900 dark:text-slate-400 hover:bg-indigo-50 dark:hover:bg-white/5 hover:pl-7"
                                      }`}
                                  >
                                    <span className="truncate pr-3 text-[12px] font-black">{p.name}</span>

                                    {isPending && (
                                      <div className="flex items-center gap-2 shrink-0">
                                        {!isSelected && (
                                          <span className="text-[10px] text-rose-500 font-bold uppercase tracking-tighter">
                                            Pending Approval
                                          </span>
                                        )}
                                        <Clock
                                          size={16}
                                          className={`${isSelected ? "text-indigo-200" : "text-rose-500"} animate-pulse`}
                                        />
                                      </div>
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* ACTION TOOLBELT */}
                      <div className="flex items-center gap-1.5 bg-white dark:bg-slate-900 p-1.5 rounded-2xl border border-slate-100 dark:border-white/5 shadow-sm">
                        <button
                          onClick={() => setShowProjectModal(true)}
                          className="relative bg-indigo-600 text-white p-3 rounded-xl transition-all shadow-lg shadow-indigo-200 dark:shadow-none hover:bg-indigo-700 hover:scale-105 active:scale-95"
                          title="Add New Project"
                        >
                          <Plus
                            size={18}
                            className="w-5 h-5 text-white"
                            strokeWidth={3}
                          />
                        </button>

                        <button
                          onClick={() => {
                            const projectData = projects?.find(
                              (p) => String(p.id) === String(currentProject)
                            );
                            if (projectData) {
                              setSelectedProject(projectData);
                              setEditName(projectData.name || "");
                              setEditBudget(projectData.budget || 0);
                              setShowProjectInfo(true);
                            }
                          }}
                          // 🟢 GUARD: Lock button if array is completely empty OR if the lookup yields nothing
                          disabled={
                            !projects ||
                            projects.length === 0 ||
                            !projects.some((p) => String(p.id) === String(currentProject))
                          }
                          className={`p-3 rounded-xl transition-all group ${(!projects || projects.length === 0 || !projects.some((p) => String(p.id) === String(currentProject)))
                            ? "text-slate-300 dark:text-slate-700 opacity-40 cursor-not-allowed" // Disabled look
                            : "text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 hover:shadow-[0_0_15px_rgba(99,102,241,0.3)] dark:hover:shadow-[0_0_20px_rgba(99,102,241,0.2)]" // Active Indigo look
                            }`}
                          title={
                            (!projects || projects.length === 0 || !projects.some((p) => String(p.id) === String(currentProject)))
                              ? "No project selected"
                              : "View Project Info"
                          }
                        >
                          <Info
                            size={18}
                            strokeWidth={2.5}
                            className={`transition-transform duration-300 ${(!projects || projects.length === 0 || !projects.some((p) => String(p.id) === String(currentProject)))
                              ? ""
                              : "group-hover:scale-110"
                              }`}
                          />
                        </button>

                        <button
                          onClick={() => {
                            // 🟢 Same evaluation logic: find the actual matching project record first
                            const projectData = projects?.find(
                              (p) => String(p.id) === String(currentProject)
                            );
                            if (projectData) {
                              triggerDelete(projectData);
                            }
                          }}
                          // 🟢 Guard: Lock button if array is completely empty OR if the lookup yields nothing
                          disabled={
                            !projects ||
                            projects.length === 0 ||
                            !projects.some((p) => String(p.id) === String(currentProject))
                          }
                          className={`p-3 rounded-xl transition-all group ${(!projects || projects.length === 0 || !projects.some((p) => String(p.id) === String(currentProject)))
                            ? "text-slate-300 dark:text-slate-700 opacity-40 cursor-not-allowed" // Disabled look
                            : "text-slate-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-500/10 hover:shadow-[0_0_15px_rgba(225,29,72,0.3)] dark:hover:shadow-[0_0_20px_rgba(225,29,72,0.2)]" // Active look
                            }`}
                          title={
                            (!projects || projects.length === 0 || !projects.some((p) => String(p.id) === String(currentProject)))
                              ? "No project selected"
                              : "Delete Project"
                          }
                        >
                          <Trash2
                            size={18}
                            strokeWidth={2.5}
                            className={`transition-transform duration-300 ${(!projects || projects.length === 0 || !projects.some((p) => String(p.id) === String(currentProject)))
                              ? ""
                              : "group-hover:scale-110"
                              }`}
                          />
                        </button>
                      </div>
                    </div>

                    {/* VISUAL DIVIDER */}
                    <div className="hidden lg:block w-px h-10 bg-slate-200 dark:bg-white/10 mx-2" />

                    {/* RIGHT SECTION: Status Workflow */}
                    <div className="flex items-center gap-4 w-full lg:w-auto">
                      {/* Status Badge */}
                      <div
                        className={`lg:w-56 justify-center px-6 py-4 rounded-2xl border-2 font-black text-[10px] uppercase tracking-[0.2em] flex items-center gap-3 transition-all duration-500 shadow-lg ${getStatusStyles(
                          currentProjectData?.status
                        )}`}
                      >
                        <div className="relative flex items-center justify-center">
                          <div className="absolute inset-0 bg-current opacity-20 blur-lg rounded-full" />
                          <Clock size={16} className="relative z-10" />
                        </div>
                        {currentProjectData?.status || "Draft"}
                      </div>

                      {/* Status Switcher */}
                      <div className="relative flex-1 lg:flex-none">
                        <select
                          disabled={selectLocked}
                          value={currentProjectData?.status}
                          onChange={(e) => updateProjectStatus(e.target.value)}
                          className={selectClassName}
                        >
                          {STATUS_OPTIONS.map((s) => (
                            <option
                              key={s}
                              value={s}
                              className="bg-white dark:bg-slate-900 text-slate-900 dark:text-white"
                            >
                              {s}
                            </option>
                          ))}
                        </select>

                        <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none">
                          {isStatusUpdating ? (
                            <RefreshCw className="animate-spin text-indigo-500" size={14} />
                          ) : (
                            /* Only show the chevron if it's NOT locked */
                            !selectLocked && (
                              <ChevronDown className="text-slate-400" size={14} />
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PROGRESS BAR COMPONENT */}
                <div className="px-2">
                  <StatusProgress currentStatus={currentProjectData?.status} />
                </div>
              </div>

              {/* DECORATIVE GLOWS */}
              <div className="absolute -top-24 -left-24 w-48 h-48 bg-indigo-500/5 dark:bg-indigo-600/10 rounded-full blur-[80px] pointer-events-none" />
              <div className="absolute -bottom-12 -right-12 w-40 h-40 bg-indigo-500/5 dark:bg-indigo-500/10 rounded-full blur-[60px] pointer-events-none opacity-50" />
            </div>

            {/* Modern Segmented Navigation Tabs */}
            <div
              className="
                flex flex-wrap lg:flex-nowrap gap-2 mb-12 p-1.5 
                bg-white/60 dark:bg-slate-900/60 backdrop-blur-md
                rounded-[28px] transition-all duration-500
                
                /* 1. LIGHT MODE DEPTH: Subtle outer border + Inner shadow track */
                border border-slate-200/50 
                shadow-[inset_0_2px_4px_rgba(0,0,0,0.03),0_1px_2px_rgba(0,0,0,0.02)]
                
                /* 2. DARK MODE DEPTH: Deep track effect with high-end glows */
                dark:border-slate-800/50 
                dark:shadow-[inset_0_4px_12px_rgba(0,0,0,0.6),0_10px_30px_rgba(0,0,0,0.4)]
                dark:ring-1 dark:ring-slate-950/50
                dark:border-t-slate-700/20
              "
            >
              {NAVIGATION_TABS.map((t) => (
                <NavButton
                  key={t.id}
                  t={t}
                  isActive={tab === t.id}
                  onClick={onTabClick}
                />
              ))}
            </div>

            {/* Dynamic Content Views */}
            <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
              {tab === "main" &&
                /* Only enter this block if we are on the 'main' tab */
                (!quote || quote.length === 0 ? (
                  /* SCENARIO A: Main Tab is active AND Quote is empty */
                  <div className="w-full py-24 px-8 bg-white dark:bg-slate-950 rounded-[40px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] flex flex-col items-center text-center relative overflow-hidden group">
                    {isImporting && (
                      <div className="absolute inset-0 z-[100] flex flex-col items-center justify-center bg-white/60 dark:bg-slate-800 backdrop-blur-md rounded-[40px] animate-in fade-in duration-300">
                        <div className="relative">
                          {/* Outer Pulse Rings */}
                          <div className="relative bg-white dark:bg-slate-800 p-6 rounded-full shadow-2xl">
                            <Loader
                              className="text-emerald-500 animate-spin"
                              size={40}
                            />
                          </div>
                        </div>

                        <div className="mt-6 text-center">
                          <h4 className="text-lg font-black text-slate-800 dark:text-white tracking-tighter">
                            Processing Data
                          </h4>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-[10px] font-black uppercase tracking-[0.2em] text-emerald-600/70">
                              Syncing with Cloud
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className="absolute inset-0 opacity-[0.03] pointer-events-none"
                      style={{
                        backgroundImage: `radial-gradient(#10b981 1px, transparent 1px)`,
                        backgroundSize: "24px 24px",
                      }}
                    />

                    <div className="relative z-10 max-w-md">
                      <div className="relative w-24 h-24 mb-8 mx-auto">
                        <div className="absolute inset-0 bg-emerald-500/10 rounded-full blur-3xl scale-125 group-hover:bg-emerald-500/20 transition-all duration-500" />
                        <div className="relative w-full h-full bg-white dark:bg-slate-800 rounded-[2.2rem] shadow-sm flex items-center justify-center transition-all duration-500 group-hover:-translate-y-2 group-hover:rotate-0 -rotate-2">
                          <div className="relative">
                            <PackageSearch
                              size={36}
                              className="text-emerald-500"
                            />
                            <span className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full shadow-sm" />
                          </div>
                        </div>
                      </div>
                      <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tighter">
                        <span className="font-black" style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}>Project is{" "}</span>
                        <span className="inline-block drop-shadow-[0_0_15px_rgba(16,185,129,0.35)]">
  <span className="font-black bg-gradient-to-r from-emerald-500 to-teal-400 bg-clip-text text-transparent px-0.5 py-0.5">
    empty
  </span>
</span>
                      </h3>

                      <p className="text-slate-500 dark:text-slate-400 text-base leading-relaxed mb-10 px-6 max-w-md mx-auto">
                        Your procurement journey starts here.<br /> <span className="font-bold">Add</span> your first{" "}
                        Project item or <span className="font-bold">import</span> a list to begin building your requirements for
                        quotations.
                      </p>
                      <div className="flex flex-col items-center gap-4">
                        {/* The Main Action Button */}
                        <button
                          type="button"
                          disabled={!canEditProject()}
                          className={`relative inline-flex items-center gap-3 px-8 py-3.5 rounded-full transition-all group/btn 
    ${!canEditProject()
                              ? "bg-gray-300 text-gray-500 cursor-not-allowed opacity-70"
                              : "bg-emerald-600 text-white hover:bg-emerald-700 hover:shadow-lg shadow-emerald-100 cursor-pointer"
                            }`}
                        >
                          <input
                            type="file"
                            disabled={!canEditProject()}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
                            onChange={(e) => canEditProject() && upload(e, "main")}
                            accept=".csv,.xlsx,.xls"
                          />
                          <Plus size={18} className={!canEditProject() ? "" : "group-hover:rotate-90"} />
                          <span className="text-sm font-bold uppercase tracking-tight">
                            {!canEditProject() && currentProject ? "Import Project Items (Locked)" : "Import Project Items"}
                          </span>
                        </button>

                        <button
                          onClick={() => canEditProject() && addItem()}
                          disabled={!canEditProject()}
                          className={`relative inline-flex items-center gap-3 px-8 py-3.5 rounded-full transition-all group/btn 
    ${!canEditProject()
                              ? "bg-gray-300 text-gray-500 cursor-not-allowed opacity-70"
                              : "bg-emerald-600 text-white hover:bg-emerald-700 hover:shadow-lg shadow-emerald-100 cursor-pointer"
                            }`}
                        >
                          <Plus size={18} className={!canEditProject() ? "" : "group-hover:rotate-90"} />
                          <span className="text-sm font-bold uppercase tracking-tight">
                            {!canEditProject() ? "Add Item (Locked)" : "Add Item"}
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />
                  </div>
                ) : (
                  /* SCENARIO B: Main Tab is active AND Quote has items */
                  <div className="bg-white dark:bg-slate-950 rounded-3xl shadow-sm overflow-visible">
                    {/* 2. Adjusted sticky top. 
      If it's sliding "under" the header too much, increase this number. 
      If it's stopping too early, decrease it. TOETS
  */}
                    <div className="bg-white dark:bg-slate-950 rounded-3xl shadow-sm overflow-visible border border-slate-200/50 dark:border-white/5 border border-slate-200/50 dark:border-white/5">
                      <div className="sticky top-[90px] z-30 p-6 bg-white/95 dark:bg-slate-950 backdrop-blur-xl flex justify-between items-center rounded-t-3xl shadow-sm">
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_65%_0%,rgba(99,102,241,0.05),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />{" "}
                        <div>
                          <div className="flex items-center gap-3">
                            <h3 className="text-lg font-black text-gray-800 dark:text-white" style={{
                              filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                            }}>
                              Project Items
                            </h3>
                            <span className="px-2.5 py-0.5 bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 rounded-full text-[10px] font-black tracking-tighter border border-slate-200/50 dark:border-white/10">
                              {quote?.length || 0}
                            </span>
                          </div>
                          {/* Added mt-1.5 for that perfect 'smidge' of space */}
                          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mt-1.5">
                            Manage project requirements
                          </p>
                        </div>
                        <div className="flex items-center justify-between gap-6">
                          {/* Search Bar - flex-1 allows it to grow/shrink while buttons stay fixed */}
                          <div className="relative group flex-1 max-w-md">
                            {/* 1. Subtle Outer Glow on Focus */}
                            <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-[1.25rem] opacity-0 group-focus-within:opacity-20 blur transition duration-500" />

                            <div className="relative flex items-center">
                              {/* 2. The Search Icon with active color shift */}
                              <Search
                                className="absolute left-4 text-slate-400 group-focus-within:text-indigo-500 group-focus-within:scale-110 transition-all duration-300 z-10 pointer-events-none"
                                size={18}
                                strokeWidth={2.5}
                              />

                              {/* 3. The Main Input */}
                              <input
                                type="text"
                                placeholder="Search Item..."
                                value={searchBuffer}
                                onChange={(e) =>
                                  setSearchBuffer(e.target.value)
                                }
                                className="w-full pl-12 pr-12 py-3.5 
                 bg-white/80 dark:bg-slate-900/50 
                 backdrop-blur-xl
                 text-slate-900 dark:text-slate-100
                 placeholder:text-slate-400 dark:placeholder:text-slate-500
                 border border-slate-200/60 dark:border-white/10 
                 rounded-[1.1rem] 
                 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_4px_6px_-2px_rgba(0,0,0,0.05)]
                 outline-none 
                 focus:ring-0
                 group-hover:border-slate-300 dark:group-hover:border-white/20
                 group-focus-within:border-indigo-500/50 dark:group-focus-within:border-indigo-400/50
                 transition-all duration-300 font-bold text-[13px]"
                              />
                            </div>
                          </div>

                          {/* Button Group - flex-shrink-0 ensures buttons never squish */}
                          <div className="flex items-center gap-2 flex-shrink-0">
                            <button
                              onClick={addItem}
                              className="h-[46px] px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all flex items-center gap-2 group shadow-sm
             /* LIGHT MODE: High-Contrast Indigo */
             bg-indigo-600 text-white 
             hover:bg-indigo-700 hover:shadow-indigo-500/10
             
             /* DARK MODE: Transparent Indigo Glass */
             dark:bg-indigo-500/10 dark:border dark:border-indigo-500/20 dark:text-indigo-400
             dark:hover:bg-indigo-500/20 dark:hover:border-indigo-500/40"
                            >
                              <Plus
                                size={18}
                                strokeWidth={2.5}
                                className="group-hover:rotate-90 transition-transform duration-300"
                              />
                              <span className="font-bold">Item</span>
                            </button>
                            <button
                              onClick={async () => {
                                setIsSavingAll(true);
                                try {
                                  await saveAllItems();
                                } catch (error) {
                                  console.error("Save failed", error);
                                } finally {
                                  setIsSavingAll(false);
                                }
                              }}
                              disabled={isSavingAll}
                              className={`h-[46px] px-5 py-3 rounded-2xl font-bold text-sm flex items-center gap-2 whitespace-nowrap transition-all shadow-sm group
    ${isSavingAll
                                  ? "bg-slate-100 dark:bg-white/5 text-slate-400 cursor-not-allowed"
                                  : `bg-emerald-500 hover:bg-emerald-600 text-white shadow-emerald-500/10
         /* DARK MODE: Transparent Emerald Glass */
         dark:bg-emerald-500/10 dark:border dark:border-emerald-500/20 dark:text-emerald-400
         dark:hover:bg-emerald-500/20 dark:hover:border-emerald-500/40`
                                }`}
                            >
                              {isSavingAll ? (
                                <Loader2
                                  size={18}
                                  strokeWidth={2.5}
                                  className="animate-spin"
                                />
                              ) : (
                                <Save
                                  size={18}
                                  strokeWidth={2.5}
                                  className="group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"
                                />
                              )}
                              <span className="font-bold">
                                {isSavingAll ? "Saving..." : "Save All"}
                              </span>
                            </button>
                            <button
                              onClick={() => setShowClearConfirmProject(true)}
                              className="h-[46px] px-4 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all flex items-center gap-2 group shadow-sm
             /* LIGHT MODE: Clean White & Red */
             bg-white border border-red-100 text-red-500 
             hover:bg-red-50 hover:border-red-200 
             
             /* DARK MODE: Transparent Stealth Red */
             dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400
             dark:hover:bg-red-500/20 dark:hover:border-red-500/40"
                            >
                              <Trash2
                                size={16}
                                className="group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"
                              />
                              <span className="font-bold">Clear All</span>
                            </button>
                            {/* --- IMPORT BUTTON --- */}
                            <label
                              className="h-[46px] cursor-pointer flex items-center gap-2 px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all shadow-sm group
                 /* LIGHT MODE: Crisp White & Indigo Accent */
                 bg-white border border-slate-200 text-slate-600 
                 hover:bg-slate-50 hover:border-indigo-200 hover:text-indigo-600
                 
                 /* DARK MODE: Technical Slate Glass */
                 dark:bg-white/5 dark:border-white/10 dark:text-slate-400
                 dark:hover:bg-indigo-500/10 dark:hover:border-indigo-500/30 dark:hover:text-indigo-400"
                            >
                              <UploadCloud
                                size={18}
                                className="group-hover:-translate-y-1 transition-transform duration-300 stroke-[2.5]"
                              />
                              <span className="font-bold">Import</span>
                              <input
                                type="file"
                                className="hidden"
                                onChange={(e) => upload(e, "main")}
                                accept=".csv,.xlsx,.xls"
                              />
                            </label>

                            {/* --- EXPORT BUTTON --- */}
                            <button
                              onClick={handleExportItems}
                              className="h-[46px] flex items-center gap-2 px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all shadow-sm group
             /* LIGHT MODE: Crisp White & Emerald Accent */
             bg-white border border-slate-200 text-slate-600 
             hover:bg-slate-50 hover:border-emerald-200 hover:text-emerald-600
             
             /* DARK MODE: Technical Slate Glass */
             dark:bg-white/5 dark:border-white/10 dark:text-slate-400
             dark:hover:bg-emerald-500/10 dark:hover:border-emerald-500/30 dark:hover:text-emerald-400"
                            >
                              <DownloadCloud
                                size={18}
                                className="group-hover:translate-y-1 transition-transform duration-300 stroke-[2.5]"
                              />
                              <span className="font-bold">Export</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="overflow-x-auto dark:bg-slate-950">
                        <table className="w-full table-fixed min-w-[1000px] border-separate border-spacing-0 dark:bg-slate-950">
                          <thead>
                            <tr className="bg-slate-50/80 dark:bg-slate-950 backdrop-blur-md border border-slate-200/40 dark:border-white/[0.03] ring-1 ring-inset ring-slate-200/20 dark:ring-white/[0.01]">
                              <th className="w-[15%] px-6 py-5 text-left">
                                <span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
                                  Reference
                                </span>
                              </th>
                              <th className="w-[55%] px-6 py-5 text-left">
                                <span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
                                  Description
                                </span>
                              </th>
                              <th className="w-[10%] px-6 py-5 text-center">
                                <span className="flex justify-center items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
                                  Qty
                                </span>
                              </th>
                              <th className="w-[10%] px-6 py-5 text-center">
                                <span className="flex justify-center items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
                                  Unit
                                </span>
                              </th>
                              <th className="w-[10%] px-6 py-5 text-center">
                                <span className="flex justify-center items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
                                  Actions
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white dark:bg-slate-950 divide-y divide-slate-100 dark:divide-slate-800/50 border border-slate-200/50 dark:border-white/5">
                            {filteredItems.map((item) => (
                              <ProjectItemsRow
                                key={item.id}
                                item={item}
                                onSave={saveItem}
                                onRemove={removeItem}
                                onUpdateGlobal={handleUpdateGlobal}
                                setItemToDelete={setItemToDelete}
                              />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}
              <button
                onClick={() => setIsOpen(true)}
                className={`fixed right-0 top-1/2 -translate-y-1/2 z-[200] flex items-center dark:bg-slate-900 dark:text-slate-200 bg-white text-slate-900 p-2.5 rounded-l-2xl shadow-2xl border-l border-t border-b border-slate-200 dark:border-slate-800 transition-all duration-300 ease-out hover:bg-white dark:hover:bg-slate-900 active:scale-100 origin-right group ${isOpen ? 'translate-x-full opacity-0' : 'translate-x-0 opacity-100'
                  }`}
                aria-label="Open support panel"
              >
                {/* Icon stays anchored */}
                <HelpCircle size={18} className="text-indigo-500 dark:text-slate-400 animate-pulse flex-shrink-0" />

                {/* 🚀 BULLETPROOF CSS SLIDE-OUT ENGINE */}
                <span className="text-[10px] text-slate-900 dark:text-slate-200 font-black uppercase tracking-widest [writing-mode:vertical-lr] rotate-180 md:[writing-mode:horizontal-tb] md:rotate-0 transition-all duration-300 ease-in-out max-w-0 opacity-0 overflow-hidden whitespace-nowrap group-hover:max-w-[60px] group-hover:opacity-100 group-hover:ml-3">
                  Support
                </span>
              </button>

              {/* 📥 2. BACKDROP BLUR SHIELD */}
              {isOpen && (
                <div
                  onClick={() => setIsOpen(false)}
                  className="fixed inset-0 bg-slate-900/20 backdrop-blur-sm z-[250] animate-in fade-in duration-300"
                />
              )}

              {/* 🗄️ 3. SLIDE-OUT DRAWER CONTAINER */}
              <div
                className={`fixed top-0 right-0 h-screen w-full sm:max-w-md bg-white dark:bg-slate-900 border-l border-slate-100 dark:border-slate-800 shadow-[0_0_50px_-12px_rgba(15,23,42,0.15)] dark:shadow-[0_0_50px_-12px_rgba(0,0,0,0.5)] z-[300] transition-transform duration-500 ease-out transform flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'
                  }`}
              >
                {/* DRAWER HEADER */}
                <div className="p-6 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between bg-slate-50/50 dark:bg-slate-900/50 backdrop-blur-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-950/40 text-indigo-600 dark:text-indigo-400 flex items-center justify-center shadow-sm border border-indigo-100/50 dark:border-indigo-900/30">
                      <MessageSquare size={18} />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold tracking-tight text-slate-900 dark:text-slate-100">Log Support Ticket</h3>
                      <p className="text-[11px] text-slate-400 dark:text-slate-500 font-medium">Direct Desk: support@quopromanager.co.za</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setIsOpen(false)}
                    className="p-2 rounded-xl text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-700 dark:hover:text-slate-300 transition-all active:scale-95"
                  >
                    <X size={16} />
                  </button>
                </div>

                {/* DRAWER CONTENT / FORM */}
                <div className="flex-1 p-6 overflow-y-auto custom-scrollbar bg-white dark:bg-slate-900">
                  {status === 'success' ? (
                    <div className="h-full flex flex-col items-center justify-center text-center space-y-4 animate-in fade-in zoom-in-95 duration-300">
                      <div className="w-14 h-14 rounded-full bg-emerald-50 dark:bg-emerald-950/30 text-emerald-500 dark:text-emerald-400 flex items-center justify-center shadow-sm border border-emerald-100 dark:border-emerald-900/20">
                        <CheckCircle2 size={28} />
                      </div>
                      <div className="space-y-1">
                        <h4 className="text-base font-bold text-slate-900 dark:text-slate-100">Ticket Dispatched!</h4>
                        <p className="text-xs text-slate-500 dark:text-slate-400 max-w-xs mx-auto leading-relaxed">
                          The team has been notified. Check your inbox shortly for confirmation.
                        </p>
                      </div>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmitSupportTicket} className="space-y-5">
                      {/* STATUS INDICATOR CARD */}
                      {status === 'error' && (
                        <div className="p-4 bg-rose-50 dark:bg-rose-950/20 border border-rose-100 dark:border-rose-900/30 rounded-xl flex items-start gap-3 text-rose-700 dark:text-rose-400 animate-shake">
                          <AlertCircle size={16} className="mt-0.5 flex-shrink-0" />
                          <p className="text-xs font-medium leading-relaxed">
                            Transmission failed. Please verify your connection or reach out directly via mail.
                          </p>
                        </div>
                      )}

                      {/* NAME FIELD */}
                      <div className="space-y-1.5">
                        <label className="text-[11px] font-semibold text-slate-500 dark:text-slate-400 tracking-wide block">Full Name</label>
                        <input
                          type="text"
                          name="name"
                          required
                          value={formState.name}
                          onChange={handleChangeSupportTicket}
                          placeholder="e.g. John Doe"
                          className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-600 focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-500/5 transition-all"
                        />
                      </div>

                      {/* EMAIL FIELD */}
                      <div className="space-y-1.5">
                        <label className="text-[11px] font-semibold text-slate-500 dark:text-slate-400 tracking-wide block">Work Email Address</label>
                        <input
                          type="email"
                          name="email"
                          required
                          value={formState.email}
                          onChange={handleChangeSupportTicket}
                          placeholder="john@company.co.za"
                          className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-600 focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-500/5 transition-all"
                        />
                      </div>

                      {/* SUBJECT SELECT */}
                      <div className="space-y-1.5">
                        <label className="text-[11px] font-semibold text-slate-500 dark:text-slate-400 tracking-wide block">Issue Classification</label>
                        <div className="relative">
                          <select
                            name="subject"
                            value={formState.subject}
                            onChange={handleChangeSupportTicket}
                            className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-500/5 transition-all appearance-none"
                          >
                            <option value="System Issue">System Issue / Bug Report</option>
                            <option value="Calculation / ROI Discrepancy">Calculation Error</option>
                            <option value="Account & Licensing">Account & Licensing</option>
                            <option value="Feature Request">Feature Request</option>
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-slate-400 dark:text-slate-500">
                            {/* Optional Chevron icon helper if available, otherwise native padding handles safety */}
                          </div>
                        </div>
                      </div>

                      {/* DETAILED MESSAGE */}
                      <div className="space-y-1.5">
                        <label className="text-[11px] font-semibold text-slate-500 dark:text-slate-400 tracking-wide block">Problem Description</label>
                        <textarea
                          name="message"
                          required
                          rows={4}
                          value={formState.message}
                          onChange={handleChangeSupportTicket}
                          placeholder="Provide explicit context (e.g., error codes, steps to reproduce)..."
                          className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-600 focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-500/5 transition-all resize-none"
                        />
                      </div>

                      {/* SUBMISSION FOOTER ACTION BUTTON */}
                      <button
                        type="submit"
                        disabled={status === 'submitting'}
                        className="w-full py-3 mt-4 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 dark:bg-indigo-500 dark:hover:bg-indigo-600 text-white font-semibold text-xs tracking-wider uppercase rounded-xl transition-all shadow-md shadow-indigo-600/10 hover:shadow-indigo-600/20 active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50 disabled:pointer-events-none"
                      >
                        {status === 'submitting' ? (
                          <>
                            <Loader2 size={14} className="animate-spin" />
                            Dispatching...
                          </>
                        ) : (
                          <>
                            <Send size={14} />
                            Send Ticket
                          </>
                        )}
                      </button>
                    </form>
                  )}
                </div>
              </div>
              {tab === "mgmt" && (
                <div className="space-y-6">
                  {supList.length === 0 ? (
                    /* SCENARIO A: Global Empty State */
                    <div className="w-full py-24 px-8 bg-white dark:bg-slate-950 rounded-[40px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] flex flex-col items-center text-center relative overflow-hidden group">
                      <div
                        className="absolute inset-0 opacity-[0.03] pointer-events-none"
                        style={{
                          backgroundImage: `radial-gradient(#4f46e5 1px, transparent 1px)`,
                          backgroundSize: "24px 24px",
                        }}
                      />

                      <div className="relative z-10 max-w-md">
                        <div className="relative w-24 h-24 mb-8 mx-auto">
                          <div className="absolute inset-0 bg-indigo-500/10 rounded-full blur-3xl scale-125 group-hover:bg-indigo-500/20 transition-all duration-500" />
                          <div className="relative w-full h-full bg-white dark:bg-slate-800 rounded-[2.2rem] shadow-sm shadow-sm flex items-center justify-center transition-all duration-500 group-hover:-translate-y-2 group-hover:rotate-0 -rotate-2">
                            <div className="relative">
                              <Users size={36} className="text-indigo-600" />
                              <span className="absolute -top-1 -right-1 w-4 h-4 bg-indigo-500 rounded-full shadow-sm" />
                            </div>
                          </div>
                        </div>
                        <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tighter">  
                        <span className="font-black" style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}>
                          Supplier Network is{" "}</span>
                          <span className="font-black bg-gradient-to-r from-indigo-500 to-blue-400 bg-clip-text text-transparent drop-shadow-[0_0_15px_rgba(99,102,241,0.4)] px-0.5">
  empty
</span>
                        </h3>

                        <p className="text-slate-500 dark:text-slate-400 text-base leading-relaxed mb-10 px-6 max-w-md mx-auto">
                          Build your procurement network. Add your trusted{" "}
                          <span className="font-bold">Suppliers</span> manually or{" "}
                          <span className="font-bold">import</span> your database to begin.
                        </p>
                        <div className="flex flex-col items-center gap-4">
                          <label className="relative inline-flex items-center gap-3 bg-indigo-600 text-white px-8 py-3.5 rounded-full hover:bg-indigo-700 hover:shadow-lg shadow-indigo-100 transition-all cursor-pointer group/btn">
                            <input
                              type="file"
                              title=""
                              className="hidden"
                              accept=".csv,.xlsx,.xls"
                              onChange={handleImportSuppliers}
                            />

                            <Plus
                              size={18}
                              className="group-hover:rotate-90 transition-transform duration-300"
                            />
                            <span className="text-sm font-bold uppercase tracking-tight">
                              Import Suppliers
                            </span>
                          </label>
                          <button
                            onClick={handleAddNewClick}
                            className="relative inline-flex items-center gap-3 bg-indigo-600 text-white px-8 py-3.5 rounded-full hover:bg-indigo-700 hover:shadow-lg shadow-indigo-100 transition-all cursor-pointer group/btn"
                          >
                            <Plus
                              size={18}
                              className="group-hover:rotate-90 transition-transform duration-300"
                            />
                            <span className="text-sm font-bold uppercase tracking-tight">
                              Add Supplier
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />
                    </div>
                  ) : (
                    /* SCENARIO B & C: Supplier List Wrapper */
                    <div className="bg-white dark:bg-slate-950 rounded-3xl shadow-sm overflow-visible border border-slate-200/50 dark:border-white/5">
                      <div className="sticky top-[75px] z-30 p-6 bg-white/95 dark:bg-slate-950 backdrop-blur-xl flex justify-between items-center rounded-t-3xl shadow-sm">
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.05),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />{" "}
                        <div>
                          <div className="flex items-center gap-3">
                            <h3 className="text-lg font-black text-gray-800 dark:text-white" style={{
                              filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                            }}>
                              Supplier Network
                            </h3>
                            <span className="px-2.5 py-0.5 bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 rounded-full text-[10px] font-black tracking-tighter border border-slate-200/50 dark:border-white/10">
                              {supList?.length || 0}
                            </span>
                          </div>
                          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mt-1.5">
                            Manage Supplier Network
                          </p>
                        </div>
                        <div className="flex items-center justify-between gap-6">
                          <div className="relative group flex-1 max-w-md">
                            <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-sky-600 rounded-[1.25rem] opacity-0 group-focus-within:opacity-20 blur transition duration-500" />
                            <div className="relative flex items-center">
                              <Search
                                className="absolute left-4 text-slate-400 group-focus-within:text-indigo-500 group-focus-within:scale-110 transition-all duration-300 z-10 pointer-events-none"
                                size={18}
                                strokeWidth={2.5}
                              />
                              <input
                                type="text"
                                placeholder="Search Supplier..."
                                value={supSearchQuery}
                                onChange={(e) => setSupSearchQuery(e.target.value)}
                                className="w-full pl-12 pr-12 py-3.5 bg-white/80 dark:bg-slate-900/50 backdrop-blur-xl text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 border border-slate-200/60 dark:border-white/10 rounded-[1.1rem] shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_4px_6px_-2px_rgba(0,0,0,0.05)] outline-none focus:ring-0 group-hover:border-slate-300 dark:group-hover:border-white/20 group-focus-within:border-indigo-500/50 dark:group-focus-within:border-indigo-400/50 transition-all duration-300 font-bold text-[13px]"
                              />
                            </div>
                          </div>

                          <div className="flex items-center gap-2 flex-shrink-0">
                            <div className="flex bg-slate-100 dark:bg-slate-800/50 p-1 rounded-2xl border border-slate-200/50 dark:border-slate-700/50">
                              <button
                                onClick={() => setViewMode("grid")}
                                className={`p-2.5 rounded-xl transition-all ${viewMode === "grid"
                                  ? "bg-white dark:bg-slate-700 shadow-sm text-indigo-600 dark:text-indigo-400"
                                  : "text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                                  }`}
                              >
                                <LayoutGrid size={20} />
                              </button>
                              <button
                                onClick={() => setViewMode("list")}
                                className={`p-2.5 rounded-xl transition-all ${viewMode === "list"
                                  ? "bg-white dark:bg-slate-700 shadow-sm text-indigo-600 dark:text-indigo-400"
                                  : "text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                                  }`}
                              >
                                <List size={20} />
                              </button>
                            </div>

                            <button
                              onClick={async () => {
                                setIsAddingSup(true);
                                handleAddNewClick();
                                setIsAddingSup(false);
                              }}
                              disabled={(user.plan !== "businessPlus" && remaining <= 0) || isAddingSup}
                              className="h-[46px] px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all flex items-center gap-3 group shadow-sm disabled:opacity-50 disabled:cursor-not-allowed bg-indigo-600 text-white hover:bg-indigo-700 dark:bg-indigo-500/10 dark:border dark:border-indigo-500/20 dark:text-indigo-400 dark:hover:bg-indigo-500/20 dark:hover:border-indigo-500/40"
                            >
                              <div className="flex items-center gap-2">
                                {isAddingSup ? (
                                  <Loader2 size={18} strokeWidth={2.5} className="animate-spin" />
                                ) : (
                                  <Plus size={18} strokeWidth={2.5} className="group-hover:rotate-90 transition-transform duration-300" />
                                )}
                                <span className="font-bold">{isAddingSup ? "Adding..." : "Supplier"}</span>
                              </div>
                              {!isAddingSup && (
                                <div className={`px-2 py-0.5 rounded-lg text-[10px] font-black border transition-all duration-300 ${user.plan !== "businessPlus" && remaining <= 0 ? "bg-slate-200 dark:bg-slate-800 border-transparent text-slate-500" : "bg-white/20 dark:bg-indigo-500/20 border-white/30 dark:border-indigo-400/30 text-white dark:text-indigo-300"}`}>
                                  {user.plan === "businessPlus" ? "∞" : `${supList.length} / ${SUPPLIER_LIMITS[user.plan]}`}
                                </div>
                              )}
                            </button>

                            <label className="h-[46px] cursor-pointer flex items-center gap-2 px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all shadow-sm group bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 hover:border-indigo-200 hover:text-indigo-600 dark:bg-white/5 dark:border-white/10 dark:text-slate-400 dark:hover:bg-indigo-500/10 dark:hover:border-indigo-500/30 dark:hover:text-indigo-400">
                              <UploadCloud size={18} className="group-hover:-translate-y-1 transition-transform duration-300 stroke-[2.5]" />
                              <span className="font-bold">Import</span>
                              <input type="file" className="hidden" accept=".csv,.xlsx,.xls" onChange={handleImportSuppliers} />
                            </label>

                            <button
                              onClick={handleExportSuppliers}
                              className="h-[46px] flex items-center gap-2 px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all shadow-sm group bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 hover:border-emerald-200 hover:text-emerald-600 dark:bg-white/5 dark:border-white/10 dark:text-slate-400 dark:hover:bg-emerald-500/10 dark:hover:border-emerald-500/30 dark:hover:text-emerald-400"
                            >
                              <DownloadCloud size={18} className="group-hover:translate-y-1 transition-transform duration-300 stroke-[2.5]" />
                              <span className="font-bold">Export</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="overflow-x-auto dark:bg-slate-950">
                        {filteredSuppliers.length === 0 ? (
                          /* SCENARIO C: Search Empty State */
                          <div className="py-32 flex flex-col items-center justify-center text-center">
                            <div className="relative mb-6">
                              <div className="absolute inset-0 bg-indigo-500/10 rounded-full blur-2xl scale-150" />
                              <div className="relative w-20 h-20 bg-slate-50 dark:bg-slate-900 rounded-3xl flex items-center justify-center border border-slate-100 dark:border-white/5">
                                <Search size={40} className="text-slate-300 dark:text-slate-600" />
                              </div>
                            </div>
                            <h3 className="text-2xl font-black text-slate-900 dark:text-white tracking-tighter mb-2">
                              No matches for <span className="font-bold text-indigo-600">"{supSearchQuery}"</span>
                            </h3>
                            <p className="text-slate-500 dark:text-slate-400 text-sm font-medium max-w-xs mx-auto">
                              Double check the spelling or try searching for a different supplier name or email address.
                            </p>
                            <button
                              onClick={() => setSupSearchQuery('')}
                              className="mt-8 px-6 py-2.5 bg-slate-900 dark:bg-white text-white dark:text-black rounded-xl text-xs font-black uppercase tracking-widest hover:scale-105 transition-all"
                            >
                              Clear Search
                            </button>
                          </div>
                        ) : viewMode === "list" ? (
                          <table className="w-full table-fixed min-w-[1000px] border-separate border-spacing-0 dark:bg-slate-950">
                            <thead>
                              <tr className="bg-slate-50/80 dark:bg-slate-950 backdrop-blur-md border-b border-slate-200 dark:border-slate-700">
                                <th className="w-[22%] px-6 py-5 text-left"><span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Supplier Name</span></th>
                                <th className="w-[23%] px-6 py-5 text-left"><span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Email Address</span></th>
                                <th className="w-[17%] px-6 py-5 text-left"><span className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Phone Number</span></th>
                                <th className="w-[15%] px-6 py-5 text-center"><span className="flex justify-center items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Compliance</span></th>
                                <th className="w-[10%] px-6 py-5 text-center"><span className="flex justify-center items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Actions</span></th>
                              </tr>
                            </thead>
                            <tbody className="bg-white dark:bg-slate-950 divide-y divide-slate-100 dark:divide-slate-800/50">
                              {memoSuppliers.map((s) => (
                                <SupplierRow
                                  key={s.id}
                                  s={s}
                                  onSave={saveSingleSupplier}
                                  onDelete={delSup}
                                  onUpdate={handleUpdateSupplierGlobal}
                                  setSupplierToDelete={setSupplierToDelete}
                                  setSelectedSupForStats={setSelectedSupForStats}
                                  setActiveSup={setActiveSup}
                                  setIsViewOnly={setIsViewOnly}
                                  setIsSupModalOpen={setIsSupModalOpen}
                                />
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 bg-gray-50/30 dark:bg-slate-950">
                            {filteredSuppliers.map((s) => (
                              <div key={s.id} className="bg-white dark:bg-slate-950 backdrop-blur-xl p-6 rounded-[32px] border border-gray-100 dark:border-white/5 shadow-sm hover:shadow-lg hover:shadow-indigo-500/5 transition-all duration-300 group relative overflow-hidden">
                                <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />
                                <div className="absolute top-0 right-0 w-24 h-24 bg-indigo-500/5 blur-[40px] pointer-events-none" />
                                <div className="flex justify-between items-start mb-6">
                                  <div className="relative">
                                    <div className="w-12 h-12 bg-indigo-50 dark:bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-600 dark:text-indigo-400 shadow-inner">
                                      <Building2 size={24} />
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <button onClick={() => handleViewClick(s.id)} className="p-2 text-slate-300 dark:text-slate-500 hover:text-amber-500 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-500/10 rounded-xl transition-all">
                                      <Eye size={18} />
                                    </button>
                                    <button onClick={() => delSup(s.id)} className="p-2 text-slate-300 dark:text-slate-500 hover:text-red-500 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-xl transition-all">
                                      <Trash2 size={18} />
                                    </button>
                                  </div>
                                </div>
                                <div className="relative flex items-center mb-1">
                                  <input type="text" value={s.name} readOnly className="w-full pr-8 bg-transparent font-black text-lg text-slate-800 dark:text-slate-100 outline-none" placeholder="Supplier Name" />
                                </div>
                                <p className={`text-[10px] font-black uppercase tracking-[0.2em] mb-4 ${!s.beeLevel || s.beeLevel.includes("Non") ? "text-rose-500" : "text-indigo-500 dark:text-indigo-400"}`}>
                                  {s.beeLevel || "Non-Compliant"}
                                </p>
                                <div className="space-y-3 border-t border-slate-50 dark:border-white/5 pt-5">
                                  <div className="flex items-center gap-3 text-slate-400 dark:text-slate-500 group/input relative">
                                    <div className="p-1.5 bg-slate-50 dark:bg-slate-800/50 rounded-lg"><Mail size={12} /></div>
                                    <input value={s.email} readOnly className="text-xs font-bold outline-none bg-transparent w-full pr-8 text-slate-600 dark:text-slate-300" placeholder="Email" />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {tab === "quotes" && (
                <div className="space-y-8">
                  {/* Header Controls: Only show if there are supplier quotes to manage */}
                  {sups && sups.length > 0 && (
                    <div className="flex flex-col md:flex-row justify-between items-center bg-white/50 dark:bg-slate-950 backdrop-blur-xl p-6 rounded-[32px] shadow-sm animate-in fade-in duration-500 gap-6 border border-slate-200/50 dark:border-white/5">
                      {/* Header Text Section */}
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.05),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

                      <div>
                        <div className="flex items-center gap-2">
                          <h3 className="text-lg font-black text-gray-800 dark:text-white" style={{
                            filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                          }}>
                            Supplier Quotes
                          </h3>
                          <span className="px-2.5 py-0.5 bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 rounded-full text-[10px] font-black tracking-tighter border border-slate-200/50 dark:border-white/10">
                            {sups?.length || 0}
                          </span>
                        </div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mt-1">
                          Enter pricing and delivery lead times per vendor
                        </p>
                      </div>

                      <div className="flex items-center gap-4 flex-shrink-0">
                        {/* View Toggle (Grid/List) */}
                        <div className="flex bg-slate-100 dark:bg-slate-800/50 p-1 rounded-2xl border border-slate-200/50 dark:border-slate-700/50">
                          <button
                            onClick={() => setQuoteView("grid")}
                            className={`p-2.5 rounded-xl transition-all ${quoteView === "grid"
                              ? "bg-white dark:bg-slate-700 shadow-sm text-indigo-600 dark:text-indigo-400"
                              : "text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                              }`}
                          >
                            <LayoutGrid size={20} />
                          </button>
                          <button
                            onClick={() => setQuoteView("list")}
                            className={`p-2.5 rounded-xl transition-all ${quoteView === "list"
                              ? "bg-white dark:bg-slate-700 shadow-sm text-indigo-600 dark:text-indigo-400"
                              : "text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                              }`}
                          >
                            <List size={20} />
                          </button>
                        </div>

                        {/* Primary Action Button */}
                        <button
                          onClick={addQuote}
                          className="h-[46px] px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all flex items-center gap-2 group shadow-sm disabled:opacity-50 disabled:cursor-not-allowed
             /* LIGHT MODE: High-Contrast Indigo */
             bg-indigo-600 text-white hover:bg-indigo-700
             
             /* DARK MODE: Transparent Indigo Glass */
             dark:bg-indigo-500/10 dark:border dark:border-indigo-500/20 dark:text-indigo-400
             dark:hover:bg-indigo-500/20 dark:hover:border-indigo-500/40"
                        >
                          <Plus
                            size={18}
                            strokeWidth={2.5}
                            className="group-hover:rotate-90 transition-transform duration-300"
                          />
                          <span className="font-bold">Supplier Quote</span>
                        </button>
                        <button
                          onClick={handleExportSupplierQuotes}
                          className="h-[46px] flex items-center gap-2 px-5 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all shadow-sm group active:scale-95
             bg-white border border-slate-200 text-slate-600 
             hover:bg-slate-50 hover:border-emerald-200 hover:text-emerald-600
             dark:bg-white/5 dark:border-white/10 dark:text-slate-400
             dark:hover:bg-emerald-500/10 dark:hover:border-emerald-500/30 dark:hover:text-emerald-400"
                        >
                          <DownloadCloud
                            size={18}
                            className="group-hover:translate-y-1 transition-transform duration-300 stroke-[2.5]"
                          />
                          <span className="font-bold">Export</span>
                        </button>
                        <button
                          onClick={() => setShowClearConfirmQuoteCard(true)}
                          className="h-[46px] px-4 py-3 rounded-2xl font-bold text-sm whitespace-nowrap transition-all flex items-center gap-2 group shadow-sm
             /* LIGHT MODE: Clean & Professional */
             bg-white border border-red-100 text-red-500 
             hover:bg-red-50 hover:border-red-200 
             
             /* DARK MODE: Sophisticated Transparent Red */
             dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400
             dark:hover:bg-red-500/20 dark:hover:border-red-500/40"
                        >
                          <Trash2
                            size={16}
                            className="group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"
                          />
                          <span className="font-bold">Clear All</span>
                        </button>
                      </div>
                    </div>
                  )}

                  {/* --- CONDITIONAL CONTENT START --- */}
                  {!sups || sups.length === 0 ? (
                    /* EMPTY STATE: Amber Theme */
                    <div className="w-full py-24 px-8 bg-white dark:bg-slate-950 rounded-[40px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] flex flex-col items-center text-center relative overflow-hidden group animate-in fade-in slide-in-from-bottom-4 duration-700">
                      <div
                        className="absolute inset-0 opacity-[0.02] pointer-events-none"
                        style={{
                          backgroundImage: `radial-gradient(#f59e0b 1px, transparent 1px)`,
                          backgroundSize: "24px 24px",
                        }}
                      />
                      <div className="relative z-10 max-w-md">
                        <div className="relative w-24 h-24 mb-8 mx-auto">
                          <div className="absolute inset-0 bg-amber-500/10 dark:bg-slate-900 rounded-full blur-3xl scale-125 group-hover:bg-amber-500/20 transition-all duration-500" />
                          <div className="relative w-full h-full bg-white dark:bg-slate-800 rounded-[2.2rem] shadow-sm shadow-sm flex items-center justify-center transition-all duration-500 group-hover:-translate-y-2 group-hover:-rotate-3">
                            <div className="relative">
                              <ClipboardSignature
                                size={36}
                                className="text-amber-500"
                              />
                              <span className="absolute -top-1 -right-1 w-4 h-4 bg-amber-500 rounded-full shadow-sm" />
                            </div>
                          </div>
                        </div>

                        <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tighter">
                          <span className="font-black" style={{
                            filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                          }}>Quotes</span>{" "}
                          <span className="font-black bg-gradient-to-r from-amber-500 to-orange-400 bg-clip-text text-transparent drop-shadow-[0_0_15px_rgba(245,158,11,0.3)]">
                            missing
                          </span>
                        </h3>

                        <p className="text-slate-500 dark:text-slate-400 text-base leading-relaxed mb-10 px-6 max-w-md mx-auto">
                          {quote && quote.length > 0 ? (
                            <>
                              You have captured your{" "}
                              <span className="text-slate-900 dark:text-amber-400 font-black decoration-amber-500/30 dark:decoration-amber-400/20 underline decoration-4 underline-offset-4">
                                Project Items
                              </span>
                              . Now, add supplier quotes to compare pricing and
                              lead times.
                            </>
                          ) : (
                            <>
                              With your <span className="font-bold">Project</span> and <span className="font-bold">Supplier Network</span> set up, you
                              can now start adding quotes to the Project!
                            </>
                          )}
                        </p>

                        <div className="flex flex-col items-center gap-4 justify-center">
                          {sups && sups.length === 0 && (
                            <button
                              onClick={handleAddQuoteClick} // 🚩 Points to the validation guard
                              className="inline-flex items-center gap-3 bg-amber-600 text-white px-8 py-3.5 rounded-full hover:bg-amber-700 hover:shadow-lg shadow-amber-100 transition-all cursor-pointer group/btn"
                            >
                              <Plus
                                size={18}
                                className="group-hover:rotate-90 transition-transform duration-300"
                              />
                              <span className="text-sm font-bold uppercase tracking-tight">
                                Add Your First Quote
                              </span>
                            </button>
                          )}
                        </div>
                      </div>
                      {/*TOETS2*/}

                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />
                    </div>
                  ) : (
                    /* RENDER QUOTE VIEWS */
                    <div className="animate-in fade-in duration-500">
                      {quoteView === "grid" ? (
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                          {sups.map((s) => (
                            <SupplierQuoteCard
                              key={s.id} // This MUST be the unique ID of the quote object, NOT the supplier ID
                              s={s}
                              sups={sups}
                              supList={supList}
                              updQuoteSup={updQuoteSup}
                              openQuoteModal={openQuoteModal}
                              shareToWhatsApp={shareToWhatsApp}
                              setQuoteSupToDelete={setQuoteSupToDelete}
                              currentProjectName={currentProjectData?.name}
                              quote={quote}
                              itemSearchQuery={itemSearchQuery}
                              updQuote={updQuote}
                              deleteItemQuote={deleteItemQuote}
                              uploadQuoteItems={uploadQuoteItems}
                              setDuplicateErrorSup={setDuplicateErrorSup}
                              user={user}
                              handleAIDocumentProcess={handleAIDocumentProcess}
                            />
                          ))}
                        </div>
                      ) : (
                        /* LIST VIEW */
                        <div className="bg-white dark:bg-slate-950 rounded-[40px] shadow-sm overflow-hidden">
                          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

                          <div className="overflow-visible relative">
                            <table className="w-full border-separate border-spacing-y-2 overflow-visible">
                              {/* 🚩 THE STICKY HEADER */}
                              <thead className="sticky top-0 z-50">
                                <tr className="bg-gray-50/50 dark:bg-slate-950 dark:text-white">
                                  <th className="px-8 py-5 text-left text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    Supplier Details
                                  </th>
                                  <th className="px-8 py-5 text-center text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    Items Priced
                                  </th>
                                  <th className="px-4 py-5 text-center text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    B-BBEE Level
                                  </th>
                                  <th className="px-8 py-5 text-center text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    Lead Time Avg
                                  </th>
                                  <th className="px-8 py-5 text-right text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    Base Total
                                  </th>
                                  <th className="px-8 py-5 text-right text-[10px] font-black text-gray-400 uppercase tracking-widest">
                                    Total Quoted
                                  </th>
                                  <th className="px-8 py-5 w-24"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {supCalcs.map((s, index) => (
                                  <tr
                                    key={s.id}
                                    className="min-h-[300px] hover:bg-indigo-50/30 dark:hover:bg-slate-900/50 transition-colors group overflow-visible"
                                  >
                                    {/* Supplier Name */}
                                    <td className="px-8 py-6">
                                      <div className="flex items-center gap-4">
                                        <div className="p-3 rounded-2xl bg-gray-100 dark:bg-slate-800 text-gray-400 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                                          <Building2 size={20} />
                                        </div>
                                        <div>
                                          <span className="font-bold text-gray-900 block dark:text-white">
                                            {s.vendorName}
                                          </span>
                                          <span className="font-bold text-[10px] text-gray-400 font-black uppercase tracking-widest">
                                            ID: {String(s.id).slice(-6)}
                                          </span>
                                        </div>
                                      </div>
                                    </td>

                                    {/* Quote Progress */}
                                    <td className="px-8 py-6 text-center">
                                      <div className="flex flex-col items-center gap-1.5">
                                        <span className="font-bold text-sm font-black text-gray-900 dark:text-white">
                                          {s.pricedCount} / {quote.length}
                                        </span>
                                        <div className="font-bold w-20 h-1.5 bg-gray-100 dark:bg-slate-800 rounded-full overflow-hidden">
                                          <div
                                            className={`h-full transition-all duration-500 ${s.completionPercentage === 100
                                              ? "bg-green-500"
                                              : "bg-orange-500"
                                              }`}
                                            style={{
                                              width: `${s.completionPercentage}%`,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </td>

                                    {/* B-BBEE Level */}
                                    <td className="px-8 py-6 text-center">
                                      <div className="flex flex-col items-center gap-1.5">
                                        <span className="text-sm font-black text-gray-900 dark:text-white tracking-tighter">
                                          {s.beeLevel
                                            ? `Level ${s.beeLevel}`
                                            : "N/A"}
                                        </span>
                                        <div className="w-20 h-1.5 bg-gray-100 dark:bg-white/5 rounded-full overflow-hidden">
                                          <div
                                            className={`h-full transition-all duration-500 ${s.beeColor}`}
                                            style={{
                                              width: `${s.beePercentage}%`,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </td>

                                    {/* Lead Time */}
                                    <td className="px-8 py-6 text-center">
                                      <div className="text-sm font-black text-orange-600">
                                        {s.avgLeadTime > 0
                                          ? `${s.avgLeadTime} Days`
                                          : "Immediate"}
                                      </div>
                                      <div className="text-[9px] text-gray-400 font-black uppercase">
                                        Avg. Delivery
                                      </div>
                                    </td>
                                    {/* Total Landed Cost */}
                                    <td className="px-8 py-6 text-right font-black border-none relative group/price">
                                      <div className="flex flex-col items-end">
                                        <div className="text-[10px] text-gray-400 font-black uppercase mb-0.5 tracking-widest">
                                          {s.isWinner
                                            ? "Best Base Price"
                                            : "Material Total"}
                                        </div>

                                        <div
                                          className={`font-bold text-base transition-all duration-500 ${s.isWinner
                                            ? "text-emerald-600 dark:text-emerald-400"
                                            : "text-gray-900 dark:text-slate-200"
                                            }`}
                                        >
                                          R
                                          {s.materialBase.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }
                                          )}
                                        </div>

                                        {/* 🚩 ALL BADGE LOGIC REMOVED AS REQUESTED */}
                                      </div>
                                    </td>
                                    <td className="px-8 py-6 text-right font-black border-none">
                                      <div className="flex flex-col items-end">
                                        <div className="text-[10px] text-gray-400 font-black uppercase mb-0.5">
                                          {s.isWinner
                                            ? "Best Landed Price"
                                            : "Total Quoted"}
                                        </div>
                                        <div
                                          className={`font-bold text-base transition-all duration-500 ${s.isWinner
                                            ? "text-emerald-600 dark:text-emerald-400"
                                            : "text-gray-900 dark:text-slate-200"
                                            }`}
                                        >
                                          R
                                          {s.finalTotal.toLocaleString(
                                            undefined,
                                            { minimumFractionDigits: 2 }
                                          )}
                                        </div>

                                        {/* Badges */}
                                        {(s.hasAdditionalFees ||
                                          s.isVatInclusive) && (
                                            <div className="flex flex-wrap justify-end gap-1 mt-1">
                                              {s.hasAdditionalFees && (
                                                <div className="flex items-center gap-1 bg-indigo-50 dark:bg-indigo-500/10 px-1.5 py-0.5 rounded-md border border-indigo-100/50 dark:border-indigo-500/10">
                                                  <Truck
                                                    size={10}
                                                    className="text-indigo-500"
                                                  />
                                                  <span className="text-[9px] text-indigo-600 dark:text-indigo-400 uppercase font-black tracking-tighter">
                                                    Landed
                                                  </span>
                                                </div>
                                              )}
                                              {s.isVatInclusive && (
                                                <div className="flex items-center gap-1 bg-amber-50 dark:bg-amber-500/10 px-1.5 py-0.5 rounded-md border border-amber-100/50 dark:border-amber-500/10">
                                                  <span className="text-[9px] text-amber-600 dark:text-amber-400 uppercase font-black tracking-tighter italic">
                                                    +VAT
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </td>

                                    {/* Action Button */}
                                    <td className="px-8 py-6 text-right">
                                      <button
                                        onClick={() => openQuoteModal(s)}
                                        className="p-2.5 hover:bg-white dark:hover:bg-slate-800 rounded-xl shadow-sm transition-all text-gray-400 hover:text-amber-600"
                                      >
                                        <Calculator size={20} />
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {tab === "comp" && (
                <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
                  {(() => {
                    // 1. SAFE DATA SCOPE
                    const activeProj = projects?.find(
                      (p) => p.id === currentProject
                    );
                    const hasData =
                      winner ||
                      (activeProj?.quote && activeProj.quote.length > 0);

                    // 2. EMPTY STATE
                    if (!hasData) {
                      return (
                        <div className="w-full py-24 px-8 bg-white dark:bg-slate-950 rounded-[40px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] flex flex-col items-center text-center relative overflow-hidden group">
                          <div
                            className="absolute inset-0 opacity-[0.02] pointer-events-none"
                            style={{
                              backgroundImage: `radial-gradient(#a855f7 1px, transparent 1px)`,
                              backgroundSize: "24px 24px",
                            }}
                          />
                          <div className="relative z-10 max-w-md">
                            <div className="relative w-24 h-24 mb-8 mx-auto">
                              <div className="absolute inset-0 bg-purple-500/10 rounded-full blur-3xl scale-125 group-hover:bg-purple-500/20 transition-all duration-500" />
                              <div className="relative w-full h-full bg-white dark:bg-slate-800 rounded-[2.2rem] flex items-center justify-center transition-all duration-500 group-hover:-translate-y-2 group-hover:-rotate-3">
                                <Database
                                  size={36}
                                  className="text-purple-500"
                                />
                              </div>
                            </div>
                            <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tighter">
                              <span className="font-black" style={{
                                filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}>Awaiting</span>{" "}
                              <span className="font-black bg-gradient-to-r from-indigo-500 to-purple-400 bg-clip-text text-transparent drop-shadow-[0_0_15px_rgba(168,85,247,0.4)]">
                                Procurement
                              </span>{" "}
                              <span className="font-black" style={{
                                filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}>Data</span>
                            </h3>
                            <p className="text-slate-500 dark:text-slate-400 mb-10">
                              Add <span className="font-bold">supplier quotes</span> to the project to begin the AI
                              comparison.
                            </p>
                            <button
                              onClick={() => setTab("quotes")}
                              className="inline-flex items-center gap-3 bg-purple-600 text-white px-8 py-3.5 rounded-full hover:bg-purple-700 hover:shadow-lg shadow-purple-100 transition-all cursor-pointer active:scale-95"
                            >
                              <Plus size={18} />
                              <span className="text-sm font-bold uppercase tracking-tight">
                                Assign Supplier Quotes
                              </span>
                            </button>
                          </div>
                          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />
                        </div>
                      );
                    }

                    // --- PROJECT BUDGET DASHBOARD LOGIC (ROBUST VERSION) ---

                    // 1. Find Project with Deep ID Check (Checks .id and ._id)
                    const freshProjectData =
                      projects?.find(
                        (p) => String(p.id || p._id) === String(currentProject)
                      ) || activeProj;

                    // 2. Budget Lookup
                    const projectBudget = Number(
                      freshProjectData?.totalBudget ||
                      freshProjectData?.budget ||
                      0
                    );

                    // 3. ACCURATE WINNER COST CALCULATION
                    const winnerCost = (() => {
                      // Try to find the Winner's ID safely
                      const winnerId =
                        qp_FinalWinner?.id ||
                        qp_FinalWinner?.supplierId ||
                        qp_FinalWinner?._id;

                      // Locate the Quotes list from any possible source
                      const sourceQuotes =
                        (typeof quotes !== "undefined" ? quotes : []) ||
                        freshProjectData?.quotes ||
                        activeProj?.quotes ||
                        [];

                      // Attempt 1: Sum from the Quotes Table (The most accurate source)
                      let total = sourceQuotes
                        .filter(
                          (q) =>
                            String(q.supplierId || q.id) === String(winnerId)
                        )
                        .reduce((acc, q) => {
                          const lineTotal = Number(
                            q.totalAmount ||
                            Number(q.unitPrice || q.price || 0) *
                            Number(q.quantity || q.qty || 1)
                          );
                          return acc + lineTotal;
                        }, 0);

                      // Attempt 2: If total is 0, check if qp_FinalWinner itself contains an items array to sum
                      if (total === 0 && qp_FinalWinner?.items) {
                        total = qp_FinalWinner.items.reduce((acc, item) => {
                          return (
                            acc +
                            Number(item.price || item.unitPrice || 0) *
                            Number(item.quantity || item.qty || 1)
                          );
                        }, 0);
                      }

                      // Attempt 3: Final fallback to direct totals
                      if (total === 0) {
                        total = Number(
                          qp_FinalWinner?.totalAmount ||
                          qp_FinalWinner?.total ||
                          qp_FinalWinner?.cost ||
                          0
                        );
                      }

                      return total;
                    })();

                    // 4. THE MATH
                    const difference = projectBudget - winnerCost;
                    const displayDiff = difference; // Positive = Savings, Negative = Over
                    const variancePercent =
                      projectBudget > 0
                        ? (Math.abs(difference) / projectBudget) * 100
                        : 0;
                    const isOverBudget = difference < 0;
                    return (
                      <>
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-8">
                          {/* WINNER CARD */}
                          <div className="lg:col-span-7 relative group h-full transition-all duration-1000 shadow-[0_20px_50px_rgba(0,0,0,0.03)]">
                            {/* 1. Subtle Radial Glow */}
                            <div
                              className={`absolute inset-0 rounded-[45px] blur-[60px] opacity-10 transition-opacity shadow-[0_20px_50px_rgba(0,0,0,0.03)] duration-1000 group-hover:opacity-20 ${isOverBudget ? "bg-rose-500" : "bg-indigo-500"
                                }`}
                            />

                            {/* 2. Main Card - Clean Professional Glass */}
                            <div className="relative h-full w-full bg-white/90 dark:bg-slate-900/90 backdrop-blur-xl rounded-[40px] p-10 border border-slate-200/60 dark:border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.03)] overflow-hidden flex flex-col transition-all duration-500">
                              {/* Premium Top Accent */}
                              <div
                                className={`absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r transition-all duration-700 ${isOverBudget
                                  ? "from-rose-500 to-amber-500"
                                  : "from-emerald-400 via-indigo-500 to-purple-600"
                                  }`}
                              />

                              {/* Header: Status & Badge */}
                              <div className="relative z-10 flex items-center justify-between mb-12">
                                <div className="space-y-2">
                                  <div
                                    className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border ${isOverBudget
                                      ? "bg-rose-50 dark:bg-rose-500/10 border-rose-100 dark:border-rose-500/20 text-rose-700 dark:text-rose-400"
                                      : "bg-emerald-50 dark:bg-emerald-500/10 border-emerald-100 dark:border-emerald-500/20 text-emerald-700 dark:text-emerald-400"
                                      }`}
                                  >
                                    <div
                                      className={`w-1.5 h-1.5 rounded-full animate-pulse ${isOverBudget
                                        ? "bg-rose-500"
                                        : "bg-emerald-500"
                                        }`}
                                    />
                                    <span className="text-[10px] font-black uppercase tracking-[0.2em]">
                                      {isOverBudget
                                        ? "Budget Variance"
                                        : "Verified Best Match"}
                                    </span>
                                  </div>
                                  <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest block pl-1">
                                    Rank #1 Primary Vendor
                                  </p>
                                </div>

                                <div className="h-12 w-12 bg-slate-50 dark:bg-white/5 rounded-2xl flex items-center justify-center border border-slate-100 dark:border-white/10 shadow-inner group-hover:scale-110 transition-transform duration-500">
                                  <Trophy
                                    className={
                                      isOverBudget
                                        ? "text-slate-300"
                                        : "text-amber-400"
                                    }
                                    size={22}
                                  />
                                </div>
                              </div>

                              {/* Body: Identity & Specs */}
                              <div className="flex-grow relative z-10 space-y-12">
                                {/* Identity Zone */}
                                <div className="space-y-2">
                                  <h2 className="text-5xl font-black text-slate-900 dark:text-white tracking-tight leading-tight">
                                    <span className="font-black" style={{
                                      filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                    }}>{qp_FinalWinner?.name || "Winner"}</span>
                                  </h2>
                                  <div className="h-1 w-16 bg-indigo-500 rounded-full opacity-30" />
                                </div>

                                {/* Operational Grid */}
                                <div className="cursor-default grid grid-cols-3 gap-x-0 p-2 bg-slate-100/80 dark:bg-slate-950/40 rounded-[2.8rem] border border-slate-200/50 dark:border-white/5 shadow-inner relative overflow-hidden">
                                  {/* Metric 1: Delivery */}
                                  <div className="relative group/metric p-6 space-y-2 rounded-[2.2rem] transition-all duration-500 hover:bg-white dark:hover:bg-white/5 hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.1)] dark:hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)]">
                                    <span className="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] block">
                                      Avg. Delivery
                                    </span>
                                    <div className="flex items-baseline gap-1">
                                      <span className="text-3xl font-black text-slate-800 dark:text-slate-100 tracking-tighter transition-transform duration-500 group-hover/metric:scale-110 origin-left">
                                        {qp_FinalWinner?.leadTime > 0
                                          ? qp_FinalWinner.leadTime
                                          : "—"}
                                      </span>
                                      <span className="text-[10px] font-black text-slate-400 uppercase tracking-tighter opacity-60 ml-2">
                                        {" "}
                                        Days
                                      </span>
                                    </div>
                                    {/* Subtle Vertical Divider Line */}
                                    <div className="absolute right-0 top-1/4 h-1/2 w-px bg-gradient-to-b from-transparent via-slate-300 dark:via-white/10 to-transparent" />
                                  </div>

                                  {/* Metric 2: Fulfillment */}
                                  <div className="relative group/metric p-6 space-y-2 rounded-[2.2rem] transition-all duration-500 hover:bg-white dark:hover:bg-white/5 hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.1)] dark:hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)]">
                                    <span className="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] block">
                                      Fulfillment
                                    </span>
                                    {(() => {
                                      const winnerData = sups.find(
                                        (s) =>
                                          String(s.sid || s.id) ===
                                          String(qp_FinalWinner?.id)
                                      );
                                      const itemsCount = Object.keys(
                                        winnerData?.quotes || {}
                                      ).length;

                                      return (
                                        <div className="flex items-baseline gap-1">
                                          <span className="text-3xl font-black text-indigo-600 dark:text-indigo-400 tracking-tighter drop-shadow-[0_0_15px_rgba(79,70,229,0.3)] transition-transform duration-500 group-hover/metric:scale-110 origin-left">
                                            {itemsCount}
                                          </span>
                                          <span className="text-[10px] font-black text-slate-400 uppercase tracking-tighter opacity-60">
                                            <span className="ml-2">
                                              {"  "}/ {quote?.length || 0} Items
                                            </span>
                                          </span>
                                        </div>
                                      );
                                    })()}
                                    {/* Subtle Vertical Divider Line */}
                                    <div className="absolute right-0 top-1/4 h-1/2 w-px bg-gradient-to-b from-transparent via-slate-300 dark:via-white/10 to-transparent" />
                                  </div>

                                  {/* Metric 3: B-BBEE */}
                                  <div className="relative group/metric p-6 space-y-2 rounded-[2.2rem] transition-all duration-500 hover:bg-white dark:hover:bg-white/5 hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.1)] dark:hover:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)]">
                                    <span className="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] block">
                                      B-BBEE Status
                                    </span>
                                    <div className="flex items-center gap-3">
                                      <span
                                        className={`text-3xl font-black tracking-tighter transition-transform duration-500 group-hover/metric:scale-110 origin-left ${qp_FinalWinner?.beeLevel <= 2
                                          ? "text-emerald-500"
                                          : qp_FinalWinner?.beeLevel <= 5
                                            ? "text-orange-500"
                                            : "text-rose-500"
                                          }`}
                                      >
                                        {qp_FinalWinner?.beeLabel}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Narrative Zone */}
                                <div className="max-w-md space-y-2">
                                  <p className="text-slate-500 dark:text-slate-400 text-[13px] leading-relaxed">
                                    Optimised procurement route identified with
                                    a total cost of:
                                  </p>
                                  <div className="flex items-center gap-2">
                                    {" "}
                                    {/* Changed items-baseline to items-center for better alignment */}
                                    <span className="text-2xl font-black text-slate-900 dark:text-white leading-none" style={{
                                      filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                    }}>
                                      R
                                      {Number(winnerCost).toLocaleString(
                                        "en-ZA",
                                        { minimumFractionDigits: 0 }
                                      )}
                                    </span>
                                    <div className="flex flex-col">
                                      <span className="text-[9px] font-black text-indigo-500/80 uppercase tracking-[0.15em] leading-none">
                                        ZAR Total
                                      </span>
                                      <span className="text-[8px] font-bold text-slate-400 uppercase tracking-tighter leading-none">
                                        (Incl. Additional Fees)
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Footer: Action & Financial Summary */}
                              <div className="pt-8 mt-auto flex items-center justify-between border-t border-slate-100 dark:border-white/5 relative z-10">
                                <button
                                  onClick={() => {
                                    if (isBusinessPlus) {
                                      handleAuditDownload();
                                    } else {
                                    }
                                  }}
                                  className={`mt-2 px-8 py-3.5 rounded-2xl font-black text-[10px] uppercase tracking-widest flex items-center gap-3 transition-all active:scale-95 shadow-md group/btn ${isBusinessPlus
                                    ? "bg-slate-900 dark:bg-indigo-600 text-white hover:bg-indigo-700 dark:hover:bg-indigo-500 hover:shadow-indigo-500/20" // 🌟 YOUR EXACT ORIGINAL STYLING PRESERVED
                                    : "bg-slate-900 dark:bg-indigo-600 text-white hover:text-slate-900 hover:bg-slate-200/60 dark:hover:bg-amber-500/10 border border-transparent hover:border-slate-500/30"
                                    }`}
                                >
                                  <span className="font-black tracking-widest transition-all duration-300">
                                    {isBusinessPlus ? "Winner Details" : "Winner Details"}
                                  </span>

                                  <div className="relative w-3.5 h-3.5 flex items-center justify-center">
                                    {/* Download icon translates to the right on hover for authorized users */}
                                    <Download
                                      size={14}
                                      className={`absolute transition-all duration-300 ${isBusinessPlus
                                        ? "group-hover/btn:translate-x-1"
                                        : "group-hover/btn:opacity-0 group-hover/btn:scale-50"
                                        }`}
                                    />

                                    {/* Lock icon cleanly steps into place for unauthorized users */}
                                    {!isBusinessPlus && (
                                      <span className="absolute text-lg opacity-0 scale-50 transition-all duration-300 group-hover/btn:opacity-100 group-hover/btn:scale-110 normal-case">
                                        🔒
                                      </span>
                                    )}
                                  </div>
                                </button>

                                <div className="text-right">
                                  <span
                                    className={`text-[10px] font-black uppercase tracking-widest mb-1 block ${isOverBudget
                                      ? "text-rose-500"
                                      : "text-emerald-500"
                                      }`}
                                  >
                                    {isOverBudget
                                      ? "Budget Deficit"
                                      : "Projected Savings"}
                                  </span>
                                  <div className="flex items-center gap-3 justify-end" style={{
                                    filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                  }}>
                                    <span className="text-3xl font-black text-slate-900 dark:text-white tracking-tighter leading-none">
                                      R{displayDiff.toLocaleString()}
                                    </span>
                                    <span
                                      className={`text-[10px] font-black px-1.5 py-0.5 rounded ${isOverBudget
                                        ? "bg-rose-500 text-white"
                                        : "bg-emerald-500 text-white"
                                        }`}
                                    >
                                      {variancePercent.toFixed(1)}%
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* RUNNER UP */}
                          {qp_secondary && (
                            <div className="lg:col-span-5">
                              <SupplierScorecard
                                supplier={qp_secondary}
                                rank={2}
                                user={user}
                                workspace={workspace}
                                sups={qp_stats}
                                quote={quote}
                                qp_FinalWinner={qp_FinalWinner}
                                qp_secondary={qp_secondary}
                                supList={supList} // Add this if you have it!
                              />
                            </div>
                          )}
                        </div>

                        {/* 🚩 MISSING ANALYSIS MATRIX SECTION START */}
                        <div className="lg:col-span-12 space-y-8 mt-6">
                          <div className="lg:col-span-12 mt-10">
                            <div className="bg-slate-900 rounded-[3.5rem] p-12 relative overflow-hidden group shadow-[0_40px_100px_rgba(0,0,0,0.2)] border border-slate-800">
                              {/* 1. LAYERED BACKGROUND EFFECTS */}
                              {/* Subtle Grid Pattern for 'Data' Feel */}
                              <div
                                className="absolute inset-0 opacity-[0.03] pointer-events-none"
                                style={{
                                  backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`,
                                  backgroundSize: "40px 40px",
                                }}
                              />
                              {/* Animated Indigo Glow */}
                              <div className="absolute -top-24 -right-24 w-96 h-96 bg-indigo-600/20 rounded-full blur-[120px] group-hover:bg-indigo-600/30 transition-all duration-1000" />
                              <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-emerald-600/10 rounded-full blur-[120px]" />

                              <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12">
                                {/* 2. LEFT SIDE: THE NUMBERS */}
                                <div className="flex-1 text-center lg:text-left space-y-4">
                                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 mb-2">
                                    <span className="relative flex h-2 w-2">
                                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                                      <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                                    </span>
                                    <span className="text-[10px] font-black text-emerald-400 uppercase tracking-[0.2em]">
                                      Item Cost Split Optimisation Engine
                                    </span>
                                  </div>

                                  <h2 className="text-7xl font-black text-white tracking-tighter leading-[0.8] mb-6">
                                    Save{" "}
                                    <span className="font-bold text-emerald-400 drop-shadow-[0_0_30px_rgba(52,211,153,0.3)]">
                                      R
                                      {(Number(procurementStats?.rawDiff) || 0).toLocaleString("en-ZA", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </span>
                                  </h2>

                                  <div className="flex flex-col lg:flex-row items-center gap-6">
                                    <p className="text-slate-400 text-xl max-w-md leading-relaxed">
                                      Your optimal item allocation is
                                      strategically sourced from{" "}
                                      <span className="text-white font-bold">
                                        multiple suppliers
                                      </span>{" "}
                                      to secure the lowest possible market rate.
                                    </p>

                                    <div className="h-12 w-px bg-slate-800 hidden lg:block" />
                                  </div>
                                </div>

                                {/* 3. RIGHT SIDE: THE CALL TO ACTION */}
                                <div className="relative">
                                  <button
                                    onClick={() => {
                                      // Blocks starter plans from viewing the matrix layout
                                      if (activePlanPBP !== "starter") {
                                        handleViewMatrixClick();
                                      } else {
                                        setShowPricingModal(true);
                                      }
                                    }}
                                    className={`group/btn relative px-12 py-7 rounded-[2rem] uppercase text-xs tracking-[0.2em] transition-all duration-500 active:scale-95 flex items-center gap-4 ${activePlanPBP !== "starter"
                                      ? "bg-white dark:bg-slate-100 text-slate-900 hover:scale-105 hover:shadow-[0_20px_60px_rgba(255,255,255,0.15)]" // 🌟 YOUR EXACT ORIGINAL STYLING PRESERVED
                                      : "bg-white dark:bg-slate-100 text-slate-900 hover:text-amber-600 dark:hover:text-amber-500 hover:shadow-[0_20px_60px_rgba(245,158,11,0.15)]"
                                      }`}
                                  >
                                    <div className="relative w-5 h-5 flex items-center justify-center">
                                      {/* Grid icon rotates normally on hover for Pro / BusinessPlus+ operators */}
                                      <LayoutGrid
                                        size={20}
                                        className={`absolute text-indigo-600 transition-all duration-500 ${activePlanPBP !== "starter"
                                          ? "group-hover/btn:rotate-90"
                                          : "group-hover/btn:opacity-0 group-hover/btn:scale-50"
                                          }`}
                                      />

                                      {/* Lock icon steps into view seamlessly for starter accounts */}
                                      {activePlanPBP === "starter" && (
                                        <span className="absolute text-xl opacity-0 scale-50 transition-all duration-500 group-hover/btn:opacity-100 group-hover/btn:scale-110 normal-case">
                                          🔒
                                        </span>
                                      )}
                                    </div>

                                    <span className="font-bold transition-all duration-300">
                                      {activePlanPBP !== "starter" ? "View Analysis Matrix" : "View Analysis Matrix"}
                                    </span>
                                  </button>

                                  <p className="mt-4 text-[9px] text-center text-slate-500 font-bold uppercase tracking-tighter opacity-60 group-hover:opacity-100 transition-opacity">
                                    Click to expand detailed item-by-item
                                    breakdown
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* 🚩 MISSING ANALYSIS MATRIX SECTION END */}
                      </>
                    );
                  })()}
                </div>
              )}
              {tab === "reps" && (
                <div className="space-y-10">
                  <div className="flex justify-between items-center">
                    <div>
                      <h3 className="text-3xl font-black text-gray-800 dark:text-white" style={{
                        filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                      }}>
                        Portfolio Analytics
                      </h3>
                      <p className="text-sm font-bold text-gray-400 uppercase tracking-widest">
                        Performance across all active projects
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {[
                      {
                        label: "Total Projects",
                        value: projects.length,
                        icon: <Briefcase size={22} />,
                        color: "text-indigo-600",
                        bg: "bg-indigo-50",
                      },
                      {
                        label: "Registered Suppliers",
                        value: supList.length,
                        icon: <Users size={22} />,
                        color: "text-orange-500",
                        bg: "bg-orange-50",
                      },
                      {
                        label: "Top Supplier Avg Lead Time",
                        value: getAverageProjectLeadTime(),
                        unit: "Days",
                        icon: <Timer size={22} />,
                        color: "text-rose-600",
                        bg: "bg-rose-50",
                      },
                      {
                        label: "Project Completion Rate",
                        value: `${getCompletionRate()}%`,
                        icon: <Target size={22} />,
                        color: "text-emerald-600",
                        bg: "bg-emerald-50",
                      },
                    ].map((kpi, i) => (
                      <div
                        key={i}
                        className="cursor-default hover:scale-[1.01] group relative bg-white dark:bg-slate-950 p-8 rounded-[40px] border border-slate-100 dark:border-white/5 shadow-sm hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.15)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] dark:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)] transition-all duration-700 overflow-hidden"
                      >
                        {/* 🚩 B-BBEE STYLE HOVER GLOW: Centered Mesh Gradient */}
                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_50%,rgba(99,102,241,0.12),transparent_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />

                        {/* 🚩 ARCHITECTURAL HIGHLIGHT: Top-edge line that wakes up on hover */}
                        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/10 dark:via-indigo-400/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />

                        {/* 🚩 CONTENT LAYER: Relative to sit above the glows */}
                        <div className="relative z-10">
                          {/* Your KPI Content (Icon, Label, Value) goes here */}
                        </div>

                        <div className="relative z-10">
                          <div className="flex justify-between items-start mb-6">
                            <div
                              className={`p-3 rounded-2xl ${kpi.bg} ${kpi.color} transition-transform duration-500 group-hover:scale-110`}
                            >
                              {kpi.icon}
                            </div>
                            <div
                              className={`h-1.5 w-10 rounded-full ${kpi.accent} opacity-20 group-hover:opacity-100 transition-opacity`}
                            />
                          </div>

                          <p className="text-[10px] font-black text-gray-400 dark:text-slate-500 uppercase tracking-[0.15em] mb-1">
                            {kpi.label}
                          </p>

                          <h4
                            className={`text-4xl font-black ${kpi.color} tracking-tighter`}
                          >
                            {kpi.value}
                            {kpi.unit && (
                              <span className="text-sm font-bold text-gray-400 ml-2 tracking-normal">
                                {kpi.unit}
                              </span>
                            )}
                          </h4>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="group bg-white dark:bg-slate-950 rounded-[40px] shadow-[0_32px_64px_-12px_rgba(0,0,0,0.08)] dark:shadow-[0_32px_64px_-12px_rgba(0,0,0,0.6)] border border-slate-100 dark:border-white/5 overflow-hidden relative transition-all duration-500">
                    {/* 🚩 DEPTH LAYER: Subtle Mesh Glow - Adapts color based on mode */}
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_50%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.1),transparent_50%)] pointer-events-none" />
                    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

                    {/* HEADER SECTION */}
                    <div className="p-8 border-b border-slate-50 dark:border-white/5 bg-slate-50/30 dark:bg-white/[0.02] flex flex-col md:flex-row justify-between items-center gap-6 relative z-10">
                      <div>
                        <h2 className="text-xl font-black text-slate-900 dark:text-white/90 tracking-tight" style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}>
                          Master Project Registry
                        </h2>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="flex h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse shadow-[0_0_8px_rgba(16,185,129,0.5)]" />
                          <p className="text-[9px] text-slate-400 dark:text-slate-500 font-black uppercase tracking-[0.25em]">
                            Active Procurement Portfolio
                          </p>
                        </div>
                      </div>

                      <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
                        {/* SEARCH BAR */}
                        <div className="relative group w-full sm:w-72">
                          <Search
                            className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300 dark:text-slate-600 group-focus-within:text-indigo-500 transition-colors"
                            size={16}
                          />
                          <input
                            type="text"
                            placeholder="Search Registry..."
                            value={projectSearchQuery}
                            onChange={(e) => setProjectSearchQuery(e.target.value)}
                            className="w-full pl-11 pr-4 py-3 bg-white dark:bg-slate-900/50 border border-slate-200 dark:border-white/5 rounded-2xl text-[13px] font-bold text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20 transition-all placeholder:text-slate-300 dark:placeholder:text-slate-600 shadow-sm dark:shadow-inner"
                          />
                        </div>

                        {/* NEW: PDF DOWNLOAD BUTTON */}
                        <button
                          disabled={false} // Keeps the button enabled so they can hover to see the upgrade indicator
                          onClick={() => {
                            // 🔒 Security Gate: Block starter plan users from exporting data
                            if (user?.plan === "starter") {
                              // Redirects them cleanly to your billing tab or alerts them
                              if (typeof setSettingsTab === "function") setSettingsTab("billing");
                              return;
                            }

                            // 🔓 Authorized Executions (Pro & Business Plus)
                            const winner = typeof qp_FinalWinner !== 'undefined' ? qp_FinalWinner : null;
                            const project = typeof currentProject !== 'undefined' ? currentProject : null;

                            downloadProjectRegistryPDF(projects, winner, project);
                          }}
                          className={`flex items-center justify-center gap-3 px-6 py-3 border rounded-2xl text-[11px] font-black uppercase tracking-widest transition-all shadow-sm active:scale-95 group/pdf
    ${user?.plan !== "starter"
                              ? "bg-white dark:bg-slate-900 border-slate-200 dark:border-white/10 text-slate-900 dark:text-white hover:bg-slate-50 dark:hover:bg-white/[0.05]"
                              : "bg-white dark:bg-slate-900 border-slate-200 dark:border-white/10 text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-white/[0.05] cursor-pointer"
                            }`}
                        >
                          {/* PDF LOGO ICON / LOCK INJECTION */}
                          <div className="relative w-5 h-5 flex items-center justify-center">
                            <div className="absolute inset-0 bg-rose-500/20 blur-md rounded-full group-hover/pdf:bg-rose-500/40 transition-all opacity-0 group-hover/pdf:opacity-100" />

                            {/* PDF Icon: Translates or fades depending on authorization status */}
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              className={`w-5 h-5 text-rose-600 dark:text-rose-500 transition-all duration-300 
        ${user?.plan !== "starter"
                                  ? "group-hover/pdf:scale-110"
                                  : "group-hover/pdf:opacity-0 group-hover/pdf:scale-50"
                                }`}
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                              <polyline points="14 2 14 8 20 8" />
                              <path d="M9 13v4" />
                              <path d="M12 13v4" />
                              <path d="M15 13v4" />
                            </svg>

                            {/* Lock Icon steps into frame on hover if they are on the starter tier */}
                            {user?.plan === "starter" && (
                              <span className="absolute text-xl opacity-0 scale-50 transition-all duration-300 group-hover/pdf:opacity-100 group-hover/pdf:scale-110 normal-case">
                                🔒
                              </span>
                            )}
                          </div>

                          <span className="relative font-bold">
                            {user?.plan === "starter" ? "Export PDF" : "Export PDF"}
                          </span>
                        </button>
                      </div>
                    </div>

                    {/* TABLE SECTION */}
                    <div className="overflow-x-auto relative z-10">
                      <table className="w-full border-collapse">
                        <thead>
                          <tr className="bg-slate-50/50 dark:bg-white/[0.01]">
                            <th className="px-8 py-5 text-left text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                              Project Details
                            </th>
                            <th className="px-8 py-5 text-center text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                              Compliance Status
                            </th>
                            <th className="px-8 py-5 text-center text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                              Project Deadline
                            </th>
                            <th className="px-8 py-5 text-center text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                              Suppliers Assigned
                            </th>
                            <th className="px-8 py-5 text-right text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                              Last Project Change
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50 dark:divide-white/[0.03]">
                          {projects
                            .filter((p) => {
                              const query = (
                                projectSearchQuery || ""
                              ).toLowerCase();
                              return (
                                (p.name || "").toLowerCase().includes(query) ||
                                (p.status || "").toLowerCase().includes(query)
                              );
                            })
                            .map((p) => (
                              <tr
                                key={p.id}
                                onClick={() => switchProject(p.id)}
                                className={`group cursor-pointer transition-all duration-300 ${currentProject === p.id
                                  ? "bg-indigo-50 dark:bg-indigo-500/[0.07]"
                                  : "hover:bg-indigo-100/30 dark:hover:bg-white/[0.02]"
                                  }`}
                              >
                                <td className="px-8 py-6">
                                  <div className="flex items-center gap-4">
                                    <div
                                      className={`p-3.5 rounded-2xl transition-all duration-500 shadow-sm dark:shadow-xl ${currentProject === p.id
                                        ? "bg-indigo-600 text-white rotate-3 scale-110 shadow-indigo-200 dark:shadow-indigo-500/20"
                                        : "bg-white dark:bg-slate-900 border border-slate-100 dark:border-white/5 text-slate-400 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 group-hover:border-indigo-100 dark:group-hover:border-indigo-500/30"
                                        }`}
                                    >
                                      <FolderOpen size={18} />
                                    </div>
                                    <div className="flex flex-col">
                                      <span
                                        className={`font-black text-[15px] tracking-tight transition-colors ${currentProject === p.id
                                          ? "text-indigo-900 dark:text-white"
                                          : "text-slate-700 dark:text-slate-300 group-hover:text-indigo-600 dark:group-hover:text-white"
                                          }`}
                                      >
                                        {p.name}
                                      </span>
                                      <span className="text-[9px] font-bold text-slate-400 dark:text-slate-600 uppercase tracking-widest mt-0.5">
                                        REF: {String(p.id).slice(0, 8)}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className="px-8 py-6 text-center">
                                  <span
                                    className={`px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-[0.1em] border-2 shadow-sm inline-block min-w-[110px] transition-transform group-hover:scale-105 ${getStatusStyles(
                                      p.status
                                    )}`}
                                  >
                                    {p.status}
                                  </span>
                                </td>
                                <td className="px-8 py-5 text-center">
                                  <div className="flex flex-col items-center justify-center gap-1">
                                    <div className="flex items-center gap-1.5">
                                      <span className="text-[11px] font-black text-slate-700 dark:text-slate-200 tabular-nums">
                                        {(() => {
                                          if (!p?.deadline) return "No Date Set";
                                          const date = new Date(p.deadline);
                                          return isNaN(date.getTime())
                                            ? "Invalid Date"
                                            : date.toLocaleDateString('en-GB', {
                                              day: '2-digit',
                                              month: 'short',
                                              year: 'numeric'
                                            });
                                        })()}
                                      </span>
                                    </div>

                                    <span className="text-[11px] font-black text-slate-700 dark:text-slate-200 tabular-nums">
                                      {(() => {
                                        if (!p?.deadline) return "No Date Set";
                                        const target = new Date(p.deadline);
                                        if (isNaN(target.getTime())) return "Invalid Date";

                                        // Calculate Days Difference
                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0); // Reset time to compare dates only
                                        const diffTime = target - today;
                                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                        // Styling based on your specific requirements:
                                        // Level 1-2 (8+ days) == green
                                        // Level 3-5 (3-7 days) == orange
                                        // Level 6-8 (0-2 days or overdue) == red
                                        let statusColor = "text-slate-400 dark:text-slate-600";
                                        if (diffDays >= 8) statusColor = "text-emerald-500";
                                        else if (diffDays >= 3) statusColor = "text-orange-500";
                                        else statusColor = "text-rose-500";

                                        return (
                                          <div className="flex flex-col items-center">
                                            <span className={`text-[9px] font-black uppercase tracking-tighter ${statusColor}`}>
                                              {diffDays > 0 ? `${diffDays}  Days  Left` : diffDays === 0 ? "Due Today" : "Overdue"}
                                            </span>
                                          </div>
                                        );
                                      })()}
                                    </span>
                                  </div>
                                </td>
                                <td className="px-8 py-6 text-center">
                                  <div className="flex flex-col items-center">
                                    <span className="text-base font-black text-slate-800 dark:text-white tracking-tighter">
                                      {p.sups?.length || 0}
                                    </span>
                                    <span className="text-[9px] font-black text-slate-400 dark:text-slate-600 uppercase tracking-widest">
                                      Suppliers
                                    </span>
                                  </div>
                                </td>
                                <td className="px-8 py-6 text-right">
                                  <div className="flex flex-col items-end">
                                    {/* User Badge: Shows who made the change */}
                                    <div className="flex items-center gap-1.5 mb-1.5 group cursor-default">
                                      <span className="text-[10px] font-black text-indigo-600 dark:text-cyan-400 uppercase tracking-tight">
                                        {/* Fix: Check for multiple common property names and ensure it's not an empty string */}
                                        {p?.lastUpdatedBy || p?.updatedBy || p?.author || "System"}
                                      </span>
                                      <div className="w-5 h-5 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center border border-slate-200 dark:border-slate-700 group-hover:border-indigo-500/50 transition-colors">
                                        <User size={10} className="text-slate-500 group-hover:text-indigo-500 transition-colors" />
                                      </div>
                                    </div>

                                    {/* Date Display */}
                                    <span className="text-xs font-black text-slate-900 dark:text-white">
                                      {p.lastUpdated
                                        ? new Date(p.lastUpdated).toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        })
                                        : "N/A"}
                                    </span>

                                    {/* Time Display */}
                                    <div className="flex items-center gap-1.5 mt-1 text-slate-400 dark:text-slate-500">
                                      <Timer size={10} />
                                      <span className="text-[9px] font-bold uppercase tracking-widest">
                                        {p.lastUpdated
                                          ? new Date(p.lastUpdated).toLocaleTimeString("en-GB", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })
                                          : "No Activity"}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>

                      {/* EMPTY STATE */}
                      {projects.filter((p) =>
                        (p.name || "")
                          .toLowerCase()
                          .includes((projectSearchQuery || "").toLowerCase())
                      ).length === 0 && (
                          <div className="py-20 flex flex-col items-center justify-center bg-slate-50/20 dark:bg-white/[0.01]">
                            <div className="p-5 rounded-full bg-slate-100 dark:bg-slate-900 text-slate-300 dark:text-slate-700 mb-4 border border-slate-200 dark:border-white/5 shadow-inner">
                              <Search size={32} />
                            </div>
                            <p className="text-slate-400 dark:text-slate-500 font-black uppercase tracking-widest text-[10px]">
                              No matches found
                            </p>
                            <button
                              onClick={() => setProjectSearchQuery("")}
                              className="mt-3 text-indigo-600 dark:text-indigo-400 font-black text-[9px] uppercase tracking-widest hover:underline transition-colors"
                            >
                              Clear filter
                            </button>
                          </div>
                        )}
                    </div>
                  </div>

                  {/* B-BBEE GRAPH */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {/* --- SECTION 1: TRANSFORMATIONAL SPEND MATRIX (DARK MODE REFILL) --- */}
                    <div className="group bg-white dark:bg-slate-950 p-4 md:p-8 rounded-[40px] shadow-[0_32px_64px_-12px_rgba(0,0,0,0.08)] dark:shadow-[0_32px_64px_-12px_rgba(0,0,0,0.6)] text-slate-900 dark:text-white relative overflow-hidden flex flex-col justify-between border border-slate-100 dark:border-white/5 transition-all duration-500 hover:shadow-indigo-500/10">
                      {/* 🚩 DEPTH LAYER: Adaptive Mesh Glow */}
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.05),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

                      <div className="flex items-center justify-between mb-8 relative z-10">
                        <div>
                          <h2 className="text-xl font-black text-slate-900 dark:text-white/90 tracking-tight" style={{
                            filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                          }}>
                            {projects.find(
                              (p) => String(p.id) === String(currentProject)
                            )?.name || "Portfolio"}{" "}
                            Compliance Matrix
                          </h2>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 animate-pulse shadow-[0_0_8px_rgba(99,102,241,0.6)]" />
                            <p className="text-[9px] text-indigo-600 dark:text-indigo-400 font-black uppercase tracking-[0.25em] opacity-80">
                              Strategic Compliance Expenditure
                            </p>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 p-2.5 rounded-2xl backdrop-blur-xl shadow-inner">
                          <CheckCheck
                            size={18}
                            className="text-emerald-500 dark:text-emerald-400 drop-shadow-[0_0_8px_rgba(99,102,241,0.4)]"
                          />
                        </div>
                      </div>

                      <div className="h-[320px] w-full relative z-10">
                        {!beeSpendData ||
                          beeSpendData.length === 0 ||
                          !quote ||
                          quote.length === 0 ? (
                          <div className="flex flex-col items-center justify-center p-20 bg-slate-50 dark:bg-white/[0.02] rounded-[3rem] border-2 border-dashed border-slate-200 dark:border-white/10">
                            <AlertCircle
                              className="text-slate-300 dark:text-slate-700 mb-4"
                              size={48}
                            />
                            <p className="text-slate-400 font-black uppercase tracking-[0.3em] text-[10px]">
                              Awaiting Supplier Data
                            </p>
                          </div>
                        ) : (
                          <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                              data={beeSpendData}
                              margin={{
                                top: 10,
                                right: 10,
                                left: 0,
                                bottom: 20,
                              }}
                            >
                              <CartesianGrid
                                strokeDasharray="0"
                                vertical={false}
                                stroke="currentColor"
                                className="text-slate-100 dark:text-white/5"
                              />
                              <XAxis
                                dataKey="name"
                                axisLine={false}
                                tickLine={false}
                                interval={0}
                                tick={(props) => {
                                  const { x, y, payload } = props;
                                  const levelNum = parseInt(
                                    payload.value.replace(/\D/g, "")
                                  );
                                  let tickColor = "#f43f5e"; // Level 1-2 Green (Style Instruction: Level 1-2 green, 3-5 orange, 6-8 red)
                                  if (levelNum <= 2) tickColor = "#10b981";
                                  else if (levelNum <= 5) tickColor = "#f59e0b";
                                  return (
                                    <text
                                      x={x}
                                      y={y + 15}
                                      fill={tickColor}
                                      textAnchor="middle"
                                      className="text-[10px] font-black tracking-tighter opacity-90"
                                    >
                                      {payload.value}
                                    </text>
                                  );
                                }}
                              />
                              <YAxis
                                axisLine={false}
                                tickLine={false}
                                tick={{
                                  fill: "currentColor",
                                  fontSize: 9,
                                  fontWeight: 900,
                                  className:
                                    "text-slate-400 dark:text-white/30",
                                }}
                                tickFormatter={(v) =>
                                  `R${(v / 1000).toFixed(0)}k`
                                }
                              />
                              <Tooltip
                                allowEscapeViewBox={{ x: false, y: true }} // Changed x to false to keep it inside the container
                                offset={20}
                                // This function prevents the tooltip from overflowing on the right
                                position={({ x, y }) => {
                                  // If the cursor is past 60% of the screen width, move the tooltip to the left of the cursor
                                  const threshold = window.innerWidth * 0.6;
                                  if (x > threshold) {
                                    return { x: x - 280, y: y - 100 }; // 280 accounts for your 260px width + padding
                                  }
                                  return undefined; // Let Recharts handle default positioning for the left/middle
                                }}
                                cursor={{
                                  fill: "currentColor",
                                  className: "pointer-events-none text-slate-50 dark:text-white/5",
                                }}
                                content={({ active, payload, coordinate }) => {
                                  if (active && payload?.length) {
                                    // ... your existing data extraction logic ...
                                    const barData = payload[0].payload;
                                    const currentLevelLabel = barData.originalName;
                                    const levelValue = barData.value;
                                    const uniqueSuppliers = barData.suppliers || [];

                                    // Your existing color logic
                                    const levelNum = parseInt(String(currentLevelLabel).replace(/\D/g, "")) || 0;
                                    let statusColor = "border-rose-500";
                                    if (levelNum > 0 && levelNum <= 2) statusColor = "border-emerald-500";
                                    else if (levelNum > 0 && levelNum <= 5) statusColor = "border-amber-500";

                                    return (
                                      /* Added 'pointer-events-none' to prevent jitter and 'transition-all' for a liquid feel */
                                      <div
                                        className={`bg-white/95 dark:bg-slate-950/90 backdrop-blur-2xl p-5 rounded-[24px] shadow-2xl border-l-[8px] ${statusColor} border border-slate-100 dark:border-white/10 min-w-[260px] relative overflow-hidden pointer-events-none transition-transform duration-200`}
                                      >
                                        {/* ... rest of your beautiful content ... */}
                                        <div className="relative z-10">
                                          <p className="text-[9px] font-black text-slate-400 dark:text-white/40 uppercase tracking-[0.2em] mb-1">
                                            {currentLevelLabel} Contribution
                                          </p>
                                          <p className="text-3xl font-black text-slate-900 dark:text-white tracking-tighter mb-4">
                                            R {levelValue.toLocaleString()}
                                          </p>

                                          <div className="pt-4 border-t border-slate-100 dark:border-white/5">
                                            <div className="flex justify-between items-center mb-3">
                                              <p className="text-[9px] font-black text-indigo-500 dark:text-indigo-400 uppercase tracking-widest">
                                                Suppliers for this Level
                                              </p>
                                              <span className="text-[11px] font-black text-white bg-slate-900 dark:bg-indigo-600 px-2.5 py-0.5 rounded-full shadow-lg">
                                                {uniqueSuppliers.length}
                                              </span>
                                            </div>

                                            <div className="flex flex-wrap gap-1.5 max-w-[250px]">
                                              {uniqueSuppliers.length > 0 ? (
                                                uniqueSuppliers.map((name, idx) => (
                                                  <span
                                                    key={idx}
                                                    className="px-2 py-1 bg-slate-100 dark:bg-white/5 rounded-md text-[10px] font-black text-slate-600 dark:text-slate-300 border border-slate-200/50 dark:border-white/5 shadow-sm"
                                                  >
                                                    {name}
                                                  </span>
                                                ))
                                              ) : (
                                                <span className="text-[9px] font-bold text-slate-400 italic">
                                                  No suppliers in this category.
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                  return null;
                                }}
                              />
                              <Bar
                                dataKey="value"
                                radius={[6, 6, 6, 6]}
                                barSize={32}
                              >
                                {beeSpendData.map((entry, index) => {
                                  const level =
                                    parseInt(entry.name.replace(/\D/g, "")) ||
                                    8;
                                  let barColor = "#f43f5e";
                                  if (level <= 2) barColor = "#10b981";
                                  else if (level <= 5) barColor = "#f59e0b";
                                  return (
                                    <Cell
                                      key={index}
                                      fill={barColor}
                                      className="hover:opacity-80 transition-all duration-300 cursor-pointer"
                                      style={{
                                        filter: `drop-shadow(0 0 8px ${barColor}44)`,
                                      }}
                                    />
                                  );
                                })}
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                        )}
                      </div>

                      {/* 🚩 DECORATIVE GLOWS */}
                      <div className="absolute -top-24 -left-24 w-48 h-48 bg-indigo-500/5 dark:bg-indigo-600/10 rounded-full blur-[80px] pointer-events-none" />
                      <div className="absolute -bottom-12 -right-12 w-40 h-40 bg-indigo-500/5 dark:bg-indigo-500/10 rounded-full blur-[60px] pointer-events-none opacity-50" />
                    </div>
                    {/* --- SECTION 2: GLOBAL PIPELINE DISTRIBUTION --- */}
                    <div className="group bg-white dark:bg-slate-950 p-4 md:p-8 rounded-[40px] shadow-[0_32px_64px_-12px_rgba(0,0,0,0.08)] dark:shadow-[0_32px_64px_-12px_rgba(0,0,0,0.6)] text-slate-900 dark:text-white relative overflow-hidden flex flex-col justify-between border border-slate-100 dark:border-white/5 transition-all duration-500 hover:shadow-indigo-500/10">
                      {/* 🚩 DEPTH LAYER: Adaptive Mesh Glow */}
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none" />
                      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent" />

                      <div className="relative z-10">
                        <div className="flex justify-between items-start mb-6">
                          <div>
                            <h4 className="text-xl font-black tracking-tight text-slate-900 dark:text-white/90" style={{
                              filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                            }}>
                              Portfolio Pulse
                            </h4>
                            <p className="text-indigo-600 dark:text-indigo-400 text-[9px] font-black uppercase tracking-[0.25em] opacity-80">
                              Global Status Distribution
                            </p>
                          </div>
                          <div className="bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 p-2.5 rounded-2xl backdrop-blur-xl shadow-inner">
                            <Zap
                              size={18}
                              className="text-amber-500 dark:text-amber-400 drop-shadow-[0_0_8px_rgba(251,191,36,0.4)]"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="h-[260px] relative mt-2">
                        <ResponsiveContainer width="100%" height="100%">
                          <PieChart>
                            <Pie
                              data={getGlobalReportData().statusData}
                              innerRadius={75}
                              outerRadius={95}
                              paddingAngle={0}
                              dataKey="value"
                              /* 🚩 DYNAMIC STROKE: Matches background mode to prevent "ghost" lines */
                              stroke="currentColor"
                              className="text-white dark:text-slate-950"
                              strokeWidth={2}
                              startAngle={90}
                              endAngle={-270}
                              animationBegin={0}
                              animationDuration={800}
                              animationEasing="ease-out"
                            >
                              {getGlobalReportData().statusData.map(
                                (entry, index) => (
                                  <Cell
                                    key={index}
                                    fill={entry.color}
                                    className="outline-none hover:opacity-80 transition-opacity cursor-pointer"
                                  />
                                )
                              )}
                            </Pie>
                            <Tooltip
                              offset={20}
                              allowEscapeViewBox={{ x: true, y: true }}
                              wrapperStyle={{ outline: "none", zIndex: 100 }}
                              contentStyle={{
                                borderRadius: "20px",
                                backgroundColor:
                                  document.documentElement.classList.contains(
                                    "dark"
                                  )
                                    ? "rgba(15, 23, 42, 0.9)"
                                    : "rgba(255, 255, 255, 0.95)",
                                backdropFilter: "blur(20px)",
                                border: "1px solid",
                                borderColor:
                                  document.documentElement.classList.contains(
                                    "dark"
                                  )
                                    ? "rgba(255, 255, 255, 0.1)"
                                    : "rgba(0, 0, 0, 0.05)",
                                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
                                padding: "10px 14px",
                              }}
                              itemStyle={{
                                fontSize: "9px",
                                fontWeight: "900",
                                textTransform: "uppercase",
                                letterSpacing: "0.1em",
                                color:
                                  document.documentElement.classList.contains(
                                    "dark"
                                  )
                                    ? "#fff"
                                    : "#1e293b",
                              }}
                              labelStyle={{ display: "none" }}
                              cursor={{ fill: "transparent" }}
                            />
                          </PieChart>
                        </ResponsiveContainer>

                        {/* Central Label with Depth */}
                        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                          <div className="relative">
                            <span className="text-5xl font-black tracking-tighter bg-gradient-to-b from-slate-900 to-slate-500 dark:from-white dark:to-slate-400 bg-clip-text text-transparent">
                              {projects.length}
                            </span>
                            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-8 h-2 bg-indigo-500/20 blur-md rounded-full" />
                          </div>
                          <span className="text-[9px] font-black uppercase text-slate-400 dark:text-slate-500 tracking-[0.2em] mt-1">
                            Active Units
                          </span>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-2.5 mt-6 relative z-10">
                        {getGlobalReportData().statusData.map(
                          (entry, index) => (
                            <div
                              key={index}
                              className="bg-slate-50 dark:bg-white/[0.03] border border-slate-100 dark:border-white/[0.05] p-2.5 rounded-2xl flex items-center justify-between hover:bg-slate-100 dark:hover:bg-white/[0.06] transition-colors"
                            >
                              <div className="flex items-center gap-2">
                                <div
                                  className="w-1.5 h-1.5 rounded-full shadow-[0_0_8px_currentcolor]"
                                  style={{
                                    backgroundColor: entry.color,
                                    color: entry.color,
                                  }}
                                />
                                <span className="text-[9px] font-black uppercase text-slate-500 dark:text-slate-400 truncate w-16">
                                  {entry.name}
                                </span>
                              </div>
                              <span className="text-xs font-black text-slate-900 dark:text-white/90">
                                {entry.value}
                              </span>
                            </div>
                          )
                        )}
                      </div>

                      {/* 🚩 DECORATIVE GLOWS: Toned down for Light Mode */}
                      <div className="absolute -top-24 -left-24 w-48 h-48 bg-indigo-500/5 dark:bg-indigo-600/10 rounded-full blur-[80px] pointer-events-none" />
                      <div className="absolute -bottom-12 -right-12 w-40 h-40 bg-emerald-500/5 dark:bg-emerald-500/10 rounded-full blur-[60px] pointer-events-none opacity-50" />
                    </div>
                  </div>

                  {/* TOETS This wrapper forces the content to be exactly the width of the screen and perfectly centered */}
                  <div>
                    <div className="overflow-x-hidden max-w-full group bg-white dark:bg-slate-950 p-10 rounded-[3rem] shadow-[0_32px_64px_-12px_rgba(0,0,0,0.08)] dark:shadow-[0_32px_64px_-12px_rgba(0,0,0,0.6)] text-slate-900 dark:text-white relative border border-slate-100 dark:border-white/5 transition-all duration-500">
                      {/* 🚩 DEPTH LAYER: Adaptive Mesh Glow */}
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.04),transparent_70%)] dark:bg-[radial-gradient(circle_at_50%_0%,rgba(99,102,241,0.15),transparent_70%)] pointer-events-none overflow-hidden" />
                      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-white/10 to-transparent overflow-hidden" />

                      {/* --- HEADER --- */}
                      <div className="relative z-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 px-4 mb-10">
                        <div>
                          <h2 className="text-3xl font-black tracking-tighter text-slate-900 dark:text-white" >
                            <span className="font-bold" style={{
                              filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                            }}>Project</span>{" "}
                            <span className="font-bold bg-gradient-to-r from-indigo-500 to-cyan-400 bg-clip-text text-transparent px-1 drop-shadow-[0_0_8px_rgba(99,102,241,0.3)]">
                              Intelligence
                            </span>
                          </h2>
                          <p className="text-slate-500 dark:text-slate-400 text-sm font-bold uppercase tracking-widest mt-1">
                            Strategic trade-off analysis
                            {(() => {
                              const project = projects.find((p) => p.id === currentProject);
                              return project?.name ? ` FOR: ${project.name}` : "";
                            })()}
                          </p>
                        </div>
                      </div>

                      <div className="relative z-10">
                        {(() => {
                          const efficiencyData = getEfficiencyData();

                          if (efficiencyData.length === 0) {
                            return (
                              <div className="flex flex-col items-center justify-center p-20 bg-slate-50 dark:bg-white/[0.02] rounded-[3rem] border-2 border-dashed border-slate-200 dark:border-white/10">
                                <AlertCircle
                                  className="text-slate-300 dark:text-slate-700 mb-4"
                                  size={48}
                                />
                                <p className="text-slate-400 font-black uppercase tracking-[0.3em] text-[10px]">
                                  Awaiting Supplier Data
                                </p>
                              </div>
                            );
                          }

                          const valueWinner = [...efficiencyData].sort(
                            (a, b) => a.cost - b.cost
                          )[0];
                          const speedWinner = [...efficiencyData].sort(
                            (a, b) => a.leadTime - b.leadTime
                          )[0];
                          const speedAdvantage =
                            Math.max(...efficiencyData.map((d) => d.leadTime)) -
                            speedWinner.leadTime;

                          return (
                            <>
                              {/* MAIN CHART CARD */}
                              <div className="bg-white dark:bg-slate-900/50 rounded-[3rem] p-8 border border-slate-100 dark:border-white/5 shadow-inner relative overflow-hidden hover:shadow-xl hover:shadow-slate-200/50 dark:hover:shadow-none dark:hover:border-slate-700">
                                <div className="absolute inset-0 bg-[radial-gradient(circle_at_100%_100%,rgba(34,211,238,0.03),transparent_40%)] pointer-events-none" />

                                <div className="mb-8 flex justify-between items-end">
                                  <div>
                                    <span className="text-[10px] font-black text-indigo-500 dark:text-indigo-400 uppercase tracking-[0.3em]">
                                      Value Matrix
                                    </span>
                                    <h3 className="text-xl font-black text-slate-800 dark:text-white mt-1">
                                      The Efficiency Frontier
                                    </h3>
                                  </div>
                                  <div className="hidden sm:block text-right">
                                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                                      Ideal Zone
                                    </p>
                                    <p className="text-[11px] font-bold text-emerald-500">
                                      Bottom-Left (Cheap & Fast)
                                    </p>
                                  </div>
                                </div>

                                <div
                                  id="project-intelligence-chart"
                                  className="h-[550px] w-full p-6 bg-white dark:bg-slate-950 rounded-[2rem] border border-slate-100 dark:border-white/5"
                                >
                                  <ResponsiveContainer
                                    width="100%"
                                    height="100%"
                                  >
                                    <ScatterChart
                                      margin={{
                                        top: 40,
                                        right: 20,
                                        bottom: 70,
                                        left: 10,
                                      }}
                                    >
                                      <CartesianGrid
                                        strokeDasharray="3 3"
                                        vertical={false}
                                        stroke={
                                          document.documentElement.classList.contains(
                                            "dark"
                                          )
                                            ? "#1e293b"
                                            : "#f1f5f9"
                                        }
                                      />
                                      <YAxis
                                        type="number"
                                        dataKey="leadTime"
                                        stroke="#64748b"
                                        fontSize={10}
                                        tick={{ dx: -10 }}
                                      >
                                        <Label
                                          value="LEAD TIME (DAYS)"
                                          angle={-90}
                                          position="left"
                                          style={{
                                            textAnchor: "middle",
                                            fill: "#64748b",
                                            fontSize: "9px",
                                            fontWeight: "900",
                                            letterSpacing: "2px",
                                          }}
                                        />
                                      </YAxis>
                                      <XAxis
                                        type="number"
                                        dataKey="cost"
                                        stroke="#64748b"
                                        fontSize={10}
                                        tick={{ dy: 15 }}
                                        tickFormatter={(v) =>
                                          `R${v.toLocaleString()}`
                                        }
                                      >
                                        <Label
                                          value="PROJECT COST (ZAR)"
                                          position="bottom"
                                          offset={50}
                                          style={{
                                            textAnchor: "middle",
                                            fill: "#64748b",
                                            fontSize: "9px",
                                            fontWeight: "900",
                                            letterSpacing: "2px",
                                          }}
                                        />
                                      </XAxis>
                                      <Tooltip
                                        content={({ active, payload }) => {
                                          if (
                                            active &&
                                            payload &&
                                            payload.length
                                          ) {
                                            const data = payload[0].payload;
                                            return (
                                              <div className="bg-slate-950 text-white p-4 rounded-2xl shadow-2xl border border-white/10 backdrop-blur-xl">
                                                <p className="text-[10px] font-black uppercase text-indigo-400 mb-1">
                                                  {data.name}
                                                </p>
                                                <p className="text-xl font-black tracking-tighter">
                                                  R
                                                  {data.cost?.toLocaleString()}
                                                </p>
                                                <p className="text-[10px] font-bold text-slate-400">
                                                  {data.leadTime.toFixed(1)}{" "}
                                                  Days Avg
                                                </p>
                                              </div>
                                            );
                                          }
                                          return null;
                                        }}
                                      />
                                      <Scatter
                                        name="Suppliers"
                                        data={efficiencyData}
                                      >
                                        {efficiencyData.map((entry, index) => (
                                          <Cell
                                            key={`cell-${index}`}
                                            fill={
                                              index === 0
                                                ? "#6366f1"
                                                : "#22d3ee"
                                            }
                                            r={8}
                                            style={{
                                              filter:
                                                "drop-shadow(0px 4px 10px rgba(99,102,241,0.4))",
                                            }}
                                          />
                                        ))}
                                      </Scatter>
                                    </ScatterChart>
                                  </ResponsiveContainer>
                                </div>
                              </div>

                              {/* INSIGHT CARDS */}
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                                {/* CARD 1: BEST VALUE */}
                                <div className="group/card bg-white dark:bg-slate-900 p-8 rounded-[2.5rem] border border-slate-100 dark:border-white/5 relative overflow-hidden transition-all hover:scale-[1.02] shadow-sm hover:shadow-2xl">
                                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/0 to-emerald-500/[0.03] opacity-0 group-hover/card:opacity-100 transition-opacity" />
                                  <div className="relative z-10 flex flex-col xl:flex-row xl:items-center justify-between gap-6">
                                    <div className="space-y-2">
                                      <div className="flex items-center gap-2">
                                        <div className="p-2 bg-emerald-500/10 rounded-lg text-emerald-500">
                                          <Zap size={18} strokeWidth={3} />
                                        </div>
                                        <span className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                                          Value Optimisation
                                        </span>
                                      </div>
                                      <h3 className="text-2xl font-black text-slate-900 dark:text-white tracking-tighter" style={{
                                        filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                      }}>
                                        {valueWinner.name}
                                      </h3>
                                      <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">
                                        Primary candidate for cost-sensitive
                                        procurement.
                                      </p>
                                    </div>
                                    <div className="flex flex-col xl:items-end gap-1">
                                      <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest whitespace-nowrap">
                                        Project Total
                                      </span>
                                      <span className="text-2xl font-black text-emerald-500">
                                        R{valueWinner.cost.toLocaleString()}
                                      </span>
                                      <div className="mt-2 px-3 py-1 bg-emerald-500/10 border border-emerald-500/20 rounded-full">
                                        <span className="text-[9px] font-black text-emerald-500 uppercase">
                                          Lowest Quote
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* CARD 2: SPEED LEADER */}
                                <div className="group/card bg-white dark:bg-slate-900 p-8 rounded-[2.5rem] border border-slate-100 dark:border-white/5 relative overflow-hidden transition-all hover:scale-[1.02] shadow-sm hover:shadow-2xl">
                                  <div className="absolute inset-0 bg-gradient-to-br from-amber-500/0 to-amber-500/[0.03] opacity-0 group-hover/card:opacity-100 transition-opacity" />
                                  <div className="relative z-10 flex flex-col xl:flex-row xl:items-center justify-between gap-6">
                                    <div className="space-y-2">
                                      <div className="flex items-center gap-2">
                                        <div className="p-2 bg-amber-500/10 rounded-lg text-amber-500">
                                          <Timer size={18} strokeWidth={3} />
                                        </div>
                                        <span className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                                          Velocity Leader
                                        </span>
                                      </div>
                                      <h3 className="text-2xl font-black text-slate-900 dark:text-white tracking-tighter" style={{
                                        filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                                      }}>
                                        {speedWinner.name}
                                      </h3>
                                      <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">
                                        Fastest turnaround for critical-path
                                        fulfillment.
                                      </p>
                                    </div>
                                    <div className="flex flex-col xl:items-end gap-1">
                                      <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                                        Lead Time
                                      </span>
                                      <span className="text-2xl font-black text-amber-500">
                                        {speedWinner.leadTime.toFixed(1)}{" "}
                                        <span className="text-xs">Days</span>
                                      </span>
                                      <div className="mt-2 px-3 py-1 bg-amber-500/10 border border-amber-500/20 rounded-full">
                                        <span className="text-[9px] font-black text-amber-500 uppercase">
                                          -{speedAdvantage.toFixed(1)} Days
                                          Saved
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* --- SUPPLIER DELETE SAFETY MODAL --- */}
            {supDeleteWarning.show && (
              <div className="fixed inset-0 z-[1000000] flex items-center justify-center p-4">
                {/* Backdrop */}
                <div
                  className="absolute inset-0 bg-slate-900/60 backdrop-blur-md transition-opacity"
                  onClick={() =>
                    setSupDeleteWarning({ ...supDeleteWarning, show: false })
                  }
                />

                {/* Modal Card */}
                <div className="relative bg-white dark:bg-slate-900 w-full max-w-md rounded-[2.5rem] shadow-2xl border border-slate-100 dark:border-white/10 overflow-hidden transform transition-all">
                  <div className="p-8 flex flex-col items-center text-center">
                    {/* Icon Header - Now Centered */}
                    <div className="w-16 h-16 bg-rose-50 dark:bg-rose-500/10 rounded-2xl flex items-center justify-center mb-6">
                      <ShieldAlert className="text-rose-500" size={32} />
                    </div>

                    {/* Text Content - Now Centered */}
                    <h3 className="text-xl font-black text-slate-900 dark:text-white mb-2">
                      Deletion Blocked
                    </h3>

                    <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-6">
                      You cannot delete{" "}
                      <span className="font-bold text-slate-900 dark:text-white">
                        "{supDeleteWarning.name}"
                      </span>{" "}
                      because it is actively linked to quote slots in the
                      following projects:
                    </p>

                    {/* Project List Tag Cloud - Centered with justify-center */}
                    <div className="flex flex-wrap justify-center gap-2 mb-8">
                      {supDeleteWarning.projects.map((proj, idx) => (
                        <div
                          key={idx}
                          className="px-3 py-1.5 bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-xl"
                        >
                          <span className="text-[10px] font-black text-slate-600 dark:text-slate-300 uppercase tracking-tight">
                            {proj}
                          </span>
                        </div>
                      ))}
                    </div>

                    <div className="space-y-3">
                      <p className="text-[10px] font-bold text-rose-500 uppercase tracking-widest text-center mb-4">
                        Action Required: Remove supplier from these projects
                        first.
                      </p>

                      <button
                        onClick={() =>
                          setSupDeleteWarning({
                            ...supDeleteWarning,
                            show: false,
                          })
                        }
                        className="w-full py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-2xl font-black text-[11px] uppercase tracking-widest hover:opacity-90 transition-all active:scale-95 shadow-lg"
                      >
                        Acknowledge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Somewhere at the bottom of your return() statement */}
            {errorModal.show && (
              /* 🚩 FIXED: Increased Z-Index to 9999 and updated blur for better layering */
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 backdrop-blur-xl animate-in fade-in duration-200">
                <div className="bg-white dark:bg-slate-900 rounded-[32px] shadow-[0_32px_64px_-15px_rgba(0,0,0,0.5)] border border-slate-100 dark:border-white/10 w-full max-w-md overflow-hidden animate-in zoom-in-95 scale-100">
                  {/* Dynamic Header */}
                  <div
                    className={`p-10 flex flex-col items-center justify-center ${errorModal.type === "success"
                      ? "bg-emerald-50 dark:bg-emerald-500/10"
                      : "bg-rose-50 dark:bg-rose-500/10"
                      }`}
                  >
                    <div
                      className={`p-4 rounded-2xl mb-4 shadow-xl ${errorModal.type === "success"
                        ? "bg-emerald-500 text-white shadow-emerald-500/20"
                        : "bg-rose-500 text-white shadow-rose-500/20"
                        }`}
                    >
                      {errorModal.type === "success" ? (
                        <Check size={28} strokeWidth={3} />
                      ) : (
                        <AlertTriangle size={28} strokeWidth={3} />
                      )}
                    </div>
                    <h3
                      className={`text-xl font-black uppercase tracking-tight ${errorModal.type === "success"
                        ? "text-emerald-600 dark:text-emerald-400"
                        : "text-rose-600 dark:text-rose-400"
                        }`}
                    >
                      {errorModal.title}
                    </h3>
                  </div>

                  <div className="p-8">
                    <p className="text-slate-600 dark:text-slate-400 font-medium text-center leading-relaxed px-2">
                      {errorModal.message}
                    </p>

                    <button
                      onClick={() => {
                        // If an onConfirm function exists, run it! 
                        // Otherwise, just close the modal.
                        if (errorModal.onConfirm) {
                          errorModal.onConfirm();
                        } else {
                          setErrorModal({ ...errorModal, show: false });
                        }
                      }}
                      disabled={loading} // 🚩 Prevents double-clicking during DB update
                      className={`mt-8 w-full py-5 rounded-2xl font-black uppercase tracking-widest text-[10px] shadow-lg transition-all active:scale-95 flex items-center justify-center ${errorModal.type === "success"
                        ? "bg-emerald-500 hover:bg-emerald-600 text-white shadow-emerald-500/20"
                        : errorModal.type === "error" && errorModal.onConfirm // 🚩 Specific style for "Danger" actions
                          ? "bg-rose-600 hover:bg-rose-700 text-white shadow-rose-500/20"
                          : "bg-slate-900 dark:bg-white dark:text-slate-900 hover:opacity-90 text-white"
                        } ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
                    >
                      {loading ? (
                        <Loader className="animate-spin" size={18} /> // 🚩 THE SPINNER
                      ) : errorModal.onConfirm ? (
                        "Yes, Disable Security" // 🚩 Label for the Action
                      ) : errorModal.type === "success" ? (
                        "Great, Got it!"
                      ) : (
                        "Okay, continue."
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* Duplicate Supplier Toast Notification */}
            {showDuplicateWarning && (
              <div className="fixed bottom-10 left-1/2 -translate-x-1/2 z-[100] animate-in fade-in slide-in-from-bottom-4 duration-300">
                <div className="bg-white dark:bg-gray-800 border-l-4 border-orange-500 shadow-2xl rounded-2xl p-4 flex items-center gap-4 min-w-[320px]">
                  <div className="bg-orange-100 p-2 rounded-full">
                    <ShieldCheck className="text-orange-600 w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 dark:text-white">
                      Duplicate Supplier
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      <strong>{duplicateName}</strong> is already added to this
                      project.
                    </p>
                  </div>
                  <button
                    onClick={() => setShowDuplicateWarning(false)}
                    className="ml-auto text-gray-400 hover:text-gray-600"
                  >
                    <LogOut className="w-4 h-4 rotate-90" />
                  </button>
                </div>
              </div>
            )}
          </div>

          {showDeleteModal && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-slate-900/40 dark:bg-black/60 backdrop-blur-md">
              {" "}
              <div className="bg-white dark:bg-slate-900 w-full max-w-md rounded-3xl shadow-2xl overflow-hidden transform transition-all border border-slate-100 dark:border-slate-900">
                <div className="p-8 text-center">
                  {/* Warning Icon */}
                  <div className="mx-auto w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-6">
                    <Trash2 size={32} />
                  </div>

                  <h3 className="text-2xl font-black text-slate-900 mb-2">
                    Delete Project?
                  </h3>
                  <p className="text-slate-500 font-medium leading-relaxed mb-8">
                    This will permanently remove the project and all associated
                    quote data.
                    <span className="text-red-500 font-bold">
                      {" "}
                      This action cannot be undone.
                    </span>
                  </p>

                  <div className="flex flex-col gap-3">
                    <button
                      disabled={isDeleting}
                      onClick={confirmDeleteProject}
                      className="w-full py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-bold uppercase tracking-widest transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                    >
                      {isDeleting ? (
                        <>
                          <RefreshCw className="animate-spin font-bold" size={18} />
                          <span className="font-bold">Deleting...</span>
                        </>
                      ) : (
                        "Yes, Delete Forever"
                      )}
                    </button>

                    <button
                      disabled={isDeleting}
                      onClick={() => {
                        setShowDeleteModal(false);
                        setProjectToDelete(null);
                      }}
                      className="w-full py-4 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-2xl font-black uppercase tracking-widest transition-all disabled:opacity-50"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showRevokeModal && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
              <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-md animate-in fade-in duration-500"
                onClick={() => setShowRevokeModal(false)} />

              <div className="relative w-full max-w-lg bg-white dark:bg-slate-900 rounded-[40px] shadow-2xl border border-slate-100 dark:border-white/10 overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-8 duration-500">

                {/* Audit Header */}
                <div className="px-10 pt-10 pb-6">
                  <div className="flex items-start justify-between mb-8">
                    <div className="flex gap-5">
                      <div className="w-14 h-14 rounded-2xl bg-rose-50 dark:bg-rose-500/10 flex items-center justify-center text-rose-600 shadow-sm">
                        <ShieldAlert size={28} strokeWidth={2.5} />
                      </div>
                      <div>
                        <h3 className="text-2xl font-black text-slate-900 dark:text-white tracking-tight">
                          Revoke Access
                        </h3>
                        <p className="text-sm font-bold text-slate-400 uppercase tracking-widest">
                          Log Entry Required
                        </p>
                      </div>
                    </div>
                    <button onClick={() => setShowRevokeModal(false)} className="text-slate-300 hover:text-slate-600 dark:hover:text-white transition-colors">
                      <X size={24} />
                    </button>
                  </div>

                  {/* User Context Area */}
                  <div className="p-5 rounded-2xl bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 mb-8">
                    <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                      You are about to terminate all system permissions for:
                      <span className="block mt-1 font-black text-lg text-slate-900 dark:text-white">
                        {/* FIX: Use the state variable, not the local function variable */}
                        {pendingDeletion?.name || "Selected User"}
                      </span>
                    </p>
                  </div>

                  {/* --- AUDIT INPUTS --- */}
                  <div className="space-y-6">
                    {/* Reason Dropdown */}
                    <div className="space-y-2">
                      <label className="text-[10px] font-black text-indigo-600 uppercase tracking-[0.2em] ml-1">
                        Reason for Revocation
                      </label>
                      <select
                        className="w-full px-5 py-4 bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 rounded-2xl font-bold text-slate-700 dark:text-slate-200 outline-none focus:border-indigo-500 transition-all appearance-none cursor-pointer"
                        onChange={(e) => setRevokeReason(e.target.value)}
                      >
                        <option value="offboarding">Offboarding / Resignation</option>
                        <option value="security">Security Protocol Breach</option>
                        <option value="role_change">Internal Role Change</option>
                        <option value="contract_end">Contract Terminated</option>
                        <option value="other">Other (Specify Below)</option>
                      </select>
                    </div>

                    {/* Optional Note */}
                    <div className="space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] ml-1">
                        Internal Audit Notes (Optional)
                      </label>
                      <textarea
                        placeholder="Provide additional context for the procurement log..."
                        className="w-full px-5 py-4 bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 rounded-2xl text-slate-700 dark:text-slate-200 outline-none focus:border-indigo-500 transition-all min-h-[100px] resize-none"
                      />
                    </div>
                  </div>
                </div>

                {/* Action Footer */}
                <div className="p-8 bg-slate-50 dark:bg-white/5 border-t border-slate-100 dark:border-white/5 flex gap-4">
                  <button
                    onClick={() => setShowRevokeModal(false)}
                    className="flex-1 px-6 py-4 rounded-2xl font-bold text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleFinalRevoke}
                    disabled={isDeleting}
                    className={`flex-[1.5] px-6 py-4 rounded-2xl font-bold shadow-[0_15px_30px_-10px_rgba(225,29,72,0.4)] transition-all flex items-center justify-center gap-2
              ${isDeleting
                        ? 'bg-rose-400 cursor-not-allowed'
                        : 'bg-rose-600 hover:bg-rose-700 hover:-translate-y-1 active:scale-95 text-white'
                      }`}
                  >
                    {isDeleting ? (
                      <>
                        <Loader2 className="animate-spin text-white" size={20} />
                        <span className="font-bold text-white">Terminating...</span>
                      </>
                    ) : (
                      "Confirm Termination"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
          {itemToDelete && (
            <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
              <div
                className="absolute inset-0 bg-slate-900/40 dark:bg-black/60 backdrop-blur-[2px] animate-in fade-in duration-200"
                onClick={() => setItemToDelete(null)}
              />

              <div className="relative bg-white dark:bg-slate-900 w-full max-w-[320px] rounded-[32px] shadow-2xl border border-white dark:border-slate-800 p-8 animate-in zoom-in-95 duration-200">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-red-50 dark:bg-red-500/10 rounded-2xl flex items-center justify-center mb-5 border border-red-100 dark:border-red-500/20">
                    <Trash2 size={28} className="text-red-500" />
                  </div>

                  <h4 className="text-xl font-black text-slate-900 dark:text-white mb-2">
                    Remove Item?
                  </h4>
                  <p className="text-xs text-slate-400 font-bold uppercase tracking-tighter mb-1">
                    Item: {itemToDelete.ref}
                  </p>
                  <p className="text-sm text-slate-500 dark:text-slate-400 font-medium mb-8">
                    This will permanently remove this line from your quote.
                  </p>

                  <div className="flex flex-col w-full gap-2">
                    <button
                      disabled={isModalDeleting}
                      onClick={async () => {
                        setIsModalDeleting(true); // Start spinning
                        try {
                          await removeItem(itemToDelete.id);
                          setItemToDelete(null); // Close modal on success
                        } catch (error) {
                          console.error("Delete failed:", error);
                        } finally {
                          setIsModalDeleting(false); // Stop spinning (if modal stays open)
                        }
                      }}
                      className={`w-full py-4 rounded-2xl font-black text-xs uppercase tracking-widest transition-all flex items-center justify-center gap-2 shadow-lg shadow-red-500/20 ${isModalDeleting
                        ? "bg-red-400 cursor-wait opacity-80"
                        : "bg-red-500 hover:bg-red-600 active:scale-95 text-white"
                        }`}
                    >
                      {isModalDeleting ? (
                        <>
                          <Loader2 size={16} className="animate-spin" />
                          <span className="font-bold">Processing...</span>
                        </>
                      ) : (
                        <>
                          <Trash2 size={16} />
                          <span className="font-bold">Delete Item</span>
                        </>
                      )}
                    </button>

                    <button
                      onClick={() => setItemToDelete(null)}
                      className="w-full py-4 bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 rounded-2xl font-bold text-xs uppercase tracking-widest hover:text-slate-600 dark:hover:text-white transition-all"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {quoteSupToDelete && (
            <div className="fixed inset-0 z-[120] flex items-center justify-center p-6">
              <div
                className="absolute inset-0 bg-slate-900/60 dark:bg-black/80 backdrop-blur-md animate-in fade-in"
                onClick={() => !isDeletingQuote && setQuoteSupToDelete(null)}
              />
              <div className="relative bg-white dark:bg-slate-900 w-full max-w-md rounded-[48px] p-10 shadow-2xl border border-white dark:border-slate-800 animate-in zoom-in-95">
                <div className="flex flex-col items-center text-center">
                  <div className="relative mb-8">
                    {/* Red Pulsing Glow */}
                    <div className="absolute inset-0 bg-red-500/20 rounded-[2.5rem] scale-125 blur-xl animate-pulse" />
                    <div className="w-24 h-24 bg-red-50 dark:bg-red-500/10 rounded-[2.5rem] flex items-center justify-center relative border border-red-200/50">
                      {isDeletingQuote ? (
                        <Loader2
                          size={40}
                          className="text-red-600 animate-spin"
                        />
                      ) : (
                        <ShieldAlert size={40} className="text-red-600" />
                      )}
                    </div>
                  </div>

                  <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tight">
                    Confirm <span className="text-red-500 font-bold">Removal</span>
                  </h3>

                  <p className="text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-8">
                    Are you sure you want to remove the quote for{" "}
                    <span className="font-black text-slate-900 dark:text-white">
                      {supList.find((sl) => sl.id === quoteSupToDelete.sid)
                        ?.name || "this supplier"}
                    </span>
                    ? This action cannot be undone.
                  </p>

                  <div className="flex flex-col w-full gap-4">
                    <button
                      disabled={isDeletingQuote || isSuccess}
                      onClick={async () => {
                        // 🚩 CRITICAL: Capture the ID immediately.
                        // If the modal starts closing, quoteSupToDelete might become null.
                        const idToPurge = quoteSupToDelete?.id;

                        if (!idToPurge) {
                          console.error("No ID found to delete");
                          return;
                        }

                        setIsDeletingQuote(true);

                        try {
                          // 1. Run the deletion with the captured ID
                          await delQuoteSup(idToPurge);

                          // 2. Trigger Success UI
                          setIsDeletingQuote(false);
                          setIsSuccess(true);

                          // 3. Wait for the user to see the "Success" state
                          setTimeout(() => {
                            setIsSuccess(false);
                            setQuoteSupToDelete(null); // NOW close the modal
                          }, 800);
                        } catch (error) {
                          console.error("Delete failed:", error);
                          setIsDeletingQuote(false);
                          // Optional: toast.error("Could not remove quote");
                        }
                      }}
                      className={`group relative overflow-hidden w-full py-5 rounded-[24px] font-black uppercase tracking-widest text-sm transition-all duration-500 shadow-lg flex items-center justify-center gap-3 ${isSuccess
                        ? "bg-emerald-500 text-white scale-95"
                        : isDeletingQuote
                          ? "bg-slate-100 dark:bg-slate-800 text-slate-400 cursor-wait"
                          : "bg-red-600 text-white hover:bg-red-700 hover:shadow-red-500/30 active:scale-95"
                        }`}
                    >
                      {/* Shimmer Effect */}
                      {isDeletingQuote && (
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" />
                      )}

                      {isSuccess ? (
                        <div className="flex items-center gap-2 animate-in zoom-in duration-300">
                          <CheckCheck size={20} />
                          <span>Quote Purged!</span>
                        </div>
                      ) : isDeletingQuote ? (
                        <div className="flex items-center gap-3">
                          <Loader2
                            size={20}
                            className="animate-spin text-red-500"
                          />
                          <span className="animate-pulse">
                            Cleaning Workspace...
                          </span>
                        </div>
                      ) : (
                        <>
                          <Trash2
                            size={20}
                            className="group-hover:animate-bounce"
                          />
                          <span className="font-bold">Remove Supplier Quote</span>
                        </>
                      )}
                    </button>

                    <button
                      disabled={isDeletingQuote}
                      onClick={() => setQuoteSupToDelete(null)}
                      className="w-full py-4 text-slate-400 dark:text-slate-500 font-bold hover:text-slate-800 dark:hover:text-white transition-all disabled:opacity-0"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {duplicateErrorSup && (
            <div className="fixed inset-0 z-[150] flex items-center justify-center p-6">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/40 dark:bg-black/60 backdrop-blur-sm animate-in fade-in"
                onClick={() => setDuplicateErrorSup(null)}
              />

              {/* Modal Card */}
              <div className="relative bg-white dark:bg-slate-900 w-full max-w-[380px] rounded-[40px] p-10 shadow-2xl border-t-4 border-orange-500 animate-in zoom-in-95">
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 bg-orange-50 dark:bg-orange-500/10 rounded-3xl flex items-center justify-center mb-6 border border-orange-100 dark:border-orange-500/20">
                    <AlertTriangle size={32} className="text-orange-500" />
                  </div>

                  <h3 className="text-2xl font-black text-slate-900 dark:text-white mb-2">
                    Already Added
                  </h3>

                  <p className="text-sm text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-8">
                    <span className="font-black text-orange-600 dark:text-orange-400">
                      {duplicateErrorSup.name}
                    </span>{" "}
                    is already being managed in another quote card. Please
                    select a different supplier or edit the existing card.
                  </p>

                  <button
                    onClick={() => setDuplicateErrorSup(null)}
                    className="w-full py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-2xl font-black text-xs uppercase tracking-[0.2em] transition-all hover:scale-[1.02] active:scale-95"
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          )}
          {showDeleteConfirm && (
            <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
              {/* Dimmer Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/40 dark:bg-black/60 backdrop-blur-[2px] animate-in fade-in duration-200"
                onClick={() => setShowDeleteConfirm(false)}
              />

              {/* Modal Card */}
              <div className="relative bg-white dark:bg-slate-900 w-full max-w-[320px] rounded-[32px] shadow-2xl border border-white dark:border-slate-800 p-8 animate-in zoom-in-95 duration-200">
                <div className="flex flex-col items-center text-center">
                  {/* Icon with Red Glow */}
                  <div className="w-16 h-16 bg-red-50 dark:bg-red-500/10 rounded-2xl flex items-center justify-center mb-5 border border-red-100 dark:border-red-500/20">
                    <Trash2 size={28} className="text-red-500" />
                  </div>

                  <h4 className="text-xl font-black text-slate-900 dark:text-white mb-2">
                    Remove Item?
                  </h4>
                  <p className="text-sm text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-8">
                    This will permanently remove this line from your quote.
                  </p>

                  <div className="flex flex-col w-full gap-2">
                    <button
                      onClick={async () => {
                        setIsDeleting(true);
                        await onRemove(localItem.id);
                        setIsDeleting(false);
                        setShowDeleteConfirm(false);
                      }}
                      disabled={isDeleting}
                      className="w-full py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-black text-xs uppercase tracking-widest transition-all shadow-lg shadow-red-500/20 active:scale-95 flex items-center justify-center gap-2"
                    >
                      {isDeleting ? (
                        <Loader2 size={16} className="animate-spin" />
                      ) : (
                        "Delete Item"
                      )}
                    </button>

                    <button
                      onClick={() => setShowDeleteConfirm(false)}
                      className="w-full py-4 bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 rounded-2xl font-bold text-xs uppercase tracking-widest hover:text-slate-600 dark:hover:text-white transition-all"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {supplierToDelete && (
            <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/40 dark:bg-black/60 backdrop-blur-[2px] animate-in fade-in duration-200"
                onClick={() => !isModalDeletingSup && setSupplierToDelete(null)}
              />

              {/* Modal Card */}
              <div className="relative bg-white dark:bg-slate-900 w-full max-w-[320px] rounded-[32px] shadow-2xl border border-white dark:border-slate-800 p-8 animate-in zoom-in-95 duration-200">
                <div className="flex flex-col items-center text-center">
                  {/* Red Warning Icon */}
                  <div className="w-16 h-16 bg-red-50 dark:bg-red-500/10 rounded-2xl flex items-center justify-center mb-5 border border-red-100 dark:border-red-500/20">
                    <Trash2 size={28} className="text-red-500" />
                  </div>

                  <h4 className="text-xl font-black text-slate-900 dark:text-white mb-2">
                    Remove Supplier?
                  </h4>

                  {/* Shows the actual supplier name being deleted */}
                  <p className="text-xs text-red-500 font-black uppercase tracking-widest mb-1 px-2 line-clamp-1">
                    {supplierToDelete.name || "Unnamed Supplier"}
                  </p>

                  <p className="text-sm text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-8">
                    This will permanently remove this supplier from your
                    database.
                  </p>

                  <div className="flex flex-col w-full gap-2">
                    <button
                      disabled={isModalDeletingSup}
                      onClick={async () => {
                        setIsModalDeletingSup(true);
                        try {
                          await delSup(supplierToDelete.id); // Call your parent delSup function
                          setSupplierToDelete(null); // Close modal
                        } catch (err) {
                          console.error("Delete failed", err);
                        } finally {
                          setIsModalDeletingSup(false);
                        }
                      }}
                      className="w-full py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-black text-xs uppercase tracking-widest transition-all shadow-lg shadow-red-500/20 active:scale-95 flex items-center justify-center gap-2"
                    >
                      {isModalDeletingSup ? (
                        <Loader2 size={16} className="animate-spin" />
                      ) : (
                        "Delete Supplier"
                      )}
                    </button>

                    <button
                      disabled={isModalDeletingSup}
                      onClick={() => setSupplierToDelete(null)}
                      className="w-full py-4 bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 rounded-2xl font-bold text-xs uppercase tracking-widest hover:text-slate-600 dark:hover:text-white transition-all"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* REVISION MODE ALERT & CANCEL BUTTON */}
          {isInRevisionMode && (
            <div className="mb-8 p-4 bg-indigo-500/10 border border-indigo-500/20 rounded-[2rem] flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-indigo-500/20 flex items-center justify-center">
                  <RefreshCcw
                    size={14}
                    className="text-indigo-500 animate-spin-slow"
                  />
                </div>
                <div>
                  <p className="text-[10px] font-black text-indigo-600 dark:text-indigo-400 uppercase tracking-widest">
                    Revision Mode
                  </p>
                  <p className="text-[9px] font-bold text-slate-500 uppercase">
                    Adjusting details from rejected request
                  </p>
                </div>
              </div>

              <button
                onClick={() => {
                  setProjectName("");
                  setProjectBudget("");
                  setIsInRevisionMode(false);
                  setShowProjectModal(false);
                  setShowWorkflowModal(true); // 👈 Take them back to where they were!
                }}
                className="px-4 py-2 bg-white dark:bg-white/5 hover:bg-rose-50 dark:hover:bg-rose-500/10 text-slate-500 hover:text-rose-600 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all border border-slate-100 dark:border-white/5"
              >
                Cancel & Go Back
              </button>
            </div>
          )}
          <QuoProIntelligencePanel
            isOpen={isReportSidebarOpen}
            onClose={() => setIsReportSidebarOpen(false)}
            projects={projects}
          />
          <SettingsModal
            showSettingsModal={showSettingsModal}
            setShowSettingsModal={setShowSettingsModal}
            user={user}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            activities={activities} // 🚩 MISSING - Add this now!
            fetchLogs={fetchLogs} // 🚩 MISSING - Add this to trigger the data fetch!
            isLoadingLogs={isLoadingLogs} // 🚩 Optional - Add for the loading spinner
            clearAuditLog={clearAuditLog}
            logout={logout}
            supList={supList}
            projects={projects}
            showTerms={showTerms}
            setShowTerms={setShowTerms}
            billingCycle={billingCycle}
            setBillingCycle={setBillingCycle}
            allUsers={allUsers}
            setAllUsers={setAllUsers}
            updateUserRole={updateUserRole}
            removeTeammate={removeTeammate}
            storage={storage}
            privacyMode={privacyMode}
            setPrivacyMode={setPrivacyMode}
            handleStartMfaSetup={handleStartMfaSetup}
            onDisable2FA={onDisable2FA}
            onMfaVerified={onMfaVerified}
          />
          <ProjectModal
            showProjectModal={showProjectModal}
            setShowProjectModal={setShowProjectModal}
            user={user}
            projects={projects}
            projectName={projectName}
            setProjectName={setProjectName}
            projectBudget={projectBudget}
            setProjectBudget={setProjectBudget}
            projectDeadline={projectDeadline}
            setProjectDeadline={setProjectDeadline}
            isBudgetValid={isBudgetValid}
            isDeadlineValid={isDeadlineValid}
            setIsDeadlineValid={setIsDeadlineValid}
            validateDate={validateDate}
            createProject={createProject}
            isCreating={isCreating}
            showSuccess={showSuccess}
          />
          <SupplierStatsModal
            isOpen={!!selectedSupForStats}
            onClose={() => setSelectedSupForStats(null)}
            supplier={selectedSupForStats}
            projects={projects}
          />
          <AnimatePresence>
            {isCompareModalOpen && (
              <ComparativeModal
                isOpen={isCompareModalOpen}
                onClose={() => setIsCompareModalOpen(false)}
                sups={sups}
                quote={quote}
              />
            )}
          </AnimatePresence>
          {showNotifs && (
            <>
              {/* FULL SCREEN BLUR OVERLAY */}
              <div
                className="fixed inset-0 z-[9998] bg-slate-900/20 dark:bg-black/20 backdrop-blur-md animate-in fade-in duration-500"
                onClick={() => setShowNotifs(false)}
              />

              {/* CENTERED COMMAND CENTRE MODAL */}
              <div
                className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[520px] bg-white/80 dark:bg-slate-950/70 backdrop-blur-3xl border border-white/20 dark:border-white/5 shadow-[0_50px_100px_-20px_rgba(15,23,42,0.3)] dark:shadow-[0_50px_100px_-20px_rgba(0,0,0,0.8)] rounded-[3.5rem] z-[9999] p-2 animate-in zoom-in-95 fade-in duration-300 overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                {/* INTERNAL CONTENT WRAPPER (To maintain padding with custom scroll) */}
                <div className="p-8 max-h-[85vh] flex flex-col">

                  {/* HEADER SECTION */}
                  <div className="flex justify-between items-center mb-8 px-2">
                    <div className="space-y-1">
                      <div className="flex items-center gap-2">
                        <h2 className="text-3xl font-bold text-slate-900 dark:text-white tracking-tighter" style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}>
                          Notification Centre
                        </h2>
                      </div>
                      <p className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.3em]">
                        {notifications.length} Unread Updates
                      </p>
                    </div>

                    <button
                      onClick={() => setShowNotifs(false)}
                      className="h-12 w-12 flex items-center justify-center bg-slate-50 dark:bg-white/5 text-slate-400 hover:text-rose-500 rounded-full transition-all hover:rotate-90"
                    >
                      <X size={20} />
                    </button>
                  </div>

                  {/* GLOBAL ACTIONS ROW */}
                  {notifications.length > 0 && (
                    <div className="flex items-center justify-between mb-6 px-2">
                      <span className="text-[11px] font-bold text-slate-400 dark:text-slate-600 uppercase tracking-widest">
                        Action Required
                      </span>
                      <button
                        onClick={(e) => { e.stopPropagation(); readAllNotifications(); }}
                        disabled={isReadingAll}
                        className="flex items-center gap-2 px-5 py-2.5 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-2xl hover:scale-105 active:scale-95 transition-all shadow-lg shadow-indigo-500/10 disabled:opacity-50"
                      >
                        {isReadingAll ? <Loader2 size={14} className="animate-spin" /> : <CheckCheck size={14} />}
                        <span className="text-[9px] font-black uppercase tracking-widest">Clear Queue</span>
                      </button>
                    </div>
                  )}

                  {/* LIST SECTION */}
                  <div className="custom-scroll space-y-3 overflow-y-auto pr-2 pb-6">
                    <style dangerouslySetInnerHTML={{
                      __html: `
            .custom-scroll::-webkit-scrollbar { width: 4px; }
            .custom-scroll::-webkit-scrollbar-thumb { background: rgba(15, 23, 42, 0.05); border-radius: 20px; }
            .dark .custom-scroll::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.05); }
          `}} />

                    {notifications.length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-20 text-center bg-slate-50/50 dark:bg-white/5 rounded-[2.5rem] border border-dashed border-slate-200 dark:border-white/5">
                        <div className="w-20 h-20 bg-white dark:bg-slate-900 rounded-3xl flex items-center justify-center mb-6 shadow-inner">
                          <Bell size={32} className="text-slate-200 dark:text-slate-700" />
                        </div>
                        <p className="text-[11px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.25em]">No New Notifications</p>
                      </div>
                    ) : (
                      notifications.map((notif) => (
                        <div
                          key={notif._id}
                          className="group relative flex items-center gap-5 p-4 bg-white dark:bg-white/5 border border-slate-100 dark:border-white/5 hover:border-indigo-500/30 rounded-3xl transition-all duration-300 hover:shadow-xl hover:shadow-indigo-500/5 hover:-translate-y-0.5"
                        >
                          {/* ICON WING */}
                          <div className={`w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-inner border transition-all duration-300 ${notif.type === 'project' ? 'bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-500/20' :
                            notif.type === 'supplier' ? 'bg-sky-50 dark:bg-sky-500/10 text-sky-600 dark:text-sky-400 border-sky-100 dark:border-sky-500/20' :

                              // 🟠 LEVEL 3-5: ORANGE TIER (System Actions & Modifications)
                              notif.type === 'user' ? 'bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-100 dark:border-orange-500/20' :
                                notif.type === 'warning' ? 'bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-100 dark:border-orange-500/20' :
                                  notif.type === 'quote' ? 'bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-100 dark:border-orange-500/20' :
                                    notif.type === 'plan' ? 'bg-orange-50 dark:bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-100 dark:border-orange-500/20' :

                                      // 🔴 LEVEL 6-8: RED TIER (System Restrictions & High-Alert Failures)
                                      notif.type === 'error' ? 'bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-500/20' :
                                        notif.type === 'danger' ? 'bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-500/20' :
                                          notif.type === 'limit' ? 'bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-500/20' :

                                            // Default / Fallback
                                            'bg-slate-50 dark:bg-slate-500/10 text-slate-600 dark:text-slate-400 border-slate-100 dark:border-slate-500/20'
                            }`}>
                            {notif.type === 'project' ? <FolderPlus size={20} strokeWidth={1.5} /> :
                              notif.type === 'supplier' ? <Truck size={20} strokeWidth={1.5} /> :
                                notif.type === 'user' ? <UserPlus size={20} strokeWidth={1.5} /> :
                                  notif.type === 'warning' ? <AlertTriangle size={20} strokeWidth={1.5} /> :

                                    // 🟢 NEW SCHEMA TYPES MATCHING
                                    notif.type === 'quote' ? <FileText size={20} strokeWidth={1.5} /> : // Document icon for quotes
                                      notif.type === 'plan' ? <CreditCard size={20} strokeWidth={1.5} /> : // Card icon for subscription plans
                                        notif.type === 'limit' ? <ShieldAlert size={20} strokeWidth={1.5} /> : // Protection lock alert for workspace limits

                                          notif.type === 'error' ? <XCircle size={20} strokeWidth={1.5} /> :
                                            notif.type === 'danger' ? <ShieldAlert size={20} strokeWidth={1.5} /> :
                                              <Zap size={20} strokeWidth={1.5} />}
                          </div>

                          {/* CONTENT WING */}
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-0.5">
                              <span className="text-[9px] font-black uppercase tracking-widest text-indigo-500">{notif.title}</span>
                              <span className="w-1 h-1 rounded-full bg-slate-300 dark:bg-slate-700" />
                              <span className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest opacity-80">
                                {new Intl.DateTimeFormat('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: false
                                }).format(new Date(notif.createdAt)).replace(',', ', ')}
                              </span>
                            </div>
                            <p className="text-[14px] font-semibold text-slate-700 dark:text-slate-200 leading-tight truncate pr-4">
                              {notif.message}
                            </p>
                          </div>

                          {/* QUICK DISMISS */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation(); // Stops the container click event from triggering if you have one
                              readSingleNotification(notif._id);
                            }}
                            className="w-8 h-8 rounded-xl bg-slate-50 dark:bg-slate-800 text-slate-400 hover:text-emerald-500 opacity-0 group-hover:opacity-100 transition-all flex items-center justify-center hover:scale-110"
                          >
                            <Check size={16} strokeWidth={3} />
                          </button>
                        </div>
                      ))
                    )}
                  </div>

                  {/* BOTTOM FADE */}
                  <div className="absolute bottom-0 left-0 w-full h-12 pointer-events-none bg-gradient-to-t from-white dark:from-slate-950 to-transparent rounded-b-[3.5rem]" />
                </div>
              </div>
            </>
          )}
          {workflowToCancel && (
            <>
              {/* OVERLAY */}
              <div className="fixed inset-0 z-[10000] bg-slate-900/60 backdrop-blur-md animate-in fade-in duration-300" />

              {/* MODAL */}
              <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[420px] bg-white dark:bg-slate-950 rounded-[3rem] shadow-[0_50px_100px_-20px_rgba(0,0,0,0.5)] z-[10001] p-10 animate-in zoom-in-95 duration-300 border border-slate-200 dark:border-white/10 text-center">
                <div className="mx-auto w-20 h-20 bg-rose-50 dark:bg-rose-500/10 rounded-[2rem] flex items-center justify-center mb-8 border border-rose-100 dark:border-rose-500/20">
                  <ShieldAlert
                    size={32}
                    className="text-rose-600 dark:text-rose-500 animate-pulse"
                  />
                </div>

                <h3 className="text-2xl font-black text-slate-900 dark:text-white uppercase tracking-tight mb-3">
                  Confirm Action
                </h3>
                <p className="text-[13px] font-medium text-slate-500 dark:text-slate-400 leading-relaxed px-4">
                  Are you sure you want to stop the workflow for <br />
                  <span className="font-black text-slate-900 dark:text-slate-200 underline decoration-rose-500/30">
                    {workflowToCancel.name}
                  </span>
                  ?
                </p>

                <div className="grid grid-cols-2 gap-4 mt-10">
                  <button
                    onClick={() => setWorkflowToCancel(null)}
                    className="py-4 bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-slate-200 dark:hover:bg-white/10 transition-all"
                  >
                    Back
                  </button>

                  {/* 🚩 THE FIX: This MUST call confirmCancelWorkflow */}
                  <button
                    onClick={confirmCancelWorkflow}
                    disabled={isCancelling}
                    className={`py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all shadow-xl active:scale-95 flex items-center justify-center gap-2 ${isCancelling
                      ? "bg-rose-400 cursor-not-allowed text-white/80"
                      : "bg-rose-600 text-white hover:bg-rose-700 shadow-rose-500/20"
                      }`}
                  >
                    {isCancelling ? (
                      <>
                        <Loader2 size={16} className="animate-spin" />
                        <span>Processing...</span>
                      </>
                    ) : (
                      "Confirm"
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
          {showProjectInfo && (
            <div className="fixed inset-0 bg-slate-900/60 dark:bg-slate-950/80 backdrop-blur-md z-[110] flex items-center justify-center p-4">
              <div className="bg-slate-50 dark:bg-slate-900 rounded-[40px] shadow-2xl w-full max-w-6xl max-h-[92vh] overflow-hidden flex flex-col animate-in zoom-in-95 duration-300 border border-white/20 dark:border-slate-800">

                {/* HEADER */}
                <div className="px-10 py-8 bg-white dark:bg-slate-900 border-b border-slate-200/60 dark:border-slate-800 flex justify-between items-center">
                  <div className="flex items-center gap-6">
                    <div className="w-16 h-16 bg-indigo-600 dark:bg-indigo-500 rounded-2xl flex items-center justify-center text-white shadow-xl ring-4 ring-indigo-50 dark:ring-indigo-900/30">
                      <FolderKanban size={32} strokeWidth={2.5} />
                    </div>
                    <div className="flex items-center gap-4 flex-wrap">
                      <h2 className="text-3xl font-black text-slate-900 dark:text-white tracking-tight" style={{
                        filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                      }}>
                        {isEditing ? "Modify Project" : selectedProject.name}
                      </h2>
                      <div className="flex items-center gap-2 pt-1">
                        <span className="px-3 py-1 bg-slate-50 dark:bg-slate-800 text-slate-400 rounded-lg text-[10px] font-black uppercase tracking-[0.1em] border border-slate-200/60 dark:border-slate-700">
                          REF: {selectedProject.id}
                        </span>
                        {!isEditing && (
                          <span className={`px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-[0.1em] border shadow-sm ${getStatusStyles(selectedProject.status)}`}>
                            {selectedProject.status || "Draft"}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <button onClick={() => { setShowProjectInfo(false); setIsEditing(false); }} className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all">
                    <X size={24} />
                  </button>
                </div>

                <div className="flex-1 overflow-y-auto p-10 space-y-10 custom-scrollbar">
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

                    {/* 1. PROJECT SPECS */}
                    <div className="bg-white dark:bg-slate-800/50 p-8 rounded-[35px] border border-slate-200/50 dark:border-slate-800 shadow-sm flex flex-col justify-center">
                      <h3 className="text-indigo-600 dark:text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em] mb-6 flex items-center gap-2">
                        <div className="w-2 h-2 bg-indigo-600 rounded-full" /> Project Specs
                      </h3>
                      <div className="space-y-5">
                        <div>
                          <label className="text-[10px] font-black text-slate-400 uppercase ml-1 mb-2 block">Project Name</label>
                          <input
                            disabled={!isEditing}
                            className={`w-full px-6 py-3 rounded-2xl font-bold transition-all ${isEditing ? "bg-white dark:bg-slate-900 border-2 border-indigo-100 ring-4 ring-indigo-50 text-slate-900 dark:text-white" : "bg-slate-50 dark:bg-slate-800/50 text-slate-500"}`}
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                          />
                        </div>
                        <div>
                          <label className="text-[10px] font-black text-slate-400 uppercase ml-1 mb-2 block flex justify-between items-center">
                            Allocated Budget {!isAuthorized && <Lock size={10} className="text-slate-300 mr-2" />}
                          </label>
                          <div className="relative">
                            <span className="absolute left-5 top-1/2 -translate-y-1/2 font-black text-indigo-600">R</span>
                            <input
                              type="number"
                              value={editBudget}
                              onChange={(e) => setEditBudget(e.target.value)}
                              disabled={!isEditing || !isAuthorized}
                              className={`w-full pl-10 pr-6 py-3 rounded-2xl font-black transition-all ${isEditing && isAuthorized ? "bg-white dark:bg-slate-900 border-2 border-indigo-100 ring-4 ring-indigo-50 text-slate-900 dark:text-white" : "bg-slate-50 dark:bg-slate-800/50 text-slate-500 cursor-not-allowed"}`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 2. COUNTDOWN */}
                    <div className={`p-8 rounded-[35px] transition-all duration-500 relative flex flex-col justify-center items-center text-center overflow-hidden border-2 ${urgency.isUrgent ? "bg-white dark:bg-slate-800 border-rose-500 shadow-[0_0_30px_rgba(239,68,68,0.1)]" : "bg-white dark:bg-slate-800/50 border-slate-100 dark:border-slate-800 shadow-sm"}`}>
                      <div className="flex items-center gap-2 mb-6 z-10">
                        <div className={`w-2 h-2 rounded-full ${urgency.isUrgent ? "bg-rose-500 animate-pulse" : "bg-orange-500"}`} />
                        <p className={`text-[10px] font-black uppercase tracking-[0.2em] ${urgency.isUrgent ? "text-rose-500" : "text-orange-500"}`}>
                          {urgency.expired ? "Project Terminated" : urgency.isUrgent ? "Urgent: Final Hours" : "Project Timeline"}
                        </p>
                      </div>
                      <div className="flex gap-4 z-10">
                        {urgency.expired ? (
                          <span className="text-2xl font-black text-slate-300 uppercase tracking-tighter py-2">Deadline Passed</span>
                        ) : (
                          urgency.parts.map((p, i) => (
                            <div key={i} className="flex flex-col items-center">
                              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center text-3xl font-black transition-colors ${urgency.isUrgent ? "bg-rose-50 dark:bg-rose-900/30 text-rose-600" : "bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white border border-slate-100 dark:border-slate-700"}`}>
                                {String(p.val).padStart(2, "0")}
                              </div>
                              <span className={`text-[9px] font-black uppercase mt-3 tracking-widest ${urgency.isUrgent ? "text-rose-400" : "text-slate-400"}`}>{p.label}</span>
                            </div>
                          ))
                        )}
                      </div>
                      <div className="mt-6 z-10 w-full">
                        {isEditing && isAuthorized ? (
                          <div className="relative">
                            <Calendar size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                            <input type="date" className="w-full bg-slate-50 dark:bg-slate-900 border-2 border-slate-100 dark:border-slate-700 rounded-xl pl-10 pr-4 py-2 text-[11px] font-bold outline-none focus:border-indigo-500" onChange={(e) => setEditDeadline(e.target.value)} />
                          </div>
                        ) : (
                          <div className={`py-2 px-4 rounded-full inline-block ${urgency.isUrgent ? "bg-rose-50 dark:bg-rose-900/30" : "bg-slate-50 dark:bg-slate-900"}`}>
                            <p className={`text-[9px] font-bold uppercase tracking-widest flex items-center gap-2 ${urgency.isUrgent ? "text-rose-500" : "text-slate-500"}`}>
                              {!isAuthorized && <Lock size={10} />} Target: {selectedProject.deadline ? new Date(selectedProject.deadline).toLocaleDateString("en-GB") : "Not Set"}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className={`absolute -right-10 -bottom-10 w-32 h-32 rounded-full blur-3xl opacity-20 ${urgency.isUrgent ? "bg-rose-500" : "bg-indigo-500"}`} />
                    </div>

                    {/* 3. SUPPLIERS */}
                    <div className="bg-white dark:bg-slate-800/50 p-8 rounded-[35px] border border-slate-200/50 dark:border-slate-800 shadow-sm">
                      <h3 className="text-emerald-600 dark:text-emerald-400 text-[10px] font-black uppercase tracking-[0.2em] mb-6 flex items-center gap-2">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full" /> Partnered Suppliers ({selectedProject.sups?.length || 0})
                      </h3>
                      <div className="space-y-3 max-h-[160px] overflow-y-auto pr-2 custom-scrollbar">
                        {supplierData.list.length > 0 ? (
                          supplierData.list.map((s, i) => {
                            const profile = supList?.find(p => String(p.id) === String(s.sid || s.id));
                            const isWinner = supplierData.winnerId && String(s.sid || s.id) === String(supplierData.winnerId);
                            const displayName = profile?.name || s.name || "Unknown Company";
                            return (
                              <div key={i} className={`flex items-center gap-4 p-3 rounded-2xl border transition-all ${isWinner ? "bg-emerald-50 dark:bg-emerald-900/20 border-emerald-200 shadow-sm" : "bg-slate-50 dark:bg-slate-900 border-transparent"}`}>
                                <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-white font-black text-[10px] ${isWinner ? "bg-emerald-500" : "bg-indigo-600"}`}>
                                  {displayName.charAt(0).toUpperCase()}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <div className="flex items-center gap-2 mb-0.5">
                                    <p className="text-xs font-black text-slate-800 dark:text-slate-200 truncate">{displayName}</p>
                                    {isWinner && <span className="px-2 py-0.5 bg-emerald-500 text-white text-[7px] font-black uppercase rounded-full">Winner</span>}
                                  </div>
                                  <p className="text-[8px] font-bold text-slate-400 uppercase">{isWinner ? "Lowest Project Cost" : "Verified Partner"}</p>
                                </div>
                                <div className="text-right">
                                  <p className={`text-[10px] font-black ${isWinner ? "text-emerald-600" : "text-slate-600 dark:text-slate-300"}`}>
                                    R{s.trueTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </p>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="h-full flex flex-col items-center justify-center border-2 border-dashed border-slate-100 rounded-[25px] py-10">
                            <p className="text-[9px] text-slate-400 font-black uppercase tracking-widest text-center">No Vendors Assigned</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* BOTTOM TABLE */}
                  <div className="bg-white dark:bg-slate-800/50 rounded-[35px] border border-slate-200/50 dark:border-slate-800 shadow-sm overflow-hidden flex flex-col">
                    <div className="px-10 py-6 bg-slate-50/50 dark:bg-slate-800 border-b border-slate-100 flex justify-between items-center">
                      <h3 className="text-xs font-black text-slate-500 uppercase tracking-[0.2em] flex items-center gap-3">
                        <div className="w-8 h-8 bg-indigo-600 rounded-xl flex items-center justify-center text-white shadow-lg"><PackageSearch size={16} /></div>
                        Project Quote Items ({selectedProject.quote?.length || 0})
                      </h3>
                    </div>
                    <div className="max-h-[350px] overflow-y-auto custom-scrollbar">
                      <table className="w-full text-left">
                        <thead className="bg-white dark:bg-slate-800 sticky top-0 text-[10px] text-slate-400 uppercase font-black border-b border-slate-50">
                          <tr><th className="px-10 py-5">Item Description</th><th className="px-10 py-5 text-right">Quantity</th></tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50 dark:divide-slate-800">
                          {selectedProject.quote?.map((item, i) => (
                            <tr key={i} className="group hover:bg-indigo-50/30 transition-all">
                              <td className="px-10 py-5">
                                <p className="font-bold text-slate-700 dark:text-slate-200 text-xs uppercase group-hover:text-indigo-600 transition-colors">{item.desc}</p>
                                <p className="text-[9px] text-slate-400 font-bold mt-1 tracking-widest">REF: {item.ref}</p>
                              </td>
                              <td className="px-10 py-5 text-right">
                                <span className="bg-slate-100 dark:bg-slate-900 group-hover:bg-indigo-100 group-hover:text-indigo-600 text-slate-500 px-4 py-2 rounded-xl text-[10px] font-black transition-all">{item.qty}</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* FOOTER ACTIONS */}
                <div className="p-10 bg-white dark:bg-slate-900 border-t border-slate-200/60 dark:border-slate-800 flex justify-center">
                  {isEditing ? (
                    <div className="flex gap-4 w-full max-w-2xl">
                      <button onClick={handleUpdateProjectDetails} disabled={isSaving || isSaved} className={`flex-[2] py-5 text-white rounded-[22px] font-black text-[11px] uppercase tracking-widest shadow-xl transition-all flex items-center justify-center gap-2 ${isSaved ? "bg-emerald-500" : "bg-indigo-600 hover:bg-indigo-700"}`}>
                        {isSaving ? <Loader className="animate-spin" size={18} /> : isSaved ? <CheckCircle2 size={18} /> : <Save size={18} />}
                        {isSaving ? "Saving..." : isSaved ? "Saved!" : "Save Changes"}
                      </button>
                      {!isSaved && <button onClick={() => setIsEditing(false)} className="flex-1 py-5 bg-slate-100 dark:bg-slate-800 text-slate-400 rounded-[22px] font-black text-[11px] uppercase tracking-widest hover:bg-slate-200 transition-all">Discard</button>}
                    </div>
                  ) : (
                    <button onClick={() => {
                      if (!isAuthorized) {
                        setErrorModal({ show: true, title: "Access Restricted", message: "Only Workspace Owners can modify budget settings." });
                        return;
                      }
                      setEditName(selectedProject.name);
                      setEditBudget(selectedProject.budget || 0);
                      setIsEditing(true);
                    }} className={`w-1/3 py-5 rounded-[22px] font-black text-[11px] uppercase tracking-[0.2em] shadow-2xl transition-all flex items-center justify-center gap-3 ${isAuthorized ? "bg-indigo-600 text-white hover:bg-indigo-700" : "bg-slate-100 text-slate-400 cursor-not-allowed"}`}>
                      {isAuthorized ? <Pencil size={18} strokeWidth={2.5} /> : <Lock size={18} strokeWidth={2.5} />}
                      {isAuthorized ? "Update Project" : "View Only"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {showWorkflowModal && (
            <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 md:p-8">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/60 dark:bg-black/80 backdrop-blur-xl animate-in fade-in duration-300"
                onClick={() => setShowWorkflowModal(false)}
              />

              {/* Modal Container */}
              <div className="relative w-full max-w-6xl bg-white/90 dark:bg-slate-900/90 backdrop-blur-2xl rounded-[3rem] shadow-[0_30px_100px_rgba(0,0,0,0.25)] border border-white dark:border-white/5 overflow-hidden flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-300">
                {/* Header Area */}
                <div className="p-8 bg-slate-50/50 dark:bg-white/5 border-b border-slate-100 dark:border-white/5 flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
                      <ClipboardCheck className="text-white" size={24} />
                    </div>
                    <div>
                      <h2 className="text-3xl font-bold text-slate-900 dark:text-white tracking-tighter" >
                        <span className="text-3xl font-bold text-slate-900 dark:text-white tracking-tighter" style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}>Manage</span>
                        <span className="font-bold bg-gradient-to-r from-indigo-500 to-cyan-400 bg-clip-text text-transparent px-1 drop-shadow-[0_0_8px_rgba(99,102,241,0.3)]">
                          Workflows
                        </span>
                      </h2>
                      <p className="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-widest mt-0.5">
                        Request Management & Authorisation
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setShowWorkflowModal(false)}
                      className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all"
                    >
                      <X size={24} />
                    </button>
                  </div>
                </div>

                {/* Main Content (Scrollable) */}
                <div className="flex-1 overflow-y-auto p-8 space-y-8 bg-white/50 dark:bg-transparent">
                  {/* SECTION 1: ADMIN TABS - ONLY OWNER AND LEAD */}
                  {(user?.isOwner ||
                    ["owner", "lead"].includes(user?.role?.toLowerCase())) && (
                      <section className="space-y-4">
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-slate-100 dark:border-white/5 mb-8 pb-4">
                          <div className="flex items-center gap-8">
                            <button
                              onClick={() => setActiveTab("pending")}
                              className={`pb-2 text-[11px] font-black uppercase tracking-[0.2em] transition-all flex items-center gap-2 ${activeTab === "pending"
                                ? "text-indigo-600 dark:text-indigo-400 border-b-2 border-indigo-600"
                                : "text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300"
                                }`}
                            >
                              <div
                                className={`w-1.5 h-1.5 rounded-full ${workflowStats.action.length > 0
                                  ? "bg-rose-500 animate-pulse shadow-[0_0_8px_rgba(244,63,94,0.5)]"
                                  : "bg-slate-300 dark:bg-slate-700"
                                  }`}
                              />
                              Action Required ({workflowStats.action.length})
                            </button>

                            <button
                              onClick={() => setActiveTab("history")}
                              className={`pb-2 text-[11px] font-black uppercase tracking-[0.2em] transition-all flex items-center gap-2 ${activeTab === "history"
                                ? "text-indigo-600 dark:text-indigo-400 border-b-2 border-indigo-600"
                                : "text-slate-400 hover:text-slate-600 dark:text-slate-500"
                                }`}
                            >
                              <HistoryIcon size={14} />
                              Authorisation History
                            </button>
                          </div>

                          {/* --- 🔍 SEARCH BAR (Now In-Line) --- */}
                          <div className="relative group min-w-[300px]">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                              <Search
                                size={14}
                                className="text-slate-400 group-focus-within:text-indigo-500 transition-colors"
                              />
                            </div>
                            <input
                              type="text"
                              placeholder="Filter by name, ID..."
                              value={workflowSearch}
                              onChange={(e) => setWorkflowSearch(e.target.value)}
                              className="w-full bg-slate-100/50 dark:bg-white/5 border border-slate-200/50 dark:border-white/5 rounded-full py-2 pl-10 pr-10 text-[11px] font-bold text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-500/50 transition-all"
                            />
                            {workflowSearch && (

                              <button
                                onClick={() => setWorkflowSearch("")}
                                className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all"
                              >
                                <X size={24} />
                              </button>
                            )}
                          </div>
                        </div>

                        {/* TAB CONTENT TOGGLE */}
                        {activeTab === "pending" ? (
                          /* PENDING VIEW */
                          workflowStats.action.length === 0 ? (
                            <div className="p-10 border-2 border-dashed border-slate-100 dark:border-white/5 rounded-3xl text-center">
                              <p className="text-slate-300 dark:text-slate-700 font-bold uppercase tracking-widest">
                                No new workflows to approve.
                              </p>
                            </div>
                          ) : (
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                              {workflowStats.action
                                .filter((req) => {
                                  const term = workflowSearch.toLowerCase();
                                  return (
                                    req.name?.toLowerCase().includes(term) ||
                                    req.projectName
                                      ?.toLowerCase()
                                      .includes(term) ||
                                    req.id?.toString().includes(term) ||
                                    req.requestedBy?.toLowerCase().includes(term)
                                  );
                                })
                                .map((request) => (
                                  <div
                                    key={request.id}
                                    className={`group bg-white dark:bg-slate-800/40 border border-slate-200 dark:border-white/5 p-6 rounded-[2rem] transition-all duration-300
                          ${exitingId === request.id
                                        ? "animate-slide-out"
                                        : "hover:border-indigo-500 hover:shadow-[0_20px_40px_rgba(0,0,0,0.1)] dark:hover:bg-slate-800/60"
                                      }
                        `}
                                  >
                                    <div className="flex flex-col h-full justify-between">
                                      <div>
                                        <div className="flex items-center gap-3 mb-4">
                                          <span className="text-[9px] font-black text-indigo-600 dark:text-indigo-400 uppercase tracking-widest bg-indigo-50 dark:bg-indigo-500/10 px-2 py-0.5 rounded">
                                            ID: {request.id.toString().slice(-6)}
                                          </span>
                                          <span className="text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest bg-slate-100 dark:bg-white/5 px-2 py-0.5 rounded flex items-center gap-1">
                                            <Layers size={10} />
                                            {request.type || "Project"}
                                          </span>
                                        </div>

                                        <h4 className="text-lg font-black text-slate-900 dark:text-white tracking-tight uppercase mb-4">
                                          {request.name ||
                                            request.projectName ||
                                            "Untitled Request"}
                                        </h4>

                                        <div className="space-y-2 mb-6">
                                          <div className="flex items-center gap-2 text-slate-500">
                                            <User
                                              size={12}
                                              className="text-slate-400"
                                            />
                                            <span className="text-[10px] font-bold uppercase tracking-tight">
                                              From:{" "}
                                              <span className="text-slate-900 dark:text-slate-300">
                                                {request.requestedBy || "Unknown"}
                                              </span>
                                            </span>
                                          </div>
                                          <div className="flex items-center gap-2 text-indigo-600 dark:text-cyan-400">
                                            <Receipt size={12} />
                                            <span className="text-md font-black">
                                              R
                                              {request.totalValue?.toLocaleString()}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="space-y-4 mt-6">
                                        <div className="relative">
                                          <textarea
                                            placeholder="Add a reason for approval or rejection..."
                                            value={
                                              decisionNotes[request.id] || ""
                                            }
                                            onChange={(e) =>
                                              setDecisionNotes({
                                                ...decisionNotes,
                                                [request.id]: e.target.value,
                                              })
                                            }
                                            className="w-full bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 rounded-2xl p-4 text-[11px] font-medium text-slate-700 dark:text-slate-300 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 transition-all resize-none h-20"
                                          />
                                          <MessageSquare
                                            size={14}
                                            className="absolute right-4 top-4 text-slate-300 pointer-events-none"
                                          />
                                        </div>

                                        <div className="flex gap-2">
                                          {/* --- APPROVE BUTTON --- */}
                                          <button
                                            disabled={processingId === request.id}
                                            onClick={() =>
                                              handleAction(request.id, "APPROVED")
                                            }
                                            className="h-[46px] flex-1 py-3 bg-slate-900 dark:bg-indigo-600 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest 
             hover:bg-emerald-600 dark:hover:bg-emerald-500 transition-all flex items-center justify-center gap-2 
             disabled:opacity-50 disabled:cursor-not-allowed font-bold group shadow-sm"
                                          >
                                            {processingId === request.id ? (
                                              <Loader2
                                                size={14}
                                                className="animate-spin"
                                              />
                                            ) : (
                                              <CheckCheck
                                                size={14}
                                                className="group-hover:scale-110 transition-transform"
                                              />
                                            )}
                                            <span>
                                              {processingId === request.id
                                                ? "Processing..."
                                                : "Approve"}
                                            </span>
                                          </button>

                                          {/* --- DECLINE BUTTON --- */}
                                          <button
                                            disabled={processingId === request.id}
                                            onClick={() =>
                                              handleAction(request.id, "REJECTED")
                                            }
                                            className="h-[46px] px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all flex items-center justify-center gap-2
             disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap
             /* LIGHT MODE: Stealth to Red */
             font-bold bg-slate-50 text-slate-400 hover:bg-rose-50 hover:text-rose-600
             
             /* DARK MODE: Transparent Red Glass (Synced with Level 6-8) */
             font-bold dark:bg-white/5 dark:text-slate-500 dark:hover:bg-rose-500/10 dark:hover:text-rose-400"
                                          >
                                            {processingId === request.id ? (
                                              <Loader2
                                                size={14}
                                                className="animate-spin"
                                              />
                                            ) : (
                                              /* No icon originally, but adding X for consistency if you like */
                                              <span className="font-bold group-hover:scale-105 transition-transform">
                                                Decline
                                              </span>
                                            )}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          )
                        ) : (
                          /* HISTORY VIEW */
                          <div className="grid grid-cols-1 gap-4">
                            {workflows.filter((w) => {
                              const term = workflowSearch.toLowerCase();
                              const isHistory = w.status !== "PENDING";
                              const matchesSearch =
                                w.name?.toLowerCase().includes(term) ||
                                w.id?.toString().includes(term) ||
                                w.requestedBy?.toLowerCase().includes(term);
                              return isHistory && matchesSearch;
                            }).length === 0 ? (
                              <div className="p-10 text-center border-2 border-dashed border-slate-100 dark:border-white/5 rounded-[2rem]">
                                <p className="text-slate-300 dark:text-slate-700 font-bold uppercase tracking-widest text-[10px]">
                                  {workflowSearch
                                    ? "No matching history found."
                                    : "No authorisation history recorded."}
                                </p>
                              </div>
                            ) : (
                              workflows
                                .filter((w) => {
                                  const term = workflowSearch.toLowerCase();
                                  const isHistory = w.status !== "PENDING";
                                  const matchesSearch =
                                    w.name?.toLowerCase().includes(term) ||
                                    w.id?.toString().includes(term) ||
                                    w.requestedBy?.toLowerCase().includes(term);
                                  return isHistory && matchesSearch;
                                })
                                .sort(
                                  (a, b) =>
                                    new Date(b.updatedAt || b.createdAt) -
                                    new Date(a.updatedAt || a.createdAt)
                                )
                                .map((request) => {
                                  // Change 'req' to 'request' to match your .map parameter
                                  const statusStr = (
                                    request.status || ""
                                  ).toUpperCase();
                                  const isApproved = statusStr === "APPROVED";
                                  const isPending = statusStr === "PENDING";
                                  const isRejected =
                                    statusStr === "REJECTED" ||
                                    statusStr === "DECLINED";
                                  const isCancelled =
                                    statusStr === "CANCELLED" ||
                                    statusStr === "CANCEL";

                                  // Ensure lastAction also uses 'request'
                                  const lastAction =
                                    request.history?.[request.history.length - 1];
                                  const getTypeIcon = (type) => {
                                    const t = type?.toLowerCase();
                                    if (t?.includes("project"))
                                      return <Briefcase size={12} />;
                                    if (t?.includes("supplier"))
                                      return <Truck size={12} />;
                                    if (t?.includes("quote"))
                                      return <FileText size={12} />;
                                    return <Layers size={12} />;
                                  };

                                  return (
                                    <div
                                      key={request.id}
                                      className="group bg-slate-50/40 dark:bg-white/[0.02] border border-slate-100 dark:border-white/5 p-6 rounded-[2rem] hover:bg-white bg-white dark:hover:bg-white/[0.04] transition-all duration-300"
                                    >
                                      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                                        <div className="flex items-start gap-4">
                                          <div
                                            className={`mt-1 p-2 rounded-xl ${request.status === "APPROVED"
                                              ? "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400"
                                              : "bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-400"
                                              }`}
                                          >
                                            {request.status === "APPROVED" ? (
                                              <CheckCircle2 size={20} />
                                            ) : (
                                              <XCircle size={20} />
                                            )}
                                          </div>
                                          <div>
                                            <div className="flex items-center gap-2 mb-1.5">
                                              <span className="flex items-center gap-1.5 bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 text-[9px] font-black px-2.5 py-1 rounded-lg uppercase tracking-widest border border-indigo-100/50 dark:border-indigo-500/20">
                                                {getTypeIcon(request.type)}
                                                {request.type || "Project"}
                                              </span>
                                              <span className="text-[10px] font-mono text-slate-400 dark:text-slate-600">
                                                #{request.id.toString().slice(-6)}
                                              </span>
                                            </div>
                                            <h4 className="text-sm font-extrabold text-slate-900 dark:text-slate-200 uppercase tracking-tight">
                                              {request.name}
                                            </h4>
                                            <div className="mt-2 flex items-center gap-4">
                                              <div className="flex flex-col">
                                                <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">
                                                  Requested By
                                                </span>
                                                <span className="text-[10px] font-bold text-slate-700 dark:text-slate-400">
                                                  {request.requestedBy}
                                                </span>
                                              </div>
                                              <div className="w-px h-6 bg-slate-200 dark:bg-slate-800" />
                                              <div className="flex flex-col">
                                                <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">
                                                  Total Value
                                                </span>
                                                <span className="text-[10px] font-bold text-emerald-600 dark:text-emerald-400">
                                                  R
                                                  {request.totalValue?.toLocaleString()}
                                                </span>
                                              </div>
                                              {lastAction?.note && (
                                                <div className="mt-3 p-3 bg-slate-100/50 dark:bg-white/5 rounded-xl border-l-2 border-indigo-500">
                                                  <p className="text-[10px] text-slate-500 dark:text-slate-400 font-medium">
                                                    "{lastAction.note}"
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex flex-col md:items-end justify-center py-2 px-4 md:border-l border-slate-100 dark:border-white/5">
                                          <div className="flex items-center gap-2 mb-1">
                                            <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest">
                                              {/* 🚩 DYNAMIC LABEL LOGIC */}
                                              {isApproved && "Approved By:"}
                                              {isPending && "Requested By:"}
                                              {(statusStr === "CANCELLED" ||
                                                statusStr === "CANCEL") &&
                                                "Cancelled By:"}
                                              {isRejected && "Rejected By:"}
                                              {!isApproved &&
                                                !isPending &&
                                                !isRejected &&
                                                statusStr !== "CANCELLED" &&
                                                "Handled By:"}
                                            </span>
                                            <span
                                              className={`text-[10px] font-black uppercase ${statusStr === "CANCELLED"
                                                ? "text-rose-600 dark:text-rose-400"
                                                : "text-slate-900 dark:text-slate-300"
                                                }`}
                                            >
                                              {lastAction?.user ||
                                                req.requestedBy ||
                                                "System"}
                                            </span>
                                          </div>
                                          <div className="flex items-center gap-2 text-slate-400 dark:text-slate-600">
                                            <Clock size={10} />
                                            <span className="text-[9px] font-mono">
                                              {lastAction?.timestamp
                                                ? new Date(
                                                  lastAction.timestamp
                                                ).toLocaleString()
                                                : "N/A"}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                            )}
                          </div>
                        )}
                      </section>
                    )}

                  {/* SECTION 2: EVERYBODY'S SUBMISSIONS (My Requests) */}
                  <section className="space-y-6">
                    <div className="flex items-center justify-between px-2">
                      <h3 className="text-[11px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] flex items-center gap-2">
                        <div className="w-8 h-8 rounded-xl bg-indigo-50 dark:bg-indigo-500/10 flex items-center justify-center shadow-sm">
                          <Timer
                            size={14}
                            className="text-indigo-600 dark:text-indigo-400"
                          />
                        </div>
                        My Request Feed
                      </h3>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1 bg-slate-100 dark:bg-white/5 p-1 rounded-xl border border-slate-200 dark:border-white/10">
                          <button
                            onClick={() => setViewMode("grid")}
                            className={`p-2 rounded-lg transition-all ${viewMode === "grid"
                              ? "bg-white dark:bg-slate-800 shadow-sm text-indigo-600"
                              : "text-slate-400 hover:text-slate-600"
                              }`}
                          >
                            <LayoutGrid size={18} />
                          </button>
                          <button
                            onClick={() => setViewMode("list")}
                            className={`p-2 rounded-lg transition-all ${viewMode === "list"
                              ? "bg-white dark:bg-slate-800 shadow-sm text-indigo-600"
                              : "text-slate-400 hover:text-slate-600"
                              }`}
                          >
                            <List size={18} />
                          </button>
                        </div>
                        <div className="flex flex-col items-end">
                          <span className="text-[10px] font-black text-slate-900 dark:text-slate-200 uppercase tracking-tighter leading-none">
                            {workflowStats.mine.length} Total
                          </span>
                          <span className="text-[8px] font-bold text-slate-400 uppercase tracking-widest">
                            Active Submissions
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        viewMode === "grid"
                          ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
                          : "flex flex-col gap-4" // Increased gap for list breathe-room
                      }
                    >
                      {workflowStats.mine.filter((req) => {
                        const term = workflowSearch.toLowerCase();
                        return (
                          req.name?.toLowerCase().includes(term) ||
                          req.id?.toString().includes(term)
                        );
                      }).length === 0 ? (
                        <div className="col-span-full py-24 border-2 border-dashed border-slate-200 dark:border-white/5 rounded-[3.5rem] flex flex-col items-center justify-center bg-slate-50/30 dark:bg-white/[0.01]">
                          <div className="w-16 h-16 rounded-3xl bg-white dark:bg-white/5 shadow-xl flex items-center justify-center mb-6">
                            <Layers
                              size={24}
                              className="text-slate-300 dark:text-slate-600"
                            />
                          </div>
                          <p className="text-slate-400 dark:text-slate-500 text-[10px] font-black uppercase tracking-[0.3em]">
                            {workflowSearch
                              ? "No matching records"
                              : "Feed is empty"}
                          </p>
                        </div>
                      ) : (
                        workflowStats.mine
                          .filter((req) => {
                            const term = workflowSearch.toLowerCase();
                            return (
                              req.name?.toLowerCase().includes(term) ||
                              req.id?.toString().includes(term)
                            );
                          })
                          .map((req) => {
                            const statusStr = (req.status || "").toUpperCase();
                            const isRejected = statusStr === "REJECTED";
                            const isPending = statusStr === "PENDING";
                            const isApproved = statusStr === "APPROVED";
                            const isDeclined =
                              statusStr === "DECLINED" ||
                              statusStr === "REJECTED";

                            const approvalAction = req.history?.find(
                              (h) => h.status === "APPROVED"
                            );
                            const approvalDate = approvalAction?.timestamp
                              ? new Date(
                                approvalAction.timestamp
                              ).toLocaleDateString("en-ZA", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              : "Not Authorized";

                            // --- GRID VIEW ITEM ---
                            if (viewMode === "grid") {
                              return (
                                <div
                                  key={req.id}
                                  className="group flex flex-col bg-white/80 dark:bg-slate-900/40 backdrop-blur-xl border border-slate-200/60 dark:border-white/[0.08] rounded-[2.5rem] relative overflow-hidden transition-all duration-500 hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.2)] dark:hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6)] hover:-translate-y-3"
                                >
                                  {/* Top Accent Bar - Level Color System */}
                                  <div
                                    className={`h-2.5 w-full ${isApproved
                                      ? "bg-emerald-500 shadow-[0_4_20_rgba(16,185,129,0.4)]" // Level 1-2 Green
                                      : isPending
                                        ? "bg-orange-500 shadow-[0_4_20_rgba(249,115,22,0.4)]" // Level 3-5 Orange
                                        : "bg-red-500 shadow-[0_4_20_rgba(239,68,68,0.4)]" // Level 6-8 Red
                                      }`}
                                  />
                                  <div className="p-9 flex flex-col h-full min-h-[420px]">
                                    {/* ZONE 1: HEADER & IDENTIFICATION */}
                                    <div className="flex justify-between items-start mb-8">
                                      <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-400 dark:text-slate-500 border border-slate-200/50 dark:border-white/5 shadow-sm">
                                          <Layers size={18} />
                                        </div>
                                        <div className="flex flex-col">
                                          <span className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em] leading-none">
                                            {req.type || "Workflow"}
                                          </span>
                                          <span className="text-[9px] font-bold text-indigo-500/60 uppercase tracking-widest mt-1.5">
                                            #{req.id.toString().slice(-4)}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    {/* ZONE 2: CONTENT & METADATA (Spaced Middle) */}
                                    <div className="flex-1 flex flex-col justify-center">
                                      <div className="mb-6">
                                        <h5 className="text-2xl font-black text-slate-900 dark:text-white leading-[1.15] tracking-tight group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors line-clamp-2">
                                          {req.name}
                                        </h5>

                                        <div className="mt-5 space-y-2.5">
                                          {/* Owner Line */}
                                          <div className="flex items-center gap-2.5 text-slate-400">
                                            <div className="w-5 h-5 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center border border-slate-200/50 dark:border-white/5">
                                              <User size={10} />
                                            </div>
                                            <span className="text-[10px] font-bold uppercase tracking-[0.1em] leading-none">
                                              Owner:{" "}
                                              <span className="text-slate-700 dark:text-slate-200 font-black">
                                                {req.requestedBy || "System"}
                                              </span>
                                            </span>
                                          </div>

                                          {/* Approval Date Line - Styled same as Owner */}
                                          <div className="flex items-center gap-2.5 text-slate-400">
                                            <div
                                              className={`w-5 h-5 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center border border-slate-200/50 dark:border-white/5
      `}
                                            >
                                              {/* ICON LOGIC - Synced with the background colors */}
                                              {isApproved ? (
                                                <CheckCircle size={14} />
                                              ) : isPending ? (
                                                <Clock size={14} />
                                              ) : (
                                                /* This handles isDeclined, isCancelling, and the Level 6-8 default */
                                                <XCircle size={14} />
                                              )}
                                            </div>

                                            <span className="text-[10px] font-bold uppercase tracking-[0.1em] leading-none">
                                              Status:{" "}
                                              <span
                                                className={`font-black ${isApproved
                                                  ? "text-emerald-600 dark:text-emerald-400"
                                                  : isPending
                                                    ? "text-orange-600 dark:text-orange-400"
                                                    : "text-rose-600 dark:text-rose-400"
                                                  }`}
                                              >
                                                {req.status}
                                              </span>
                                            </span>
                                          </div>

                                          <div className="flex items-center gap-2.5 text-slate-400">
                                            <div className="w-5 h-5 rounded-lg bg-slate-100 dark:bg-white/5 flex items-center justify-center border border-slate-200/50 dark:border-white/5">
                                              <CalendarCheck size={10} />
                                            </div>
                                            <span className="text-[10px] font-bold uppercase tracking-[0.1em] leading-none">
                                              Date:{" "}
                                              <span className="font-black">
                                                {(() => {
                                                  // 1. Try to find the specific approval timestamp in history
                                                  const approvalEntry =
                                                    req.history?.find(
                                                      (h) =>
                                                        h.status ===
                                                        "APPROVED" ||
                                                        h.status === "Approved"
                                                    );

                                                  // 2. Use approval timestamp, OR fallback to createdAt from your schema, OR final fallback
                                                  const rawDate =
                                                    approvalEntry?.timestamp ||
                                                    req.createdAt ||
                                                    req.updatedAt;

                                                  return rawDate
                                                    ? new Date(
                                                      rawDate
                                                    ).toLocaleDateString(
                                                      "en-ZA",
                                                      {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                      }
                                                    )
                                                    : "N/A";
                                                })()}
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* ZONE 3: FINANCIAL FOOTER */}
                                    <div className="mt-8 pt-7 border-t border-slate-100 dark:border-white/5 flex items-center justify-between">
                                      <div className="flex flex-col">
                                        <span className="text-[9px] font-black text-indigo-500/80 dark:text-indigo-400/80 uppercase tracking-[0.2em] mb-1.5">
                                          Total Authorisation
                                        </span>
                                        <div className="flex items-baseline gap-1.5">
                                          <span className="text-sm font-black text-slate-300 dark:text-slate-600">
                                            R
                                          </span>
                                          <span className="text-4xl font-black text-slate-900 dark:text-white tracking-tighter leading-none">
                                            {req.totalValue?.toLocaleString()}
                                          </span>
                                        </div>
                                      </div>

                                      <div className="flex gap-2">
                                        {/* NEW: CANCEL BUTTON FOR PENDING */}
                                        {isPending && (
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation(); // 🚩 ADD THIS LINE
                                              initiateCancel(req);
                                            }}
                                            className="group/cancel relative w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-800 text-slate-400 hover:text-rose-600 border border-slate-100 dark:border-white/10 rounded-2xl hover:shadow-lg hover:shadow-rose-500/10 transition-all active:scale-90"
                                            title="Cancel Pending Request"
                                          >
                                            <XCircle
                                              size={18}
                                              className="group-hover/cancel:rotate-90 transition-transform duration-500"
                                            />
                                          </button>
                                        )}

                                        {isRejected && (
                                          <button
                                            onClick={() => handleRevise(req)}
                                            className="group/btn w-14 h-14 bg-red-500 text-white rounded-2xl flex items-center justify-center shadow-xl shadow-red-500/30 hover:bg-red-600 transition-all active:scale-90"
                                          >
                                            <RefreshCcw
                                              size={22}
                                              className="group-hover/btn:rotate-180 transition-transform duration-700"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }

                            // --- LIST VIEW ITEM ---
                            return (
                              <div
                                key={req.id}
                                className="group flex items-center bg-white/40 dark:bg-slate-900/40 backdrop-blur-md border border-slate-200/60 dark:border-white/[0.05] rounded-[2rem] p-5 pr-8 transition-all duration-300 hover:bg-white dark:hover:bg-slate-800/80 hover:shadow-[0_15px_30px_-10px_rgba(0,0,0,0.1)] dark:hover:shadow-[0_15px_30px_-10px_rgba(0,0,0,0.5)] hover:border-indigo-500/40"
                              >
                                {/* Left Level Indicator - Thicker and taller for better balance */}
                                <div
                                  className={`w-2 h-14 rounded-full ${isApproved
                                    ? "bg-emerald-500 shadow-[0_0_15px_rgba(16,185,129,0.3)]" // Level 1-2 Green
                                    : isPending
                                      ? "bg-orange-500 shadow-[0_0_15px_rgba(249,115,22,0.3)]" // Level 3-5 Orange
                                      : "bg-red-500 shadow-[0_0_15_rgba(239,68,68,0.3)]" // Level 6-8 Red
                                    } mr-8 ml-2`}
                                />

                                <div className="flex-1 flex items-center justify-between gap-8">
                                  {/* 1. Name & ID - More width priority */}
                                  <div className="flex-1 min-w-[200px]">
                                    <h5 className="text-slate-900 dark:text-slate-100 text-base font-black uppercase tracking-tight truncate group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                                      {req.name}
                                    </h5>
                                    <div className="flex items-center gap-2 mt-1">
                                      <span className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-[0.2em]">
                                        Reference
                                      </span>
                                      <span className="text-[10px] font-mono font-bold text-indigo-500/70">
                                        #{req.id.toString().slice(-4)}
                                      </span>
                                    </div>
                                  </div>

                                  {/* 2. Value - Centered weight */}
                                  <div className="w-32 text-right">
                                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-0.5">
                                      Amount
                                    </p>
                                    <span className="text-slate-900 dark:text-slate-100 font-black text-lg tracking-tighter">
                                      R {req.totalValue?.toLocaleString()}
                                    </span>
                                  </div>

                                  {/* 3. Status Badge - Modern Pill */}
                                  <div className="w-36 flex justify-center">
                                    <span
                                      className={`px-4 py-1.5 rounded-xl text-[9px] font-black uppercase tracking-[0.15em] border-2 ${isApproved
                                        ? "text-emerald-600 bg-emerald-50/50 border-emerald-100 dark:text-emerald-400 dark:bg-emerald-500/10 dark:border-emerald-500/20"
                                        : isPending
                                          ? "text-orange-600 bg-orange-50/50 border-orange-100 dark:text-orange-400 dark:bg-orange-500/10 dark:border-orange-500/20"
                                          : "text-red-600 bg-red-50/50 border-red-100 dark:text-red-400 dark:bg-red-500/10 dark:border-red-500/20"
                                        }`}
                                    >
                                      {req.status}
                                    </span>
                                  </div>
                                  {/* 4. Action Area */}
                                  <div className="w-24 flex justify-end gap-3">
                                    {isPending && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); // 🚩 ADD THIS LINE
                                          initiateCancel(req);
                                        }}
                                        className="group/cancel relative w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-800 text-slate-400 hover:text-rose-600 border border-slate-100 dark:border-white/10 rounded-2xl hover:shadow-lg hover:shadow-rose-500/10 transition-all active:scale-90"
                                        title="Cancel Pending Request"
                                      >
                                        <XCircle
                                          size={18}
                                          className="group-hover/cancel:rotate-90 transition-transform duration-500"
                                        />
                                      </button>
                                    )}

                                    {isRejected ? (
                                      <button
                                        onClick={() => handleRevise(req)}
                                        className="group/btn relative w-12 h-12 flex items-center justify-center bg-red-500 text-white rounded-2xl hover:bg-red-600 shadow-lg shadow-red-500/20 transition-all active:scale-90"
                                      >
                                        <RefreshCcw
                                          size={18}
                                          className="group-hover/btn:rotate-180 transition-transform duration-500"
                                        />
                                      </button>
                                    ) : (
                                      !isPending && (
                                        <div className="flex flex-col items-end gap-1">
                                          <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 flex items-center justify-center text-[12px] font-black text-slate-600 dark:text-slate-400 shadow-sm">
                                            {req.requestedBy
                                              ?.charAt(0)
                                              .toUpperCase()}
                                          </div>
                                          <span className="text-[7px] font-black text-slate-400 uppercase tracking-tighter">
                                            {req.requestedBy}
                                          </span>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      )}
                    </div>
                  </section>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-slate-100 dark:border-white/5 bg-slate-50/80 dark:bg-white/5 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                    <span className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">
                      Workflow Engine Active // System Time:{" "}
                      {new Date().toLocaleTimeString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* SUPPLIER MODAL */}
          {isSupModalOpen && activeSup && (
            <div className="fixed inset-0 z-[150] flex items-center justify-center p-4 sm:p-8">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-slate-950/60 backdrop-blur-xl animate-in fade-in duration-500"
                onClick={() => setIsSupModalOpen(false)}
              />

              {/* Main Modal Container */}
              <div className="relative w-full max-w-6xl bg-white dark:bg-slate-900 rounded-[3.5rem] shadow-[0_40px_80px_-15px_rgba(0,0,0,0.5)] border border-slate-200 dark:border-white/5 flex flex-col h-full max-h-[92vh] overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-10 duration-500">
                {/* 1. HEADER: Deep Slate for both modes for that "Premium" feel */}
                <div className="relative shrink-0 p-6 overflow-hidden bg-slate-900 border-b border-white/10">
                  {/* Subtler decorative glow */}
                  <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-600/5 rounded-full blur-[80px] right-0 translate-x-1/2 -mt-24" />

                  <div className="relative z-10 flex justify-between items-center h-full">
                    {/* Left Side: Icon + Title */}
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded-2xl bg-indigo-600 flex items-center justify-center shadow-xl shadow-indigo-500/20 border border-white/10">
                        <Building2 size={24} className="text-white" />
                      </div>

                      <div className="flex flex-col justify-center">
                        <div className="flex items-center gap-3 mb-0.5">
                          <span className="text-[9px] font-black uppercase tracking-[0.2em] text-indigo-400/80 leading-none">
                            {isViewOnly
                              ? "Registry Record"
                              : "Edit Mode Active"}
                          </span>
                          {isViewOnly && (
                            <button
                              onClick={() => setIsViewOnly(false)}
                              className="group flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-white/5 border border-white/10 text-[8px] font-black uppercase tracking-widest text-white hover:bg-white hover:text-slate-900 transition-all leading-none"
                            >
                              <Edit3 size={10} />
                              Unlock
                            </button>
                          )}
                        </div>
                        <h3 className="text-2xl font-black text-white tracking-tight leading-tight">
                          {activeSup.name || "New Supplier Profile"}
                        </h3>
                      </div>
                    </div>

                    {/* Right Side: Badge + Close */}
                    <div className="flex items-center gap-3">
                      <div
                        className={`px-4 h-11 rounded-xl border flex flex-col items-center justify-center min-w-[110px] backdrop-blur-md transition-all duration-500 shadow-md ${(() => {
                          const level = parseInt(
                            activeSup.beeLevel?.replace("Level ", "")
                          );
                          if (!level || activeSup.beeLevel === "Non-Compliant")
                            return "bg-rose-500/10 border-rose-500/40 text-rose-400";
                          if (level <= 2)
                            return "bg-emerald-500/10 border-emerald-500/40 text-emerald-400 shadow-[0_0_15px_rgba(16,185,129,0.1)]";
                          if (level <= 5)
                            return "bg-orange-500/10 border-orange-500/40 text-orange-400";
                          return "bg-rose-500/10 border-rose-500/40 text-rose-400";
                        })()}`}
                      >
                        <span className="text-[7px] font-black uppercase tracking-widest opacity-60 leading-none mb-1">
                          B-BBEE Status
                        </span>
                        <span className="text-xs font-black uppercase tracking-tight leading-none">
                          {activeSup.beeLevel || "Non-Compliant"}
                        </span>
                      </div>


                      <button
                        onClick={() => setIsSupModalOpen(false)}
                        className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all"
                      >
                        <X size={24} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* 2. AUDIT STRIP */}
                <div className="shrink-0 px-10 py-4 bg-slate-50 dark:bg-black/40 border-b border-slate-200 dark:border-white/5 flex items-center justify-between">
                  <div className="flex items-center gap-6">
                    <div className="flex items-center gap-2.5">
                      <div
                        className={`w-2 h-2 rounded-full ${activeSup.verificationStatus === "verified"
                          ? "bg-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.4)]"
                          : "bg-amber-500"
                          }`}
                      />
                      <span className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-500 dark:text-slate-400">
                        {activeSup.verificationStatus || "Pending Review"}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      <span>
                        Last Check:{" "}
                        <span className="text-slate-900 dark:text-slate-200">
                          {activeSup.lastVerified
                            ? new Date(
                              activeSup.lastVerified
                            ).toLocaleDateString("en-ZA")
                            : "N/A"}
                        </span>
                      </span>
                      <span className="w-1 h-1 rounded-full bg-slate-300 dark:bg-white/10" />
                      <span>
                        By:{" "}
                        <span className="text-indigo-600 dark:text-indigo-400 font-black uppercase">
                          {activeSup.verifiedBy || user?.name || "System"}
                        </span>
                      </span>
                    </div>
                  </div>
                  {isViewOnly && (
                    <button
                      onClick={() => handleManualVerify(activeSup.id)}
                      className="text-[9px] font-black uppercase tracking-widest text-indigo-500 hover:text-indigo-400 transition-colors flex items-center gap-2"
                    >
                      <RefreshCw size={12} /> Sync Registry
                    </button>
                  )}
                </div>
                {/* 3. CONTENT AREA */}
                <div className="flex-1 overflow-y-auto min-h-0 p-12 space-y-16 bg-white dark:bg-slate-900 custom-scrollbar">
                  {/* SECTION 1: IDENTITY */}
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                      <h4 className="text-sm font-black uppercase tracking-widest text-slate-900 dark:text-white">
                        Business Location
                      </h4>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                        Ensure physical addresses match CIPC records for
                        successful verification.
                      </p>
                    </div>
                    <div className="lg:col-span-8 space-y-8">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2 md:col-span-2">
                          <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                            Company Name
                          </label>
                          <input
                            disabled={isViewOnly}
                            value={activeSup.name || ""}
                            onChange={(e) =>
                              setActiveSup({
                                ...activeSup,
                                name: e.target.value,
                              })
                            }
                            className="w-full bg-slate-50 dark:bg-white/5 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-transparent transition-all font-bold outline-none dark:text-white"
                          />
                        </div>
                        <div className="space-y-2">
                          <label className="text-[10px] font-black text-slate-400 uppercase">
                            Business Email
                          </label>
                          {activeSup.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(activeSup.email) && (
                            <span className="text-[10px] font-bold text-orange-500 uppercase animate-pulse ml-1">
                              Invalid Format
                            </span>
                          )}
                          <input
                            disabled={isViewOnly}
                            type="email"
                            value={activeSup.email || ""}
                            onChange={(e) =>
                              setActiveSup({
                                ...activeSup,
                                email: e.target.value,
                              })
                            }
                            placeholder="e.g. contact@supplier.com"
                            className={`w-full p-4 rounded-2xl border transition-all font-bold outline-none 
      ${isViewOnly ? 'opacity-50 cursor-not-allowed' : ''}
      ${!activeSup.email
                                ? 'bg-slate-50 dark:bg-white/5 border-slate-200 dark:border-white/10'
                                : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(activeSup.email)
                                  ? 'bg-white dark:bg-white/10 border-green-500/50 focus:border-green-500 dark:text-white'
                                  : 'bg-orange-50/30 dark:bg-orange-500/5 border-orange-500 focus:border-orange-500 dark:text-white'
                              }`}
                          />
                        </div>
                        <div className="space-y-2">
                          <label className="text-[10px] font-black text-slate-400 uppercase">
                            Phone
                          </label>
                          {activeSup.phone?.length === 10 && (
                            <span className="text-[10px] font-bold text-green-500 uppercase ml-1">
                              Verified Length
                            </span>
                          )}
                          <input
                            disabled={isViewOnly}
                            type="tel" // Optimized for mobile numeric keypads
                            value={activeSup.phone || ""}
                            onChange={(e) => {
                              // 🚩 THE VALIDATION: Only allow numbers and max 10 chars
                              const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                              setActiveSup({
                                ...activeSup,
                                phone: val,
                              });
                            }}
                            placeholder="0123456789"
                            className={`w-full p-4 rounded-2xl border transition-all font-bold outline-none 
      ${isViewOnly ? 'opacity-50 cursor-not-allowed' : 'bg-slate-50 dark:bg-white/5'}
      ${activeSup.phone?.length === 10
                                ? 'border-green-500/50 focus:border-green-500 dark:text-white'
                                : 'border-slate-200 dark:border-white/10 focus:border-indigo-500'
                              }`}
                          />
                        </div>
                      </div>

                      {/* NESTED ADDRESS CARD */}

                      <div className="space-y-3">
                        {/* Section Header */}
                        <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                          Address Details
                        </label>

                        {/* Address Container */}
                        <div className="p-6 rounded-[2.5rem] bg-slate-100/40 dark:bg-white/[0.02] border border-slate-200/60 dark:border-white/5 shadow-inner-sm">
                          <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                            {/* No. */}
                            <div className="space-y-2 md:col-span-2">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                No.
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.no || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      no: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* Street */}
                            <div className="space-y-2 md:col-span-10">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                Street
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.street || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      street: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* Building / Complex */}
                            <div className="space-y-2 md:col-span-6">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                Building / Complex
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.building || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      building: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* Suburb */}
                            <div className="space-y-2 md:col-span-6">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                Suburb
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.suburb || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      suburb: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* City */}
                            <div className="space-y-2 md:col-span-3">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                City
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.city || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      city: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* Province */}
                            <div className="space-y-2 md:col-span-3">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                Province
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.province || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      province: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* Postal */}
                            <div className="space-y-2 md:col-span-3">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                Postal Code
                              </label>
                              <input
                                disabled={isViewOnly}
                                value={activeSup.address?.postalCode || ""}
                                onChange={(e) =>
                                  setActiveSup({
                                    ...activeSup,
                                    address: {
                                      ...activeSup.address,
                                      postalCode: e.target.value,
                                    },
                                  })
                                }
                                className="w-full bg-white dark:bg-slate-900/50 p-4 rounded-2xl border border-slate-200 dark:border-white/10 focus:border-indigo-500 focus:bg-white dark:focus:bg-slate-900 transition-all font-bold outline-none dark:text-white text-sm"
                              />
                            </div>

                            {/* Country */}
                            <div className="space-y-2 md:col-span-3">
                              <label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase ml-1">
                                Country
                              </label>
                              <div className="relative">
                                <select
                                  disabled={isViewOnly}
                                  value={activeSup.address?.country || ""}
                                  onChange={(e) =>
                                    setActiveSup({
                                      ...activeSup,
                                      address: {
                                        ...activeSup.address,
                                        country: e.target.value,
                                      },
                                    })
                                  }
                                  className={`w-full appearance-none bg-white dark:bg-slate-900/50 p-4 rounded-2xl border transition-all font-bold outline-none dark:text-white text-sm cursor-pointer
        ${activeSup.address?.country
                                      ? 'border-green-500/40 focus:border-green-500'
                                      : 'border-slate-200 dark:border-white/10 focus:border-indigo-500'
                                    }`}
                                >
                                  <option value="" disabled>Select Country</option>
                                  {countryList.map((country) => (
                                    <option key={country} value={country} className="dark:bg-slate-900 text-slate-900 dark:text-white">
                                      {country}
                                    </option>
                                  ))}
                                </select>

                                {/* Custom Arrow Icon */}
                                <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr className="border-slate-200 dark:border-white/5" />

                  {/* SECTION 2: REGULATORY */}
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                      <h4 className="text-sm font-black uppercase tracking-widest text-slate-900 dark:text-white">
                        Compliance DNA
                      </h4>
                      <p className="text-xs text-slate-500 mt-2">
                        Required for tax clearance and verification.
                      </p>
                    </div>
                    <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
                          B-BBEE Level
                        </label>
                        <div className="relative">
                          <select
                            disabled={isViewOnly}
                            // Ensure we match the row's "Level 1" vs "Non-Compliant" format
                            value={activeSup.beeLevel || "Non-Compliant"}
                            onChange={(e) =>
                              setActiveSup({
                                ...activeSup,
                                beeLevel: e.target.value,
                              })
                            }
                            className="w-full bg-slate-50 dark:bg-white/5 p-4 rounded-2xl border border-slate-200 dark:border-white/10 font-bold outline-none appearance-none dark:text-white"
                          >
                            {[1, 2, 3, 4, 5, 6, 7, 8].map((lvl) => (
                              <option
                                key={lvl}
                                value={`Level ${lvl}`} // Matches SupplierRow
                                className="text-slate-900 dark:text-white bg-white dark:bg-slate-900"
                              >
                                Level {lvl}
                              </option>
                            ))}
                            <option
                              value="Non-Compliant" // Matches SupplierRow
                              className="text-slate-900 dark:text-white bg-white dark:bg-slate-900"
                            >
                              Non-Compliant
                            </option>
                          </select>
                          <ChevronDown
                            className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                            size={16}
                          />
                        </div>
                      </div>
                      <div className="space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
                          SARS Tax Pin
                        </label>
                        <input
                          disabled={isViewOnly}
                          value={activeSup.sarsTcsPin || ""}
                          onChange={(e) =>
                            setActiveSup({
                              ...activeSup,
                              sarsTcsPin: e.target.value.toUpperCase(),
                            })
                          }
                          className="w-full bg-slate-50 dark:bg-white/5 p-4 rounded-2xl border border-slate-200 dark:border-white/10 font-bold uppercase outline-none dark:text-white placeholder:text-slate-300"
                          placeholder="XXXXXXXXXX"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
                          CIPC Reg Number
                        </label>
                        <input
                          disabled={isViewOnly}
                          value={activeSup.cipcRegNumber || ""}
                          onChange={(e) =>
                            setActiveSup({
                              ...activeSup,
                              cipcRegNumber: e.target.value,
                            })
                          }
                          className="w-full bg-slate-50 dark:bg-white/5 p-4 rounded-2xl border border-slate-200 dark:border-white/10 font-bold outline-none dark:text-white"
                          placeholder="20XX/XXXXXX/XX"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="text-[10px] font-black text-slate-400 uppercase ml-1">
                          VAT Number
                        </label>
                        <input
                          disabled={isViewOnly}
                          value={activeSup.vatNumber || ""}
                          onChange={(e) =>
                            setActiveSup({
                              ...activeSup,
                              vatNumber: e.target.value,
                            })
                          }
                          className="w-full bg-slate-50 dark:bg-white/5 p-4 rounded-2xl border border-slate-200 dark:border-white/10 font-bold outline-none dark:text-white"
                        />
                      </div>
                    </div>
                  </div>

                  <hr className="border-slate-200 dark:border-white/5" />

                  {/* SECTION 3: DOCUMENTS */}
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                      <h4 className="text-sm font-black uppercase tracking-widest text-slate-900 dark:text-white">
                        Document Vault
                      </h4>
                      <p className="text-xs text-slate-500 mt-2">
                        Manage certificates and bank confirmations.
                      </p>
                    </div>
                    <div className="lg:col-span-8">
                      <div className="relative p-10 rounded-[3rem] border-2 border-dashed border-slate-200 dark:border-white/10 bg-slate-50/50 dark:bg-black/20 flex flex-col items-center justify-center text-center group hover:border-indigo-500/50 hover:bg-white dark:hover:bg-indigo-500/5 transition-all">
                        <div className="w-16 h-16 rounded-3xl bg-white dark:bg-indigo-500/10 shadow-sm border border-slate-100 dark:border-white/10 flex items-center justify-center text-indigo-600 mb-4 group-hover:scale-110 transition-transform">
                          <UploadCloud size={32} />
                        </div>
                        <h5 className="text-sm font-black uppercase tracking-widest text-slate-900 dark:text-white">
                          Upload New Documents
                        </h5>
                        <p className="text-[10px] text-slate-400 font-bold uppercase mt-1">
                          PDF, JPG or PNG (Max 10MB)
                        </p>
                        <input
                          type="file"
                          multiple
                          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                          disabled={isViewOnly}
                        />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                        {(activeSup.documents || []).map((doc, idx) => (
                          <div
                            key={idx}
                            className="p-4 rounded-2xl bg-white dark:bg-white/5 border border-slate-200 dark:border-white/5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow"
                          >
                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-500/10 flex items-center justify-center text-indigo-600">
                                <FileText size={18} />
                              </div>
                              <div className="flex flex-col">
                                <span className="text-[10px] font-black uppercase text-slate-900 dark:text-white truncate max-w-[120px]">
                                  {doc.name}
                                </span>
                                <span className="text-[8px] text-slate-400 font-bold">
                                  {doc.size}
                                </span>
                              </div>
                            </div>
                            <button className="p-2 text-slate-400 hover:bg-rose-500/10 hover:text-rose-500 rounded-lg transition-all">
                              <Trash2 size={14} />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <hr className="border-slate-200 dark:border-white/5" />

                  {/* SECTION 4: SETTLEMENT & BANKING VERIFICATION */}
                  <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                      <h4 className="text-sm font-black uppercase tracking-widest text-slate-900 dark:text-white">
                        Settlement Checks
                      </h4>
                      <p className="text-xs text-slate-500 mt-2 leading-relaxed">
                        Internal verification of financial data and procurement
                        eligibility.
                      </p>
                    </div>
                    <div className="lg:col-span-8 flex flex-col sm:flex-row gap-6">
                      {/* Banking Details Checkbox */}
                      <label className="flex-1 group cursor-pointer">
                        <div className="relative p-6 rounded-[2rem] bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 group-hover:border-indigo-500/50 transition-all flex items-start gap-4">
                          <div className="relative flex items-center h-6">
                            <input
                              type="checkbox"
                              disabled={isViewOnly}
                              checked={activeSup.bankingVerified}
                              onChange={(e) =>
                                setActiveSup({
                                  ...activeSup,
                                  bankingVerified: e.target.checked,
                                })
                              }
                              className="peer h-6 w-6 rounded-lg border-2 border-slate-300 dark:border-white/20 bg-transparent text-indigo-600 focus:ring-offset-0 focus:ring-0 transition-all appearance-none checked:bg-indigo-600 checked:border-indigo-600"
                            />
                            <Check className="absolute w-4 h-4 text-white left-1 opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none" />
                          </div>
                          <div>
                            <span className="block text-[11px] font-black uppercase tracking-widest text-slate-900 dark:text-white">
                              Banking Details Verified
                            </span>
                            <span className="block text-[10px] text-slate-500 font-bold uppercase mt-1">
                              Matched against bank confirmation letter
                            </span>
                          </div>
                        </div>
                      </label>

                      {/* Restricted Supplier Checkbox */}
                      <label className="flex-1 group cursor-pointer">
                        <div className="relative p-6 rounded-[2rem] bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 group-hover:border-indigo-500/50 transition-all flex items-start gap-4">
                          <div className="relative flex items-center h-6">
                            <input
                              type="checkbox"
                              disabled={isViewOnly}
                              checked={activeSup.isBlacklisted}
                              onChange={(e) =>
                                setActiveSup({
                                  ...activeSup,
                                  isBlacklisted: e.target.checked,
                                })
                              }
                              className="peer h-6 w-6 rounded-lg border-2 border-slate-300 dark:border-white/20 bg-transparent text-indigo-600 focus:ring-offset-0 focus:ring-0 transition-all appearance-none checked:bg-rose-600 checked:border-rose-600"
                            />
                            <AlertTriangle className="absolute w-4 h-4 text-white left-1 opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none" />
                          </div>
                          <div>
                            <span className="block text-[11px] font-black uppercase tracking-widest text-slate-900 dark:text-white">
                              Registry Restriction
                            </span>
                            <span className="block text-[10px] text-slate-500 font-bold uppercase mt-1">
                              Confirm supplier is not on restricted list
                            </span>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                {/* 4. FOOTER ACTIONS */}
                <div className="shrink-0 p-4 sm:px-8 bg-slate-50/50 dark:bg-black/20 border-t border-slate-200 dark:border-white/5 flex flex-col sm:flex-row items-center gap-3">
                  <button
                    onClick={() => setIsSupModalOpen(false)}
                    className="px-6 py-3 rounded-xl font-black uppercase tracking-[0.15em] text-[9px] text-slate-400 hover:text-slate-900 dark:hover:text-white transition-all flex-1"
                  >
                    {isViewOnly ? "Dismiss Record" : "Discard Changes"}
                  </button>

                  {!isViewOnly && (
                    <button
                      onClick={() => handleSaveSupplier(activeSup)}
                      disabled={isSaving}
                      className="relative px-10 py-3.5 rounded-xl bg-indigo-600 text-white font-black uppercase tracking-[0.15em] text-[10px] shadow-lg shadow-indigo-500/20 hover:bg-indigo-500 active:scale-[0.98] transition-all flex-[2] disabled:opacity-70 disabled:cursor-not-allowed overflow-hidden"
                    >
                      <span
                        className={`text-[11px] tracking-widest font-bold flex items-center justify-center transition-all duration-300 ${isSaving
                          ? "opacity-0 scale-90"
                          : "opacity-100 scale-100"
                          }`}
                      >
                        Update Supplier
                      </span>

                      {isSaving && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-indigo-600 animate-in fade-in duration-200">
                          <div className="flex items-center gap-2">
                            <Loader2
                              className="animate-spin text-white"
                              size={14}
                              strokeWidth={3}
                            />
                            <span className="text-[11px] tracking-widest text-white font-bold">
                              Updating...
                            </span>
                          </div>
                        </div>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {isCompareOpen && winner && runnerUp && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-slate-900/40 dark:bg-black/60 backdrop-blur-md">
              {" "}
              <div className="bg-white dark:bg-slate-900 w-full max-w-6xl rounded-[40px] shadow-2xl overflow-hidden relative animate-in zoom-in-95 duration-300 max-h-[95vh] flex flex-col">
                {/* 1. Header Section */}
                <div className="p-6 border-b border-slate-50 flex justify-between items-center bg-white dark:bg-slate-900 sticky top-0 z-20">
                  <div>
                    <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight">
                      Strategy Benchmarking
                    </h2>
                    <p className="text-[10px] text-slate-400 font-black uppercase tracking-[0.2em]">
                      Comparing{" "}
                      <span className="text-emerald-600">
                        {supList.find(
                          (s) => s.id === winner.sid || s.id === winner.id
                        )?.name || "Winner"}
                      </span>{" "}
                      <span
                        className="font-bold text-slate-900"
                        style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}
                      >vs</span>{" "}
                      <span className="text-indigo-600">
                        {supList.find(
                          (s) => s.id === runnerUp.sid || s.id === runnerUp.id
                        )?.name || "Runner-up"}
                      </span>
                    </p>
                  </div>
                  <button
                    onClick={() => setIsCompareOpen(false)}
                    className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all"
                  >
                    <X size={24} />
                  </button>
                </div>

                <div className="overflow-y-auto flex-grow bg-white">
                  {/* 2. Variance Profile Graph */}
                  <div className="px-8 py-6 bg-slate-50/50 border-b border-slate-100">
                    <div className="max-w-4xl mx-auto bg-white rounded-[32px] p-8 border border-slate-200/60 shadow-sm relative">
                      <div className="flex justify-between items-center mb-6 px-2">
                        <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                          Bid Variance Profile
                        </span>
                        <div className="flex gap-4">
                          <div className="flex items-center gap-2">
                            <div className="w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.4)]" />
                            <span className="text-[9px] font-black text-slate-600 uppercase tracking-tighter">
                              Winner Price
                            </span>
                          </div>
                          <div className="flex items-center gap-2">
                            <div className="w-2 h-2 rounded-full bg-indigo-500 shadow-[0_0_8px_rgba(99,102,241,0.4)]" />
                            <span className="text-[9px] font-black text-slate-600 uppercase tracking-tighter">
                              Runner Up Price
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="h-[240px] w-full">
                        <ResponsiveContainer width="100%" height="100%">
                          <AreaChart
                            data={quote.map((item) => ({
                              ref: item.ref,
                              desc: item.desc,
                              "Winner Price": Number(
                                winner.quotes?.[item.ref]?.price || 0
                              ),
                              "Runner Up Price": Number(
                                runnerUp.quotes?.[item.ref]?.price || 0
                              ),
                            }))}
                            margin={{
                              top: 10,
                              right: 10,
                              left: 20,
                              bottom: 20,
                            }}
                          >
                            <defs>
                              <linearGradient
                                id="colorWin"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor="#10b981"
                                  stopOpacity={0.15}
                                />
                                <stop
                                  offset="95%"
                                  stopColor="#10b981"
                                  stopOpacity={0}
                                />
                              </linearGradient>
                            </defs>
                            <CartesianGrid
                              strokeDasharray="3 3"
                              vertical={false}
                              stroke={
                                document.documentElement.classList.contains(
                                  "dark"
                                )
                                  ? "#1e293b"
                                  : "#f1f5f9"
                              }
                            />
                            <XAxis dataKey="ref" hide />
                            <YAxis
                              fontSize={9}
                              stroke="#94a3b8"
                              tickFormatter={(v) => `R${v}`}
                              tickLine={false}
                              axisLine={false}
                            >
                              <Label
                                value="SUPPLIER PRICE"
                                angle={-90}
                                position="insideLeft"
                                style={{
                                  textAnchor: "middle",
                                  fill: "#94a3b8",
                                  fontSize: "9px",
                                  fontWeight: "900",
                                  letterSpacing: "2px",
                                }}
                              />
                            </YAxis>
                            <Tooltip
                              cursor={{ stroke: "#e2e8f0", strokeWidth: 1 }}
                              content={({ active, payload }) => {
                                if (active && payload && payload.length) {
                                  const data = payload[0].payload;
                                  return (
                                    <div className="bg-slate-900 text-white p-4 rounded-2xl shadow-2xl border border-white/10 min-w-[200px]">
                                      <p className="text-[9px] font-black text-slate-400 uppercase mb-2 border-b border-white/10 pb-2">
                                        {data.ref}: {data.desc}
                                      </p>
                                      <div className="flex justify-between items-center mb-1">
                                        <span className="text-[10px] font-bold text-emerald-400 uppercase">
                                          Winner
                                        </span>
                                        <span className="text-sm font-black text-white">
                                          R
                                          {data[
                                            "Winner Price"
                                          ].toLocaleString()}
                                        </span>
                                      </div>
                                      <div className="flex justify-between items-center">
                                        <span className="text-[10px] font-bold text-indigo-400 uppercase">
                                          Runner Up
                                        </span>
                                        <span className="text-sm font-black text-white/80">
                                          R
                                          {data[
                                            "Runner Up Price"
                                          ].toLocaleString()}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                                return null;
                              }}
                            />
                            <Area
                              type="monotone"
                              dataKey="Winner Price"
                              stroke="#10b981"
                              strokeWidth={4}
                              fillOpacity={1}
                              fill="url(#colorWin)"
                            />
                            <Area
                              type="monotone"
                              dataKey="Runner Up Price"
                              stroke="#6366f1"
                              strokeWidth={1.5}
                              fillOpacity={0}
                            />
                          </AreaChart>
                        </ResponsiveContainer>
                        <div className="text-center mt-4 text-[9px] font-black text-slate-400 uppercase tracking-[0.3em]">
                          Supplier Items Trend
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 3. Detailed Comparison Table */}
                  <div className="p-0">
                    <table className="w-full border-collapse">
                      <thead className="sticky top-0 bg-white z-10 shadow-sm">
                        <tr className="border-b border-slate-100">
                          <th className="p-5 text-[9px] font-black text-slate-400 uppercase tracking-widest bg-slate-50/30 text-left">
                            Line Item Detail
                          </th>
                          <th className="p-5 text-[9px] font-black text-slate-400 uppercase tracking-widest bg-slate-50/30 text-center">
                            Qty
                          </th>
                          <th className="p-5 text-[9px] font-black text-emerald-600 uppercase tracking-widest bg-emerald-50/20 text-right">
                            {supList.find(
                              (s) => s.id === winner.sid || s.id === winner.id
                            )?.name || "Winner"}
                          </th>
                          <th className="p-5 text-[9px] font-black text-indigo-600 uppercase tracking-widest bg-indigo-50/10 text-right">
                            {supList.find(
                              (s) =>
                                s.id === runnerUp.sid || s.id === runnerUp.id
                            )?.name || "Runner-up"}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-50">
                        {quote.map((item, idx) => {
                          const wPrice = Number(
                            winner.quotes?.[item.ref]?.price || 0
                          );
                          const rPrice = Number(
                            runnerUp.quotes?.[item.ref]?.price || 0
                          );
                          const isWinLower =
                            wPrice > 0 && (rPrice === 0 || wPrice <= rPrice);
                          return (
                            <tr
                              key={idx}
                              className="hover:bg-slate-50/30 transition-colors"
                            >
                              <td className="p-5">
                                <div className="text-sm font-bold text-slate-800 leading-none mb-1">
                                  {item.desc}
                                </div>
                                <div className="text-[9px] text-slate-400 font-bold uppercase tracking-tight">
                                  {item.ref}
                                </div>
                              </td>
                              <td className="p-5 text-center text-xs font-black text-slate-500">
                                {item.qty}
                              </td>
                              <td
                                className={`p-5 text-right font-black text-sm ${isWinLower
                                  ? "bg-emerald-50/60 text-emerald-700"
                                  : "text-slate-300"
                                  }`}
                              >
                                {wPrice > 0
                                  ? `R ${(wPrice * item.qty).toLocaleString()}`
                                  : "—"}
                              </td>
                              <td
                                className={`p-5 text-right font-black text-sm ${!isWinLower
                                  ? "bg-indigo-50/30 text-indigo-700"
                                  : "text-slate-300"
                                  }`}
                              >
                                {rPrice > 0
                                  ? `R ${(rPrice * item.qty).toLocaleString()}`
                                  : "—"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* 4. Action Footer with Fixed Math Logic */}
                <div className="p-6 bg-slate-900 flex justify-between items-center shrink-0">
                  <div className="flex gap-8 items-center">
                    <div className="flex flex-col">
                      <span className="text-[9px] font-black text-slate-500 uppercase block mb-1 tracking-widest">
                        Procurement Impact
                      </span>
                      <div className="flex items-center gap-3">
                        <div className="flex items-center gap-3">
                          <span className="text-xl font-black text-emerald-400">
                            R {stats?.rawDiff.toLocaleString()}
                          </span>
                          <span className="px-2 py-1 bg-emerald-500/20 text-emerald-400 text-[10px] font-black rounded-lg">
                            {stats?.savingsPct}% Saved
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="h-10 w-px bg-white/10" />

                    <div className="hidden sm:block">
                      <span className="text-[9px] font-black text-slate-500 uppercase block mb-1 tracking-widest">
                        Market Strategy
                      </span>
                      <div className="flex items-center gap-2">
                        <ShieldCheck size={14} className="text-indigo-400" />
                        <span className="text-xs font-black text-white uppercase tracking-tight">
                          Optimized Cost Path
                        </span>
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => setIsCompareOpen(false)}
                    className="px-10 py-4 bg-emerald-500 hover:bg-emerald-400 text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] transition-all shadow-xl shadow-emerald-900/40 active:scale-95 group"
                  >
                    Confirm Strategy
                    <ArrowRight
                      size={14}
                      className="inline-block ml-2 group-hover:translate-x-1 transition-transform"
                    />
                  </button>
                </div>
              </div>
            </div>
          )}
          {showScrollTop && (
            <button
              onClick={scrollToTop}
              // 🚩 POSITION: The "Perfect" Middle Ground (32px from left)
              className="fixed bottom-7 left-7 z-[100] 
               flex items-center
               h-12 w-12 hover:w-40
               bg-white/80 dark:bg-slate-900/80 backdrop-blur-md
               text-indigo-500
               rounded-full shadow-xl
               border border-slate-200 dark:border-slate-800
               hover:border-indigo-500/50
               transition-all duration-500 ease-[cubic-bezier(0.2,1,0.3,1)]
               animate-in fade-in slide-in-from-left-6
               group overflow-hidden"
            >
              {/* Inner Track */}
              <div className="flex items-center w-full px-[14px]">
                {/* Icon Container */}
                <div className="flex items-center justify-center w-5 shrink-0">
                  <ArrowUp
                    size={18}
                    strokeWidth={3}
                    className="group-hover:-translate-y-1 transition-transform duration-300"
                  />
                </div>

                {/* Label */}
                <span
                  className="ml-4 opacity-0 scale-95 whitespace-nowrap overflow-hidden
                     group-hover:opacity-100 group-hover:scale-100
                     transition-all duration-300 delay-100
                     text-[10px] font-bold uppercase tracking-[0.25em] text-slate-600 dark:text-slate-300"
                >
                  Back to Top
                </span>
              </div>

              {/* Elegant Surface Detail */}
              <div className="absolute inset-x-0 top-0 h-1/2 bg-white/20 dark:bg-white/5 pointer-events-none" />
            </button>
          )}
          {/* CLEAR CONFIRMATION MODAL */}
          {showClearConfirmProject && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-6">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/60 dark:bg-black/80 backdrop-blur-md animate-in fade-in duration-500"
                onClick={() =>
                  !isClearingProject && setShowClearConfirmProject(false)
                }
              />

              {/* Modal Card - Exact Replica of Modal B */}
              <div className="relative bg-white dark:bg-slate-900 w-full max-w-md rounded-[48px] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.3)] dark:shadow-[0_32px_64px_-16px_rgba(0,0,0,0.6)] border border-white dark:border-slate-800 p-10 animate-in zoom-in-95 duration-300">
                <div className="flex flex-col items-center text-center">
                  <div className="relative mb-8">
                    {/* Red Pulse Glow */}
                    <div className="absolute inset-0 bg-red-500/20 dark:bg-red-500/10 rounded-[2.5rem] scale-125 blur-xl animate-pulse" />
                    <div className="w-24 h-24 bg-gradient-to-br from-red-50 to-red-100 dark:from-red-950/40 dark:to-red-900/40 rounded-[2.5rem] flex items-center justify-center relative border border-red-200/50 dark:border-red-500/20">
                      <ShieldAlert
                        size={40}
                        className="text-red-600 dark:text-red-500"
                      />
                    </div>
                  </div>

                  <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tight">
                    Clear All <span className="text-red-500 font-bold">Items</span>
                  </h3>

                  <p className="text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-6">
                    This action will remove all the items loaded into this
                    current project. To prevent accidental deletion, please type{" "}
                    <span className="font-black text-red-500 select-none">
                      DELETE
                    </span>{" "}
                    below to unlock the button.
                  </p>

                  {/* SECURITY INPUT */}
                  <div className="w-full mb-8 relative">
                    <input
                      type="text"
                      value={confirmProjectDeleteText}
                      onChange={(e) =>
                        setConfirmProjectDeleteText(e.target.value)
                      }
                      placeholder="Type 'DELETE' here..."
                      className={`w-full px-6 py-4 rounded-2xl text-center font-black tracking-widest transition-all duration-300 border-2 outline-none 
              ${confirmProjectDeleteText === "DELETE"
                          ? "bg-emerald-50 dark:bg-emerald-500/10 border-emerald-500 text-emerald-600 dark:text-emerald-400"
                          : "bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-white focus:border-red-500"
                        }`}
                    />
                    {confirmProjectDeleteText === "DELETE" && (
                      <div className="absolute -bottom-6 left-0 right-0 animate-in slide-in-from-top-2">
                        <span className="text-[10px] font-black text-emerald-500 uppercase tracking-[0.2em]">
                          Security Check Passed
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col gap-4">
                  <button
                    disabled={
                      isClearingProject || confirmProjectDeleteText !== "DELETE"
                    }
                    onClick={async () => {
                      setIsClearingProject(true);
                      try {
                        await clearProjectItems();
                        setConfirmProjectDeleteText("");
                        setShowClearConfirmProject(false);
                      } catch (error) {
                        console.error(error);
                      } finally {
                        setIsClearingProject(false);
                      }
                    }}
                    className={`group relative overflow-hidden py-5 rounded-[24px] font-black text-sm tracking-widest uppercase transition-all duration-300 shadow-lg ${isClearingProject || confirmProjectDeleteText !== "DELETE"
                      ? "bg-slate-100 dark:bg-slate-800 text-slate-300 dark:text-slate-600 cursor-not-allowed grayscale"
                      : "bg-red-600 text-white hover:bg-red-700 hover:shadow-red-500/40 active:scale-95"
                      }`}
                  >
                    <div className="flex items-center justify-center gap-3 relative z-10">
                      {isClearingProject ? (
                        <Loader2 size={20} className="animate-spin" />
                      ) : (
                        <Trash2
                          size={20}
                          className={
                            confirmProjectDeleteText === "DELETE"
                              ? "animate-bounce"
                              : ""
                          }
                        />
                      )}
                      <span className="font-bold">
                        {isClearingProject
                          ? "Processing..."
                          : "Clear All Items"}
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      setShowClearConfirmProject(false);
                      setConfirmProjectDeleteText("");
                    }}
                    className="w-full py-5 rounded-[24px] font-bold text-sm text-slate-400 dark:text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* DELETE ALL QUOTES CONFIRMATION MODAL */}
          {showClearConfirmQuoteCard && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-6">
              {/* High-Friction Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/60 dark:bg-black/80 backdrop-blur-md animate-in fade-in duration-500"
                onClick={() =>
                  !isClearingQuotes && setShowClearConfirmQuoteCard(false)
                }
              />

              <div className="relative bg-white dark:bg-slate-900 w-full max-w-md rounded-[48px] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.3)] dark:shadow-[0_32px_64px_-16px_rgba(0,0,0,0.6)] border border-white dark:border-slate-800 p-10 animate-in zoom-in-95 duration-300">
                <div className="flex flex-col items-center text-center">
                  {/* Level 6-8 Red Alert Icon */}
                  <div className="relative mb-8">
                    <div className="absolute inset-0 bg-red-500/20 dark:bg-red-500/10 rounded-[2.5rem] scale-125 blur-xl animate-pulse" />
                    <div className="w-24 h-24 bg-gradient-to-br from-red-50 to-red-100 dark:from-red-950/40 dark:to-red-900/40 rounded-[2.5rem] flex items-center justify-center relative border border-red-200/50 dark:border-red-500/20">
                      <ShieldAlert
                        size={40}
                        className="text-red-600 dark:text-red-500"
                      />
                    </div>
                  </div>

                  <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tight">
                    Clear All <span className="text-red-500 font-bold">Quotes</span>
                  </h3>

                  <p className="text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-6">
                    This action will wipe all Quotes added to this project. To
                    confirm this action, please type{" "}
                    <span className="font-black text-red-500 select-none">
                      DELETE
                    </span>{" "}
                    below.
                  </p>

                  {/* SECURITY INPUT */}
                  <div className="w-full mb-8 relative">
                    <input
                      type="text"
                      value={confirmDeleteText}
                      onChange={(e) => setConfirmDeleteText(e.target.value)}
                      placeholder="Type 'DELETE' here..."
                      className={`w-full px-6 py-4 rounded-2xl text-center font-black tracking-widest transition-all duration-300 border-2 outline-none 
              ${confirmDeleteText === "DELETE"
                          ? "bg-emerald-50 dark:bg-emerald-500/10 border-emerald-500 text-emerald-600 dark:text-emerald-400"
                          : "bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-white focus:border-red-500"
                        }`}
                    />
                    {confirmDeleteText === "DELETE" && (
                      <div className="absolute -bottom-6 left-0 right-0 animate-in slide-in-from-top-2">
                        <span className="text-[10px] font-black text-emerald-500 uppercase tracking-[0.2em]">
                          Security Check Passed
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col gap-4">
                  <button
                    disabled={
                      isClearingQuotes || confirmDeleteText !== "DELETE"
                    }
                    onClick={async () => {
                      setIsClearingQuotes(true);
                      try {
                        await handleClearAllQuotes();
                        setConfirmDeleteText(""); // Reset text
                        setShowClearConfirmQuoteCard(false);
                      } catch (error) {
                        console.error(error);
                      } finally {
                        setIsClearingQuotes(false);
                      }
                    }}
                    className={`group relative overflow-hidden py-5 rounded-[24px] font-black text-sm tracking-widest uppercase transition-all duration-300 shadow-lg ${isClearingQuotes || confirmDeleteText !== "DELETE"
                      ? "bg-slate-100 dark:bg-slate-800 text-slate-300 dark:text-slate-600 cursor-not-allowed grayscale"
                      : "bg-red-600 text-white hover:bg-red-700 hover:shadow-red-500/40 active:scale-95"
                      }`}
                  >
                    <div className="flex items-center justify-center gap-3 relative z-10">
                      {isClearingQuotes ? (
                        <Loader2 size={20} className="animate-spin" />
                      ) : (
                        <Trash2
                          size={20}
                          className={
                            confirmDeleteText === "DELETE"
                              ? "animate-bounce"
                              : ""
                          }
                        />
                      )}
                      <span className="font-bold">
                        {isClearingQuotes
                          ? "Processing..."
                          : "Clear All Quotes"}
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      setShowClearConfirmQuoteCard(false);
                      setConfirmDeleteText("");
                    }}
                    className="w-full py-5 rounded-[24px] font-bold text-sm text-slate-400 dark:text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {showClearConfirmSupplier && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-6">
              <div
                className="absolute inset-0 bg-slate-900/60 dark:bg-black/80 backdrop-blur-md animate-in fade-in duration-500"
                onClick={() =>
                  !isClearingSuppliers && setShowClearConfirmSupplier(false)
                }
              />

              <div className="relative bg-white dark:bg-slate-900 w-full max-w-md rounded-[48px] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.3)] dark:shadow-[0_32px_64px_-16px_rgba(0,0,0,0.6)] border border-white dark:border-slate-800 p-10 animate-in zoom-in-95 duration-300">
                <div className="flex flex-col items-center text-center">
                  <div className="relative mb-8">
                    <div className="absolute inset-0 bg-red-500/20 dark:bg-red-500/10 rounded-[2.5rem] scale-125 blur-xl animate-pulse" />
                    <div className="w-24 h-24 bg-gradient-to-br from-red-50 to-red-100 dark:from-red-950/40 dark:to-red-900/40 rounded-[2.5rem] flex items-center justify-center relative border border-red-200/50 dark:border-red-500/20">
                      <ShieldAlert
                        size={40}
                        className="text-red-600 dark:text-red-500"
                      />
                    </div>
                  </div>

                  <h3 className="text-3xl font-black text-slate-900 dark:text-white mb-4 tracking-tight">
                    Clear All <span className="text-red-500 font-bold">Suppliers</span>
                  </h3>

                  <p className="text-slate-500 dark:text-slate-400 font-medium leading-relaxed mb-6">
                    This action will remove all the Suppliers in your workspace.
                    To prevent accidental deletion, please type{" "}
                    <span className="font-black text-red-500 select-none">
                      DELETE
                    </span>{" "}
                    below to unlock the button.
                  </p>

                  {/* SECURITY INPUT */}
                  <div className="w-full mb-8 relative">
                    <input
                      type="text"
                      value={confirmDeleteText}
                      onChange={(e) => setConfirmDeleteText(e.target.value)}
                      placeholder="Type 'DELETE' here..."
                      className={`w-full px-6 py-4 rounded-2xl text-center font-black tracking-widest transition-all duration-300 border-2 outline-none 
              ${confirmDeleteText === "DELETE"
                          ? "bg-emerald-50 dark:bg-emerald-500/10 border-emerald-500 text-emerald-600 dark:text-emerald-400"
                          : "bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-white focus:border-red-500"
                        }`}
                    />
                    {confirmDeleteText === "DELETE" && (
                      <div className="absolute -bottom-6 left-0 right-0 animate-in slide-in-from-top-2">
                        <span className="text-[10px] font-black text-emerald-500 uppercase tracking-[0.2em]">
                          Security Check Passed
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-col gap-4">
                  <button
                    disabled={
                      isClearingSuppliers || confirmDeleteText !== "DELETE"
                    }
                    onClick={async () => {
                      setIsClearingSuppliers(true);
                      try {
                        await clearAllSuppliers();
                        setConfirmDeleteText(""); // Reset for next time
                        setShowClearConfirmSupplier(false);
                      } catch (error) {
                        console.error(error);
                      } finally {
                        setIsClearingSuppliers(false);
                        setShowClearConfirmSupplier(false);
                      }
                    }}
                    className={`group relative overflow-hidden py-5 rounded-[24px] font-black text-sm tracking-widest uppercase transition-all duration-300 shadow-lg ${isClearingSuppliers || confirmDeleteText !== "DELETE"
                      ? "bg-slate-100 dark:bg-slate-800 text-slate-300 dark:text-slate-600 cursor-not-allowed grayscale"
                      : "bg-red-600 text-white hover:bg-red-700 hover:shadow-red-500/40 active:scale-95"
                      }`}
                  >
                    <div className="flex items-center justify-center gap-3 relative z-10">
                      {isClearingSuppliers ? (
                        <Loader2 size={20} className="animate-spin" />
                      ) : (
                        <Trash2
                          size={20}
                          className={
                            confirmDeleteText === "DELETE"
                              ? "animate-bounce"
                              : ""
                          }
                        />
                      )}
                      <span className="font-bold">
                        {isClearingSuppliers
                          ? "Processing..."
                          : "Clear All Suppliers"}
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      setShowClearConfirmSupplier(false);
                      setConfirmDeleteText("");
                    }}
                    className="w-full py-5 rounded-[24px] font-bold text-sm text-slate-400 dark:text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {isLoggingOut && (

            <div className="fixed inset-0 z-[1000] bg-white flex items-center justify-center">
              {/* 2. THE growing LOGO SECTION - Added negative margin to lift it up */}
              <div className="relative flex flex-col items-center mb-5 -mt-[50px]">
                {/* Logo - Synced to 1s Tailwind Bounce */}
                <br />
                <div className="w-20 h-20 relative z-10 animate-[breathe_1.5s_ease-in-out_infinite]">
                  <img
                    src="/logo.png"
                    className="w-full h-full object-contain"
                    alt="QuoPro Logo"
                  />
                </div>

                <style>
                  {`
      @keyframes breathe {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `}
                </style>
              </div>

              <style dangerouslySetInnerHTML={{
                __html: `
    @keyframes shadowSync {
      0%, 100% {
        transform: translateX(-50%) scale(0.4);
        opacity: 0.1;
        filter: blur(12px);
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
      }
      50% {
        transform: translateX(-50%) scale(1.2);
        opacity: 0.5;
        filter: blur(4px);
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
      }
    }
  ` }} />
            </div>
          )}
          {showSplitModal && (
            <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xl animate-in fade-in duration-300">
              <div className="bg-white dark:bg-slate-900 w-full max-w-[95vw] max-h-[90vh] rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col border border-slate-200 dark:border-slate-800 transition-colors">
                {/* 1. SLIM MODAL HEADER */}
                <div className="pt-7 px-4 md:px-12 pb-5 bg-white dark:bg-slate-900 shrink-0 z-40 border-b border-slate-100 dark:border-slate-800">
                  <div className="flex justify-between items-center gap-8">
                    <div className="flex items-center gap-5 shrink-0">
                      <div className="h-12 w-12 bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 rounded-2xl flex items-center justify-center border border-indigo-100 dark:border-indigo-500/20">
                        <ClipboardList size={24} />
                      </div>
                      <div>
                        <h3 className="text-xl font-black text-slate-900 dark:text-white uppercase tracking-tight" style={{
                          filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                        }}>
                          Split-Award Matrix
                        </h3>
                        <p className="text-[10px] text-emerald-600 font-black uppercase tracking-[0.2em]">
                          Optimised for Cost Efficiency
                        </p>
                      </div>
                    </div>

                    {/* SEARCH BAR INTEGRATION */}
                    <div className="relative flex-grow max-w-md ml-auto group">
                      {/* Search Icon */}
                      <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-500 transition-colors z-10">
                        <Search size={18} />
                      </div>

                      <input
                        type="text"
                        placeholder="Search matrix..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-12 pr-12 py-3.5 
                                    bg-white/80 dark:bg-slate-900/50 
                                    backdrop-blur-xl
                                    text-slate-900 dark:text-slate-100
                                    placeholder:text-slate-400 dark:placeholder:text-slate-500
                                    border border-slate-200/60 dark:border-white/10 
                                    rounded-[1.1rem] 
                                    shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_4px_6px_-2px_rgba(0,0,0,0.05)]
                                    outline-none 
                                    focus:ring-0
                                    group-hover:border-slate-300 dark:group-hover:border-white/20
                                    group-focus-within:border-indigo-500/50 dark:group-focus-within:border-indigo-400/50
                                    transition-all duration-300 font-bold text-[13px]"
                      />

                      {/* Clear Button */}
                      {searchTerm && (
                        <button
                          onClick={() => setSearchTerm("")}
                          className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-rose-500 transition-colors z-10"
                        >
                          <X size={16} />
                        </button>
                      )}
                    </div>

                    <button
                      onClick={() => setShowSplitModal(false)}
                      className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all shrink-0"
                    >
                      <X size={24} />
                    </button>
                  </div>
                </div>

                {/* 2. DENSE TABLE SECTION */}
                <div className="flex-grow h-[70vh] min-h-[500px] overflow-y-auto bg-slate-50/50 dark:bg-slate-950/40 relative">
                  <table className="w-full border-separate border-spacing-0 table-fixed">
                    <thead className="sticky top-0 z-50">
                      <tr>
                        <th colSpan="7" className="p-0">
                          <div className="flex w-full bg-white dark:bg-slate-900 border-b border-slate-100 dark:border-slate-800 px-12">
                            <div className="w-[10%] py-4 pl-4 text-[10px] font-black uppercase text-slate-400 tracking-widest">
                              Ref
                            </div>
                            <div className="w-[28%] py-4 text-[10px] font-black uppercase text-slate-400 tracking-widest">
                              Description
                            </div>
                            <div className="w-[18%] py-4 text-[10px] font-black uppercase text-slate-400 tracking-widest">
                              Vendor
                            </div>
                            <div className="w-[6%] py-4 text-[10px] font-black uppercase text-slate-400 tracking-widest text-center">
                              Qty
                            </div>
                            <div className="w-[12%] py-4 text-[10px] font-black uppercase text-slate-400 tracking-widest text-right pr-6">
                              Best Price
                            </div>
                            <div className="w-[12%] py-4 text-[10px] font-black uppercase text-slate-400 tracking-widest text-right pr-6">
                              Saving
                            </div>
                            <div className="w-[14%] py-4 text-[10px] font-black uppercase text-slate-400 tracking-widest text-right pr-6">
                              Extended
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>

                    <tbody className="relative">
                      <tr className="h-3">
                        <td colSpan="7"></td>
                      </tr>

                      {memoizedMatrixRows}

                      {/* 🚩 Feedback if the filter clears the whole list */}
                      {searchTerm && memoizedMatrixRows.length > 0 && memoizedMatrixRows.length < 5 && (
                        <tr style={{ height: `${(5 - memoizedMatrixRows.length) * 80}px` }}>
                          <td colSpan="7" />
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 3. SLIM LINEAR FOOTER */}
                <div className="px-12 py-5 bg-slate-900 dark:bg-black text-white flex flex-row justify-between items-center shrink-0 border-t border-white/10">
                  <div className="flex items-center gap-12">
                    <div className="flex items-baseline gap-3">
                      <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                        Winner Bid:
                      </span>
                      <span className="text-sm font-bold text-slate-400 line-through decoration-rose-500/50">
                        R{(Number(procurementStats?.winnerTotal) || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </span>
                    </div>

                    <div className="h-5 w-px bg-white/10" />

                    <div className="flex items-baseline gap-3">
                      <span className="text-[10px] font-black text-indigo-400 uppercase tracking-widest">
                        Optimised:
                      </span>
                      <span className="text-base font-black text-white">
                        R
                        {(
                          Number(procurementStats?.splitMin) || 0
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div>

                    <div className="h-5 w-px bg-white/10" />

                    <div className="group relative flex items-baseline gap-3 cursor-help">
                      <span className="text-[10px] font-black text-emerald-400 uppercase tracking-widest">
                        Net Savings:
                      </span>
                      <div className="flex items-baseline gap-2">
                        {/* This shows the R 7,595 gap */}
                        <span className="text-emerald-400 font-bold">
                          R
                          {(
                            Number(procurementStats?.rawDiff) || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}
                        </span>

                        {/* This shows the 2.68% percentage */}
                        <span className="text-[11px] font-black text-emerald-500/70">
                          (
                          {Math.abs(
                            Number(procurementStats?.savingsPct) || 0
                          ).toFixed(2)}
                          %)
                        </span>
                      </div>

                      {/* THE TOOLTIP - Also updated to show the breakdown clearly */}
                      <div className="absolute bottom-full mb-4 left-1/2 -translate-x-1/2 w-64 p-4 bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-700 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all pointer-events-none z-[100]">
                        <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">
                          Efficiency Analysis
                        </div>
                        <div className="space-y-2 text-slate-900 dark:text-white">
                          <div className="flex justify-between text-xs">
                            <span className="text-slate-500">
                              Winner Baseline:
                            </span>
                            <span className="font-bold">
                              R
                              {Number(procurementStats?.winnerTotal || 0).toLocaleString("en-ZA", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                          <div className="flex justify-between text-xs">
                            <span className="text-slate-500">
                              Split Optimized:
                            </span>
                            <span className="font-bold text-emerald-500">
                              R
                              {Number(procurementStats?.splitMin || 0).toLocaleString("en-ZA", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                          <div className="pt-2 border-t border-slate-50 dark:border-slate-700 flex justify-between text-xs">
                            <span className="font-black text-slate-400">
                              TOTAL SAVED:
                            </span>
                            <span className="font-black text-emerald-500">
                              R
                              {Number(procurementStats?.rawDiff || 0).toLocaleString("en-ZA", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        </div>
                        <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white dark:border-t-slate-800" />
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      exportToCSV();
                      setShowSplitModal(false);
                    }}
                    className="px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl font-black text-[11px] uppercase tracking-widest flex items-center gap-3 transition-all active:scale-95 shadow-lg shadow-indigo-600/20"
                  >
                    <FileSpreadsheet size={18} /> Export CSV Report
                  </button>
                </div>
              </div>
            </div>
          )}
          {isQuoteModalOpen && selectedSupplierForModal && (
            <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/60 backdrop-blur-xl p-4 animate-in fade-in duration-300">
              {/* 🚩 Widened max-w-5xl for Landscape feel */}
              <div className="bg-white dark:bg-slate-900 rounded-[40px] w-full max-w-5xl h-auto max-h-[90vh] shadow-2xl border border-white/20 dark:border-slate-800 overflow-hidden flex flex-col animate-in zoom-in-95 duration-300">
                {/* Header - Full Width */}
                <div className="p-6 border-b border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-800 relative">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-cyan-500 to-indigo-500 opacity-50" />
                  <div className="flex justify-between items-center px-4">
                    <div>
                      <span className="text-[10px] font-bold text-indigo-500 uppercase dark:text-indigo-400 tracking-[0.3em] block mb-1">
                        Finalise Landed Cost
                      </span>
                      <h3 className="text-3xl font-bold text-slate-900 dark:text-white tracking-tight" style={{
                        filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                      }}>
                        {supList.find(
                          (sl) =>
                            String(sl.id) ===
                            String(selectedSupplierForModal.sid)
                        )?.name || "Supplier Quote"}
                      </h3>
                    </div>
                    <button
                      onClick={() => setIsQuoteModalOpen(false)}
                      className="h-12 w-12 flex items-center justify-center text-slate-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-500 rounded-2xl transition-all"
                    >
                      <X size={24} />
                    </button>
                  </div>
                </div>

                {/* 🚩 LANDSCAPE GRID BODY */}
                <div className="grid grid-cols-1 lg:grid-cols-2 overflow-y-auto">
                  {/* LEFT COLUMN: Input Fields */}
                  <div className="p-8 space-y-6 border-r border-slate-100 dark:border-slate-800 bg-slate-50/30 dark:bg-slate-950/30">
                    <div className="shadow-lg bg-white dark:bg-slate-900 p-6 rounded-[32px] border border-slate-200/60 dark:border-white/5">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                            Base Material Cost
                          </p>
                          <p className="text-xs text-slate-500 italic">
                            Aggregated from {quote.length} line items
                          </p>
                        </div>
                        <div className="text-xl font-black text-slate-900 dark:text-white">
                          R
                          {Number(
                            calculateBaseTotal(selectedSupplierForModal, quote)
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      {/* Delivery / Freight */}
                      <div className="hover:scale-[1.04] hover:shadow-sm bg-white dark:bg-slate-900 p-5 rounded-[28px] border-2 border-slate-200/60 dark:border-white/5 transition-all hover:border-indigo-500/30">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-2.5 bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 rounded-xl">
                            <Truck size={18} />
                          </div>
                          <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                            Freight & Delivery
                          </p>
                        </div>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-sm">
                            R
                          </span>
                          <input
                            type="number"
                            placeholder="0.00"
                            className="w-full bg-slate-50 dark:bg-slate-800 border-none rounded-xl py-3 pl-8 pr-4 text-right font-black text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-indigo-500/20 transition-all"
                            value={selectedSupplierForModal.deliveryFee || ""}
                            onChange={(e) =>
                              updateSurcharge("deliveryFee", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      {/* Insurance */}
                      <div className="hover:scale-[1.04] hover:shadow-sm bg-white dark:bg-slate-900 p-5 rounded-[28px] border-2 border-slate-200/60 dark:border-white/5 transition-all hover:border-cyan-500/30">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-2.5 bg-cyan-50 dark:bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 rounded-xl">
                            <ShieldCheck size={18} />
                          </div>
                          <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                            Risk & Insurance
                          </p>
                        </div>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-sm">
                            R
                          </span>
                          <input
                            type="number"
                            placeholder="0.00"
                            className="w-full bg-slate-50 dark:bg-slate-800 border-none rounded-xl py-3 pl-8 pr-4 text-right font-black text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-cyan-500/20 transition-all"
                            value={selectedSupplierForModal.insuranceFee || ""}
                            onChange={(e) =>
                              updateSurcharge("insuranceFee", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      {/* Handling */}
                      <div className="hover:scale-[1.04] hover:shadow-sm bg-white dark:bg-slate-900 p-5 rounded-[28px] border-2 border-slate-200/60 dark:border-white/5 transition-all hover:border-amber-500/30">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-2.5 bg-amber-50 dark:bg-amber-500/10 text-amber-600 dark:text-amber-400 rounded-xl">
                            <Package size={18} />
                          </div>
                          <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                            Handling Fees
                          </p>
                        </div>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-sm">
                            R
                          </span>
                          <input
                            type="number"
                            placeholder="0.00"
                            className="w-full bg-slate-50 dark:bg-slate-800 border-none rounded-xl py-3 pl-8 pr-4 text-right font-black text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-amber-500/20 transition-all"
                            value={selectedSupplierForModal.handlingFee || ""}
                            onChange={(e) =>
                              updateSurcharge("handlingFee", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      {/* Other / Misc */}
                      <div className="hover:scale-[1.04] hover:shadow-sm bg-white dark:bg-slate-900 p-5 rounded-[28px] border-2 border-slate-200/60 dark:border-white/5 transition-all hover:border-rose-500/30">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="p-2.5 bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 rounded-xl">
                            <Plus size={18} />
                          </div>
                          <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
                            Other Surcharges
                          </p>
                        </div>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-bold text-sm">
                            R
                          </span>
                          <input
                            type="number"
                            placeholder="0.00"
                            className="w-full bg-slate-50 dark:bg-slate-800 border-none rounded-xl py-3 pl-8 pr-4 text-right font-black text-slate-900 dark:text-white outline-none focus:ring-2 focus:ring-rose-500/20 transition-all"
                            value={selectedSupplierForModal.miscFee || ""}
                            onChange={(e) =>
                              updateSurcharge("miscFee", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    {/* VAT Toggle integrated into left col */}
                    <div className="shadow-lg flex items-center justify-between p-5 bg-indigo-50/50 dark:bg-indigo-500/5 rounded-3xl border border-indigo-100/50 dark:border-indigo-500/10">
                      <div className="flex items-center gap-3">
                        <div
                          className={`p-2 rounded-lg ${selectedSupplierForModal.isVatInclusive
                            ? "bg-indigo-500 text-white"
                            : "bg-slate-200 dark:bg-slate-700 text-slate-400"
                            }`}
                        >
                          <span className="text-[10px] font-black italic">
                            VAT
                          </span>
                        </div>
                        <p className="text-xs font-black text-slate-700 dark:text-slate-300 uppercase">
                          Apply 15% VAT
                        </p>
                      </div>
                      <button
                        onClick={toggleVat}
                        className={`relative w-12 h-6 rounded-full transition-colors ${selectedSupplierForModal.isVatInclusive
                          ? "bg-indigo-600"
                          : "bg-slate-300 dark:bg-slate-700"
                          }`}
                      >
                        <div
                          className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${selectedSupplierForModal.isVatInclusive
                            ? "translate-x-6"
                            : "translate-x-0"
                            }`}
                        />
                      </button>
                    </div>
                  </div>

                  {/* RIGHT COLUMN: Financial Summary */}
                  <div className="p-8 flex flex-col justify-between bg-white dark:bg-slate-900">
                    {(() => {
                      // 1. Find the budget first
                      const budgetData = projects.find(
                        (p) => String(p.id) === String(currentProject)
                      );
                      const currentBudgetAmount =
                        budgetData?.totalBudget || budgetData?.budget || 0;

                      // 2. Destructure the result of the function so all variables are defined
                      const {
                        subtotal,
                        vatAmount,
                        grandTotal,
                        projectBudget,
                        variance,
                        isOverBudget,
                      } = calculateGrandTotal(
                        selectedSupplierForModal,
                        quote,
                        currentBudgetAmount
                      );

                      return (
                        <div className="space-y-8">
                          {/* TOP SECTION: LANDED COST & VAT BREAKDOWN */}
                          <div className="space-y-4">
                            <div>
                              <p className="text-xs font-black text-slate-400 uppercase tracking-[0.2em] mb-2">
                                Total Landed Cost
                              </p>
                              <p className="text-6xl font-black text-indigo-600 dark:text-indigo-400 tracking-tighter" style={{
                                filter: isOverBudget
                                  ? `
      /* Layer 1: Core ruby definition (crisp edge accent) */
      drop-shadow(0 0 1px rgba(239, 68, 68, 0.6)) 
      /* Layer 2: Mid-range ruby body depth */
      drop-shadow(0 0 3px rgba(220, 38, 38, 0.35)) 
      /* Layer 3: Outer soft rose volumetric glow */
      drop-shadow(0 0 8px rgba(251, 113, 133, 0.2))`
                                  : `
      /* Layer 1: Core indigo definition (crisp edge accent) */
      drop-shadow(0 0 1px rgba(99, 102, 241, 0.6)) 
      /* Layer 2: Mid-range deep indigo body depth */
      drop-shadow(0 0 3px rgba(79, 70, 229, 0.35)) 
      /* Layer 3: Outer soft lavender/violet volumetric glow */
      drop-shadow(0 0 8px rgba(165, 180, 252, 0.25))`
                              }}>
                                R
                                {(grandTotal || 0).toLocaleString("en-ZA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </p>
                            </div>

                            {/* VAT & SUBTOTAL MINI-BREAKDOWN */}
                            <div className="flex gap-6 py-3 px-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
                              <div>
                                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                                  Subtotal (Excl)
                                </p>
                                <p className="text-sm font-bold text-slate-600 dark:text-slate-300">
                                  R
                                  {(subtotal || 0).toLocaleString("en-ZA", {
                                    minimumFractionDigits: 2,
                                  })}
                                </p>
                              </div>
                              <div className="w-px h-8 bg-slate-200 dark:bg-slate-700 my-auto" />
                              <div>
                                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                                  VAT (15%){" "}
                                  {selectedSupplierForModal?.isVatInclusive
                                    ? ""
                                    : "— EXEMPT"}
                                </p>
                                <p className="text-sm font-bold text-slate-600 dark:text-slate-300">
                                  R
                                  {(vatAmount || 0).toLocaleString("en-ZA", {
                                    minimumFractionDigits: 2,
                                  })}
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* BUDGET ANALYSIS GRID */}
                          <div className="grid grid-cols-2 gap-8 pt-8 border-t border-slate-100 dark:border-slate-800">
                            <div>
                              <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1">
                                Allocated Budget
                              </p>
                              <p className="text-2xl font-bold text-slate-700 dark:text-slate-300" style={{
                                filter: `
      /* Layer 1: Core definition (slightly crisper) */
      drop-shadow(0 0 1px rgba(15, 23, 42, 0.45)) 
      /* Layer 2: Mid-range body (darker for depth) */
      drop-shadow(0 0 3px rgba(165, 169, 179, 0.25)) 
      /* Layer 3: Outer soft glow (expanded for 5% boost) */
      drop-shadow(0 0 8px rgba(15, 23, 42, 0.15))`
                              }}>
                                R
                                {(projectBudget || 0).toLocaleString("en-ZA", {
                                  minimumFractionDigits: 2,
                                })}
                              </p>
                            </div>
                            <div>
                              <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1">
                                {isOverBudget ? "Overspend" : "Savings"}
                              </p>
                              <div
                                className={`text-2xl font-black ${isOverBudget
                                  ? "text-red-500"
                                  : "text-emerald-500"
                                  }`} style={{
                                    filter: isOverBudget
                                      ? `
      /* Layer 1: Sharp ruby core edge */
      drop-shadow(0 0 1px rgba(239, 68, 68, 0.6)) 
      /* Layer 2: Mid-range deep red body */
      drop-shadow(0 0 3px rgba(220, 38, 38, 0.35)) 
      /* Layer 3: Soft coral/rose outer volumetric glow */
      drop-shadow(0 0 8px rgba(251, 113, 133, 0.2))`
                                      : `
      /* Layer 1: Sharp emerald core edge */
      drop-shadow(0 0 1px rgba(16, 185, 129, 0.6)) 
      /* Layer 2: Mid-range deep forest body */
      drop-shadow(0 0 3px rgba(5, 150, 105, 0.35)) 
      /* Layer 3: Soft mint/teal outer volumetric glow */
      drop-shadow(0 0 8px rgba(145, 233, 200, 0.25))`
                                  }}
                              >
                                {isOverBudget ? "" : ""} R
                                {Math.abs(variance || 0).toLocaleString(
                                  "en-ZA",
                                  {
                                    minimumFractionDigits: 2,
                                  }
                                )}
                              </div>
                            </div>
                          </div>

                          {/* PROGRESS BAR */}
                          <div className="space-y-2">
                            <div className="flex justify-between text-[10px] font-black uppercase text-slate-400">
                              <span>Budget Usage</span>
                              <span
                                className={
                                  isOverBudget
                                    ? "text-red-500"
                                    : "text-indigo-500"
                                }
                              >
                                {(
                                  (grandTotal / (projectBudget || 1)) *
                                  100
                                ).toFixed(1)}
                                %
                              </span>
                            </div>
                            <div className="h-3 w-full bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                              <div
                                className={`h-full transition-all duration-1000 ${isOverBudget ? "bg-red-500" : "bg-indigo-500"
                                  }`}
                                style={{
                                  width: `${Math.min(
                                    (grandTotal / (projectBudget || 1)) * 100,
                                    100
                                  )}%`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })()}

                    {/* Action Button */}
                    <button
                      onClick={handleSaveFinalCosts}
                      disabled={isSaving}
                      className={`mx-auto w-max px-10 py-5 rounded-[24px] font-black uppercase tracking-[0.2em] text-xs transition-all shadow-xl flex items-center justify-center gap-3 mt-8
                        ${isSaving
                          ? "bg-slate-100 dark:bg-slate-800 text-slate-400"
                          : "bg-slate-900 dark:bg-white text-white dark:text-slate-900 hover:shadow-indigo-500/20 active:scale-95"
                        }`}
                    >
                      {isSaving ? (
                        <Loader2 className="animate-spin" size={20} />
                      ) : (
                        <span className="font-bold">Confirm & Save Quote</span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* --- PLACE THIS AT THE VERY BOTTOM OF YOUR JSX --- */}
          {showSupWarning && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-md">
              <div className="bg-white dark:bg-slate-900 rounded-[40px] shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="p-10 text-center">
                  <div className="w-20 h-20 bg-amber-100 rounded-3xl flex items-center justify-center mx-auto mb-6 rotate-3">
                    <AlertTriangle
                      size={42}
                      className="text-amber-600 -rotate-3"
                    />
                  </div>

                  <h3 className="text-2xl font-black text-slate-800 mb-3 tracking-tight">
                    Select a Supplier
                  </h3>
                  <p className="text-slate-500 font-medium leading-relaxed">
                    You need to assign a name to this quote box before you can
                    import the pricing data.
                  </p>
                </div>

                <div className="p-6 bg-slate-50 border-t border-slate-100">
                  <button
                    onClick={() => setShowSupWarning(false)}
                    className="w-full py-5 bg-indigo-600 text-white rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] hover:bg-indigo-700 transition-all shadow-xl shadow-indigo-100"
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          )}

          {confirmModal.show && (
            <div className="fixed inset-0 z-[1100] flex items-center justify-center p-6 animate-in fade-in duration-200">
              {/* Backdrop */}
              <div
                className="absolute inset-0 bg-slate-900/60 backdrop-blur-md"
                onClick={() =>
                  setConfirmModal({ ...confirmModal, show: false })
                }
              />

              {/* Modal Card */}
              <div className="relative bg-white dark:bg-slate-900 rounded-[2.5rem] shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="p-10 text-center">
                  <div className="w-20 h-20 bg-rose-50 text-rose-500 rounded-3xl flex items-center justify-center mx-auto mb-6">
                    <Trash2 size={40} />
                  </div>

                  <h3 className="text-2xl font-black text-slate-900 mb-3">
                    {confirmModal.title}
                  </h3>
                  <p className="text-slate-500 font-medium text-sm leading-relaxed mb-10">
                    {confirmModal.message}
                  </p>

                  <div className="flex gap-3">
                    <button
                      onClick={() =>
                        setConfirmModal({ ...confirmModal, show: false })
                      }
                      className="flex-1 py-4 bg-slate-100 text-slate-600 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-slate-200 transition-all"
                    >
                      Cancel
                    </button>
                    <button
                      disabled={isDeleting} // Stop double clicks
                      onClick={confirmModal.onConfirm}
                      className="bg-red-600 text-white px-6 py-2 rounded-lg font-bold flex items-center justify-center gap-2"
                    >
                      {isDeleting ? (
                        <>
                          <RefreshCw className="animate-spin" size={16} />
                          <span>Clearing Logs...</span>
                        </>
                      ) : (
                        "Yes, clear it!"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* THE VERY LAST PIECE OF JSX BEFORE THE CLOSING FRAGMENT */}
          {pendingPlan && (
            <div
              style={{ zIndex: 9999 }}
              className="fixed inset-0 flex items-center justify-center p-4"
            >
              <div
                className="absolute inset-0 bg-slate-900/90 backdrop-blur-md"
                onClick={() => setPendingPlan(null)}
              />
              <div className="relative bg-white dark:bg-slate-900 rounded-[3rem] shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="p-8 text-center">
                  <div className="w-16 h-16 bg-indigo-50 text-indigo-600 rounded-3xl flex items-center justify-center mx-auto mb-6">
                    <Zap size={32} />
                  </div>
                  <h3 className="text-2xl font-black text-slate-900 mb-2">
                    Confirm Change
                  </h3>
                  <p className="text-slate-500 font-medium text-sm leading-relaxed mb-8">
                    Are you sure you want to switch to the{" "}
                    <span className="text-indigo-600 font-bold uppercase">
                      {pendingPlan.name}
                    </span>{" "}
                    plan?
                  </p>

                  <div className="flex flex-col gap-3">
                    <button
                      onClick={() => {
                        // 1. Close the confirmation modal FIRST to stop layout shifting
                        setPendingPlan(null);

                        // 2. Wait a heartbeat for the animation to finish before running the heavy logic
                        setTimeout(() => {
                          handleUpdatePlan(pendingPlan.id);
                        }, 100);
                      }}
                      className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black text-[11px] uppercase tracking-widest hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-100"
                    >
                      Confirm & Update
                    </button>

                    {/* NEW: Cancel Button */}
                    <button
                      onClick={() => setPendingPlan(null)}
                      className="w-full py-4 bg-slate-50 text-slate-400 rounded-2xl font-black text-[11px] uppercase tracking-widest hover:bg-slate-100 hover:text-slate-600 transition-all"
                    >
                      Cancel & Keep Current
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div >
      ) : (
        /* --- NEW SEPARATE FINANCE PAGE --- */

        <FinancePage
          projects={projects}
          supList={supList}
          allUsers={allUsers}
          user={user}
          logout={logout}
          setShowSettingsModal={setShowSettingsModal}
          setShowHelpModal={setShowHelpModal}
          setView={setView}
          generatePDFDocument={generatePDFDocument}
          matrixData={matrixData}
          procurementStats={procurementStats}
          storage={storage}
          darkMode={darkMode}
          setProjects={setProjects}
        />
      )}

    </>
  );
};
export default QuoteManager;
